(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('before-after')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class BeforeAfter extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.stage = this.querySelector('[data-ba-stage]');
        this.range = this.querySelector('[data-ba-range]');
        if (!this.stage || !this.range) return;
        this.start = Number(this.range.value) || 50;
        this.set(this.start);

        this.range.addEventListener(
          'input',
          () => {
            this.touched();
            this.set(Number(this.range.value));
          },
          { signal }
        );
        this.stage.addEventListener('pointerdown', (e) => this.down(e), { signal });
        this.stage.addEventListener('pointermove', (e) => this.move(e), { signal });
        this.stage.addEventListener('pointerup', (e) => this.up(e), { signal });
        this.stage.addEventListener('pointercancel', () => this.cancel(), { signal });
        this.stage.addEventListener('dragstart', (e) => e.preventDefault(), { signal });

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        const rise = Array.from(this.querySelectorAll('[data-ba-rise]'));
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => {
              this.io.unobserve(el);
              const delay = Math.min(n, 3) * 100;
              el.style.setProperty('--d', delay + 'ms');
              el.classList.add('is-in');
              this.later(() => el.classList.add('is-settled'), 1300 + delay);
              if (el.contains(this.stage)) this.later(() => this.sway(), 900 + delay);
            });
          },
          { rootMargin: '0px 0px -12% 0px' }
        );
        rise.forEach((el) => this.io.observe(el));
      }

      set(p) {
        const v = Math.min(100, Math.max(0, Math.round(p * 10) / 10));
        this.p = v;
        this.style.setProperty('--p', String(v));
        const whole = Math.round(v);
        if (Number(this.range.value) !== whole) this.range.value = String(whole);
        this.range.setAttribute(
          'aria-valuetext',
          `${this.dataset.before} ${whole}%, ${this.dataset.after} ${100 - whole}%`
        );
        this.classList.toggle('is-low', v < 14);
        this.classList.toggle('is-high', v > 86);
      }

      // A small sway to the right and back, once, to show the seam can move
      sway() {
        if (this.wasTouched) return;
        const a = this.start;
        const steps = [Math.min(a + 14, 92), Math.max(a - 12, 8), a];
        this.classList.add('is-hinting');
        steps.forEach((p, i) => this.later(() => !this.wasTouched && this.set(p), i * 850));
        this.later(() => this.classList.remove('is-hinting'), steps.length * 850);
      }

      touched() {
        this.wasTouched = true;
        this.classList.remove('is-hinting');
      }

      at(clientX) {
        const r = this.stage.getBoundingClientRect();
        return ((clientX - r.left) / r.width) * 100;
      }

      down(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        this.touched();
        this.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, on: false };
        if (e.pointerType === 'mouse') this.grab(e);
      }

      grab(e) {
        this.drag.on = true;
        this.classList.add('is-dragging');
        try {
          this.stage.setPointerCapture(e.pointerId);
        } catch (err) {}
        this.set(this.at(e.clientX));
      }

      move(e) {
        const d = this.drag;
        if (!d || e.pointerId !== d.id) return;
        if (!d.on) {
          // Touch: only a sideways move takes the seam; up and down still scrolls the page
          if (Math.abs(e.clientX - d.x) < 6 || Math.abs(e.clientY - d.y) > Math.abs(e.clientX - d.x)) return;
          this.grab(e);
          return;
        }
        this.set(this.at(e.clientX));
      }

      up(e) {
        const d = this.drag;
        if (!d || e.pointerId !== d.id) return;
        // A tap moves the seam to where you tapped
        if (!d.on) this.set(this.at(e.clientX));
        this.cancel();
      }

      cancel() {
        this.drag = null;
        this.classList.remove('is-dragging');
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        this.drag = null;
      }
    }

    customElements.define('before-after', BeforeAfter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('blog-posts')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class BlogPosts extends HTMLElement {
      connectedCallback() {
        this.timers = new Set();
        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        const items = Array.from(this.querySelectorAll('[data-bp-rise], [data-bp-spread], [data-bp-item]'));
        if (!items.length) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => {
              this.io.unobserve(el);
              const delay = el.hasAttribute('data-bp-item') ? Math.min(n, 5) * 100 : 0;
              el.style.setProperty('--d', delay + 'ms');
              el.classList.add('is-in');
              const hold = el.hasAttribute('data-bp-spread') ? 2200 : 1500;
              this.later(() => el.classList.add('is-settled'), hold + delay);
            });
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        items.forEach((el) => this.io.observe(el));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('blog-posts', BlogPosts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-set"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('bundle-set')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class BundleSet extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-bd-form]');
        if (!this.form) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.items = Array.from(this.querySelectorAll('[data-bd-item]'));
        this.example = this.classList.contains('bd--example');
        this.readMoney();

        this.form.addEventListener(
          'change',
          (e) => {
            if (e.target.matches('[data-bd-check], [data-bd-variant]')) this.update(true);
          },
          { signal }
        );
        this.form.addEventListener(
          'submit',
          (e) => {
            if (this.example || this.count === 0) {
              e.preventDefault();
              return;
            }
            // A cart drawer that opens on add takes the form itself and slides in
            if (document.querySelector('cart-drawer[data-open-on-add]')) return;
            e.preventDefault();
            this.add();
          },
          { signal }
        );

        this.update(false);
      }

      /* The shop's own money format, read from a sample the theme printed */
      readMoney() {
        const sample = this.dataset.money || '';
        const m = sample.match(/1([^0-9]?)000(?:([^0-9])(0+))?/);
        if (!m) {
          this.money = (cents) => (cents / 100).toFixed(2);
          return;
        }
        const [hit, group, dec, decimals] = m;
        const places = decimals ? decimals.length : 0;
        const before = sample.slice(0, m.index);
        const after = sample.slice(m.index + hit.length);
        this.money = (cents) => {
          const fixed = (Math.round(cents) / 100).toFixed(places);
          const [whole, frac] = fixed.split('.');
          const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, group);
          return before + grouped + (places ? dec + frac : '') + after;
        };
      }

      update(changed) {
        let count = 0;
        let total = 0;
        let was = 0;
        this.items.forEach((item) => {
          const box = item.querySelector('[data-bd-check]');
          const select = item.querySelector('[data-bd-variant]');
          const on = !!box && box.checked && !box.disabled;
          if (select) {
            const opt = select.selectedOptions[0];
            if (opt) {
              item.dataset.price = opt.dataset.price;
              item.dataset.compare = opt.dataset.compare;
              item.dataset.min = opt.dataset.min;
              const id = item.querySelector('[data-bd-id]');
              if (id) id.value = opt.value;
            }
          }
          const price = Number(item.dataset.price) || 0;
          const compare = Number(item.dataset.compare) || 0;
          const min = Math.max(1, Number(item.dataset.min) || 1);
          const qty = item.querySelector('[data-bd-qty]');
          if (qty) qty.value = String(min);
          this.paintPrice(item, price, compare);

          item.classList.toggle('is-off', !on);
          // Only ticked pieces are sent, numbered without gaps
          const id = item.querySelector('[data-bd-id]');
          [id, qty].forEach((input) => {
            if (!input) return;
            input.disabled = !on;
            const field = input === id ? 'id' : 'quantity';
            if (on) input.name = `items[${count}][${field}]`;
          });
          if (!on) return;
          count += 1;
          total += price * min;
          was += Math.max(compare, price) * min;
        });
        this.count = count;

        const amount = this.querySelector('[data-bd-total]');
        if (amount) {
          const text = this.money(total);
          if (amount.textContent !== text) {
            amount.textContent = text;
            if (changed && !reduceMotion.matches) {
              amount.classList.remove('is-new');
              void amount.offsetWidth;
              amount.classList.add('is-new');
            }
          }
        }
        const counter = this.querySelector('[data-bd-count]');
        if (counter) counter.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
        const save = this.querySelector('[data-bd-save]');
        const saved = this.querySelector('[data-bd-saved]');
        if (save && saved) {
          save.hidden = was - total <= 0;
          saved.textContent = this.money(was - total);
        }
        const btn = this.querySelector('[data-bd-add]');
        const label = this.querySelector('[data-bd-label]');
        const available = this.items.filter((i) => {
          const b = i.querySelector('[data-bd-check]');
          return b && !b.disabled;
        }).length;
        if (btn) btn.disabled = this.example || count === 0;
        if (label) {
          if (count === 0) label.textContent = 'Choose at least one';
          else if (count === available && count > 1) label.textContent = `Add all ${count} to cart`;
          else label.textContent = `Add ${count} to cart`;
        }
        if (changed) this.say(`${count} ${count === 1 ? 'item' : 'items'}, total ${this.money(total)}`);
      }

      paintPrice(item, price, compare) {
        const now = item.querySelector('[data-bd-now]');
        if (now) now.textContent = this.money(price);
        const was = item.querySelector('[data-bd-was]');
        const wasAmount = item.querySelector('[data-bd-was-amount]');
        if (was && wasAmount) {
          was.hidden = !(compare > price);
          wasAmount.textContent = this.money(compare);
        }
      }

      async add() {
        const btn = this.querySelector('[data-bd-add]');
        if (!btn || btn.getAttribute('aria-busy') === 'true') return;
        const items = this.items
          .filter((item) => !item.classList.contains('is-off'))
          .map((item) => ({
            id: Number((item.querySelector('[data-bd-id]') || {}).value),
            quantity: Math.max(1, Number(item.dataset.min) || 1),
          }))
          .filter((x) => x.id);
        if (!items.length) return;
        this.fail('');
        btn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items }),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || 'The set could not be added to your cart.');
          btn.classList.add('is-added');
          this.later(() => btn.classList.remove('is-added'), 2000);
          this.say(`${items.length} ${items.length === 1 ? 'item' : 'items'} added to your cart.`);
          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else {
            const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
              .then((r) => r.json())
              .catch(() => null);
            if (cart)
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'bundle-set' } }));
          }
        } catch (err) {
          this.fail((err && err.message) || 'Something went wrong. Please try again.');
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      fail(text) {
        const msg = this.querySelector('[data-bd-msg]');
        if (!msg) return;
        msg.textContent = text;
        msg.hidden = !text;
      }

      say(text) {
        const live = this.querySelector('[data-bd-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('bundle-set', BundleSet);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cart-drawer')) return;

    const root = document.documentElement;
    // Theme settings › Motion "Off" behaves like a visitor who asked for reduced motion.
    const reduceMotion = window.matchMedia(root.dataset.motion === 'none' ? 'all' : '(prefers-reduced-motion: reduce)');
    // Waits that sit out a CSS transition stretch with Theme settings › Motion › speed.
    let speed = 0;
    const motionSpeed = () =>
      speed || (speed = parseFloat(getComputedStyle(root).getPropertyValue('--motion-speed')) || 1);
    const wait = (ms) => new Promise((r) => setTimeout(r, ms * motionSpeed()));
    const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.sectionId = this.dataset.sectionId;
        this.dialog = this.querySelector('[data-dr-dialog]');
        this.live = this.querySelector('[data-dr-live]');
        this.queue = Promise.resolve();
        this.timers = new Map();
        this.stale = false;
        this.recsLoaded = false;
        if (!this.dialog) return;

        const cartPath = this.pathOf(this.dataset.cartUrl);
        const addPath = this.pathOf(this.dataset.addUrl);

        // Any link to the cart opens the drawer instead (the header icon included).
        document.addEventListener(
          'click',
          (e) => {
            if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            const a = e.target.closest('a[href]');
            if (!a || this.contains(a) || a.target === '_blank') return;
            if (this.pathOf(a.href) !== cartPath || a.hash) return;
            e.preventDefault();
            this.open(a);
          },
          { signal }
        );

        // Product forms add to the bag without leaving the page.
        if (this.hasAttribute('data-open-on-add')) {
          document.addEventListener(
            'submit',
            (e) => {
              const form = e.target;
              if (!(form instanceof HTMLFormElement) || e.defaultPrevented || this.contains(form)) return;
              if (form.hasAttribute('data-no-drawer') || this.pathOf(form.action) !== addPath) return;
              e.preventDefault();
              this.addForm(form, e.submitter);
            },
            { signal }
          );
        }

        document.addEventListener('cart:open', (e) => this.open(e.detail && e.detail.opener), { signal });
        document.addEventListener('cart:refresh', () => this.refresh().then(() => this.open()), { signal });
        document.addEventListener(
          'cart:updated',
          (e) => {
            if (e.detail && e.detail.source === 'cart-drawer') return;
            this.stale = true;
          },
          { signal }
        );

        this.dialog.addEventListener(
          'cancel',
          (e) => {
            e.preventDefault();
            this.close();
          },
          { signal }
        );
        this.addEventListener('click', (e) => this.onClick(e), { signal });
        if (this.hasAttribute('data-swipe')) this.initSwipe(signal);
        this.addEventListener('change', (e) => this.onChange(e), { signal });
        this.addEventListener('input', (e) => this.onInput(e), { signal });
        this.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'Enter' && e.target.matches('[data-dr-input]')) {
              e.preventDefault();
              this.schedule(e.target, 0);
            }
          },
          { signal }
        );

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener(
            'shopify:section:select',
            (e) => {
              if (e.detail && e.detail.sectionId === this.sectionId) this.open();
            },
            { signal }
          );
          document.addEventListener(
            'shopify:section:deselect',
            (e) => {
              if (e.detail && e.detail.sectionId === this.sectionId) this.close();
            },
            { signal }
          );
        }
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        this.timers.forEach((t) => clearTimeout(t));
        clearTimeout(this.settleTimer);
        this.unlock();
      }

      pathOf(url) {
        try {
          return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
        } catch (e) {
          return '';
        }
      }

      /* ---------- Open / close ---------- */
      async open(opener) {
        if (this.isOpen) return;
        this.isOpen = true;
        this.opener = opener instanceof HTMLElement ? opener : document.activeElement;
        if (this.stale) await this.refresh();

        this.lock();
        this.classList.remove('is-closing');
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');

        // The staggered entrance is skipped when the theme's entrance animations are off.
        const entering = !reduceMotion.matches && root.dataset.reveal !== 'none';
        if (entering) this.classList.add('is-entering');
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
        clearTimeout(this.enterTimer);
        this.enterTimer = setTimeout(() => this.classList.remove('is-entering'), 1200 * motionSpeed());
        this.settle(entering ? 1200 : 700);

        const close = this.querySelector('.dr-close');
        if (close) close.focus({ preventScroll: true });
        this.loadRecommendations();
      }

      async close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        clearTimeout(this.settleTimer);
        this.classList.remove('is-settled');
        this.classList.add('is-closing');
        this.classList.remove('is-open', 'is-entering');
        if (!reduceMotion.matches) await wait(400);
        if (this.isOpen) return; // reopened meanwhile
        this.classList.remove('is-closing');
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
        this.unlock();
        if (this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
      }

      // Backdrop blur only once the panel and its entrance stand still (see .is-settled in the styles).
      settle(after = 700) {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(
          () => {
            if (this.isOpen) this.classList.add('is-settled');
          },
          reduceMotion.matches ? 0 : after * motionSpeed()
        );
      }

      lock() {
        const sbw = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--dr-sbw', `${Math.max(sbw, 0)}px`);
        document.documentElement.classList.add('dr-locked');
      }

      unlock() {
        document.documentElement.classList.remove('dr-locked');
        document.documentElement.style.removeProperty('--dr-sbw');
      }

      /* ---------- Swipe to close (Theme settings › Drawers) ---------- */
      initSwipe(signal) {
        const panel = this.querySelector('[data-dr-panel]');
        const overlay = this.querySelector('.dr__overlay');
        if (!panel) return;
        let startX = 0;
        let startY = 0;
        let startT = 0;
        let axis = null;
        let offset = 0;
        let frame = 0;

        const paint = () => {
          frame = 0;
          panel.style.transform = `translate3d(${offset}px, 0, 0)`;
          if (overlay) overlay.style.opacity = (1 - Math.min(offset / panel.offsetWidth, 1)).toFixed(3);
        };

        panel.addEventListener(
          'touchstart',
          (e) => {
            // Text in the note field stays selectable.
            if (!this.isOpen || e.touches.length !== 1 || e.target.closest('textarea')) {
              axis = 'none';
              return;
            }
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            startT = e.timeStamp;
            axis = null;
            offset = 0;
          },
          { passive: true, signal }
        );

        panel.addEventListener(
          'touchmove',
          (e) => {
            if (axis === 'none' || !this.isOpen || e.touches.length !== 1) return;
            const dx = e.touches[0].clientX - startX;
            const dy = e.touches[0].clientY - startY;
            if (axis === null) {
              if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
              axis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'none';
              if (axis === 'x') {
                clearTimeout(this.settleTimer);
                this.classList.remove('is-settled');
                this.classList.add('is-dragging');
              }
            }
            if (axis !== 'x') return;
            offset = Math.max(0, dx);
            if (!frame) frame = requestAnimationFrame(paint);
          },
          { passive: true, signal }
        );

        const end = (e) => {
          const dragged = axis === 'x';
          axis = null;
          if (!dragged) return;
          if (frame) cancelAnimationFrame(frame);
          frame = 0;
          const flick = offset > 40 && e.timeStamp - startT < 250;
          const shut = e.type === 'touchend' && (flick || offset > panel.offsetWidth * 0.28);
          this.classList.remove('is-dragging');
          panel.style.transform = '';
          if (overlay) overlay.style.opacity = '';
          if (shut) this.close();
          else this.settle();
        };
        panel.addEventListener('touchend', end, { passive: true, signal });
        panel.addEventListener('touchcancel', end, { passive: true, signal });
      }

      /* ---------- Clicks inside ---------- */
      onClick(e) {
        if (e.target.closest('[data-dr-close]')) {
          this.close();
          return;
        }

        const step = e.target.closest('[data-dr-step]');
        if (step) {
          const input = step.closest('[data-dr-qty]').querySelector('[data-dr-input]');
          const inc = parseInt(input.step, 10) || 1;
          const min = parseInt(input.min, 10) || 0;
          const max = input.max ? parseInt(input.max, 10) : Infinity;
          const cur = parseInt(input.value, 10) || 0;
          const next = Math.min(Math.max(cur + inc * parseInt(step.dataset.drStep, 10), min), max);
          if (next === cur) return;
          input.value = next;
          if (!reduceMotion.matches) {
            input.classList.remove('is-bump');
            void input.offsetWidth;
            input.classList.add('is-bump');
          }
          this.schedule(input, 380);
          return;
        }

        const remove = e.target.closest('[data-dr-remove]');
        if (remove) {
          e.preventDefault();
          this.change(remove.dataset.drRemove, 0);
          return;
        }

        const add = e.target.closest('[data-dr-add]');
        if (add) {
          e.preventDefault();
          this.addRec(add);
        }
      }

      onChange(e) {
        if (e.target.matches('[data-dr-input]')) this.schedule(e.target, 0);
        if (e.target.matches('[data-dr-note]')) this.saveNote(e.target.value);
      }

      onInput(e) {
        if (!e.target.matches('[data-dr-note]')) return;
        clearTimeout(this.noteTimer);
        const value = e.target.value;
        this.noteTimer = setTimeout(() => this.saveNote(value), 700);
      }

      schedule(input, delay) {
        const key = input.dataset.drKey;
        clearTimeout(this.timers.get(key));
        this.timers.set(
          key,
          setTimeout(() => {
            this.timers.delete(key);
            let qty = parseInt(input.value, 10);
            if (Number.isNaN(qty) || qty < 0) qty = parseInt(input.dataset.drValue, 10) || 0;
            if (String(qty) === input.dataset.drValue) return;
            this.change(key, qty);
          }, delay)
        );
      }

      /* ---------- Cart API ---------- */
      change(key, quantity) {
        this.queue = this.queue.then(() => this.runChange(key, quantity)).catch(() => {});
        return this.queue;
      }

      async runChange(key, quantity) {
        const item = this.querySelector(`[data-dr-item="${CSS.escape(key)}"]`);
        const err = item && item.querySelector('[data-dr-error]');
        if (err) err.textContent = '';
        this.setBusy(true, item);
        try {
          const res = await fetch(`${this.dataset.changeUrl}.js`, {
            method: 'POST',
            headers: json,
            body: JSON.stringify({
              id: key,
              quantity,
              sections: [this.sectionId],
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (!res.ok || data.status) {
            this.lineError(item, data.description || data.message || 'Something went wrong. Please try again.');
            return;
          }
          if (quantity === 0 && item && !reduceMotion.matches) {
            item.classList.add('is-leaving');
            await wait(300);
          }
          this.render(data.sections && data.sections[this.sectionId]);
          this.announce(quantity === 0 ? 'Item removed from your bag.' : 'Your bag has been updated.');
          if (quantity > 0) {
            const line = data.items && data.items.find((i) => i.key === key);
            if (line && line.quantity < quantity) {
              const fresh = this.querySelector(`[data-dr-item="${CSS.escape(key)}"] [data-dr-error]`);
              if (fresh) fresh.textContent = `Only ${line.quantity} available — we've updated your bag.`;
            }
          }
          this.emit(data);
        } catch (e) {
          this.lineError(item, 'Connection problem. Please try again.');
        } finally {
          this.setBusy(false);
        }
      }

      async addForm(form, submitter) {
        const btn = submitter || form.querySelector('[type="submit"]');
        if (btn) {
          btn.setAttribute('aria-busy', 'true');
          btn.disabled = true;
        }
        try {
          const fd = new FormData(form);
          fd.append('sections', this.sectionId);
          fd.append('sections_url', window.location.pathname);
          const res = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd,
          });
          const data = await res.json();
          if (!res.ok || data.status) {
            this.banner(data.description || data.message || 'This item could not be added.');
            this.open(btn);
            return;
          }
          const addedKey = data.key || (data.items && data.items[0] && data.items[0].key);
          this.render(data.sections && data.sections[this.sectionId], addedKey);
          this.recsLoaded = false;
          const slot = this.querySelector('[data-dr-recs]');
          if (slot) slot.innerHTML = '';
          this.open(btn);
          this.announce('Added to your bag.');
          this.emitFresh();
        } catch (e) {
          // Network trouble: fall back to the normal form post.
          form.setAttribute('data-no-drawer', '');
          form.submit();
        } finally {
          if (btn) {
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          }
        }
      }

      async addRec(button) {
        button.setAttribute('aria-busy', 'true');
        const row = button.closest('.dr-rec');
        try {
          const res = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: json,
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.drAdd), quantity: 1 }],
              sections: [this.sectionId],
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (!res.ok || data.status) {
            this.banner(data.description || data.message || 'This item could not be added.');
            button.removeAttribute('aria-busy');
            return;
          }
          if (row && !reduceMotion.matches) {
            row.classList.add('is-leaving');
            await wait(280);
          }
          if (row) row.remove();
          const addedKey = data.items && data.items[0] && data.items[0].key;
          this.render(data.sections && data.sections[this.sectionId], addedKey);
          this.announce('Added to your bag.');
          this.emitFresh();
        } catch (e) {
          button.removeAttribute('aria-busy');
          this.banner('Connection problem. Please try again.');
        }
      }

      async saveNote(note) {
        try {
          await fetch(`${this.dataset.updateUrl}.js`, {
            method: 'POST',
            headers: json,
            body: JSON.stringify({ note }),
          });
        } catch (e) {
          /* The note still goes with the form at checkout. */
        }
      }

      async refresh() {
        try {
          const root = this.dataset.rootUrl.replace(/\/$/, '');
          const html = await fetch(`${root}/?section_id=${encodeURIComponent(this.sectionId)}`).then((r) =>
            r.ok ? r.text() : ''
          );
          if (html) this.render(html);
          this.stale = false;
        } catch (e) {
          /* keep what we have */
        }
      }

      async emitFresh() {
        try {
          const cart = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }).then(
            (r) => r.json()
          );
          this.emit(cart);
        } catch (e) {
          document.dispatchEvent(new CustomEvent('cart:refresh-count'));
        }
      }

      emit(cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'cart-drawer' } }));
      }

      lineError(item, msg) {
        if (item) {
          const input = item.querySelector('[data-dr-input]');
          if (input) input.value = input.dataset.drValue;
          const err = item.querySelector('[data-dr-error]');
          if (err) err.textContent = msg;
        } else {
          this.banner(msg);
        }
        this.announce(msg);
      }

      banner(msg) {
        const b = this.querySelector('[data-dr-banner]');
        if (!b) return;
        b.textContent = msg;
        b.hidden = false;
        clearTimeout(this.bannerTimer);
        this.bannerTimer = setTimeout(() => (b.hidden = true), 6000);
      }

      setBusy(busy, item) {
        this.classList.toggle('is-busy', busy);
        if (item) item.classList.toggle('is-busy', busy);
        if (!busy) this.querySelectorAll('.dr-item.is-busy').forEach((el) => el.classList.remove('is-busy'));
      }

      announce(msg) {
        if (!this.live) return;
        this.live.textContent = '';
        setTimeout(() => (this.live.textContent = msg), 60);
      }

      /* ---------- Render (Section Rendering API) ---------- */
      render(html, highlightKey) {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-dr-body]');
        const body = this.querySelector('[data-dr-body]');
        if (!next || !body) return;

        const active = document.activeElement;
        const hadFocus = active && body.contains(active);
        const focusId = hadFocus ? active.dataset.drFocus : null;
        const oldFill = body.querySelector('[data-dr-ship-fill]');
        const oldP = oldFill ? getComputedStyle(oldFill).getPropertyValue('--p') : null;
        const oldTotal = ((body.querySelector('.dr-total__value') || {}).textContent || '').trim();
        const oldScroll = body.querySelector('[data-dr-scroll]');
        const scrollTop = oldScroll ? oldScroll.scrollTop : 0;
        const oldRecs = body.querySelector('[data-dr-recs]');
        const keepRecs = oldRecs ? Array.from(oldRecs.childNodes) : [];

        body.replaceWith(next);

        const recsSlot = next.querySelector('[data-dr-recs]');
        if (recsSlot && keepRecs.length) recsSlot.append(...keepRecs);
        if (!next.querySelector('.dr-item')) this.recsLoaded = false;

        const scroller = next.querySelector('[data-dr-scroll]');
        if (scroller) scroller.scrollTop = highlightKey ? 0 : scrollTop;

        const fill = next.querySelector('[data-dr-ship-fill]');
        if (fill && oldP !== null && !reduceMotion.matches) {
          const target = fill.style.getPropertyValue('--p');
          fill.style.transition = 'none';
          fill.style.setProperty('--p', oldP);
          void fill.offsetWidth;
          fill.style.transition = '';
          requestAnimationFrame(() => fill.style.setProperty('--p', target));
        }

        const total = next.querySelector('[data-dr-total]');
        const newTotal = ((next.querySelector('.dr-total__value') || {}).textContent || '').trim();
        if (total && oldTotal && newTotal !== oldTotal && !reduceMotion.matches) total.classList.add('is-fresh');

        if (highlightKey && !reduceMotion.matches) {
          const added = next.querySelector(`[data-dr-item="${CSS.escape(highlightKey)}"]`);
          if (added) added.classList.add('is-new');
        }

        if (hadFocus && this.isOpen) {
          const target =
            (focusId && next.querySelector(`[data-dr-focus="${CSS.escape(focusId)}"]`)) ||
            next.querySelector('[data-dr-title]');
          if (target) target.focus({ preventScroll: true });
        }

        const pid = doc.querySelector('cart-drawer') && doc.querySelector('cart-drawer').dataset.recsProduct;
        if (pid) this.dataset.recsProduct = pid;
        else delete this.dataset.recsProduct;
      }

      /* ---------- Recommendations ---------- */
      async loadRecommendations() {
        if (this.recsLoaded) return;
        const pid = this.dataset.recsProduct;
        const slot = this.querySelector('[data-dr-recs]');
        if (!pid || !slot || !this.dataset.recsUrl) return;
        this.recsLoaded = true;
        try {
          const url = `${this.dataset.recsUrl}?section_id=${encodeURIComponent(
            this.sectionId
          )}&product_id=${encodeURIComponent(pid)}&limit=6&intent=related`;
          const html = await fetch(url).then((r) => (r.ok ? r.text() : ''));
          if (!html) return;
          const tpl = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-dr-recs-source]');
          if (!tpl) return;
          const frag = tpl.content.cloneNode(true);
          frag.querySelectorAll('.dr-rec').forEach((li, i) => {
            if (i >= 3) li.remove();
          });
          const target = this.querySelector('[data-dr-recs]');
          if (target) target.replaceChildren(frag);
        } catch (e) {
          this.recsLoaded = false;
        }
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-page"]) return;
  try {
    
  (() => {
    if (customElements.get('cart-page')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));

    class CartPage extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.sectionId = this.dataset.sectionId;
        this.queue = Promise.resolve();
        this.timers = new Map();
        this.live = this.querySelector('[data-ct-live]');

        if (!reduceMotion.matches && !(window.Shopify && window.Shopify.designMode)) {
          this.classList.add('is-entering');
          setTimeout(() => this.classList.remove('is-entering'), 1400);
        }

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('change', (e) => this.onChange(e), { signal });
        this.addEventListener('keydown', (e) => this.onKeydown(e), { signal });
        this.addEventListener('input', (e) => this.onInput(e), { signal });

        this.bindBar();
        this.loadRecommendations();
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.barIO) this.barIO.disconnect();
        this.timers.forEach((t) => clearTimeout(t));
      }

      /* ---------- Events ---------- */
      onClick(e) {
        const step = e.target.closest('[data-ct-step]');
        if (step) {
          const input = step.closest('[data-ct-qty]').querySelector('[data-ct-input]');
          const inc = parseInt(input.step, 10) || 1;
          const min = parseInt(input.min, 10) || 0;
          const max = input.max ? parseInt(input.max, 10) : Infinity;
          const cur = parseInt(input.value, 10) || 0;
          const next = Math.min(Math.max(cur + inc * parseInt(step.dataset.ctStep, 10), min), max);
          if (next === cur) return;
          input.value = next;
          this.bump(input);
          this.schedule(input, 380);
          return;
        }

        const remove = e.target.closest('[data-ct-remove]');
        if (remove) {
          e.preventDefault();
          this.change(remove.dataset.ctRemove, 0);
          return;
        }

        const add = e.target.closest('[data-ct-add]');
        if (add) {
          e.preventDefault();
          this.add(add);
        }
      }

      onChange(e) {
        if (e.target.matches('[data-ct-input]')) this.schedule(e.target, 0);
        if (e.target.matches('[data-ct-note]')) this.saveNote(e.target.value);
      }

      onInput(e) {
        if (e.target.matches('[data-ct-note]')) {
          clearTimeout(this.noteTimer);
          const value = e.target.value;
          this.noteTimer = setTimeout(() => this.saveNote(value), 700);
        }
      }

      onKeydown(e) {
        // Enter in a quantity field updates the line instead of submitting to checkout.
        if (e.key === 'Enter' && e.target.matches('[data-ct-input]')) {
          e.preventDefault();
          this.schedule(e.target, 0);
        }
      }

      bump(input) {
        if (reduceMotion.matches) return;
        input.classList.remove('is-bump');
        void input.offsetWidth;
        input.classList.add('is-bump');
      }

      schedule(input, delay) {
        const key = input.dataset.ctKey;
        clearTimeout(this.timers.get(key));
        this.timers.set(
          key,
          setTimeout(() => {
            this.timers.delete(key);
            let qty = parseInt(input.value, 10);
            if (Number.isNaN(qty) || qty < 0) qty = parseInt(input.dataset.ctValue, 10) || 0;
            if (String(qty) === input.dataset.ctValue) return;
            this.change(key, qty);
          }, delay)
        );
      }

      /* ---------- Cart API ---------- */
      change(key, quantity) {
        this.queue = this.queue.then(() => this.runChange(key, quantity)).catch(() => {});
        return this.queue;
      }

      async runChange(key, quantity) {
        const item = this.querySelector(`[data-ct-item="${CSS.escape(key)}"]`);
        const error = item && item.querySelector('[data-ct-error]');
        if (error) error.textContent = '';
        this.setBusy(true, item);

        try {
          const res = await fetch(`${this.dataset.changeUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: key,
              quantity,
              sections: [this.sectionId],
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();

          if (!res.ok || data.status) {
            const msg = data.description || data.message || 'Something went wrong. Please try again.';
            this.showLineError(item, msg);
            return;
          }

          if (quantity === 0 && item && !reduceMotion.matches) {
            item.classList.add('is-leaving');
            await wait(300);
          }

          this.render(data.sections && data.sections[this.sectionId]);
          this.announce(quantity === 0 ? 'Item removed from your bag.' : 'Your bag has been updated.');

          // Quantity capped by stock: tell the shopper on that line.
          if (quantity > 0) {
            const line = data.items && data.items.find((i) => i.key === key);
            if (line && line.quantity < quantity) {
              const fresh = this.querySelector(`[data-ct-item="${CSS.escape(key)}"] [data-ct-error]`);
              if (fresh) fresh.textContent = `Only ${line.quantity} available — we've updated your bag.`;
            }
          }

          this.emit(data);
        } catch (err) {
          this.showLineError(item, 'Connection problem. Please try again.');
        } finally {
          this.setBusy(false);
        }
      }

      showLineError(item, msg) {
        if (item) {
          const input = item.querySelector('[data-ct-input]');
          if (input) input.value = input.dataset.ctValue;
          const error = item.querySelector('[data-ct-error]');
          if (error) error.textContent = msg;
        } else {
          const general = this.querySelector('[data-ct-general-error]');
          if (general) {
            general.textContent = msg;
            general.hidden = false;
          }
        }
        this.announce(msg);
      }

      setBusy(busy, item) {
        this.classList.toggle('is-busy', busy);
        this.setAttribute('aria-busy', String(busy));
        if (item) item.classList.toggle('is-busy', busy);
        if (!busy) this.querySelectorAll('.ct-item.is-busy').forEach((el) => el.classList.remove('is-busy'));
      }

      async saveNote(note) {
        try {
          await fetch(`${this.dataset.updateUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note }),
          });
        } catch (e) {
          /* The note is still sent with the form on checkout. */
        }
      }

      async add(button) {
        button.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.ctAdd), quantity: 1 }],
              sections: [this.sectionId],
              sections_url: window.location.pathname,
            }),
          });
          const data = await res.json();
          if (!res.ok || data.status) {
            this.showLineError(null, data.description || data.message || 'Could not add this item.');
            button.removeAttribute('aria-busy');
            return;
          }
          const pick = button.closest('.ct-pick');
          if (pick && !reduceMotion.matches) {
            pick.style.transition = 'opacity .3s ease, transform .4s cubic-bezier(.22,1,.36,1)';
            pick.style.opacity = '0';
            pick.style.transform = 'translate3d(0,-10px,0)';
          }
          this.render(data.sections && data.sections[this.sectionId]);
          this.announce('Added to your bag.');
          const cart = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }).then(
            (r) => r.json()
          );
          this.emit(cart);
          if (pick) pick.remove();
          this.pruneRecs();
        } catch (e) {
          button.removeAttribute('aria-busy');
          this.showLineError(null, 'Connection problem. Please try again.');
        }
      }

      emit(cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'cart-page' } }));
      }

      announce(msg) {
        if (!this.live) return;
        this.live.textContent = '';
        setTimeout(() => (this.live.textContent = msg), 60);
      }

      /* ---------- Render (Section Rendering API) ---------- */
      render(html) {
        if (!html) {
          window.location.reload();
          return;
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-ct-body]');
        const body = this.querySelector('[data-ct-body]');
        if (!next || !body) return;

        const active = document.activeElement;
        const focusId = active && this.contains(active) ? active.dataset.ctFocus : null;
        const hadFocus = active && this.contains(active);
        const oldFill = body.querySelector('[data-ct-ship-fill]');
        const oldP = oldFill ? getComputedStyle(oldFill).getPropertyValue('--p') : null;
        const oldTotal = (body.querySelector('.ct-total__value') || {}).textContent;

        body.replaceWith(next);

        // Free shipping line grows from where it was.
        const fill = next.querySelector('[data-ct-ship-fill]');
        if (fill && oldP !== null && !reduceMotion.matches) {
          const target = fill.style.getPropertyValue('--p');
          fill.style.transition = 'none';
          fill.style.setProperty('--p', oldP);
          void fill.offsetWidth;
          fill.style.transition = '';
          requestAnimationFrame(() => fill.style.setProperty('--p', target));
        }

        const total = next.querySelector('[data-ct-total]');
        if (total && oldTotal !== undefined && total.textContent.indexOf(oldTotal.trim()) === -1)
          total.classList.add('is-fresh');

        if (hadFocus) {
          const target =
            (focusId && next.querySelector(`[data-ct-focus="${CSS.escape(focusId)}"]`)) ||
            next.querySelector('[data-ct-title]');
          if (target) target.focus({ preventScroll: true });
        }

        if (!next.querySelector('.ct-item')) {
          const recs = this.querySelector('[data-ct-recs]');
          if (recs) recs.innerHTML = '';
        }

        this.bindBar();
      }

      pruneRecs() {
        const recs = this.querySelector('[data-ct-recs-source]');
        if (recs && !recs.querySelector('.ct-pick')) recs.remove();
      }

      /* ---------- Mobile checkout bar ---------- */
      bindBar() {
        if (this.barIO) this.barIO.disconnect();
        const bar = this.querySelector('[data-ct-bar]');
        const receipt = this.querySelector('[data-ct-checkout]');
        const items = this.querySelector('.ct-items');
        if (!bar || !receipt || !('IntersectionObserver' in window)) return;
        const btn = bar.querySelector('button');
        let receiptSeen = false;
        let itemsSeen = false;
        const set = () => {
          const show = itemsSeen && !receiptSeen;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', String(!show));
          if (btn) btn.tabIndex = show ? 0 : -1;
        };
        this.barIO = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === receipt) receiptSeen = entry.isIntersecting;
            else itemsSeen = entry.isIntersecting;
          });
          set();
        });
        this.barIO.observe(receipt);
        if (items) this.barIO.observe(items);
      }

      /* ---------- Recommendations ---------- */
      async loadRecommendations() {
        const pid = this.dataset.recsProduct;
        const slot = this.querySelector('[data-ct-recs]');
        if (!pid || !slot || slot.children.length || !this.dataset.recsUrl) return;

        const load = async () => {
          try {
            const url = `${this.dataset.recsUrl}?section_id=${encodeURIComponent(
              this.sectionId
            )}&product_id=${encodeURIComponent(pid)}&limit=6&intent=related`;
            const html = await fetch(url).then((r) => (r.ok ? r.text() : ''));
            if (!html) return;
            const src = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ct-recs-source]');
            if (!src) return;
            const picks = src.querySelectorAll('.ct-pick');
            picks.forEach((p, i) => {
              if (i >= 4) p.remove();
            });
            slot.replaceChildren(src);
          } catch (e) {
            /* Recommendations are optional. */
          }
        };

        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              io.disconnect();
              load();
            },
            { rootMargin: '400px 0px' }
          );
          io.observe(slot);
        } else {
          load();
        }
      }
    }

    customElements.define('cart-page', CartPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('collapsible-content')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wide = window.matchMedia('(min-width: 990px)');

    class CollapsibleContent extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.items = Array.from(this.querySelectorAll('[data-cc-item]'));
        this.exclusive = this.hasAttribute('data-one');
        this.timers = new Map();
        this.classList.add('is-js');

        this.items.forEach((d) => {
          // Exclusivity is handled here so the closing one can fade out too
          d.removeAttribute('name');
          if (d.open) d.classList.add('is-shown');
          d.querySelector('summary').addEventListener(
            'click',
            (e) => {
              e.preventDefault();
              if (d.open && !d.classList.contains('is-closing')) this.close(d);
              else this.open(d);
            },
            { signal }
          );
          // Opened some other way (find in page, the editor, a link)
          d.addEventListener(
            'toggle',
            () => {
              if (d.open) {
                if (d.classList.contains('is-closing')) return;
                if (this.exclusive) this.closeOthers(d);
                if (!d.classList.contains('is-shown')) this.show(d);
              } else {
                clearTimeout(this.timers.get(d));
                d.classList.remove('is-shown', 'is-closing');
              }
            },
            { signal }
          );
        });

        document.addEventListener(
          'shopify:block:select',
          (e) => {
            const d = e.target instanceof Element ? e.target.closest('[data-cc-item]') : null;
            if (d && this.contains(d)) this.open(d);
          },
          { signal }
        );
        window.addEventListener('hashchange', () => this.fromHash(), { signal });
        this.fromHash();

        this.side = this.querySelector('[data-cc-side]');
        if (this.side && this.classList.contains('cc--split')) {
          this.stick = () => this.sticky();
          window.addEventListener('resize', this.stick, { signal });
          wide.addEventListener('change', this.stick, { signal });
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.stick);
            this.ro.observe(this.side);
          }
          this.sticky();
        }

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        const rise = Array.from(this.querySelectorAll('[data-cc-rise]'));
        if (!rise.length) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => {
              this.io.unobserve(el);
              const delay = Math.min(n, 6) * 70;
              el.style.setProperty('--d', delay + 'ms');
              el.classList.add('is-in');
              this.later(() => el.classList.add('is-settled'), 1300 + delay);
            });
          },
          { rootMargin: '0px 0px -6% 0px' }
        );
        rise.forEach((el) => this.io.observe(el));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.pending.delete(id);
          fn();
        }, ms);
        (this.pending = this.pending || new Set()).add(id);
        return id;
      }

      open(d) {
        clearTimeout(this.timers.get(d));
        d.classList.remove('is-closing');
        if (this.exclusive) this.closeOthers(d);
        if (!d.open) d.open = true;
        this.show(d);
      }

      show(d) {
        // Two frames: the hidden state has to be painted once before it can fade in
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            if (d.open && !d.classList.contains('is-closing')) d.classList.add('is-shown');
          })
        );
      }

      close(d) {
        clearTimeout(this.timers.get(d));
        d.classList.remove('is-shown');
        d.classList.add('is-closing');
        this.timers.set(
          d,
          setTimeout(
            () => {
              d.open = false;
              d.classList.remove('is-closing');
            },
            reduceMotion.matches ? 0 : 240
          )
        );
      }

      closeOthers(d) {
        this.items.forEach((o) => {
          if (o !== d && o.open && !o.classList.contains('is-closing')) this.close(o);
        });
      }

      fromHash() {
        if (!location.hash) return;
        let id = '';
        try {
          id = decodeURIComponent(location.hash.slice(1));
        } catch (err) {
          return;
        }
        const d = this.items.find((x) => x.id === id);
        if (d && !d.open) this.open(d);
      }

      // The heading column follows the questions only when it fits on screen
      sticky() {
        const header = document.querySelector('[data-sticky]:not([data-sticky="none"])');
        const offset = header ? Math.round(header.getBoundingClientRect().height) : 0;
        this.style.setProperty('--cc-offset', offset + 'px');
        const fits = this.side.offsetHeight + offset + 64 < window.innerHeight;
        this.classList.toggle('is-stick', wide.matches && fits);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        if (this.pending) this.pending.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('collapsible-content', CollapsibleContent);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"]) return;
  try {
    
  (() => {
    if (customElements.get('collection-grid')) return;

    // Theme settings › Animations › off counts as "reduce" too (same object shape for .matches)
    const reduceMotion = window.matchMedia(
      document.documentElement.dataset.motion === 'none' ? 'all' : '(prefers-reduced-motion: reduce)'
    );
    const subtleMotion = () => document.documentElement.dataset.motion === 'subtle';
    // Theme settings › Animations › speed (slow 1.3, normal 1, fast 0.75) for timings set in script
    const motionSpeed = () =>
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--motion-speed')) || 1;
    const sheetQuery = window.matchMedia('(max-width: 989px)');
    const store = {
      get(key) {
        try {
          return window.localStorage.getItem(key);
        } catch (e) {
          return null;
        }
      },
      set(key, value) {
        try {
          window.localStorage.setItem(key, value);
        } catch (e) {
          /* private mode: fine, it just won't be remembered */
        }
      },
    };
    const plainClick = (e) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

    class CollectionGrid extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
        if (this.loadCtrl) this.loadCtrl.abort();
        if (this.io) this.io.disconnect();
        if (this.stuckIo) this.stuckIo.disconnect();
        clearTimeout(this.priceTimer);
        clearTimeout(this.settleTimer);
        document.documentElement.classList.remove('cg-lock');
        this.ctrl = null;
        this.io = null;
      }

      setup() {
        if (this.ctrl || !this.isConnected) return;
        this.ctrl = new AbortController();
        const signal = this.ctrl.signal;
        this.sectionId = this.dataset.sectionId;
        this.cache = new Map();
        this.sheetOpen = false;
        this.classList.add('is-js');
        this.querySelectorAll('[data-cg-filter-toggle], [data-cg-density]').forEach((el) => (el.hidden = false));

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('change', (e) => this.onChange(e), { signal });
        this.addEventListener('input', (e) => this.onInput(e), { signal });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });
        this.addEventListener('keydown', (e) => this.onKeydown(e), { signal });
        this.addEventListener('pointerover', (e) => this.onPointerOver(e), { signal });
        this.addEventListener('pointerout', (e) => this.onPointerOut(e), { signal });
        this.addEventListener(
          'animationend',
          (e) => {
            if (e.target.classList && e.target.classList.contains('cg-tag')) e.target.classList.remove('is-swing');
          },
          { signal }
        );
        document.addEventListener(
          'pointerdown',
          (e) => {
            if (this.quickCard && !this.quickCard.contains(e.target)) this.closeQuick(false);
          },
          { signal }
        );
        // Once something lands in the cart, put the option picker away.
        document.addEventListener(
          'cart:updated',
          (e) => {
            if (!this.quickCard) return;
            if (e.detail && e.detail.source === 'collection-grid') {
              const card = this.quickCard;
              setTimeout(() => this.quickCard === card && this.closeQuick(true), 1200);
            } else {
              this.closeQuick(false);
            }
          },
          { signal }
        );
        window.addEventListener(
          'popstate',
          (e) => {
            if (e.state && e.state.cg === this.sectionId) this.load(window.location.href, { push: false });
          },
          { signal }
        );
        window.addEventListener('resize', () => this.setOffset(), { signal });
        sheetQuery.addEventListener('change', () => this.layoutFilters(), { signal });
        if (this.hasAttribute('data-swipe')) this.initSwipe(signal);

        this.setOffset();
        this.layoutFilters();
        this.initDensity();
        this.refresh();
        this.reveal(true);
        history.replaceState(Object.assign({}, history.state, { cg: this.sectionId }), '');
      }

      /* Everything that has to be set up again when parts of the page are swapped. */
      refresh() {
        this.querySelectorAll('[data-cg-open]').forEach((a) => {
          a.setAttribute('role', 'button');
          a.setAttribute('aria-expanded', 'false');
        });
        this.querySelectorAll('[data-cg-price]').forEach((box) => {
          const range = box.querySelector('[data-cg-range]');
          if (range) range.hidden = false;
          this.paintRange(box);
        });
        this.querySelectorAll('[data-cg-more-values]').forEach((el) => (el.hidden = false));
        this.applyDensity();
      }

      // The sticky header covers the top of the page; the toolbar sticks just below it.
      setOffset() {
        const header = document.querySelector('[data-sticky]:not([data-sticky="none"])');
        const h = header ? Math.round(header.getBoundingClientRect().height) : 0;
        if (h === this.offset) return;
        this.offset = h;
        this.style.setProperty('--cg-offset', h + 'px');
        this.watchStuck();
      }

      watchStuck() {
        const bar = this.querySelector('[data-cg-bar]');
        const mark = this.querySelector('[data-cg-sentinel]');
        if (!bar || !mark || !this.classList.contains('cg--sticky') || !('IntersectionObserver' in window)) return;
        if (this.stuckIo) this.stuckIo.disconnect();
        const off = this.offset || 0;
        this.stuckIo = new IntersectionObserver(
          ([entry]) =>
            bar.classList.toggle('is-stuck', !entry.isIntersecting && entry.boundingClientRect.top < off + 2),
          { rootMargin: '-' + (off + 1) + 'px 0px 0px 0px' }
        );
        this.stuckIo.observe(mark);
      }

      /* ---------- events ---------- */

      onClick(e) {
        const t = e.target;
        if (t.closest('[data-cg-filter-toggle]')) return this.toggleFilters();
        if (t.closest('[data-cg-close]')) return this.closeSheet(true);
        const open = t.closest('[data-cg-open]');
        if (open) {
          if (!plainClick(e)) return;
          e.preventDefault();
          return this.toggleQuick(open);
        }
        if (t.closest('[data-cg-close-quick]')) return this.closeQuick(true);
        const sw = t.closest('[data-cg-sw]');
        if (sw) return this.pickSwatch(sw);
        const dens = t.closest('[data-cg-density] button');
        if (dens) return this.setDensity(dens);
        const moreValues = t.closest('[data-cg-more-values]');
        if (moreValues) return this.toggleValues(moreValues);
        const more = t.closest('[data-cg-more]');
        if (more && plainClick(e)) {
          e.preventDefault();
          return this.loadMore(more);
        }
        const link = t.closest('a[data-cg-link]');
        if (link && plainClick(e)) {
          e.preventDefault();
          this.load(link.href, { scroll: true });
        }
      }

      onChange(e) {
        const t = e.target;
        if (t.matches('[data-cg-sort]')) {
          this.submitFilters();
          return;
        }
        // A thumb was let go (or nudged with the keyboard): wait a beat in case it keeps moving.
        if (t.matches('[data-cg-lo], [data-cg-hi]')) {
          clearTimeout(this.priceTimer);
          this.priceTimer = setTimeout(() => this.submitFilters(), 450);
          return;
        }
        if (t.form && t.form.hasAttribute('data-cg-form') && t.type === 'checkbox') this.submitFilters();
      }

      onInput(e) {
        const t = e.target;
        const box = t.closest('[data-cg-price]');
        if (!box) return;
        if (t.matches('[data-cg-lo], [data-cg-hi]')) {
          this.fromRange(box, t);
          return;
        }
        if (t.matches('[data-cg-min], [data-cg-max]')) {
          this.fromFields(box);
          clearTimeout(this.priceTimer);
          this.priceTimer = setTimeout(() => this.submitFilters(), 800);
        }
      }

      onSubmit(e) {
        const form = e.target;
        if (form.hasAttribute('data-cg-form')) {
          e.preventDefault();
          clearTimeout(this.priceTimer);
          this.submitFilters();
          return;
        }
        if (form.hasAttribute('data-cg-add')) this.addToCart(e, form);
      }

      onKeydown(e) {
        if (this.sheetOpen) {
          if (e.key === 'Escape') {
            e.preventDefault();
            this.closeSheet(true);
          } else if (e.key === 'Tab') {
            this.trap(e, this.querySelector('[data-cg-panel]'));
          }
          return;
        }
        if (e.key === 'Escape' && this.quickCard) {
          e.preventDefault();
          this.closeQuick(true);
        }
      }

      onPointerOver(e) {
        if (e.pointerType !== 'mouse') return;
        const sw = e.target.closest('[data-cg-sw]');
        if (sw) {
          const card = sw.closest('[data-cg-card]');
          if (sw.dataset.src) this.showImage(card, sw.dataset.src, sw.dataset.srcset);
          return;
        }
        const card = e.target.closest('[data-cg-card]');
        if (card && !(e.relatedTarget && card.contains(e.relatedTarget))) this.swing(card);
      }

      onPointerOut(e) {
        if (e.pointerType !== 'mouse') return;
        const list = e.target.closest('.cg-swatches');
        if (!list || (e.relatedTarget && list.contains(e.relatedTarget))) return;
        this.restoreImage(list.closest('[data-cg-card]'));
      }

      /* ---------- the hang tag ---------- */

      // Decorative, so it stays still on subtle motion as well as when motion is off.
      swing(card) {
        if (reduceMotion.matches || subtleMotion() || !this.classList.contains('cg--tag')) return;
        const tag = card.querySelector('.cg-tag');
        if (tag && !tag.classList.contains('is-swing')) tag.classList.add('is-swing');
      }

      /* ---------- color dots ---------- */

      pickSwatch(sw) {
        const card = sw.closest('[data-cg-card]');
        card
          .querySelectorAll('[data-cg-sw]')
          .forEach((el) => el.setAttribute('aria-pressed', el === sw ? 'true' : 'false'));
        const link = card.querySelector('.cg-card__link');
        if (link && sw.dataset.url) link.href = sw.dataset.url;
        if (sw.dataset.src) {
          card.dataset.pickSrc = sw.dataset.src;
          card.dataset.pickSet = sw.dataset.srcset || '';
          card.classList.add('is-picked');
          this.showImage(card, sw.dataset.src, sw.dataset.srcset);
        }
      }

      restoreImage(card) {
        const img = card && card.querySelector('.cg-card__img:not(.cg-card__img--2)');
        if (!img || !img.dataset.origSrc) return;
        if (card.dataset.pickSrc) this.showImage(card, card.dataset.pickSrc, card.dataset.pickSet);
        else this.showImage(card, img.dataset.origSrc, img.dataset.origSet);
      }

      showImage(card, src, srcset) {
        const img = card.querySelector('.cg-card__img:not(.cg-card__img--2)');
        if (!img || img.tagName !== 'IMG') return;
        if (!img.dataset.origSrc) {
          img.dataset.origSrc = img.getAttribute('src');
          img.dataset.origSet = img.getAttribute('srcset') || '';
          img.dataset.showing = img.dataset.origSrc;
        }
        if (img.dataset.showing === src) return;
        img.dataset.showing = src;
        const apply = () => {
          if (img.dataset.showing !== src) return;
          if (srcset) img.srcset = srcset;
          else img.removeAttribute('srcset');
          img.src = src;
          img.classList.remove('is-swap');
        };
        const pre = new Image();
        pre.sizes = img.sizes;
        if (srcset) pre.srcset = srcset;
        pre.src = src;
        if (pre.complete) {
          apply();
        } else {
          img.classList.add('is-swap');
          pre.onload = pre.onerror = apply;
        }
      }

      /* ---------- products per row ---------- */

      initDensity() {
        const d = store.get('cg-cols-d');
        const m = store.get('cg-cols-m');
        this.cols = {
          d: ['2', '3', '4'].includes(d) ? d : this.dataset.colsD,
          m: ['1', '2'].includes(m) ? m : this.dataset.colsM,
        };
      }

      applyDensity() {
        if (!this.cols) return;
        ['d2', 'd3', 'd4', 'm1', 'm2'].forEach((c) => this.classList.remove('cg--' + c));
        this.classList.add('cg--d' + this.cols.d, 'cg--m' + this.cols.m);
        this.querySelectorAll('[data-cg-density] button').forEach((el) =>
          el.setAttribute('aria-pressed', String(el.dataset.cols === this.cols[el.dataset.kind]))
        );
        const layout = this.querySelector('[data-cg-layout]');
        const avail = layout && layout.classList.contains('is-collapsed') ? '(100vw - 5rem)' : this.dataset.avail;
        const sizes =
          '(min-width: 990px) calc(' +
          avail +
          ' / ' +
          this.cols.d +
          '), (min-width: 750px) calc((100vw - 5rem) / ' +
          this.dataset.colsT +
          '), calc((100vw - 2.5rem) / ' +
          this.cols.m +
          ')';
        this.querySelectorAll('img.cg-card__img').forEach((img) => {
          if (img.getAttribute('sizes') !== sizes) img.setAttribute('sizes', sizes);
        });
      }

      setDensity(btn) {
        const kind = btn.dataset.kind;
        const n = btn.dataset.cols;
        if (!this.cols || this.cols[kind] === n) return;
        this.cols[kind] = n;
        store.set('cg-cols-' + kind, n);
        this.regrid(() => this.applyDensity());
      }

      // Change the grid behind a quick fade, so cards never jump in plain sight.
      regrid(change) {
        const grid = this.querySelector('[data-cg-grid]');
        if (!grid || reduceMotion.matches || !grid.animate) {
          change();
          return;
        }
        const speed = motionSpeed();
        const out = grid.animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: Math.round(140 * speed),
          easing: 'ease-out',
          fill: 'forwards',
        });
        out.onfinish = () => {
          change();
          grid.animate(
            [
              { opacity: 0, transform: subtleMotion() ? 'none' : 'translate3d(0, 8px, 0)' },
              { opacity: 1, transform: 'none' },
            ],
            { duration: Math.round(380 * speed), easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
          out.cancel();
        };
      }

      /* ---------- filters ---------- */

      layoutFilters() {
        const box = this.querySelector('[data-cg-filters]');
        if (!box) return;
        const sheet = this.classList.contains('cg--drawer') || sheetQuery.matches;
        if (!sheet && this.sheetOpen) this.closeSheet(false);
        box.classList.toggle('is-sheet', sheet);
        const panel = box.querySelector('[data-cg-panel]');
        const toggle = this.querySelector('[data-cg-filter-toggle]');
        if (sheet) {
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          if (!this.sheetOpen) box.setAttribute('inert', '');
          if (toggle) toggle.setAttribute('aria-expanded', String(this.sheetOpen));
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-modal');
          box.removeAttribute('inert');
          const layout = this.querySelector('[data-cg-layout]');
          if (toggle) toggle.setAttribute('aria-expanded', String(!layout.classList.contains('is-collapsed')));
        }
      }

      toggleFilters() {
        const box = this.querySelector('[data-cg-filters]');
        if (!box) return;
        if (box.classList.contains('is-sheet')) {
          this.openSheet();
          return;
        }
        // Sidebar: tuck it away to give the products the full width, or bring it back.
        const layout = this.querySelector('[data-cg-layout]');
        this.regrid(() => {
          layout.classList.toggle('is-collapsed');
          this.layoutFilters();
          this.applyDensity();
        });
      }

      openSheet() {
        const box = this.querySelector('[data-cg-filters]');
        if (!box || !box.classList.contains('is-sheet')) return;
        this.sheetOpen = true;
        this.opener = document.activeElement;
        box.removeAttribute('inert');
        box.classList.add('is-open');
        this.settle(box);
        document.documentElement.classList.add('cg-lock');
        const toggle = this.querySelector('[data-cg-filter-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        const close = box.querySelector('.cg-filters__close');
        requestAnimationFrame(() => close && close.focus({ preventScroll: true }));
      }

      // The page behind gets its blur once the sheet has finished moving in.
      settle(box) {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(
          () => {
            if (this.sheetOpen) box.classList.add('is-settled');
          },
          reduceMotion.matches ? 0 : Math.round(420 * motionSpeed())
        );
      }

      closeSheet(returnFocus) {
        const box = this.querySelector('[data-cg-filters]');
        if (!box || !this.sheetOpen) return;
        this.sheetOpen = false;
        clearTimeout(this.settleTimer);
        box.classList.remove('is-open', 'is-settled', 'is-dragging');
        document.documentElement.classList.remove('cg-lock');
        const toggle = this.querySelector('[data-cg-filter-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (box.classList.contains('is-sheet')) box.setAttribute('inert', '');
        if (returnFocus) (toggle || this.opener || this).focus({ preventScroll: true });
      }

      /* Swipe the open sheet away (Theme settings › Drawers › swipe to close): down on phones,
         to the left for the side drawer. The panel follows the finger by transform only. */
      initSwipe(signal) {
        const box = this.querySelector('[data-cg-filters]');
        const panel = box && box.querySelector('[data-cg-panel]');
        if (!panel) return;
        const scrim = box.querySelector('.cg-filters__scrim');
        let startX = 0;
        let startY = 0;
        let startT = 0;
        let axis = null;
        let offset = 0;
        let frame = 0;
        let down = true;

        const size = () => (down ? panel.offsetHeight : panel.offsetWidth) || 1;
        const paint = () => {
          frame = 0;
          panel.style.transform = down ? `translate3d(0, ${offset}px, 0)` : `translate3d(${-offset}px, 0, 0)`;
          if (scrim) scrim.style.opacity = (1 - Math.min(offset / size(), 1)).toFixed(3);
        };

        panel.addEventListener(
          'touchstart',
          (e) => {
            axis = 'none';
            if (!this.sheetOpen || e.touches.length !== 1 || e.target.closest('input[type="range"]')) return;
            down = sheetQuery.matches;
            // Pulling the sheet down starts only from the top of the list, so the list still scrolls.
            const list = panel.querySelector('.cg-facets');
            if (down && list && list.contains(e.target) && list.scrollTop > 0) return;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            startT = e.timeStamp;
            axis = null;
            offset = 0;
          },
          { passive: true, signal }
        );

        panel.addEventListener(
          'touchmove',
          (e) => {
            if (axis === 'none' || !this.sheetOpen || e.touches.length !== 1) return;
            const dx = e.touches[0].clientX - startX;
            const dy = e.touches[0].clientY - startY;
            if (axis === null) {
              if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
              const along = down ? dy > 0 && dy > Math.abs(dx) * 1.2 : dx < 0 && -dx > Math.abs(dy) * 1.2;
              axis = along ? 'drag' : 'none';
              if (axis !== 'drag') return;
              clearTimeout(this.settleTimer);
              box.classList.remove('is-settled');
              box.classList.add('is-dragging');
            }
            offset = Math.max(0, down ? dy : -dx);
            if (!frame) frame = requestAnimationFrame(paint);
          },
          { passive: true, signal }
        );

        const end = (e) => {
          const dragged = axis === 'drag';
          axis = null;
          if (!dragged) return;
          if (frame) cancelAnimationFrame(frame);
          frame = 0;
          const flick = offset > 40 && e.timeStamp - startT < 250;
          const shut = e.type === 'touchend' && (flick || offset > size() * 0.28);
          box.classList.remove('is-dragging');
          panel.style.transform = '';
          if (scrim) scrim.style.opacity = '';
          if (shut) this.closeSheet(true);
          else if (this.sheetOpen) this.settle(box);
        };
        panel.addEventListener('touchend', end, { passive: true, signal });
        panel.addEventListener('touchcancel', end, { passive: true, signal });
      }

      trap(e, root) {
        if (!root) return;
        const items = Array.from(
          root.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, summary, [tabindex]:not([tabindex="-1"])'
          )
        ).filter((el) => el.offsetParent !== null);
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      toggleValues(btn) {
        const facet = btn.closest('.cg-facet');
        if (!btn.dataset.more) btn.dataset.more = btn.textContent;
        const all = facet.classList.toggle('is-all');
        btn.textContent = all ? btn.dataset.less : btn.dataset.more;
      }

      /* Price: the two thumbs and the two fields always agree. */
      paintRange(box) {
        const range = box.querySelector('[data-cg-range]');
        if (!range) return;
        const max = Number(box.dataset.max) || 1;
        const lo = box.querySelector('[data-cg-lo]');
        const hi = box.querySelector('[data-cg-hi]');
        const a = Number(lo.value);
        const b = Number(hi.value);
        range.style.setProperty('--lo', ((a / max) * 100).toFixed(2));
        range.style.setProperty('--hi', ((b / max) * 100).toFixed(2));
        // When both thumbs meet near the top, the lower one has to be the one you can grab.
        lo.classList.toggle('is-top', a > max / 2);
      }

      fromRange(box, moved) {
        const max = Number(box.dataset.max) || 1;
        const lo = box.querySelector('[data-cg-lo]');
        const hi = box.querySelector('[data-cg-hi]');
        let a = Number(lo.value);
        let b = Number(hi.value);
        if (a > b) {
          if (moved === lo) {
            a = b;
            lo.value = String(a);
          } else {
            b = a;
            hi.value = String(b);
          }
        }
        box.querySelector('[data-cg-min]').value = a <= 0 ? '' : String(a);
        box.querySelector('[data-cg-max]').value = b >= max ? '' : String(b);
        this.paintRange(box);
      }

      fromFields(box) {
        const max = Number(box.dataset.max) || 1;
        const lo = box.querySelector('[data-cg-lo]');
        const hi = box.querySelector('[data-cg-hi]');
        const minVal = parseFloat(box.querySelector('[data-cg-min]').value);
        const maxVal = parseFloat(box.querySelector('[data-cg-max]').value);
        lo.value = String(Number.isFinite(minVal) ? Math.max(0, Math.min(max, Math.floor(minVal))) : 0);
        hi.value = String(Number.isFinite(maxVal) ? Math.max(0, Math.min(max, Math.ceil(maxVal))) : max);
        this.paintRange(box);
      }

      /* ---------- Section Rendering API ---------- */

      submitFilters() {
        const form = this.querySelector('[data-cg-form]');
        const params = new URLSearchParams();
        const data = form ? new FormData(form) : new FormData();
        const sort = this.querySelector('[data-cg-sort]');
        if (sort) data.set('sort_by', sort.value);
        for (const [key, value] of data.entries()) {
          if (typeof value === 'string' && value.trim() !== '') params.append(key, value);
        }
        const qs = params.toString();
        this.load(this.dataset.url + (qs ? '?' + qs : ''), {});
      }

      sectionUrl(url) {
        const u = new URL(url, window.location.origin);
        u.searchParams.set('section_id', this.sectionId);
        return u.toString();
      }

      async fetchHtml(url, signal) {
        const key = this.sectionUrl(url);
        if (this.cache.has(key)) return this.cache.get(key);
        const html = await fetch(key, { signal }).then((r) => {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        });
        this.cache.set(key, html);
        return html;
      }

      async load(url, { push = true, scroll = false } = {}) {
        if (this.loadCtrl) this.loadCtrl.abort();
        this.loadCtrl = new AbortController();
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        try {
          const html = await this.fetchHtml(url, this.loadCtrl.signal);
          const doc = new DOMParser().parseFromString(html, 'text/html');
          this.swap(doc);
          if (push) {
            const clean = new URL(url, window.location.origin);
            clean.searchParams.delete('section_id');
            history.pushState({ cg: this.sectionId }, '', clean.pathname + clean.search);
          }
          if (scroll) {
            const top = this.querySelector('[data-cg-sentinel]') || this;
            const y = top.getBoundingClientRect().top + window.scrollY - (this.offset || 0);
            if (window.scrollY > y) window.scrollTo({ top: y, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          }
        } catch (err) {
          if (err.name === 'AbortError') return;
          window.location.href = url; // fall back to a normal page load
        } finally {
          this.classList.remove('is-loading');
          this.removeAttribute('aria-busy');
        }
      }

      swap(doc) {
        this.closeQuick(false);
        const active = document.activeElement;
        const hadFocus = active && this.contains(active);
        const focusId = hadFocus ? active.id : null;
        const open = new Set(Array.from(this.querySelectorAll('.cg-facet[open]')).map((d) => d.dataset.cgFacet));
        const closed = new Set(
          Array.from(this.querySelectorAll('.cg-facet:not([open])')).map((d) => d.dataset.cgFacet)
        );
        const all = new Set(Array.from(this.querySelectorAll('.cg-facet.is-all')).map((d) => d.dataset.cgFacet));
        const scroller =
          this.querySelector('.cg-filters.is-sheet .cg-facets') || this.querySelector('.cg-filters__panel');
        const scrollTop = scroller ? scroller.scrollTop : 0;

        ['[data-cg-form]', '[data-cg-active]', '[data-cg-results]', '[data-cg-count]'].forEach((sel) => {
          const next = doc.querySelector(sel);
          const cur = this.querySelector(sel);
          if (next && cur) cur.innerHTML = next.innerHTML;
        });
        ['[data-cg-filter-count]', '[data-cg-show]'].forEach((sel) => {
          const next = doc.querySelector(sel);
          const cur = this.querySelector(sel);
          if (next && cur) {
            cur.innerHTML = next.innerHTML;
            cur.className = next.className;
          }
        });
        const sort = doc.querySelector('[data-cg-sort]');
        const curSort = this.querySelector('[data-cg-sort]');
        if (sort && curSort) curSort.value = sort.value;

        this.querySelectorAll('.cg-facet').forEach((d) => {
          if (open.has(d.dataset.cgFacet)) d.open = true;
          else if (closed.has(d.dataset.cgFacet) && !d.querySelector('input:checked')) d.open = false;
          if (all.has(d.dataset.cgFacet)) {
            const btn = d.querySelector('[data-cg-more-values]');
            if (btn) this.toggleValues(btn);
          }
        });
        const box = this.querySelector('.cg-filters.is-sheet .cg-facets') || this.querySelector('.cg-filters__panel');
        if (box) box.scrollTop = scrollTop;

        this.refresh();

        if (hadFocus) {
          const el = focusId && document.getElementById(focusId);
          if (el) el.focus({ preventScroll: true });
          else if (!this.contains(document.activeElement) || document.activeElement === document.body) {
            // What had focus (a removed chip, say) is gone: land on the new result count.
            const count = this.querySelector('[data-cg-count]');
            if (count) count.focus({ preventScroll: true });
          }
        }
        this.reveal(false);
      }

      async loadMore(btn) {
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        try {
          const html = await this.fetchHtml(btn.href);
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = this.querySelector('[data-cg-grid]');
          const fresh = Array.from(doc.querySelectorAll('[data-cg-grid] > [data-cg-item]'));
          fresh.forEach((item) => grid.append(item));
          const pager = doc.querySelector('[data-cg-pager]');
          const cur = this.querySelector('[data-cg-pager]');
          if (cur && pager) cur.innerHTML = pager.innerHTML;
          else if (cur) cur.remove();
          this.refresh();
          this.reveal(false);
          // Keep keyboard users where the new products start.
          const link = fresh[0] && fresh[0].querySelector('.cg-card__link');
          if (link) link.focus({ preventScroll: true });
          this.say(fresh.length + ' more products loaded.');
        } catch (err) {
          window.location.href = btn.href;
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      /* Cards ease in as they arrive. Ones already on screen at load stay put. */
      reveal(initial) {
        // Theme settings › Animations › reveal on scroll off (or motion off): cards are simply there.
        const off = document.documentElement.dataset.reveal === 'none';
        if (off || reduceMotion.matches || !('IntersectionObserver' in window)) return;
        const items = Array.from(this.querySelectorAll('[data-cg-item]:not(.is-in)'));
        if (!items.length) return;
        if (initial) {
          const h = window.innerHeight;
          items.forEach((item) => {
            if (item.getBoundingClientRect().top < h) item.classList.add('is-in');
          });
        }
        this.classList.add('is-ready');
        if (!this.io) {
          this.io = new IntersectionObserver(
            (entries) => {
              let k = 0;
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.style.transitionDelay = Math.min(k++ * 60, 360) + 'ms';
                entry.target.classList.add('is-in');
                this.io.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -5% 0px' }
          );
        }
        items.forEach((item) => {
          if (!item.classList.contains('is-in')) this.io.observe(item);
        });
      }

      /* ---------- quick add ---------- */

      toggleQuick(btn) {
        const card = btn.closest('[data-cg-card]');
        if (!card) return;
        if (this.quickCard === card) {
          this.closeQuick(true);
          return;
        }
        this.closeQuick(false);
        let panel = card.querySelector('[data-cg-quick]');
        if (!panel) {
          const tpl = card.querySelector('[data-cg-tpl]');
          if (!tpl) return;
          card.append(tpl.content.cloneNode(true));
          panel = card.querySelector('[data-cg-quick]');
          this.qid = (this.qid || 0) + 1;
          panel.id = 'Quick-' + this.sectionId + '-' + this.qid;
          btn.setAttribute('aria-controls', panel.id);
        }
        panel.hidden = false;
        void panel.offsetWidth; // start the slide from its resting place
        this.quickCard = card;
        this.quickBtn = btn;
        btn.setAttribute('aria-expanded', 'true');
        card.classList.add('is-quick');
        const first =
          panel.querySelector('input:checked:not(:disabled)') ||
          panel.querySelector('input[type="radio"]:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      }

      closeQuick(returnFocus) {
        const card = this.quickCard;
        if (!card) return;
        const btn = this.quickBtn;
        const panel = card.querySelector('[data-cg-quick]');
        this.quickCard = null;
        this.quickBtn = null;
        card.classList.remove('is-quick');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        const hide = () => {
          if (panel && !card.classList.contains('is-quick')) panel.hidden = true;
        };
        if (reduceMotion.matches) hide();
        else setTimeout(hide, Math.round(400 * motionSpeed()));
        if (returnFocus && btn && btn.isConnected) btn.focus({ preventScroll: true });
      }

      async addToCart(e, form) {
        // The bag drawer adds the item itself and opens.
        if (document.querySelector('cart-drawer[data-open-on-add]')) return;
        e.preventDefault();
        const btn = form.querySelector('[data-cg-add-btn]');
        if (btn && btn.getAttribute('aria-busy') === 'true') return;
        const msg = form.querySelector('[data-cg-msg]');
        if (msg) msg.textContent = '';
        if (btn) btn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || 'This item could not be added.');
          this.say('Added to your bag.');
          if (btn) {
            btn.classList.add('is-added');
            setTimeout(() => btn.classList.remove('is-added'), 1800);
          }
          const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .catch(() => null);
          if (cart)
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'collection-grid' } }));
        } catch (err) {
          const text = (err && err.message) || 'Something went wrong. Please try again.';
          if (msg) msg.textContent = text;
          else this.say(text);
        } finally {
          if (btn) btn.removeAttribute('aria-busy');
        }
      }

      say(text) {
        const live = this.querySelector('[data-cg-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }
    }

    customElements.define('collection-grid', CollectionGrid);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('collection-list')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class CollectionList extends HTMLElement {
      connectedCallback() {
        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        const items = Array.from(this.querySelectorAll('[data-cl-item]'));
        if (!items.length) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => {
              this.io.unobserve(el);
              el.style.setProperty('--d', Math.min(n, 6) * 80 + 'ms');
              el.classList.add('is-in');
              setTimeout(() => el.classList.add('is-settled'), 1300 + Math.min(n, 6) * 80);
            });
          },
          { rootMargin: '0px 0px -6% 0px' }
        );
        items.forEach((el) => this.io.observe(el));
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }
    }

    customElements.define('collection-list', CollectionList);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('compare-table')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class CompareTable extends HTMLElement {
      connectedCallback() {
        this.timers = new Set();
        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        const lane = this.querySelector('[data-cp-lane]');
        const parts = Array.from(this.querySelectorAll('[data-cp-rise], [data-cp-row]'));
        if (lane) parts.unshift(lane);
        if (!parts.length) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, k) => {
              this.io.unobserve(el);
              const delay = Math.min(k, 8) * 110;
              el.style.setProperty('--d', delay + 'ms');
              el.classList.add('is-in');
              this.later(() => el.classList.add('is-settled'), delay + 1000);
            });
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        parts.forEach((el) => this.io.observe(el));

        if (window.Shopify && window.Shopify.designMode) {
          this.ac = new AbortController();
          document.addEventListener(
            'shopify:block:select',
            (e) => {
              if (!(e.target instanceof Element) || !this.contains(e.target)) return;
              parts.forEach((el) => el.classList.add('is-in', 'is-settled'));
            },
            { signal: this.ac.signal }
          );
        }
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('compare-table', CompareTable);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.customElements || customElements.get('contact-page')) return;

    class ContactPage extends HTMLElement {
      connectedCallback() {
        this.cleanups = [];
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.initReveal();
        this.initSpotlight();
        this.initForm();
        this.initCounter();
        this.focusMessage();
      }

      disconnectedCallback() {
        this.cleanups.forEach(function (fn) {
          fn();
        });
        this.cleanups = [];
      }

      initReveal() {
        var items = this.querySelectorAll('[data-reveal]');
        if (!items.length || this.reducedMotion || !('IntersectionObserver' in window)) return;
        if (document.documentElement.getAttribute('data-reveal') === 'none') return;

        var root = this;
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        );

        // Items already on screen are marked visible before hiding is armed: no flash
        var viewport = window.innerHeight || document.documentElement.clientHeight;
        items.forEach(function (el) {
          if (el.getBoundingClientRect().top < viewport * 0.92) {
            el.classList.add('is-visible');
          } else {
            io.observe(el);
          }
        });
        root.classList.add('is-ready');

        // Safety net: never leave content hidden
        var fallback = setTimeout(function () {
          items.forEach(function (el) {
            el.classList.add('is-visible');
          });
          io.disconnect();
        }, 3000);

        this.cleanups.push(function () {
          io.disconnect();
          clearTimeout(fallback);
        });
      }

      initSpotlight() {
        var card = this.querySelector('.cn__card');
        if (!card || this.reducedMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        var frame = null;
        var x = 0;
        var y = 0;

        var update = function () {
          frame = null;
          var rect = card.getBoundingClientRect();
          card.style.setProperty('--mx', x - rect.left + 'px');
          card.style.setProperty('--my', y - rect.top + 'px');
        };
        var onMove = function (e) {
          x = e.clientX;
          y = e.clientY;
          if (!frame) frame = requestAnimationFrame(update);
        };
        var onEnter = function () {
          card.classList.add('is-lit');
        };
        var onLeave = function () {
          card.classList.remove('is-lit');
        };

        card.addEventListener('pointermove', onMove, { passive: true });
        card.addEventListener('pointerenter', onEnter);
        card.addEventListener('pointerleave', onLeave);

        this.cleanups.push(function () {
          card.removeEventListener('pointermove', onMove);
          card.removeEventListener('pointerenter', onEnter);
          card.removeEventListener('pointerleave', onLeave);
          if (frame) cancelAnimationFrame(frame);
        });
      }

      initForm() {
        var form = this.querySelector('form');
        var button = form && form.querySelector('.cn__submit');
        if (!form || !button) return;

        var reset = function () {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          button.disabled = false;
        };

        var onSubmit = function (e) {
          if (button.classList.contains('is-loading')) {
            e.preventDefault();
            return;
          }
          if (!form.checkValidity()) {
            e.preventDefault();
            form.reportValidity();
            return;
          }
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
          setTimeout(function () {
            button.disabled = true;
          }, 0);
        };

        var onPageShow = function (e) {
          if (e.persisted) reset();
        };

        form.addEventListener('submit', onSubmit);
        window.addEventListener('pageshow', onPageShow);

        this.cleanups.push(function () {
          form.removeEventListener('submit', onSubmit);
          window.removeEventListener('pageshow', onPageShow);
        });
      }

      initCounter() {
        var input = this.querySelector('[data-counter-input]');
        var counter = this.querySelector('[data-counter]');
        if (!input || !counter) return;

        var max = input.getAttribute('maxlength');
        var render = function () {
          counter.textContent = input.value.length + ' / ' + max;
        };

        render();
        counter.hidden = false;
        input.addEventListener('input', render);
        this.cleanups.push(function () {
          input.removeEventListener('input', render);
        });
      }

      focusMessage() {
        var target = this.querySelector('[data-focus]');
        if (!target) return;
        var smooth = !this.reducedMotion;
        requestAnimationFrame(function () {
          target.focus({ preventScroll: true });
          target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
        });
      }
    }

    customElements.define('contact-page', ContactPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delivery-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('delivery-countdown')) return;
    const DAY = 864e5;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class DeliveryCountdown extends HTMLElement {
      connectedCallback() {
        this.read();
        if (!this.ship.length) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.lang = document.documentElement.lang || 'en';
        this.lastKey = '';
        this.tick();
        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.visibilityState === 'visible') this.tick();
          },
          { signal }
        );

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.classList.add('is-in');
            this.io.disconnect();
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this.io.observe(this);
      }

      /* ---------- Settings from the theme ---------- */

      read() {
        const d = this.dataset;
        const m = (d.offset || '+0000').match(/([+-])(\d{2}):?(\d{2})/);
        this.offset = m ? (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3])) : 0;
        this.cutoff = Number(d.cutoff) || 0;
        this.ship = (d.ship || '')
          .split(',')
          .filter((x) => x !== '')
          .map(Number);
        this.prep = Number(d.prep) || 0;
        this.tmin = Math.max(0, Number(d.tmin) || 0);
        this.tmax = Math.max(this.tmin, Number(d.tmax) || 0);
        this.deliver = [1, 2, 3, 4, 5];
        if (d.sat === '1') this.deliver.push(6);
        if (d.sun === '1') this.deliver.push(0);
        this.holidays = new Set();
        (d.holidays || '').replace(/(\d{4}-)?(\d{1,2})-(\d{1,2})/g, (all, year, mo, da) => {
          const md = `${mo.padStart(2, '0')}-${da.padStart(2, '0')}`;
          this.holidays.add(year ? year + md : md);
          return all;
        });
      }

      /* Dates are kept as midnight UTC of the shop's calendar day */
      key(t) {
        return new Date(t).toISOString().slice(0, 10);
      }

      off(t) {
        const k = this.key(t);
        return this.holidays.has(k) || this.holidays.has(k.slice(5));
      }

      isShip(t) {
        return this.ship.includes(new Date(t).getUTCDay()) && !this.off(t);
      }

      nextShip(t) {
        for (let i = 0; i < 400; i += 1, t += DAY) if (this.isShip(t)) return t;
        return null;
      }

      addDelivery(t, n) {
        let k = 0;
        for (let i = 0; i < 400 && k < n; i += 1) {
          t += DAY;
          if (this.deliver.includes(new Date(t).getUTCDay()) && !this.off(t)) k += 1;
        }
        return t;
      }

      plan(nowMs) {
        // The shop's wall clock, as if it were UTC
        const now = nowMs + this.offset * 60000;
        const today = Math.floor(now / DAY) * DAY;
        const mins = (now - today) / 60000;
        let start = this.isShip(today) && mins < this.cutoff ? today : this.nextShip(today + DAY);
        if (start === null) return null;
        let ship = start;
        for (let i = 0; i < this.prep; i += 1) {
          ship = this.nextShip(ship + DAY);
          if (ship === null) return null;
        }
        return {
          now,
          today,
          left: start + this.cutoff * 60000 - now,
          ship,
          from: this.addDelivery(ship, this.tmin),
          to: this.addDelivery(ship, this.tmax),
        };
      }

      /* ---------- Words ---------- */

      day(t) {
        return new Intl.DateTimeFormat(this.lang, {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          timeZone: 'UTC',
        }).format(new Date(t));
      }

      relative(t, today) {
        const diff = Math.round((t - today) / DAY);
        if (diff === 0) return 'today';
        if (diff === 1) return 'tomorrow';
        if (diff < 7)
          return new Intl.DateTimeFormat(this.lang, { weekday: 'long', timeZone: 'UTC' }).format(new Date(t));
        return this.day(t);
      }

      /* ---------- Every second ---------- */

      tick() {
        clearTimeout(this.timer);
        const p = this.plan(Date.now());
        if (!p) return;
        this.paint(p);
        if (document.visibilityState !== 'visible') return;
        this.timer = setTimeout(() => this.tick(), 1000 - (Date.now() % 1000) + 20);
      }

      paint(p) {
        const counting = p.left > 0 && p.left <= DAY;
        const within = this.querySelector('[data-dl-lead-within]');
        const now = this.querySelector('[data-dl-lead-now]');
        const timer = this.querySelector('[data-dl-timer]');
        if (within) within.hidden = !counting;
        if (now) now.hidden = counting;
        if (timer) timer.hidden = !counting;
        if (counting) {
          const total = Math.floor(p.left / 1000);
          this.set('[data-dl-h]', String(Math.floor(total / 3600)).padStart(2, '0'));
          this.set('[data-dl-m]', String(Math.floor((total % 3600) / 60)).padStart(2, '0'));
          this.set('[data-dl-s]', String(total % 60).padStart(2, '0'), true);
        }

        // Dates only change now and then; skip the work when they haven't
        const key = [p.today, p.ship, p.from, p.to].join();
        if (key !== this.lastKey) {
          this.lastKey = key;
          this.text('[data-dl-ship-rel]', this.relative(p.ship, p.today));
          this.text('[data-dl-order]', this.day(p.today));
          this.text('[data-dl-ship]', this.day(p.ship));
          this.text('[data-dl-arrive]', p.from === p.to ? this.day(p.from) : `${this.day(p.from)} – ${this.day(p.to)}`);
        }
        this.classList.add('is-set');
      }

      set(sel, value, quiet) {
        const el = this.querySelector(sel);
        if (!el || el.textContent === value) return;
        el.textContent = value;
        if (quiet || reduceMotion.matches) return;
        el.classList.remove('is-tick');
        void el.offsetWidth;
        el.classList.add('is-tick');
      }

      text(sel, value) {
        this.querySelectorAll(sel).forEach((el) => (el.textContent = value));
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
      }
    }

    customElements.define('delivery-countdown', DeliveryCountdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depth-scene"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('depth-scene')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

    class DepthScene extends HTMLElement {
      connectedCallback() {
        this.scene = this.querySelector('[data-ld-scene]');
        if (!this.scene) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.layers = Array.from(this.querySelectorAll('[data-ld-depth]')).map((el) => ({ el, d: Number(el.dataset.ldDepth) || 0 }));
        this.amount = Number(this.dataset.amount) || 24;
        this.aim = { x: 0, y: 0 };
        this.cur = { x: 0, y: 0 };
        this.lift = 0;
        this.liftAim = 0;
        this.leans = finePointer.matches;
        const still = reduceMotion.matches;
        if (this.classList.contains('ld--animate') && !still) this.classList.add('is-armed');

        if (!still) {
          // The mouse looks around the scene; the near layers move the most
          this.scene.addEventListener('pointermove', (e) => {
            if (e.pointerType !== 'mouse' || !finePointer.matches) return;
            const r = this.scene.getBoundingClientRect();
            if (!r.width || !r.height) return;
            this.aim.x = clamp(((e.clientX - r.left) / r.width) * 2 - 1, -1, 1);
            this.aim.y = clamp(((e.clientY - r.top) / r.height) * 2 - 1, -1, 1);
            this.kick();
          }, { passive: true, signal });
          this.scene.addEventListener('pointerleave', () => {
            this.aim.x = 0;
            this.aim.y = 0;
            this.kick();
          }, { signal });
          if (this.dataset.scroll === 'true') {
            window.addEventListener('scroll', () => this.readScroll(), { passive: true, signal });
            window.addEventListener('resize', () => this.readScroll(), { passive: true, signal });
          }
          if (this.dataset.tilt === 'true') this.setupTilt();
        }

        if ('IntersectionObserver' in window) {
          this.seen = new IntersectionObserver((entries) => {
            const en = entries[entries.length - 1];
            this.visible = en.isIntersecting;
            if (this.visible && en.intersectionRatio >= 0.15) this.classList.add('is-shown');
            if (this.visible) this.readScroll();
          }, { threshold: [0, 0.15] });
          this.seen.observe(this.scene);
        } else {
          this.visible = true;
          this.classList.add('is-shown');
        }
        this.readScroll();
      }

      /* -1 while the scene is below the middle of the screen, 1 once it has passed above */
      readScroll() {
        if (this.dataset.scroll !== 'true' || reduceMotion.matches) return;
        const r = this.scene.getBoundingClientRect();
        const vh = window.innerHeight || 1;
        this.liftAim = clamp((vh / 2 - (r.top + r.height / 2)) / (vh / 2 + r.height / 2), -1, 1);
        this.kick();
      }

      /* ---------- The phone's tilt ---------- */

      setupTilt() {
        const DOE = window.DeviceOrientationEvent;
        if (!DOE || finePointer.matches) return;
        const signal = this.ac.signal;
        const listen = () => {
          window.addEventListener('deviceorientation', (e) => {
            if (typeof e.gamma !== 'number' || typeof e.beta !== 'number') return;
            if (!this.base) this.base = { g: e.gamma, b: e.beta };
            // The resting point drifts toward how the phone is held, so the scene settles back by itself
            this.base.g += (e.gamma - this.base.g) * 0.006;
            this.base.b += (e.beta - this.base.b) * 0.006;
            this.aim.x = clamp((e.gamma - this.base.g) / 18, -1, 1);
            this.aim.y = clamp((e.beta - this.base.b) / 18, -1, 1);
            this.kick();
          }, { passive: true, signal });
        };
        if (typeof DOE.requestPermission !== 'function') return listen();
        // iPhones ask first, and only after a tap
        const btn = this.querySelector('[data-ld-motion]');
        if (!btn) return;
        btn.hidden = false;
        btn.addEventListener('click', () => {
          btn.hidden = true;
          Promise.resolve()
            .then(() => DOE.requestPermission())
            .then((state) => {
              if (state === 'granted' && this.ac) listen();
            })
            .catch(() => {});
        }, { signal });
      }

      /* ---------- Moving the layers ---------- */

      kick() {
        if (this.raf || !this.visible || !this.ac) return;
        this.raf = requestAnimationFrame(() => this.loop());
      }

      loop() {
        this.raf = 0;
        this.cur.x += (this.aim.x - this.cur.x) * 0.12;
        this.cur.y += (this.aim.y - this.cur.y) * 0.12;
        const settled = Math.abs(this.aim.x - this.cur.x) < 0.002 && Math.abs(this.aim.y - this.cur.y) < 0.002;
        if (settled) {
          this.cur.x = this.aim.x;
          this.cur.y = this.aim.y;
        }
        this.lift = this.liftAim;
        this.paint();
        if (!settled) this.kick();
      }

      paint() {
        const k = this.amount;
        this.layers.forEach((layer) => {
          const x = -this.cur.x * layer.d * k;
          const y = -this.cur.y * layer.d * k * 0.6 - this.lift * layer.d * k * 1.6;
          layer.el.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0)`;
        });
        // With a mouse the box turns a little toward the pointer, as if you stepped that way to look
        if (this.leans) this.scene.style.transform = `rotateX(${(this.cur.y * 1.6).toFixed(3)}deg) rotateY(${(this.cur.x * -2.2).toFixed(3)}deg)`;
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.ac = null;
        if (this.seen) this.seen.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }
    }

    customElements.define('depth-scene', DepthScene);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('featured-collection')) return;

    const root = document.documentElement;
    // Theme settings › Animations: "none" behaves like the visitor's reduced-motion preference,
    // "subtle" keeps fades and state changes but drops the decorative swing.
    const reduceMotion = window.matchMedia(root.dataset.motion === 'none' ? 'all' : '(prefers-reduced-motion: reduce)');
    const calm = () => reduceMotion.matches || root.dataset.motion === 'subtle';
    const speed = () => parseFloat(getComputedStyle(root).getPropertyValue('--motion-speed')) || 1;
    const plainClick = (e) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

    class FeaturedCollection extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
        [this.showIo, this.ro].forEach((o) => o && o.disconnect());
        clearTimeout(this.settleTimer);
        cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.ctrl = null;
      }

      setup() {
        if (this.ctrl || !this.isConnected) return;
        this.ctrl = new AbortController();
        const signal = this.ctrl.signal;
        this.sectionId = this.dataset.sectionId;
        this.list = this.querySelector('[data-fc-list]');

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });
        this.addEventListener('keydown', (e) => this.onKeydown(e), { signal });
        this.addEventListener('pointerover', (e) => this.onPointerOver(e), { signal });
        this.addEventListener('pointerout', (e) => this.onPointerOut(e), { signal });
        this.addEventListener(
          'animationend',
          (e) => {
            if (e.target.classList && e.target.classList.contains('fc-tag')) e.target.classList.remove('is-swing');
          },
          { signal }
        );
        document.addEventListener(
          'pointerdown',
          (e) => {
            if (this.quickCard && !this.quickCard.contains(e.target)) this.closeQuick(false);
          },
          { signal }
        );
        document.addEventListener(
          'cart:updated',
          (e) => {
            if (!this.quickCard) return;
            if (e.detail && e.detail.source === 'featured-collection') {
              const card = this.quickCard;
              setTimeout(() => this.quickCard === card && this.closeQuick(true), 1200);
            } else {
              this.closeQuick(false);
            }
          },
          { signal }
        );

        if (this.classList.contains('fc--rail') && this.list) this.initRail(signal);
        this.reveal();
      }

      /* ---------- the sliding row ---------- */

      initRail(signal) {
        this.nav = this.querySelector('[data-fc-nav]');
        this.progress = this.querySelector('[data-fc-progress]');
        this.thumb = this.querySelector('[data-fc-thumb]');
        this.list.addEventListener(
          'scroll',
          () => {
            if (this.raf) return;
            this.raf = requestAnimationFrame(() => {
              this.raf = 0;
              this.update(false);
            });
          },
          { passive: true, signal }
        );
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.update(true));
          this.ro.observe(this.list);
        }
        this.update(true);
      }

      reveal() {
        // Scroll-in off in Theme settings (or no motion at all): the cards are simply there.
        if (reduceMotion.matches || root.dataset.reveal === 'none' || !('IntersectionObserver' in window)) return;
        const items = Array.from(this.querySelectorAll('[data-fc-item]'));
        if (!items.length) return;
        this.classList.add('is-ready');
        this.showIo = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            const k = speed();
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => {
              this.showIo.unobserve(el);
              el.style.setProperty('--d', Math.min(n, 6) * 70 + 'ms');
              el.classList.add('is-in');
              // Once it has settled, drop the transition so nothing lingers.
              setTimeout(() => el.classList.add('is-settled'), Math.round(1000 * k) + Math.min(n, 6) * 70);
            });
            if (coming.length) this.classList.add('is-in');
          },
          { rootMargin: '0px 0px -6% 0px' }
        );
        items.forEach((el) => this.showIo.observe(el));
      }

      isRtl() {
        return getComputedStyle(this.list).direction === 'rtl';
      }

      update(full) {
        const list = this.list;
        if (!list) return;
        const max = list.scrollWidth - list.clientWidth;
        const over = max > 2;
        const pos = Math.min(max, Math.abs(list.scrollLeft));
        if (full) {
          this.classList.toggle('fc--over', over);
          if (this.nav) this.nav.hidden = !over;
          if (this.progress) this.progress.hidden = !over;
          if (this.thumb && over)
            this.thumb.style.width = ((list.clientWidth / list.scrollWidth) * 100).toFixed(2) + '%';
        }
        if (this.nav) {
          const [prev, next] = this.nav.querySelectorAll('[data-fc-step]');
          const focused = document.activeElement;
          prev.disabled = !over || pos <= 2;
          next.disabled = !over || pos >= max - 2;
          // Never strand keyboard focus on an arrow that just switched off.
          if (focused === prev && prev.disabled && !next.disabled) next.focus({ preventScroll: true });
          if (focused === next && next.disabled && !prev.disabled) prev.focus({ preventScroll: true });
        }
        if (this.thumb && over && this.progress) {
          const track = this.progress.clientWidth;
          const room = track - this.thumb.offsetWidth;
          const x = max > 0 ? (room * pos) / max : 0;
          this.thumb.style.transform = 'translate3d(' + (this.isRtl() ? -x : x).toFixed(1) + 'px,0,0)';
        }
      }

      step(dir) {
        const list = this.list;
        const item = list && list.querySelector('[data-fc-item]');
        if (!item) return;
        const cs = getComputedStyle(list);
        const gap = parseFloat(cs.columnGap) || 0;
        const visible = list.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        const one = item.getBoundingClientRect().width + gap;
        const n = Math.max(1, Math.floor((visible + gap + 1) / one));
        list.scrollBy({
          left: dir * n * one * (this.isRtl() ? -1 : 1),
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
      }

      /* ---------- events ---------- */

      onClick(e) {
        const t = e.target;
        const stepBtn = t.closest('[data-fc-step]');
        if (stepBtn) return this.step(Number(stepBtn.dataset.fcStep));
        const open = t.closest('[data-fc-open]');
        if (open) {
          if (!plainClick(e)) return;
          e.preventDefault();
          return this.toggleQuick(open);
        }
        if (t.closest('[data-fc-close-quick]')) return this.closeQuick(true);
        const sw = t.closest('[data-fc-sw]');
        if (sw) return this.pickSwatch(sw);
      }

      onSubmit(e) {
        const form = e.target;
        if (form.hasAttribute('data-fc-add')) this.addToCart(e, form);
      }

      onKeydown(e) {
        if (e.key === 'Escape' && this.quickCard) {
          e.preventDefault();
          this.closeQuick(true);
        }
      }

      onPointerOver(e) {
        if (e.pointerType !== 'mouse') return;
        const sw = e.target.closest('[data-fc-sw]');
        if (sw) {
          if (sw.dataset.src) this.showImage(sw.closest('[data-fc-card]'), sw.dataset.src, sw.dataset.srcset);
          return;
        }
        const card = e.target.closest('[data-fc-card]');
        if (card && !(e.relatedTarget && card.contains(e.relatedTarget))) this.swing(card);
      }

      onPointerOut(e) {
        if (e.pointerType !== 'mouse') return;
        const list = e.target.closest('.fc-swatches');
        if (!list || (e.relatedTarget && list.contains(e.relatedTarget))) return;
        this.restoreImage(list.closest('[data-fc-card]'));
      }

      swing(card) {
        if (calm() || !this.classList.contains('fc--card-tag')) return;
        const tag = card.querySelector('.fc-tag');
        if (tag && !tag.classList.contains('is-swing')) tag.classList.add('is-swing');
      }

      /* ---------- color dots ---------- */

      pickSwatch(sw) {
        const card = sw.closest('[data-fc-card]');
        card
          .querySelectorAll('[data-fc-sw]')
          .forEach((el) => el.setAttribute('aria-pressed', el === sw ? 'true' : 'false'));
        const link = card.querySelector('.fc-card__link');
        if (link && sw.dataset.url) link.href = sw.dataset.url;
        if (sw.dataset.src) {
          card.dataset.pickSrc = sw.dataset.src;
          card.dataset.pickSet = sw.dataset.srcset || '';
          card.classList.add('is-picked');
          this.showImage(card, sw.dataset.src, sw.dataset.srcset);
        }
      }

      restoreImage(card) {
        const img = card && card.querySelector('.fc-card__img:not(.fc-card__img--2)');
        if (!img || !img.dataset.origSrc) return;
        if (card.dataset.pickSrc) this.showImage(card, card.dataset.pickSrc, card.dataset.pickSet);
        else this.showImage(card, img.dataset.origSrc, img.dataset.origSet);
      }

      showImage(card, src, srcset) {
        const img = card && card.querySelector('.fc-card__img:not(.fc-card__img--2)');
        if (!img || img.tagName !== 'IMG') return;
        if (!img.dataset.origSrc) {
          img.dataset.origSrc = img.getAttribute('src');
          img.dataset.origSet = img.getAttribute('srcset') || '';
          img.dataset.showing = img.dataset.origSrc;
        }
        if (img.dataset.showing === src) return;
        img.dataset.showing = src;
        const apply = () => {
          if (img.dataset.showing !== src) return;
          if (srcset) img.srcset = srcset;
          else img.removeAttribute('srcset');
          img.src = src;
          img.classList.remove('is-swap');
        };
        const pre = new Image();
        pre.sizes = img.sizes;
        if (srcset) pre.srcset = srcset;
        pre.src = src;
        if (pre.complete) {
          apply();
        } else {
          img.classList.add('is-swap');
          pre.onload = pre.onerror = apply;
        }
      }

      /* ---------- quick add ---------- */

      toggleQuick(btn) {
        const card = btn.closest('[data-fc-card]');
        if (!card) return;
        if (this.quickCard === card) {
          this.closeQuick(true);
          return;
        }
        this.closeQuick(false);
        let panel = card.querySelector('[data-fc-quick]');
        if (!panel) {
          const tpl = card.querySelector('[data-fc-tpl]');
          if (!tpl) return;
          card.append(tpl.content.cloneNode(true));
          panel = card.querySelector('[data-fc-quick]');
          this.qid = (this.qid || 0) + 1;
          panel.id = 'FCQuick-' + this.sectionId + '-' + this.qid;
          btn.setAttribute('aria-controls', panel.id);
        }
        panel.hidden = false;
        void panel.offsetWidth; // start the slide from its resting place
        this.quickCard = card;
        this.quickBtn = btn;
        btn.setAttribute('aria-expanded', 'true');
        card.classList.add('is-quick');
        const first =
          panel.querySelector('input:checked:not(:disabled)') ||
          panel.querySelector('input[type="radio"]:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      }

      closeQuick(returnFocus) {
        const card = this.quickCard;
        if (!card) return;
        const btn = this.quickBtn;
        const panel = card.querySelector('[data-fc-quick]');
        this.quickCard = null;
        this.quickBtn = null;
        card.classList.remove('is-quick');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        const hide = () => {
          if (panel && !card.classList.contains('is-quick')) panel.hidden = true;
        };
        if (reduceMotion.matches) hide();
        else setTimeout(hide, Math.round(400 * speed()));
        if (returnFocus && btn && btn.isConnected) btn.focus({ preventScroll: true });
      }

      async addToCart(e, form) {
        // The bag drawer adds the item itself and opens.
        if (document.querySelector('cart-drawer[data-open-on-add]')) return;
        e.preventDefault();
        const btn = form.querySelector('[data-fc-add-btn]');
        if (btn && btn.getAttribute('aria-busy') === 'true') return;
        const msg = form.querySelector('[data-fc-msg]');
        if (msg) msg.textContent = '';
        if (btn) btn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || 'This item could not be added.');
          this.say('Added to your bag.');
          if (btn) {
            btn.classList.add('is-added');
            setTimeout(() => btn.classList.remove('is-added'), 1800);
          }
          const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .catch(() => null);
          if (cart)
            document.dispatchEvent(
              new CustomEvent('cart:updated', { detail: { cart, source: 'featured-collection' } })
            );
        } catch (err) {
          const text = (err && err.message) || 'Something went wrong. Please try again.';
          if (msg) msg.textContent = text;
          else this.say(text);
        } finally {
          if (btn) btn.removeAttribute('aria-busy');
        }
      }

      say(text) {
        const live = this.querySelector('[data-fc-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }
    }

    customElements.define('featured-collection', FeaturedCollection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('featured-product')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class FeaturedProduct extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.stage = this.querySelector('[data-fp-stage]');
        this.medias = Array.from(this.querySelectorAll('[data-fp-media]'));
        this.firstId = this.medias.length ? this.medias[0].dataset.fpMedia : null;
        this.active = this.querySelector('[data-fp-media].is-active') || this.medias[0] || null;
        const json = this.querySelector('[data-fp-json]');
        try {
          this.variants = json ? JSON.parse(json.textContent) : [];
        } catch (err) {
          this.variants = [];
        }
        this.options = Array.from(this.querySelectorAll('[data-fp-option]'));

        this.addEventListener(
          'change',
          (e) => {
            if (e.target.matches('[data-fp-value]')) this.onOption();
            if (e.target.matches('[data-fp-qty]')) this.clampQty(e.target);
          },
          { signal }
        );
        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });
        document.addEventListener('shopify:block:select', (e) => this.onBlock(e), { signal });

        this.setStageState();
        if (this.options.length) this.markAvailability(this.chosen());
        this.initSwipe(signal);
        this.initReveal();
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.io) this.io.disconnect();
      }

      /* ---------- notes appear when the plate is in view ---------- */

      initReveal() {
        if (!this.stage) return;
        if (reduceMotion.matches || !('IntersectionObserver' in window)) {
          this.stage.classList.add('is-drawn');
          return;
        }
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.io.disconnect();
            this.stage.classList.add('is-drawn');
          },
          { threshold: 0.4 }
        );
        this.io.observe(this.stage);
      }

      /* ---------- clicks ---------- */

      onClick(e) {
        const thumb = e.target.closest('[data-fp-thumb]');
        if (thumb) {
          this.show(thumb.dataset.fpThumb);
          return;
        }
        const play = e.target.closest('[data-fp-play]');
        if (play) {
          this.play(play);
          return;
        }
        const step = e.target.closest('[data-fp-step]');
        if (step) {
          const input = this.querySelector('[data-fp-qty]');
          if (!input) return;
          const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.fpStep, 10));
          if (String(next) !== input.value) {
            input.value = next;
            this.bump(input);
          }
          this.syncQtyButtons(input);
        }
      }

      clampQty(input) {
        const v = parseInt(input.value, 10);
        input.value = Number.isFinite(v) && v > 0 ? v : 1;
        this.syncQtyButtons(input);
      }

      syncQtyButtons(input) {
        const minus = this.querySelector('[data-fp-step="-1"]');
        if (minus) minus.disabled = (parseInt(input.value, 10) || 1) <= 1;
      }

      bump(el) {
        if (reduceMotion.matches) return;
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }

      onSubmit(e) {
        const form = e.target;
        if (!form.matches('.fp-buy__form')) return;
        const id = form.querySelector('[data-fp-variant-id]');
        const btn = form.querySelector('[data-fp-add]');
        if (!id || !id.value || (btn && btn.disabled)) {
          e.preventDefault();
          return;
        }
        // The cart drawer (if present) takes the submit from here; otherwise it posts normally.
        if (btn && !e.defaultPrevented) {
          btn.setAttribute('aria-busy', 'true');
          setTimeout(() => btn.removeAttribute('aria-busy'), 1500);
        }
      }

      /* ---------- media ---------- */

      setStageState() {
        if (!this.stage || !this.active) return;
        this.stage.classList.toggle(
          'is-first',
          this.active.dataset.fpMedia === this.firstId || !this.active.dataset.fpMedia
        );
        const fig = this.querySelector('[data-fp-fig]');
        if (fig && this.active.dataset.index) fig.textContent = this.active.dataset.index;
      }

      show(id) {
        const next = this.medias.find((m) => m.dataset.fpMedia === String(id));
        if (!next || next === this.active) return;
        this.pauseAll();
        const prev = this.active;
        if (prev) {
          prev.classList.remove('is-active');
          prev.setAttribute('aria-hidden', 'true');
          if (!reduceMotion.matches) {
            prev.classList.add('is-leaving');
            setTimeout(() => prev.classList.remove('is-leaving'), 460);
          }
        }
        next.classList.remove('is-leaving');
        next.classList.add('is-active');
        next.removeAttribute('aria-hidden');
        this.active = next;
        this.querySelectorAll('[data-fp-thumb]').forEach((t) => {
          if (t.dataset.fpThumb === String(id)) {
            t.setAttribute('aria-current', 'true');
            t.scrollIntoView({
              block: 'nearest',
              inline: 'nearest',
              behavior: reduceMotion.matches ? 'auto' : 'smooth',
            });
          } else {
            t.removeAttribute('aria-current');
          }
        });
        this.setStageState();
      }

      step(dir) {
        if (this.medias.length < 2 || !this.active) return;
        const i = this.medias.indexOf(this.active);
        const next = this.medias[(i + dir + this.medias.length) % this.medias.length];
        this.show(next.dataset.fpMedia);
      }

      initSwipe(signal) {
        if (!this.stage || this.medias.length < 2) return;
        let x0 = null;
        let y0 = null;
        this.stage.addEventListener(
          'pointerdown',
          (e) => {
            if (e.pointerType !== 'touch' || e.target.closest('video, iframe, model-viewer')) return;
            x0 = e.clientX;
            y0 = e.clientY;
          },
          { signal }
        );
        this.stage.addEventListener(
          'pointerup',
          (e) => {
            if (x0 === null) return;
            const dx = e.clientX - x0;
            const dy = e.clientY - y0;
            x0 = null;
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) this.step(dx < 0 ? 1 : -1);
          },
          { signal }
        );
        this.stage.addEventListener(
          'pointercancel',
          () => {
            x0 = null;
          },
          { signal }
        );
      }

      play(btn) {
        const box = btn.closest('[data-fp-media]');
        const tpl = box && box.querySelector('template[data-fp-deferred]');
        if (!tpl) return;
        box.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
        btn.remove();
        const video = box.querySelector('video');
        if (video) {
          video.focus();
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
        const model = box.querySelector('model-viewer');
        if (model && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: (err) => {
                if (err || !window.Shopify.ModelViewerUI) return;
                this.modelUI = new window.Shopify.ModelViewerUI(model);
              },
            },
          ]);
        }
        const frame = box.querySelector('iframe');
        if (frame) frame.focus();
      }

      pauseAll() {
        this.querySelectorAll('video').forEach((v) => {
          if (!v.paused) v.pause();
        });
        this.querySelectorAll('iframe').forEach((f) => {
          try {
            if (/youtube/.test(f.src))
              f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            if (/vimeo/.test(f.src)) f.contentWindow.postMessage('{"method":"pause"}', '*');
          } catch (err) {
            /* cross-origin frames that refuse messages */
          }
        });
        this.querySelectorAll('model-viewer').forEach((m) => {
          if (typeof m.pause === 'function') m.pause();
        });
      }

      /* ---------- variants ---------- */

      chosen() {
        return this.options.map((fs) => {
          const select = fs.querySelector('select[data-fp-value]');
          if (select) return select.value;
          const c = fs.querySelector('[data-fp-value]:checked');
          return c ? c.value : null;
        });
      }

      onOption() {
        const picked = this.chosen();
        this.options.forEach((fs, i) => {
          const out = fs.querySelector('[data-fp-chosen]');
          if (out) out.textContent = picked[i] || '';
        });
        const v = this.variants.find((x) => x.options.every((o, i) => o === picked[i])) || null;
        this.markAvailability(picked);
        this.render(v);
      }

      markAvailability(picked) {
        this.options.forEach((fs, i) => {
          const isOk = (value) =>
            this.variants.some(
              (v) =>
                v.available &&
                v.options[i] === value &&
                v.options.every((o, j) => j === i || picked[j] === null || o === picked[j])
            );
          const select = fs.querySelector('select[data-fp-value]');
          if (select) {
            // Dropdowns say it in words: "Large - Sold out"
            Array.from(select.options).forEach((opt) => {
              const ok = isOk(opt.value);
              opt.textContent = (opt.dataset.label || opt.value) + (ok ? '' : ' - Sold out');
            });
            return;
          }
          fs.querySelectorAll('[data-fp-value]').forEach((input) => {
            const label = input.nextElementSibling;
            if (label) label.classList.toggle('is-out', !isOk(input.value));
          });
        });
      }

      render(v) {
        this.querySelectorAll('[data-fp-variant-id]').forEach((input) => {
          input.value = v ? v.id : '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        const set = (sel, text) => {
          const el = this.querySelector(sel);
          if (el) el.textContent = text;
        };
        const toggle = (sel, show) => {
          const el = this.querySelector(sel);
          if (el) el.hidden = !show;
        };
        if (v) {
          set('[data-fp-price]', v.price);
          set('[data-fp-compare]', v.compare || '');
          toggle('[data-fp-compare-wrap]', !!v.compare);
          toggle('[data-fp-sale]', !!v.compare && v.available);
          const sale = this.querySelector('[data-fp-sale]');
          if (sale && v.compare) {
            if (sale.dataset.mode === 'percent') sale.textContent = '-' + v.pct + '%';
            else if (sale.dataset.mode === 'amount' && v.save) sale.textContent = '-' + v.save;
          }
          set('[data-fp-save-text]', v.save || '');
          toggle('[data-fp-save]', !!v.compare);
          toggle('[data-fp-soldout]', !v.available);
          set('[data-fp-unit-text]', v.unit || '');
          toggle('[data-fp-unit]', !!v.unit);
          if (v.media) this.show(v.media);
        } else {
          toggle('[data-fp-sale]', false);
          toggle('[data-fp-soldout]', false);
          toggle('[data-fp-save]', false);
        }
        const btn = this.querySelector('[data-fp-add]');
        const label = this.querySelector('[data-fp-add-label]');
        if (btn && label) {
          btn.disabled = !v || !v.available;
          label.textContent = !v ? 'Unavailable' : v.available ? 'Add to cart' : 'Sold out';
        }
      }

      /* ---------- theme editor ---------- */

      onBlock(e) {
        const id = e.detail && e.detail.blockId;
        const pin = id && this.querySelector(`[data-fp-pin="${id}"]`);
        if (!pin) return;
        if (this.firstId) this.show(this.firstId);
        if (this.stage) this.stage.classList.add('is-drawn');
        pin.classList.remove('is-flash');
        void pin.offsetWidth;
        pin.classList.add('is-flash');
      }
    }

    customElements.define('featured-product', FeaturedProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('flash-sale-bar')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pad = (n) => String(n).padStart(2, '0');

    class FlashSaleBar extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.editor = !!(window.Shopify && window.Shopify.designMode);
        this.clock = this.querySelector('[data-fsb-clock]');
        this.fuse = this.querySelector('[data-fsb-fuse]');
        this.live = this.querySelector('[data-fsb-live]');
        this.visible = true;

        // A shopper who closed the bar doesn't see it again this visit.
        if (this.hasAttribute('data-closable') && !this.editor) {
          let closed = null;
          try {
            closed = sessionStorage.getItem(this.dataset.key);
          } catch (e) {
            closed = null;
          }
          if (closed) {
            this.wrapper().hidden = true;
            return;
          }
        }

        const end = Date.parse(this.dataset.end || '');
        const start = Date.parse(this.dataset.start || '');
        if (!Number.isNaN(end)) this.end = end;
        else if (this.editor) this.end = Date.now() + 5 * 3600000 + 42 * 60000;
        if (!Number.isNaN(start) && this.end && start < this.end) this.start = start;

        this.nums = {};
        this.querySelectorAll('[data-fsb-unit]').forEach((u) => {
          const num = u.querySelector('[data-fsb-num]');
          this.nums[u.dataset.fsbUnit] = num;
          this.renderDigits(num, num.textContent.trim(), false);
        });

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            this.classList.toggle('is-inview', entry.isIntersecting);
            if (entry.isIntersecting) this.tick(true);
          });
          this.io.observe(this);
        } else {
          this.classList.add('is-inview');
        }
        document.addEventListener(
          'visibilitychange',
          () => {
            if (!document.hidden) this.tick(true);
          },
          { signal }
        );

        if (this.end) {
          if (this.clock) this.clock.hidden = false;
          if (this.fuse && this.start) this.fuse.hidden = false;
          this.tick(true);
          this.schedule();
        }

        this.addEventListener(
          'click',
          (e) => {
            const copy = e.target.closest('[data-fsb-copy]');
            if (copy) this.copy(copy);
            if (e.target.closest('[data-fsb-close]')) this.close();
          },
          { signal }
        );
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.io) this.io.disconnect();
        clearTimeout(this.timer);
      }

      wrapper() {
        return this.closest('.shopify-section') || this;
      }

      renderDigits(num, value, animate) {
        const chars = String(value).split('');
        let slots = Array.from(num.querySelectorAll('.fsb-digit'));
        if (slots.length !== chars.length) {
          num.textContent = '';
          chars.forEach((ch) => {
            const d = document.createElement('span');
            d.className = 'fsb-digit';
            d.setAttribute('aria-hidden', 'true');
            const cur = document.createElement('span');
            cur.className = 'fsb-digit__in fsb-digit__in--cur';
            cur.textContent = ch;
            d.appendChild(cur);
            num.appendChild(d);
          });
          return;
        }
        slots.forEach((d, i) => {
          const cur = d.querySelector('.fsb-digit__in--cur');
          if (cur.textContent === chars[i]) return;
          if (!animate || reduceMotion.matches || !this.visible) {
            d.querySelectorAll('.fsb-digit__in--next').forEach((n) => n.remove());
            d.classList.remove('is-rolling');
            cur.textContent = chars[i];
            return;
          }
          const next = document.createElement('span');
          next.className = 'fsb-digit__in fsb-digit__in--next';
          next.textContent = chars[i];
          d.appendChild(next);
          void d.offsetWidth;
          d.classList.add('is-rolling');
          setTimeout(() => {
            cur.textContent = chars[i];
            next.remove();
            d.classList.remove('is-rolling');
          }, 550);
        });
      }

      schedule() {
        clearTimeout(this.timer);
        const wait = 1000 - (Date.now() % 1000) + 5;
        this.timer = setTimeout(() => {
          this.tick(false);
          if (!this.ended) this.schedule();
        }, wait);
      }

      tick(force) {
        if (!this.end) return;
        if (!force && (!this.visible || document.hidden)) return;
        const now = Date.now();
        const left = Math.max(0, Math.round((this.end - now) / 1000));
        const d = Math.floor(left / 86400);
        const h = Math.floor((left % 86400) / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        this.classList.toggle('is-under-day', d === 0);
        const animate = !force;
        if (this.nums.d) this.renderDigits(this.nums.d, pad(d), animate);
        if (this.nums.h) this.renderDigits(this.nums.h, pad(h), animate);
        if (this.nums.m) this.renderDigits(this.nums.m, pad(m), animate);
        if (this.nums.s) this.renderDigits(this.nums.s, pad(s), animate);
        if (this.clock) {
          const words = d > 0 ? `${d} days ${h} hours ${m} minutes` : `${h} hours ${m} minutes ${s} seconds`;
          this.clock.setAttribute('aria-label', left > 0 ? `Sale ends in ${words}` : 'Sale has ended');
        }
        if (this.fuse && this.start && !this.fuse.hidden) {
          const f = Math.min(Math.max((this.end - now) / (this.end - this.start), 0), 1);
          this.fuse.style.setProperty('--f', f.toFixed(5));
        }
        if (left === 0 && !this.ended) this.finish();
      }

      finish() {
        this.ended = true;
        clearTimeout(this.timer);
        this.classList.add('is-ended');
        if (this.editor) return;
        if (this.dataset.after === 'hide') {
          this.leave();
          return;
        }
        const kicker = this.querySelector('[data-fsb-kicker]');
        if (kicker && this.dataset.endedMessage) kicker.textContent = this.dataset.endedMessage;
      }

      async leave() {
        if (!reduceMotion.matches) {
          this.classList.add('is-leaving');
          await new Promise((r) => setTimeout(r, 380));
        }
        this.wrapper().hidden = true;
      }

      close() {
        try {
          sessionStorage.setItem(this.dataset.key, '1');
        } catch (e) {
          /* storage unavailable: hide for this page only */
        }
        const focusTarget = document.getElementById('MainContent');
        this.leave().then(() => {
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        });
      }

      async copy(btn) {
        const code = btn.dataset.fsbCopy;
        let ok = false;
        try {
          await navigator.clipboard.writeText(code);
          ok = true;
        } catch (e) {
          const ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try {
            ok = document.execCommand('copy');
          } catch (err) {
            ok = false;
          }
          ta.remove();
        }
        const hint = btn.querySelector('[data-fsb-hint]');
        if (!ok) return;
        btn.classList.remove('is-copied');
        void btn.offsetWidth;
        btn.classList.add('is-copied');
        if (hint) hint.textContent = 'Copied';
        if (this.live) {
          this.live.textContent = '';
          setTimeout(() => (this.live.textContent = `Code ${code} copied`), 60);
        }
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          btn.classList.remove('is-copied');
          if (hint) hint.textContent = 'Copy';
        }, 2200);
      }
    }

    customElements.define('flash-sale-bar', FlashSaleBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('flash-sale')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pad = (n) => String(n).padStart(2, '0');

    class FlashSale extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.editor = !!(window.Shopify && window.Shopify.designMode);
        this.clock = this.querySelector('[data-fs-clock]');
        this.fuse = this.querySelector('[data-fs-fuse]');
        this.live = this.querySelector('[data-fs-live]');
        this.visible = true;

        const end = Date.parse(this.dataset.end || '');
        const start = Date.parse(this.dataset.start || '');
        if (!Number.isNaN(end)) this.end = end;
        else if (this.editor) this.end = Date.now() + 2 * 86400000 + 5 * 3600000 + 12 * 60000; // demo clock
        if (!Number.isNaN(start) && this.end && start < this.end) this.start = start;

        this.buildDigits();
        this.initReveal();

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            ([entry]) => {
              this.visible = entry.isIntersecting;
              this.classList.toggle('is-inview', entry.isIntersecting);
              if (entry.isIntersecting) this.tick(true);
            },
            { rootMargin: '100px 0px' }
          );
          this.io.observe(this);
        } else {
          this.classList.add('is-inview');
        }
        document.addEventListener(
          'visibilitychange',
          () => {
            if (!document.hidden) this.tick(true);
          },
          { signal }
        );

        if (this.end) {
          if (this.clock) this.clock.hidden = false;
          if (this.fuse && this.start) this.fuse.hidden = false;
          this.tick(true);
          this.schedule();
        }

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });
        this.initShelf(signal);
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.io) this.io.disconnect();
        if (this.revealIO) this.revealIO.disconnect();
        if (this.ro) this.ro.disconnect();
        clearTimeout(this.timer);
      }

      /* ---------- Clock ---------- */
      buildDigits() {
        this.nums = {};
        this.querySelectorAll('[data-fs-unit]').forEach((unit) => {
          const num = unit.querySelector('[data-fs-num]');
          this.nums[unit.dataset.fsUnit] = num;
          this.renderDigits(num, num.textContent.trim(), false);
        });
      }

      renderDigits(num, value, animate) {
        const chars = String(value).split('');
        let slots = Array.from(num.querySelectorAll('.fs-digit'));
        if (slots.length !== chars.length) {
          num.textContent = '';
          slots = chars.map(() => {
            const d = document.createElement('span');
            d.className = 'fs-digit';
            d.setAttribute('aria-hidden', 'true');
            const cur = document.createElement('span');
            cur.className = 'fs-digit__in fs-digit__in--cur';
            d.appendChild(cur);
            num.appendChild(d);
            return d;
          });
          slots.forEach((d, i) => (d.firstChild.textContent = chars[i]));
          return;
        }
        slots.forEach((d, i) => {
          const cur = d.querySelector('.fs-digit__in--cur');
          if (cur.textContent === chars[i]) return;
          if (!animate || reduceMotion.matches || !this.visible) {
            d.querySelectorAll('.fs-digit__in--next').forEach((n) => n.remove());
            d.classList.remove('is-rolling');
            cur.textContent = chars[i];
            return;
          }
          const next = document.createElement('span');
          next.className = 'fs-digit__in fs-digit__in--next';
          next.textContent = chars[i];
          d.appendChild(next);
          void d.offsetWidth;
          d.classList.add('is-rolling');
          setTimeout(() => {
            cur.textContent = chars[i];
            next.remove();
            d.classList.remove('is-rolling');
          }, 600);
        });
      }

      schedule() {
        clearTimeout(this.timer);
        // Land on the next whole second so every unit flips together.
        const wait = 1000 - (Date.now() % 1000) + 5;
        this.timer = setTimeout(() => {
          this.tick(false);
          if (!this.ended) this.schedule();
        }, wait);
      }

      tick(force) {
        if (!this.end) return;
        if (!force && (!this.visible || document.hidden)) return;
        const now = Date.now();
        const left = Math.max(0, Math.round((this.end - now) / 1000));
        const d = Math.floor(left / 86400);
        const h = Math.floor((left % 86400) / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        const animate = !force;
        if (this.nums.d) this.renderDigits(this.nums.d, pad(d), animate);
        if (this.nums.h) this.renderDigits(this.nums.h, pad(h), animate);
        if (this.nums.m) this.renderDigits(this.nums.m, pad(m), animate);
        if (this.nums.s) this.renderDigits(this.nums.s, pad(s), animate);

        if (this.clock) {
          const words = d > 0 ? `${d} days ${h} hours ${m} minutes` : `${h} hours ${m} minutes ${s} seconds`;
          this.clock.setAttribute('aria-label', left > 0 ? `Sale ends in ${words}` : 'Sale has ended');
        }

        if (this.fuse && this.start && !this.fuse.hidden) {
          const f = Math.min(Math.max((this.end - now) / (this.end - this.start), 0), 1);
          this.fuse.style.setProperty('--f', f.toFixed(5));
        }

        if (left === 0 && !this.ended) this.finish();
      }

      finish() {
        this.ended = true;
        clearTimeout(this.timer);
        this.classList.add('is-ended');
        if (this.editor) return;
        if (this.dataset.after === 'hide') {
          const wrap = this.closest('.shopify-section') || this;
          wrap.hidden = true;
          return;
        }
        const kicker = this.querySelector('[data-fs-kicker-text]');
        const msg = this.getAttribute('data-ended-message');
        if (kicker && msg) kicker.textContent = msg;
        this.querySelectorAll('[data-fs-add] button').forEach((b) => (b.disabled = true));
      }

      /* ---------- Copy code ---------- */
      async copy(btn) {
        const code = btn.dataset.fsCopy;
        let ok = false;
        try {
          await navigator.clipboard.writeText(code);
          ok = true;
        } catch (e) {
          const ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try {
            ok = document.execCommand('copy');
          } catch (err) {
            ok = false;
          }
          ta.remove();
        }
        const hint = btn.querySelector('[data-fs-copy-hint]');
        if (ok) {
          btn.classList.remove('is-copied');
          void btn.offsetWidth;
          btn.classList.add('is-copied');
          if (hint) hint.textContent = 'Copied';
          this.announce(`Code ${code} copied`);
          clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => {
            btn.classList.remove('is-copied');
            if (hint) hint.textContent = 'Copy';
          }, 2200);
        } else if (hint) {
          hint.textContent = code;
        }
      }

      announce(msg) {
        if (!this.live) return;
        this.live.textContent = '';
        setTimeout(() => (this.live.textContent = msg), 60);
      }

      /* ---------- Clicks & quick add ---------- */
      onClick(e) {
        const copy = e.target.closest('[data-fs-copy]');
        if (copy) {
          this.copy(copy);
          return;
        }
        if (e.target.closest('[data-fs-next]')) this.step(1);
        if (e.target.closest('[data-fs-prev]')) this.step(-1);
      }

      onSubmit(e) {
        const form = e.target;
        if (!form.hasAttribute('data-fs-add')) return;
        const btn = e.submitter || form.querySelector('button');
        this.markAdding(btn);
        if (document.querySelector('cart-drawer[data-open-on-add]')) return; // the drawer handles it
        e.preventDefault();
        this.add(new FormData(form), btn);
      }

      markAdding(btn) {
        if (!btn) return;
        btn.setAttribute('aria-busy', 'true');
        const onUpdate = () => {
          clearTimeout(t);
          btn.removeAttribute('aria-busy');
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 1800);
        };
        const t = setTimeout(() => {
          document.removeEventListener('cart:updated', onUpdate);
          btn.removeAttribute('aria-busy');
        }, 6000);
        document.addEventListener('cart:updated', onUpdate, { once: true });
      }

      async add(body, btn) {
        try {
          const res = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          });
          const data = await res.json();
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || 'This item could not be added.');
          const cart = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }).then(
            (r) => r.json()
          );
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'flash-sale' } }));
          this.announce('Added to your bag.');
        } catch (err) {
          if (btn) btn.removeAttribute('aria-busy');
          this.announce(err.message);
          const card = btn && btn.closest('[data-fs-card]');
          if (card) {
            let note = card.querySelector('.fs-card__stock--err');
            if (!note) {
              note = document.createElement('p');
              note.className = 'fs-card__stock fs-card__stock--out fs-card__stock--err';
              card.querySelector('.fs-card__info').appendChild(note);
            }
            note.textContent = err.message;
          }
        }
      }

      /* ---------- Shelf ---------- */
      initShelf(signal) {
        this.track = this.querySelector('[data-fs-track]');
        this.nav = this.querySelector('[data-fs-nav]');
        if (!this.track || !this.nav) return;
        this.thumb = this.nav.querySelector('[data-fs-thumb]');
        this.prev = this.nav.querySelector('[data-fs-prev]');
        this.next = this.nav.querySelector('[data-fs-next]');
        let ticking = false;
        const update = () => {
          ticking = false;
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.nav.hidden = max <= 2;
          if (max <= 2) return;
          const x = Math.abs(this.track.scrollLeft);
          const size = this.track.clientWidth / this.track.scrollWidth;
          const pos = x / max;
          this.thumb.style.transform = `translate3d(${(pos * (1 - size) * 100).toFixed(
            3
          )}%, 0, 0) scaleX(${size.toFixed(4)})`;
          this.prev.disabled = x <= 2;
          this.next.disabled = x >= max - 2;
        };
        const request = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(update);
        };
        this.track.addEventListener('scroll', request, { passive: true, signal });
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(request);
          this.ro.observe(this.track);
        }
        update();
      }

      step(dir) {
        const card = this.track && this.track.querySelector('[data-fs-card]');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const w = card.getBoundingClientRect().width + gap;
        const per = Math.max(1, Math.floor((this.track.clientWidth + gap) / w) - 1);
        this.track.scrollBy({ left: dir * w * per, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      /* ---------- Reveal ---------- */
      initReveal() {
        const cards = Array.from(this.querySelectorAll('[data-fs-card]'));
        if (!cards.length || reduceMotion.matches || this.editor || !('IntersectionObserver' in window)) return;
        const track = this.querySelector('[data-fs-track]');
        if (track.getBoundingClientRect().top < window.innerHeight) return;
        cards.forEach((c, i) => c.style.setProperty('--i', Math.min(i, 6)));
        this.classList.add('has-reveal');
        this.revealIO = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) return;
            this.classList.add('is-revealed');
            this.revealIO.disconnect();
            setTimeout(() => this.classList.remove('has-reveal', 'is-revealed'), 1600);
          },
          { threshold: 0.15 }
        );
        this.revealIO.observe(track);
      }
    }

    customElements.define('flash-sale', FlashSale);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fold-poster"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('fold-poster')) return;
    const moving = window.matchMedia('(prefers-reduced-motion: no-preference)');
    const RAD = Math.PI / 180;
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
    const smooth = (k) => k * k * (3 - 2 * k);

    class FoldPoster extends HTMLElement {
      connectedCallback() {
        this.poster = this.querySelector('[data-fo-poster]');
        if (!this.poster || this.ac) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.mode = this.dataset.unfold === 'view' ? 'view' : 'scroll';
        this.fold = Number(this.dataset.fold) || 62;
        this.open = 0;
        this.goal = 0;
        this.held = false;
        this.near = false;
        this.tickFn = (t) => this.tick(t);

        moving.addEventListener('change', () => this.start(), { signal });
        window.addEventListener('scroll', () => this.kick(), { passive: true, signal });
        window.addEventListener('resize', () => this.kick(), { passive: true, signal });
        /* Reaching a note by keyboard, or choosing one in the editor, opens the poster fully */
        this.addEventListener('focusin', () => this.hold(true), { signal });
        this.addEventListener(
          'focusout',
          (e) => {
            if (!this.contains(e.relatedTarget)) this.hold(false);
          },
          { signal }
        );
        this.addEventListener('shopify:block:select', () => this.hold(true), { signal });
        this.addEventListener('shopify:block:deselect', () => this.hold(false), { signal });
        if ('IntersectionObserver' in window) {
          this.seen = new IntersectionObserver(
            (entries) => {
              const entry = entries[entries.length - 1];
              this.near = entry.isIntersecting;
              if (this.mode === 'view' && entry.intersectionRatio >= 0.35) this.goal = 1;
              this.kick();
            },
            { threshold: [0, 0.35] }
          );
          this.seen.observe(this.poster);
        } else {
          this.near = true;
          this.goal = 1;
        }
        this.start();
      }

      /* Start folded when motion is welcome; otherwise leave the poster lying flat */
      start() {
        this.on = moving.matches;
        this.classList.toggle('is-armed', this.on);
        if (!this.on) {
          ['--fo-a', '--fo-c', '--fo-s'].forEach((v) => this.poster.style.removeProperty(v));
          this.classList.add('is-open');
          return;
        }
        this.goal = this.target();
        this.open = this.goal;
        this.apply();
        this.kick();
      }

      hold(on) {
        this.held = on;
        this.kick();
      }

      /* How open it should be: by scroll, it opens as the poster rises from the bottom of the
         screen until its middle is a little below the middle of the screen */
      target() {
        if (this.held) return 1;
        if (this.mode === 'view') return this.goal;
        const r = this.poster.getBoundingClientRect();
        const vh = window.innerHeight || 1;
        const startY = vh * 0.95;
        const endY = vh * 0.62 - r.height / 2;
        return clamp((startY - r.top) / Math.max(1, startY - endY), 0, 1);
      }

      kick() {
        if (this.raf || !this.on || !this.near || !this.ac) return;
        this.last = 0;
        this.raf = requestAnimationFrame(this.tickFn);
      }

      tick(now) {
        this.raf = 0;
        if (!this.on) return;
        const dt = this.last ? Math.min(50, now - this.last) : 16;
        this.last = now;
        const goal = this.held ? 1 : this.target();
        if (this.mode === 'view' || this.held) {
          /* opening on its own: a set pace, eased in and out by the fold curve, landing exactly */
          const pace = dt / (this.held ? 500 : 1300);
          this.open = goal > this.open ? Math.min(goal, this.open + pace) : Math.max(goal, this.open - pace);
        } else {
          /* following the scroll: quick, with a little softness */
          this.open += (goal - this.open) * (1 - Math.exp(-dt / 110));
          if (Math.abs(goal - this.open) < 0.002) this.open = goal;
        }
        this.apply();
        if (this.open !== goal) this.raf = requestAnimationFrame(this.tickFn);
      }

      apply() {
        const a = this.fold * (1 - smooth(clamp(this.open, 0, 1)));
        const r = a * RAD;
        const st = this.poster.style;
        st.setProperty('--fo-a', `${a.toFixed(2)}deg`);
        st.setProperty('--fo-c', Math.cos(r).toFixed(4));
        st.setProperty('--fo-s', Math.sin(r).toFixed(4));
        this.classList.toggle('is-open', this.open > 0.85);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.ac = null;
        if (this.seen) this.seen.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }
    }

    customElements.define('fold-poster', FoldPoster);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('site-footer')) return;

    const root = document.documentElement;
    // Theme settings › Animations "None" counts as reduced motion for every visitor.
    const reduceMotion = window.matchMedia(root.dataset.motion === 'none' ? 'all' : '(prefers-reduced-motion: reduce)');
    const mobileMQ = window.matchMedia('(max-width: 749px)');

    class SiteFooter extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const editor = !!(window.Shopify && window.Shopify.designMode);

        this.initAccordions(signal);
        this.initInView();
        this.initDrift(signal);
        this.initReveal(editor);
        this.initBackToTop(signal);

        this.querySelectorAll('[data-ft-autosubmit]').forEach((select) => {
          select.addEventListener('change', () => select.form && select.form.submit(), { signal });
        });

        if (editor) {
          document.addEventListener(
            'shopify:block:select',
            (e) => {
              if (!this.contains(e.target)) return;
              const toggle = e.target.querySelector('[data-ft-toggle]');
              if (toggle) this.setOpen(toggle, true);
            },
            { signal }
          );
        }
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.viewIO) this.viewIO.disconnect();
        if (this.io) this.io.disconnect();
        if (this.markIO) this.markIO.disconnect();
        if (this.ro) this.ro.disconnect();
      }

      /* Mobile accordions (lists stay open from tablet up) */
      initAccordions(signal) {
        this.toggles = Array.from(this.querySelectorAll('[data-ft-toggle]'));
        const sync = () => this.toggles.forEach((t) => this.setOpen(t, !mobileMQ.matches));
        this.toggles.forEach((t) =>
          t.addEventListener(
            'click',
            () => {
              if (!mobileMQ.matches) return;
              this.setOpen(t, t.getAttribute('aria-expanded') !== 'true', true);
            },
            { signal }
          )
        );
        mobileMQ.addEventListener('change', sync, { signal });
        sync();
      }

      setOpen(toggle, open, animate) {
        const isOpen = open || !mobileMQ.matches;
        const body = document.getElementById(toggle.getAttribute('aria-controls'));
        toggle.setAttribute('aria-expanded', String(isOpen));
        if (!body) return;
        body.hidden = !isOpen;
        body.classList.remove('is-opening');
        if (isOpen && animate && !reduceMotion.matches) {
          void body.offsetWidth;
          body.classList.add('is-opening');
        }
      }

      /* Loops only run while the footer is on screen */
      initInView() {
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-inview');
          return;
        }
        this.viewIO = new IntersectionObserver(([entry]) => this.classList.toggle('is-inview', entry.isIntersecting), {
          rootMargin: '100px 0px',
        });
        this.viewIO.observe(this);
      }

      /* Constant speed in px/s, whatever the number or size of photos */
      initDrift(signal) {
        const track = this.querySelector('[data-ft-track]');
        if (!track || !this.classList.contains('ft--drift')) return;
        const speed = Math.max(parseFloat(this.dataset.speed) || 30, 5);
        const measure = () => {
          const w = track.offsetWidth;
          if (w > 0) this.style.setProperty('--ft-dur', `${(w / speed).toFixed(2)}s`);
        };
        measure();
        if ('ResizeObserver' in window) {
          let last = 0;
          this.ro = new ResizeObserver(([entry]) => {
            const w = Math.round(entry.contentRect.width);
            if (w === last) return;
            last = w;
            measure();
          });
          this.ro.observe(track);
        }

        const btn = this.querySelector('[data-ft-pause]');
        if (btn) {
          btn.addEventListener(
            'click',
            () => {
              this.userPaused = btn.getAttribute('aria-pressed') !== 'true';
              btn.setAttribute('aria-pressed', String(this.userPaused));
              this.classList.toggle('is-paused', this.userPaused);
            },
            { signal }
          );
        }
      }

      initReveal(editor) {
        const items = Array.from(this.querySelectorAll('[data-ft-reveal]'));
        const mark = this.querySelector('[data-ft-mark]');
        // Theme settings › Animations: "reveal on scroll" off (or motion off) shows everything at once.
        const instant =
          reduceMotion.matches || editor || root.dataset.reveal === 'none' || !('IntersectionObserver' in window);

        if (instant) {
          this.classList.add('is-mark-in', 'is-mark-ready');
          return;
        }

        // Only hide what is still below the fold, so nothing flashes.
        const vh = window.innerHeight;
        const pending = items.filter((el) => el.getBoundingClientRect().top >= vh);
        if (pending.length) {
          this.classList.add('has-reveal');
          items.filter((el) => !pending.includes(el)).forEach((el) => el.classList.add('is-revealed'));
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-revealed');
                this.io.unobserve(entry.target);
              });
            },
            { threshold: 0.1 }
          );
          pending.forEach((el) => this.io.observe(el));
        }

        if (mark) {
          this.markIO = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              this.classList.add('is-mark-in');
              this.markIO.disconnect();
              const total = mark.querySelectorAll('.ft-mark__ch, .ft-mark__sp').length;
              const speed = parseFloat(getComputedStyle(root).getPropertyValue('--motion-speed')) || 1;
              // Hover ripple turns on once the entrance has finished.
              setTimeout(() => this.classList.add('is-mark-ready'), 1120 * speed + total * 45);
            },
            { threshold: 0.3 }
          );
          this.markIO.observe(mark);
        }
      }

      initBackToTop(signal) {
        const btn = this.querySelector('[data-ft-top]');
        if (!btn) return;
        let ticking = false;
        let visible = false;
        const update = () => {
          ticking = false;
          const show = window.scrollY > window.innerHeight * 0.8;
          if (show === visible) return;
          visible = show;
          btn.classList.toggle('is-visible', show);
        };
        window.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(update);
          },
          { passive: true, signal }
        );
        btn.addEventListener(
          'click',
          () => {
            window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
            const target = document.getElementById('MainContent');
            if (target) target.focus({ preventScroll: true });
          },
          { signal }
        );
        update();
      }
    }

    customElements.define('site-footer', SiteFooter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-ring"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('gallery-ring')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const DEG = 180 / Math.PI;
    const REST = 3500;
    const ease = (k) => 1 - Math.pow(1 - k, 3);
    const pad = (v) => String(v).padStart(2, '0');

    class GalleryRing extends HTMLElement {
      connectedCallback() {
        this.ring = this.querySelector('[data-gr-ring]');
        this.stage = this.querySelector('[data-gr-stage]');
        this.cards = Array.from(this.querySelectorAll('[data-gr-card]'));
        this.count = this.cards.length;
        if (!this.ring || !this.stage || this.count < 2) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.step = 360 / this.count;
        this.reach = Number(this.dataset.reach) || 1.2;
        this.motion = this.dataset.motion || 'spin';
        this.speed = Math.max(2, Number(this.dataset.speed) || 10);
        this.hold = Math.max(1, Number(this.dataset.hold) || 4) * 1000;
        this.way = this.dataset.dir === 'right' ? 1 : -1;
        this.paused = this.motion === 'none' || reduceMotion.matches;
        this.angle = 0;
        this.front = -1;
        this.glide = null;
        this.spin = 0;
        this.per = 0.2;
        this.restUntil = 0;
        this.calmSince = performance.now();
        this.region = this.querySelector('[data-gr-show]') || this;
        this.capBox = this.querySelector('[data-gr-caps]');
        this.caps = Array.from(this.querySelectorAll('[data-gr-cap]'));
        this.nowEl = this.querySelector('[data-gr-now]');
        this.playBtn = this.querySelector('[data-gr-play]');
        this.base = 'translateZ(calc(var(--gr-r) * -1)) rotateX(calc(var(--gr-tilt) * -1))';

        // Linked pictures are reached from the words under the ring, so the keyboard does not stop on every card
        this.cards.forEach((card) => {
          const link = card.querySelector('a[href]');
          if (link) link.setAttribute('tabindex', '-1');
        });

        this.bindHand();
        this.addEventListener('click', (e) => {
          const t = e.target instanceof Element ? e.target : null;
          if (!t) return;
          if (t.closest('[data-gr-play]')) return this.setPaused(!this.paused, true);
          const arrow = t.closest('[data-gr-go]');
          if (arrow) this.shift(Number(arrow.dataset.grGo) || 1);
        }, { signal });
        this.region.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          this.shift(e.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        // Keyboard focus inside holds the ring still; a mouse click on a button does not
        this.region.addEventListener('focusin', (e) => {
          let seen = true;
          try {
            seen = e.target instanceof Element && e.target.matches(':focus-visible');
          } catch (err) {}
          this.inside = seen;
          this.calm();
        }, { signal });
        this.region.addEventListener('focusout', (e) => {
          if (e.relatedTarget instanceof Node && this.region.contains(e.relatedTarget)) return;
          this.inside = false;
          this.calm();
          this.kick();
        }, { signal });
        this.addEventListener('shopify:block:select', (e) => {
          const card = e.target instanceof Element ? e.target.closest('[data-gr-card]') : null;
          if (!card) return;
          this.editing = true;
          this.goTo(Number(card.dataset.grCard) || 0);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => {
          this.editing = false;
          this.touch();
          this.kick();
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          this.calm();
          this.kick();
        }, { signal });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.measure());
          this.ro.observe(this.stage);
        }
        this.measure();

        // The ring swings into place the first time it comes into view
        const swing = this.classList.contains('gr--animate') && !reduceMotion.matches;
        if (swing) {
          this.angle = -this.way * 60;
          this.intro = true;
          this.classList.add('is-armed');
        }
        this.paint(true);
        this.paintPlay();
        if ('IntersectionObserver' in window) {
          this.seen = new IntersectionObserver((entries) => {
            this.visible = entries[entries.length - 1].isIntersecting;
            if (this.visible && !this.shown) this.reveal(swing);
            this.calm();
            this.kick();
          }, { threshold: 0.15 });
          this.seen.observe(this.stage);
        } else {
          this.visible = true;
          this.reveal(swing);
        }
        this.classList.add('is-ready');
      }

      reveal(swing) {
        this.shown = true;
        this.classList.add('is-shown');
        if (swing) this.glideTo(0, 1500);
      }

      measure() {
        const w = this.cards[0].offsetWidth;
        if (w) this.per = (DEG / (w * this.reach)) * 0.95;
      }

      /* ---------- Where the ring stands ---------- */

      nearest(a) {
        return Math.round(a / this.step) * this.step;
      }

      frontAt(a) {
        const i = Math.round(-a / this.step) % this.count;
        return (i + this.count) % this.count;
      }

      paint(force) {
        this.ring.style.transform = `${this.base} rotateY(${this.angle.toFixed(3)}deg)`;
        // While it swings in, the first card stays the front one
        const f = this.intro ? 0 : this.frontAt(this.angle);
        if (f === this.front && !force) return;
        this.front = f;
        this.cards.forEach((card, i) => card.classList.toggle('is-front', i === f));
        this.caps.forEach((cap, i) => {
          cap.hidden = i !== f;
        });
        if (this.nowEl) this.nowEl.textContent = pad(f + 1);
      }

      glideTo(to, dur) {
        this.spin = 0;
        const from = this.angle;
        if (reduceMotion.matches || Math.abs(to - from) < 0.01) {
          this.glide = null;
          this.angle = to;
          this.paint();
          this.settle();
          this.kick();
          return;
        }
        this.glide = { from, to, t0: performance.now(), dur: dur || Math.min(1100, 420 + Math.abs(to - from) * 6) };
        this.kick();
      }

      goTo(i) {
        const from = this.glide ? this.glide.to : this.angle;
        const diff = ((((-i * this.step - from) % 360) + 540) % 360) - 180;
        this.glideTo(from + diff);
      }

      /* One card on (1) or back (-1) */
      shift(by) {
        this.touch();
        const from = this.glide ? this.glide.to : this.nearest(this.angle);
        this.glideTo(from - by * this.step);
      }

      settle() {
        this.intro = false;
        this.calm();
        if (Math.abs(this.angle) > 7200) this.angle -= Math.round(this.angle / 360) * 360;
      }

      /* ---------- Turning on its own ---------- */

      calm() {
        this.calmSince = performance.now();
      }

      touch() {
        this.intro = false;
        this.restUntil = performance.now() + REST;
        this.calm();
        this.classList.add('is-touched');
        if (this.capBox) this.capBox.setAttribute('aria-live', 'polite');
      }

      setPaused(on, byHand) {
        if (this.motion === 'none') return;
        this.paused = on;
        if (byHand) this.touch();
        if (on) {
          if (!this.glide && !this.press) this.glideTo(this.nearest(this.angle));
        } else {
          this.restUntil = 0;
          if (this.motion === 'step' && !this.glide) this.glideTo(this.nearest(this.angle) + this.way * this.step);
        }
        this.paintPlay();
        this.kick();
      }

      paintPlay() {
        const on = !this.paused && this.motion !== 'none';
        this.classList.toggle('is-going', on);
        if (this.playBtn) this.playBtn.setAttribute('aria-label', on ? 'Stop turning' : 'Start turning');
        if (this.capBox) this.capBox.setAttribute('aria-live', on ? 'off' : 'polite');
      }

      autoOn() {
        return !this.paused && this.motion !== 'none' && !this.hover && !this.inside && !this.editing && !this.press && this.visible && !document.hidden;
      }

      kick() {
        if (this.raf || !this.visible || document.hidden || !this.ac) return;
        this.last = 0;
        this.raf = requestAnimationFrame((t) => this.loop(t));
      }

      wake(ms) {
        if (this.wakeId) {
          clearTimeout(this.wakeId);
          this.timers.delete(this.wakeId);
        }
        this.wakeId = this.later(() => {
          this.wakeId = 0;
          this.kick();
        }, Math.max(16, ms + 16));
      }

      loop(now) {
        this.raf = 0;
        const dt = this.last ? Math.min(64, now - this.last) : 16;
        this.last = now;
        let more = false;
        if (this.press) {
          more = false;
        } else if (this.glide) {
          const g = this.glide;
          const k = Math.min(1, (now - g.t0) / g.dur);
          this.angle = g.from + (g.to - g.from) * ease(k);
          if (k >= 1) {
            this.glide = null;
            this.angle = g.to;
            this.settle();
          }
          more = true;
        } else if (this.spin) {
          this.angle += this.spin * dt;
          this.spin *= Math.pow(0.93, dt / 16.7);
          if (Math.abs(this.spin) < 0.02) {
            const lead = this.spin * 160;
            this.spin = 0;
            this.glideTo(this.nearest(this.angle + lead));
          }
          more = true;
        } else if (this.autoOn()) {
          if (this.motion === 'spin') {
            if (now >= this.restUntil) {
              this.angle += (this.way * this.speed * dt) / 1000;
              this.hush();
              more = true;
            } else {
              this.wake(this.restUntil - now);
            }
          } else {
            const due = Math.max(this.calmSince + this.hold, this.restUntil);
            if (now >= due) {
              this.hush();
              this.glideTo(this.nearest(this.angle) + this.way * this.step);
              more = true;
            } else {
              this.wake(due - now);
            }
          }
        }
        this.paint();
        if (more && this.visible && !document.hidden && !this.raf) this.raf = requestAnimationFrame((t) => this.loop(t));
      }

      /* While it turns by itself the captions change quietly */
      hush() {
        if (this.capBox && this.capBox.getAttribute('aria-live') !== 'off') this.capBox.setAttribute('aria-live', 'off');
      }

      /* ---------- Turning by hand ---------- */

      bindHand() {
        const signal = this.ac.signal;
        const stage = this.stage;
        stage.addEventListener('dragstart', (e) => e.preventDefault(), { signal });
        stage.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hover = true;
          this.calm();
        }, { signal });
        stage.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.hover = false;
          this.calm();
          this.kick();
        }, { signal });
        stage.addEventListener('pointerdown', (e) => {
          if (e.button > 0) return;
          this.dragged = false;
          // A finger on the ring stops it where it is
          this.press = { x: e.clientX, y: e.clientY, a: this.angle, id: e.pointerId, moved: false, samples: [] };
          this.glide = null;
          this.spin = 0;
          this.intro = false;
          this.classList.add('is-touched');
          this.calm();
        }, { signal });
        stage.addEventListener('pointermove', (e) => {
          const p = this.press;
          if (!p || e.pointerId !== p.id) return;
          const dx = e.clientX - p.x;
          const dy = e.clientY - p.y;
          if (!p.moved) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            if (Math.abs(dy) > Math.abs(dx)) {
              this.press = null;
              return this.letGo(0);
            }
            p.moved = true;
            this.dragged = true;
            try {
              stage.setPointerCapture(e.pointerId);
            } catch (err) {}
            stage.classList.add('is-dragging');
          }
          this.angle = p.a + dx * this.per;
          this.paint();
          p.samples.push({ a: this.angle, t: performance.now() });
          if (p.samples.length > 4) p.samples.shift();
        }, { signal });
        const end = (e) => {
          const p = this.press;
          if (!p || e.pointerId !== p.id) return;
          // On touch screens the card under the finger holds the pointer first; handing it to the stage is not a release
          if (e.type === 'lostpointercapture' && e.target !== stage) return;
          this.press = null;
          stage.classList.remove('is-dragging');
          let fling = 0;
          if (p.moved && e.type === 'pointerup' && p.samples.length > 1) {
            const head = p.samples[0];
            const tail = p.samples[p.samples.length - 1];
            if (performance.now() - tail.t < 90 && tail.t > head.t) fling = Math.max(-0.8, Math.min(0.8, (tail.a - head.a) / (tail.t - head.t)));
          }
          this.letGo(fling);
        };
        stage.addEventListener('pointerup', end, { signal });
        stage.addEventListener('pointercancel', end, { signal });
        stage.addEventListener('lostpointercapture', end, { signal });
        // A tap brings a card forward, opens the front one, or stops and starts the ring
        stage.addEventListener('click', (e) => {
          if (this.dragged) {
            e.preventDefault();
            this.dragged = false;
            return;
          }
          const t = e.target instanceof Element ? e.target : null;
          const card = t ? t.closest('[data-gr-card]') : null;
          if (card) {
            const i = Number(card.dataset.grCard) || 0;
            if (i !== this.front) {
              e.preventDefault();
              this.touch();
              return this.goTo(i);
            }
            if (t.closest('a[href]')) return;
          }
          this.setPaused(!this.paused, true);
        }, { signal });
      }

      letGo(fling) {
        this.touch();
        if (fling && !reduceMotion.matches) {
          this.spin = fling;
          this.kick();
        } else {
          this.glideTo(this.nearest(this.angle));
        }
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
        return id;
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.ac = null;
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        if (this.seen) this.seen.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.wakeId = 0;
      }
    }

    customElements.define('gallery-ring', GalleryRing);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-tunnel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('gallery-tunnel')) return;
    const moving = window.matchMedia('(prefers-reduced-motion: no-preference)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
    const pad = (n) => (n < 10 ? `0${n}` : String(n));

    class GalleryTunnel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-tn-track]');
        this.sticky = this.querySelector('[data-tn-sticky]');
        this.world = this.querySelector('[data-tn-world]');
        this.n = Number(this.dataset.count) || 0;
        if (!this.track || !this.sticky || !this.world || !this.n || this.ac) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.parts = Array.from(this.querySelectorAll('[data-tn-z]')).map((el) => ({ el, z: Number(el.dataset.tnZ) || 0, o: -1, rib: el.classList.contains('tn-rib') }));
        this.cam = 0;
        this.goal = 0;
        this.look = { x: 0, y: 0 };
        this.lookGoal = { x: 0, y: 0 };
        this.near = false;
        this.shown = -1;
        this.nowEl = this.querySelector('[data-tn-now]');
        this.fill = this.querySelector('[data-tn-fill]');
        this.tickFn = (t) => this.tick(t);

        window.addEventListener('scroll', () => this.kick(), { passive: true, signal });
        window.addEventListener('resize', () => this.measure(true), { passive: true, signal });
        moving.addEventListener('change', () => this.measure(true), { signal });
        if (this.classList.contains('tn--look')) {
          this.sticky.addEventListener('pointermove', (e) => {
            if (e.pointerType !== 'mouse' || !finePointer.matches) return;
            const r = this.sticky.getBoundingClientRect();
            this.lookGoal.x = clamp((e.clientX - r.left) / r.width - 0.5, -0.5, 0.5);
            this.lookGoal.y = clamp((e.clientY - r.top) / r.height - 0.5, -0.5, 0.5);
            this.kick();
          }, { passive: true, signal });
          this.sticky.addEventListener('pointerleave', () => {
            this.lookGoal.x = 0;
            this.lookGoal.y = 0;
            this.kick();
          }, { signal });
        }
        /* Keyboard focus on a picture (or the card at the end) walks the tunnel to it */
        this.addEventListener('focusin', (e) => {
          const part = e.target instanceof Element && e.target.closest('[data-tn-z]');
          if (part) this.walkTo(Number(part.dataset.tnZ) || 0, false);
        }, { signal });
        this.addEventListener('shopify:block:select', (e) => {
          const part = e.target instanceof Element && e.target.closest('[data-tn-z]');
          if (part) this.walkTo(Number(part.dataset.tnZ) || 0, true);
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.seen = new IntersectionObserver((entries) => {
            this.near = entries[entries.length - 1].isIntersecting;
            this.kick();
          }, { rootMargin: '200px 0px' });
          this.seen.observe(this.track);
        } else {
          this.near = true;
        }
        this.measure(true);
      }

      /* ---------- Sizes ---------- */

      measure(jump) {
        this.on = moving.matches && getComputedStyle(this.sticky).position === 'sticky';
        if (!this.on) {
          this.world.style.removeProperty('transform');
          this.parts.forEach((p) => {
            p.el.style.removeProperty('opacity');
            p.el.style.removeProperty('pointer-events');
            p.o = -1;
          });
          return;
        }
        this.p = parseFloat(getComputedStyle(this.sticky).perspective) || 800;
        this.d = this.p * 0.9;
        this.depth = this.d * (this.dataset.end === 'true' ? this.n + 1 : this.n);
        this.travel = Math.max(1, this.track.offsetHeight - this.sticky.offsetHeight);
        this.goal = this.read() * this.depth;
        if (jump) this.cam = this.goal;
        this.apply();
      }

      read() {
        const top = this.track.getBoundingClientRect().top;
        return clamp(-top / this.travel, 0, 1);
      }

      /* ---------- Walking ---------- */

      kick() {
        if (this.raf || !this.on || !this.near) return;
        this.last = 0;
        this.raf = requestAnimationFrame(this.tickFn);
      }

      tick(now) {
        this.raf = 0;
        if (!this.on) return;
        const dt = this.last ? Math.min(50, now - this.last) : 16;
        this.last = now;
        this.goal = this.read() * this.depth;
        const k = 1 - Math.exp(-dt / 110);
        this.cam += (this.goal - this.cam) * k;
        if (Math.abs(this.goal - this.cam) < 0.4) this.cam = this.goal;
        const kl = 1 - Math.exp(-dt / 320);
        this.look.x += (this.lookGoal.x - this.look.x) * kl;
        this.look.y += (this.lookGoal.y - this.look.y) * kl;
        if (Math.abs(this.lookGoal.x - this.look.x) < 0.002) this.look.x = this.lookGoal.x;
        if (Math.abs(this.lookGoal.y - this.look.y) < 0.002) this.look.y = this.lookGoal.y;
        const still = this.cam === this.goal && Math.abs(this.lookGoal.x - this.look.x) < 0.001 && Math.abs(this.lookGoal.y - this.look.y) < 0.001;
        this.apply();
        if (!still) this.raf = requestAnimationFrame(this.tickFn);
      }

      apply() {
        const cam = this.cam;
        const turnY = (this.look.x * 5).toFixed(3);
        const turnX = (-this.look.y * 3.5).toFixed(3);
        this.world.style.transform = `rotateX(${turnX}deg) rotateY(${turnY}deg) translate3d(0, 0, ${cam.toFixed(1)}px)`;
        const p = this.p;
        const d = this.d;
        for (const part of this.parts) {
          const rel = cam - part.z * d;
          /* Far away: lost in the haze; close by: fading as it drifts past */
          const far = clamp((rel + d * 3.4) / (d * 2.4), 0, 1);
          const close = part.z === this.n + 1 ? 1 : clamp((p * (part.rib ? 0.75 : 0.5) - rel) / (p * 0.35), 0, 1);
          const o = Math.round(Math.min(far, close) * 50) / 50;
          if (o === part.o) continue;
          part.o = o;
          part.el.style.opacity = String(o);
          part.el.style.pointerEvents = o < 0.35 ? 'none' : '';
        }
        const progress = this.depth ? cam / this.depth : 0;
        this.classList.toggle('is-moving', progress > 0.02);
        const i = clamp(Math.round(cam / d) - 1, 0, this.n - 1);
        if (i !== this.shown) {
          this.shown = i;
          if (this.nowEl) this.nowEl.textContent = pad(i + 1);
        }
        if (this.fill) this.fill.style.transform = `scaleX(${clamp(progress, 0, 1).toFixed(4)})`;
      }

      /* Scroll the page so a part of the tunnel stands just ahead */
      walkTo(z, smooth) {
        if (!this.on) return;
        const ahead = z === this.n + 1 ? 0 : this.p * 0.32;
        const target = clamp((z * this.d - ahead) / this.depth, 0, 1);
        const y = this.track.getBoundingClientRect().top + window.scrollY + target * this.travel;
        window.scrollTo({ top: Math.round(y), behavior: smooth ? 'smooth' : 'auto' });
        this.kick();
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.ac = null;
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        if (this.seen) this.seen.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }
    }

    customElements.define('gallery-tunnel', GalleryTunnel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('header-announcements')) return;
    const KEY = 'turblyn:announcements';
    const reduceMotion = window.matchMedia(
      document.documentElement.dataset.motion === 'none' ? 'all' : '(prefers-reduced-motion: reduce)'
    );
    // Theme settings › Animations "Subtle" or "None": no ticker and no turning on a timer
    const calm = () => ['subtle', 'none'].includes(document.documentElement.dataset.motion);

    class HeaderAnnouncements extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.design = this.hasAttribute('data-design');
        if (!this.design && this.querySelector('[data-ha-close]') && this.closed()) {
          this.hidden = true;
          return;
        }
        // Pages can be served from a cache: drop messages whose dates have passed since
        if (!this.design) this.prune();
        if (!this.design && !this.querySelector('[data-ha-msg]')) {
          this.hidden = true;
          return;
        }
        this.stage = this.querySelector('[data-ha-stage]');
        this.pauseBtn = this.querySelector('[data-ha-pause]');

        this.addEventListener(
          'click',
          (e) => {
            const t = e.target;
            if (!(t instanceof Element)) return;
            if (t.closest('[data-ha-close]')) return this.close();
            if (t.closest('[data-ha-pause]')) return this.setPaused(!this.paused);
            if (t.closest('[data-ha-prev]')) return this.go(this.index - 1, -1, true);
            if (t.closest('[data-ha-next]')) return this.go(this.index + 1, 1, true);
          },
          { signal }
        );

        if (this.stage) {
          // Holding still while the visitor reads or tabs through a message
          this.stage.addEventListener(
            'pointerenter',
            (e) => e.pointerType === 'mouse' && this.classList.add('is-held'),
            { signal }
          );
          this.stage.addEventListener('pointerleave', () => this.classList.remove('is-held'), { signal });
          this.stage.addEventListener('focusin', () => this.classList.add('is-held'), { signal });
          this.stage.addEventListener(
            'focusout',
            (e) => {
              if (!this.stage.contains(e.relatedTarget)) this.classList.remove('is-held');
            },
            { signal }
          );
        }

        this.addEventListener(
          'shopify:block:select',
          (e) => {
            const slide = e.target instanceof Element && e.target.closest('[data-ha-msg]');
            this.editorHold = true;
            this.classList.add('is-paused');
            if (slide && this.slides) {
              const i = this.slides.indexOf(slide);
              if (i > -1) this.go(i, 1, false);
            }
          },
          { signal }
        );
        this.addEventListener(
          'shopify:block:deselect',
          () => {
            this.editorHold = false;
            this.classList.toggle('is-paused', !!this.paused);
          },
          { signal }
        );

        if (this.dataset.mode === 'marquee') this.setupTicker();
        else this.setupTurns();
      }

      /* ---------- Taking turns ---------- */

      setupTurns() {
        const signal = this.ac.signal;
        this.slides = Array.from(this.querySelectorAll('.ha-slide[data-ha-msg]'));
        this.live = this.querySelector('[data-ha-slides]');
        this.bar = this.querySelector('[data-ha-progress]');
        if (!this.slides.length) return;
        this.index = this.slides.findIndex((slide) => slide.classList.contains('is-on'));
        if (this.index < 0) {
          this.index = 0;
          this.slides[0].classList.add('is-on');
        }
        this.label();
        const single = this.slides.length < 2;
        this.classList.toggle('ha--single', single);
        if (single) return;

        this.auto = this.dataset.autoplay === 'true' && !calm();
        if (this.auto && this.bar) {
          this.bar.addEventListener('animationend', () => this.go(this.index + 1, 1, false), { signal });
          this.run();
        }

        // A sideways swipe moves to the next or previous message
        this.live.addEventListener(
          'pointerdown',
          (e) => {
            this.from = e.pointerType !== 'mouse' && e.isPrimary ? { x: e.clientX, y: e.clientY } : null;
          },
          { passive: true, signal }
        );
        this.live.addEventListener(
          'pointerup',
          (e) => {
            const from = this.from;
            this.from = null;
            if (!from) return;
            const dx = e.clientX - from.x;
            if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(e.clientY - from.y) * 1.5) return;
            const rtl = getComputedStyle(this).direction === 'rtl';
            const step = dx < 0 !== rtl ? 1 : -1;
            this.go(this.index + step, step, true);
            this.swiped = true;
            this.later(() => (this.swiped = false), 400);
          },
          { signal }
        );
        this.live.addEventListener('pointercancel', () => (this.from = null), { signal });
        this.live.addEventListener(
          'click',
          (e) => {
            if (!this.swiped) return;
            this.swiped = false;
            e.preventDefault();
          },
          { signal, capture: true }
        );
      }

      go(i, dir, byHand) {
        if (!this.slides || this.slides.length < 2) return;
        const n = this.slides.length;
        const next = ((i % n) + n) % n;
        if (next === this.index) return;
        const from = this.slides[this.index];
        const to = this.slides[next];
        // Turning back rolls the other way; settle the direction before anything moves
        this.stage.classList.toggle('is-back', dir < 0);
        void this.stage.offsetWidth;
        this.slides.forEach((slide) => slide.classList.remove('is-out'));
        from.classList.remove('is-on');
        from.classList.add('is-out');
        to.classList.add('is-on');
        this.index = next;
        this.live.setAttribute('aria-live', byHand ? 'polite' : 'off');
        this.label();
        this.run();
      }

      label() {
        this.slides.forEach((slide, k) => {
          slide.setAttribute('aria-label', `${k + 1} of ${this.slides.length}`);
          if (k === this.index) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
      }

      /* The thread along the seam is the clock: when it is sewn, the next message comes */
      run() {
        if (!this.auto || !this.bar) return;
        this.bar.classList.remove('is-running');
        void this.bar.offsetWidth;
        this.bar.classList.add('is-running');
      }

      /* ---------- Ticker ---------- */

      setupTicker() {
        if (calm()) return;
        this.track = this.querySelector('[data-ha-track]');
        this.group = this.querySelector('[data-ha-group]');
        if (!this.track || !this.group) return;
        this.fill();
        if ('ResizeObserver' in window) {
          let last = 0;
          this.ro = new ResizeObserver((entries) => {
            const w = Math.round(entries[0].contentRect.width);
            if (w === last) return;
            last = w;
            clearTimeout(this.refill);
            this.refill = setTimeout(() => this.fill(), 150);
          });
          this.ro.observe(this.track.parentElement);
        }
      }

      /* Enough copies to cover the bar twice over; the track moves by exactly one copy and starts again */
      fill() {
        this.track.querySelectorAll('[data-ha-clone]').forEach((c) => c.remove());
        const w = this.group.getBoundingClientRect().width;
        const room = this.track.parentElement.clientWidth;
        if (!w || !room) return;
        const copies = Math.ceil(room / w) + 1;
        for (let k = 0; k < copies; k += 1) {
          const copy = this.group.cloneNode(true);
          copy.removeAttribute('data-ha-group');
          copy.setAttribute('data-ha-clone', '');
          copy.setAttribute('aria-hidden', 'true');
          copy
            .querySelectorAll('[data-shopify-editor-block]')
            .forEach((x) => x.removeAttribute('data-shopify-editor-block'));
          copy.querySelectorAll('a, button').forEach((x) => x.setAttribute('tabindex', '-1'));
          this.track.appendChild(copy);
        }
        const speed = Math.max(10, Number(this.dataset.speed) || 40);
        this.style.setProperty('--ha-shift', `${w}px`);
        this.style.setProperty('--ha-mdur', `${(w / speed).toFixed(2)}s`);
        this.classList.add('is-live');
      }

      /* ---------- Pause, dates, closing ---------- */

      setPaused(on) {
        this.paused = on;
        this.classList.toggle('is-paused', on || !!this.editorHold);
        if (this.pauseBtn) this.pauseBtn.setAttribute('aria-label', on ? 'Play announcements' : 'Pause announcements');
      }

      prune() {
        const now = Date.now();
        this.querySelectorAll('[data-ha-msg]').forEach((m) => {
          const start = Number(m.dataset.start) || 0;
          const end = Number(m.dataset.end) || 0;
          if ((start && now < start) || (end && now > end)) m.remove();
        });
      }

      closed() {
        const sig = this.dataset.sig;
        try {
          if (window.sessionStorage.getItem(KEY) === sig) return true;
          const kept = JSON.parse(window.localStorage.getItem(KEY) || 'null');
          return !!(kept && kept.sig === sig && kept.until > Date.now());
        } catch (e) {
          return false;
        }
      }

      close() {
        const sig = this.dataset.sig;
        const days = { day: 1, week: 7, month: 30 }[this.dataset.memory] || 0;
        try {
          if (days) window.localStorage.setItem(KEY, JSON.stringify({ sig, until: Date.now() + days * 86400000 }));
          else window.sessionStorage.setItem(KEY, sig);
        } catch (e) {}
        const hadFocus = this.contains(document.activeElement);
        const done = () => {
          this.hidden = true;
          this.classList.remove('is-closing');
          if (!hadFocus) return;
          // Hand the focus to what now comes first: the header
          const section = this.closest('.shopify-section');
          const next = section && section.nextElementSibling;
          const target = next && next.querySelector('a[href], button:not([disabled])');
          if (target) target.focus();
        };
        if (reduceMotion.matches) return done();
        this.classList.add('is-closing');
        // Wait out the fade, which follows the theme's motion speed
        const fade = parseFloat(getComputedStyle(this).transitionDuration) * 1000 || 0;
        this.later(done, fade + 20);
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        clearTimeout(this.refill);
        if (this.ro) this.ro.disconnect();
      }
    }

    customElements.define('header-announcements', HeaderAnnouncements);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-3d"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-3d')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const RAD = Math.PI / 180;
    const norm = (a) => ((a % 360) + 360) % 360;
    const apart = (a, b) => {
      const d = Math.abs(norm(a) - norm(b));
      return Math.min(d, 360 - d);
    };
    /* Signed shortest way from a to b, in degrees */
    const toward = (a, b) => ((norm(b) - norm(a) + 540) % 360) - 180;
    const WINDOW = 25;
    const REST = 2500;

    class Hero3D extends HTMLElement {
      connectedCallback() {
        this.view = this.querySelector('[data-hx-view]');
        if (!this.view) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.kind = this.dataset.kind;
        this.turns = this.kind === 'spin' || this.kind === 'model';
        this.speed = Math.max(5, Number(this.dataset.speed) || 25);
        this.way = this.dataset.dir === 'left' ? -1 : 1;
        this.auto = this.dataset.auto === 'true' && !reduceMotion.matches;
        this.scrollTurn = this.dataset.scroll === 'true' && !reduceMotion.matches;
        // Turning pieces start only when asked to; a single picture sways unless motion is reduced
        this.paused = this.turns ? !this.auto : reduceMotion.matches;
        this.angle = 0;
        this.shown = -1;
        this.restUntil = 0;
        this.visible = false;
        this.progress = 0;
        this.plate = this.querySelector('[data-hx-plate]');
        this.mark = this.querySelector('[data-hx-mark]');
        this.ticks = Array.from(this.querySelectorAll('[data-hx-tick]'));
        this.chips = Array.from(this.querySelectorAll('[data-hx-chip]'));
        this.playBtn = this.querySelector('[data-hx-play]');

        this.addEventListener('click', (e) => {
          const t = e.target;
          if (!(t instanceof Element)) return;
          if (t.closest('[data-hx-play]')) return this.setPaused(!this.paused, true);
          const chip = t.closest('[data-hx-chip]');
          if (chip) this.turnTo(Number(chip.dataset.hxChip) || 0);
        }, { signal });
        this.addEventListener('shopify:block:select', (e) => {
          const chip = e.target instanceof Element && e.target.querySelector('[data-hx-chip]');
          if (chip) this.turnTo(Number(chip.dataset.hxChip) || 0);
        }, { signal });
        document.addEventListener('visibilitychange', () => this.kick(), { signal });
        window.addEventListener('scroll', () => this.queueScroll(), { passive: true, signal });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.measure());
          this.ro.observe(this.view);
          if (this.plate) this.ro.observe(this.plate);
        }
        this.measure();

        if (this.kind === 'model') this.setupModel();
        else if (this.kind === 'spin') this.setupSpin();
        else this.setupTilt();

        if ('IntersectionObserver' in window) {
          this.seen = new IntersectionObserver((entries) => {
            this.visible = entries[entries.length - 1].isIntersecting;
            this.kick();
          }, { threshold: 0.1 });
          this.seen.observe(this.view);
        } else {
          this.visible = true;
        }
        // A hero is usually on screen from the start: get its pictures or 3D viewer going right away
        this.prepare();
        this.readScroll();
        this.paintPlay();
        this.setAngle(0, true);
      }

      /* ---------- Where it faces ---------- */

      setAngle(a, force) {
        this.angle = norm(a);
        if (this.kind === 'spin') this.render();
        const whole = Math.round(this.angle) % 360;
        if (!force && whole === this.shown) return;
        this.shown = whole;
        this.paintMark();
        if (this.view.getAttribute('role') === 'slider') {
          this.view.setAttribute('aria-valuenow', String(whole));
          this.view.setAttribute('aria-valuetext', `${whole} degrees`);
        }
        this.chips.forEach((c) => {
          if (apart(Number(c.dataset.hxChip) || 0, this.angle) <= WINDOW) c.setAttribute('aria-current', 'true');
          else c.removeAttribute('aria-current');
        });
        this.ticks.forEach((t) => t.classList.toggle('is-on', apart(Number(t.dataset.hxTick) || 0, this.angle) <= WINDOW));
      }

      spot(a) {
        const r = norm(a) * RAD;
        return { x: Math.sin(r) * this.rx, y: Math.cos(r) * this.ry, front: Math.cos(r) >= 0 };
      }

      paintMark() {
        if (!this.mark || !this.rx) return;
        const pt = this.spot(this.angle);
        this.mark.style.setProperty('--hx-mx', `${pt.x.toFixed(1)}px`);
        this.mark.style.setProperty('--hx-my', `${pt.y.toFixed(1)}px`);
        this.mark.style.setProperty('--hx-ms', pt.front ? '1' : '0.7');
        this.mark.style.setProperty('--hx-mo', pt.front ? '1' : '0.45');
      }

      measure() {
        if (this.plate) {
          this.rx = this.plate.clientWidth / 2;
          this.ry = this.plate.clientHeight / 2;
          this.ticks.forEach((t) => {
            const pt = this.spot(Number(t.dataset.hxTick) || 0);
            t.style.transform = `translate3d(${pt.x.toFixed(1)}px, ${pt.y.toFixed(1)}px, 0)`;
          });
          this.paintMark();
        }
        if (this.canvas) this.fit();
      }

      /* ---------- Scrolling turns it further ---------- */

      queueScroll() {
        if (this.scrollRaf) return;
        this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = 0;
          this.readScroll();
        });
      }

      readScroll() {
        const r = this.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        const progress = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height)));
        const delta = progress - this.progress;
        this.progress = progress;
        if (reduceMotion.matches) return;
        this.style.setProperty('--hx-p', progress.toFixed(4));
        if (!this.scrollTurn || !delta) return;
        if (this.kind === 'spin') this.setAngle(this.angle + delta * 180 * this.way);
        else if (this.kind === 'model') this.nudgeModel(delta * 180 * this.way);
      }

      /* ---------- Turning on its own ---------- */

      setPaused(on, byHand) {
        this.paused = on;
        if (!on) this.restUntil = 0;
        this.classList.toggle('is-paused', on);
        if (this.kind === 'model') this.applyAuto();
        this.paintPlay();
        if (byHand) this.say(on ? 'Stopped.' : this.turns ? 'Turning.' : 'Moving.');
        this.kick();
      }

      paintPlay() {
        const on = !this.paused;
        this.classList.toggle('is-going', on);
        this.classList.toggle('is-paused', !on);
        if (!this.playBtn) return;
        if (this.turns) this.playBtn.setAttribute('aria-label', on ? 'Stop turning' : 'Turn on its own');
        else this.playBtn.setAttribute('aria-label', on ? 'Stop moving' : 'Start moving');
      }

      turning() {
        return !this.paused && !this.holding && this.visible && !document.hidden && this.ready && performance.now() >= this.restUntil;
      }

      kick() {
        if (this.raf || !this.visible || document.hidden || !this.turns) return;
        this.last = 0;
        this.raf = requestAnimationFrame((t) => this.loop(t));
      }

      loop(now) {
        this.raf = 0;
        const dt = this.last ? Math.min(64, now - this.last) : 16;
        this.last = now;
        let more = false;
        if (this.kind === 'model') {
          more = this.readModel(now);
        } else if (this.inertia) {
          this.setAngle(this.angle + this.inertia * dt);
          this.inertia *= Math.pow(0.92, dt / 16.7);
          if (Math.abs(this.inertia) < 0.003) this.inertia = 0;
          more = true;
        } else if (this.turning()) {
          this.setAngle(this.angle + (this.way * this.speed * dt) / 1000);
          more = true;
        } else if (!this.paused && this.ready) {
          more = true;
        }
        if (more && this.visible && !document.hidden) this.raf = requestAnimationFrame((t) => this.loop(t));
      }

      /* ---------- Turning by hand ---------- */

      bindHand(target) {
        const signal = this.ac.signal;
        target.addEventListener('pointerdown', (e) => {
          if (e.button > 0) return;
          this.press = { x: e.clientX, y: e.clientY, t: performance.now(), a: this.angle, id: e.pointerId, moved: false, samples: [] };
          this.inertia = 0;
          this.holding = true;
          this.classList.add('is-touched');
        }, { signal });
        target.addEventListener('pointermove', (e) => {
          const p = this.press;
          if (!p || e.pointerId !== p.id) return;
          const dx = e.clientX - p.x;
          const dy = e.clientY - p.y;
          if (!p.moved) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            if (Math.abs(dy) > Math.abs(dx)) {
              this.press = null;
              this.holding = false;
              this.restUntil = performance.now() + 600;
              return this.kick();
            }
            p.moved = true;
            if (this.kind === 'spin') {
              try {
                target.setPointerCapture(e.pointerId);
              } catch (err) {}
              this.view.classList.add('is-dragging');
            }
          }
          if (this.kind !== 'spin') return;
          const per = 360 / Math.max(260, this.view.clientWidth * 1.15);
          const a = p.a + dx * per * this.way;
          this.setAngle(a);
          p.samples.push({ a, t: performance.now() });
          if (p.samples.length > 4) p.samples.shift();
        }, { signal });
        const end = (e) => {
          const p = this.press;
          if (!p || (e && e.pointerId !== p.id)) return;
          this.press = null;
          this.holding = false;
          this.view.classList.remove('is-dragging');
          const now = performance.now();
          if (p.moved) {
            if (this.kind === 'spin' && p.samples.length > 1) {
              const s0 = p.samples[0];
              const s1 = p.samples[p.samples.length - 1];
              if (now - s1.t < 80 && s1.t > s0.t) this.inertia = Math.max(-1.2, Math.min(1.2, (s1.a - s0.a) / (s1.t - s0.t)));
            }
          } else if (e && e.type === 'pointerup' && now - p.t < 350) {
            // A tap stops it, another tap sets it going again
            this.setPaused(!this.paused, true);
          }
          this.restUntil = now + REST;
          this.kick();
        };
        target.addEventListener('pointerup', end, { signal });
        target.addEventListener('pointercancel', end, { signal });
        target.addEventListener('lostpointercapture', end, { signal });
      }

      turnTo(a) {
        if (!this.turns) return;
        this.classList.add('is-touched');
        this.setPaused(true);
        if (this.kind === 'model') return this.nudgeModel(toward(this.angle, a));
        this.inertia = 0;
        const from = this.angle;
        const by = toward(from, a);
        if (reduceMotion.matches || !by) return this.setAngle(a);
        const start = performance.now();
        const span = Math.min(900, 300 + Math.abs(by) * 4);
        cancelAnimationFrame(this.glide);
        const step = (now) => {
          const k = Math.min(1, (now - start) / span);
          this.setAngle(from + by * (1 - Math.pow(1 - k, 3)));
          if (k < 1) this.glide = requestAnimationFrame(step);
        };
        this.glide = requestAnimationFrame(step);
      }

      /* ---------- Pictures all the way round ---------- */

      setupSpin() {
        const signal = this.ac.signal;
        this.canvas = this.querySelector('.hx-canvas');
        this.bindHand(this.view);
        this.view.addEventListener('keydown', (e) => {
          const steps = { ArrowRight: 15, ArrowUp: 15, ArrowLeft: -15, ArrowDown: -15, PageUp: 90, PageDown: -90 };
          let next = null;
          if (e.key in steps) next = this.angle + steps[e.key];
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = 180;
          else if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            return this.setPaused(!this.paused, true);
          }
          if (next === null) return;
          e.preventDefault();
          this.classList.add('is-touched');
          this.setPaused(true);
          this.setAngle(next);
        }, { signal });
      }

      prepare() {
        if (this.kind === 'model') return this.loadModel();
        if (this.kind !== 'spin' || this.frames) return;
        const data = this.querySelector('script[data-hx-frames]');
        let list = [];
        try {
          list = JSON.parse(data ? data.textContent : '[]');
        } catch (e) {
          list = [];
        }
        if (list.length < 2) return;
        this.frames = list.map(() => null);
        const big = this.view.clientWidth * Math.min(2, window.devicePixelRatio || 1) > 1000;
        let settled = 0;
        const after = () => {
          settled += 1;
          if (settled === list.length && this.frames && this.frames.some(Boolean)) {
            this.ready = true;
            this.classList.add('is-ready');
            this.kick();
          }
        };
        // The first picture comes first; the rest follow once it is in
        const fetchOne = (i) => {
          const img = new Image();
          img.decoding = 'async';
          img.src = big ? list[i].l : list[i].s;
          const ok = img.decode ? img.decode() : new Promise((res, rej) => {
            img.onload = res;
            img.onerror = rej;
          });
          return ok.then(() => {
            if (!this.frames) return;
            this.frames[i] = img;
            if (i === 0 || this.index() === i) this.render(true);
            after();
          }, after);
        };
        fetchOne(0).then(() => {
          for (let i = 1; i < list.length; i += 1) fetchOne(i);
        });
      }

      index() {
        const n = this.frames ? this.frames.length : 0;
        return n ? Math.round((this.angle / 360) * n) % n : 0;
      }

      fit() {
        const dpr = Math.min(2, window.devicePixelRatio || 1);
        const w = Math.round(this.canvas.clientWidth * dpr);
        const h = Math.round(this.canvas.clientHeight * dpr);
        if (!w || !h) return;
        if (this.canvas.width !== w || this.canvas.height !== h) {
          this.canvas.width = w;
          this.canvas.height = h;
        }
        this.drawn = -1;
        this.render(true);
      }

      render(force) {
        if (!this.frames || !this.canvas) return;
        const n = this.frames.length;
        let i = this.index();
        if (!this.frames[i]) {
          for (let d = 1; d < n; d += 1) {
            if (this.frames[(i + d) % n]) {
              i = (i + d) % n;
              break;
            }
            if (this.frames[(i - d + n) % n]) {
              i = (i - d + n) % n;
              break;
            }
          }
        }
        const img = this.frames[i];
        if (!img || (!force && i === this.drawn)) return;
        const ctx = this.canvas.getContext('2d');
        const cw = this.canvas.width;
        const ch = this.canvas.height;
        const scale = Math.min(cw / img.naturalWidth, ch / img.naturalHeight);
        const w = img.naturalWidth * scale;
        const h = img.naturalHeight * scale;
        ctx.clearRect(0, 0, cw, ch);
        ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
        this.drawn = i;
        this.classList.add('is-live');
      }

      /* ---------- One picture that leans ---------- */

      setupTilt() {
        const signal = this.ac.signal;
        this.tilt = this.querySelector('[data-hx-tilt]');
        this.ready = true;
        if (!this.tilt) return;
        const stage = this.querySelector('.hx-stage');
        // The whole column listens, so the pointer over a tag still leads the picture
        const area = this.querySelector('.hx-stagecol') || stage;
        area.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse' || !finePointer.matches || reduceMotion.matches) return;
          const r = stage.getBoundingClientRect();
          const x = Math.max(-0.5, Math.min(0.5, (e.clientX - r.left) / r.width - 0.5));
          const y = Math.max(-0.5, Math.min(0.5, (e.clientY - r.top) / r.height - 0.5));
          this.tilt.classList.add('is-led');
          this.tilt.style.setProperty('--hx-ry', `${(x * 18).toFixed(2)}deg`);
          this.tilt.style.setProperty('--hx-rx', `${(-y * 12).toFixed(2)}deg`);
        }, { passive: true, signal });
        area.addEventListener('pointerleave', () => {
          this.tilt.classList.remove('is-led');
          this.tilt.style.setProperty('--hx-ry', '0deg');
          this.tilt.style.setProperty('--hx-rx', '0deg');
        }, { signal });
      }

      /* ---------- A 3D model ---------- */

      setupModel() {
        const signal = this.ac.signal;
        this.mv = this.querySelector('model-viewer');
        if (!this.mv) return;
        this.bindHand(this.mv);
        this.mv.addEventListener('camera-change', () => {
          this.activeUntil = performance.now() + 900;
          this.kick();
        }, { signal });
      }

      loadModel() {
        if (!this.mv || this.asked) return;
        this.asked = true;
        const give = this.later(() => !this.ready && this.still(), 10000);
        const go = () => {
          customElements.whenDefined('model-viewer').then(() => {
            if (!this.isConnected) return;
            clearTimeout(give);
            const mv = this.mv;
            mv.setAttribute('rotation-per-second', `${this.way * this.speed}deg`);
            mv.setAttribute('auto-rotate-delay', String(REST));
            mv.setAttribute('interaction-prompt', 'none');
            mv.setAttribute('touch-action', 'pan-y');
            mv.setAttribute('disable-zoom', '');
            this.applyAuto();
            const live = () => {
              this.ready = true;
              this.classList.add('is-live', 'is-ready');
              this.kick();
            };
            if (mv.loaded) live();
            else mv.addEventListener('load', live, { once: true, signal: this.ac.signal });
            mv.addEventListener('error', () => this.still(), { once: true, signal: this.ac.signal });
          });
        };
        if (customElements.get('model-viewer')) go();
        else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: (err) => (err ? this.still() : go()) }]);
        } else {
          this.still();
        }
        this.loadXR();
      }

      /* The 3D viewer could not start: the picture stays, the controls go */
      still() {
        this.classList.add('is-still');
        const c = this.querySelector('.hx-controls');
        if (c) c.hidden = true;
      }

      applyAuto() {
        if (!this.mv) return;
        if (!this.paused) this.mv.setAttribute('auto-rotate', '');
        else this.mv.removeAttribute('auto-rotate');
      }

      readModel(now) {
        const mv = this.mv;
        if (!mv || !this.ready || typeof mv.getCameraOrbit !== 'function') return false;
        const orbit = mv.getCameraOrbit();
        const turned = Number(mv.turntableRotation) || 0;
        this.setAngle((turned - orbit.theta) / RAD);
        return !this.paused || now < (this.activeUntil || 0);
      }

      /* Swing the camera round by some degrees (scrolling, or turning to a tag) */
      nudgeModel(by) {
        const mv = this.mv;
        if (!mv || !this.ready || typeof mv.getCameraOrbit !== 'function' || !by) return;
        const orbit = mv.getCameraOrbit();
        mv.cameraOrbit = `${orbit.theta - by * RAD}rad ${orbit.phi}rad ${orbit.radius}m`;
        this.activeUntil = performance.now() + 1500;
        this.kick();
      }

      loadXR() {
        const json = this.querySelector('script[data-hx-models]');
        if (!json || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
        window.Shopify.loadFeatures([{
          name: 'shopify-xr',
          version: '1.0',
          onLoad: (err) => {
            if (err) return;
            const setup = () => {
              if (!window.ShopifyXR) {
                document.addEventListener('shopify_xr_initialized', setup, { once: true });
                return;
              }
              try {
                window.ShopifyXR.addModels(JSON.parse(json.textContent));
                window.ShopifyXR.setupXRElements();
              } catch (e) {
                /* no AR on this device */
              }
            };
            setup();
          },
        }]);
      }

      say(text) {
        const live = this.querySelector('[data-hx-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
        return id;
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        if (this.seen) this.seen.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
        cancelAnimationFrame(this.glide);
        this.raf = 0;
        this.scrollRaf = 0;
        this.frames = null;
      }
    }

    customElements.define('hero-3d', Hero3D);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-duo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-duo')) return;
    const KEY = 'turblyn:side';
    const wide = window.matchMedia('(min-width: 990px)');

    /* Respect the shop's cookie banner when it is on the page */
    const allowed = () => {
      try {
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (privacy && typeof privacy.preferencesProcessingAllowed === 'function') {
          return privacy.preferencesProcessingAllowed() !== false;
        }
      } catch (e) {}
      return true;
    };

    class HeroDuo extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('[data-hd-stage]');
        this.picks = Array.from(this.querySelectorAll('[data-hd-pick]'));
        if (!this.stage || this.picks.length < 2) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.remember = this.hasAttribute('data-remember');

        let side = this.dataset.side === 'b' ? 'b' : 'a';
        if (this.remember) {
          try {
            const kept = window.localStorage.getItem(KEY);
            if (kept === 'a' || kept === 'b') side = kept;
          } catch (e) {}
        }
        this.show(side, false);

        this.addEventListener('click', (e) => {
          const t = e.target;
          if (!(t instanceof Element)) return;
          // A swipe ends with the finger on whatever was under it: that is not a tap
          if (this.swiped) {
            this.swiped = false;
            if (t.closest('a, button')) e.preventDefault();
            return;
          }
          const pick = t.closest('[data-hd-pick]');
          if (pick) return this.show(pick.dataset.hdPick, true);
          // Shopping from one side tells us which side this visitor likes
          const link = t.closest('a[href]');
          const panel = link && link.closest('[data-hd-side]');
          if (panel) this.keep(panel.dataset.hdSide);
        }, { signal });

        this.addEventListener('keydown', (e) => {
          const pick = e.target instanceof Element && e.target.closest('[data-hd-pick]');
          if (!pick || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
          e.preventDefault();
          let next = pick.dataset.hdPick === 'a' ? 'b' : 'a';
          if (e.key === 'Home') next = 'a';
          if (e.key === 'End') next = 'b';
          this.show(next, true);
          const target = this.picks.find((p) => p.dataset.hdPick === next);
          if (target) target.focus();
        }, { signal });

        // A sideways swipe turns to the other side when only one shows
        this.stage.addEventListener('pointerdown', (e) => {
          this.from = e.pointerType !== 'mouse' && e.isPrimary && this.switching() ? { x: e.clientX, y: e.clientY } : null;
        }, { passive: true, signal });
        this.stage.addEventListener('pointerup', (e) => {
          const from = this.from;
          this.from = null;
          if (!from) return;
          const dx = e.clientX - from.x;
          const dy = e.clientY - from.y;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          const next = (dx < 0) !== rtl ? 'b' : 'a';
          if (next === this.side) return;
          this.show(next, true);
          this.swiped = true;
          this.later(() => (this.swiped = false), 450);
        }, { signal });
        this.stage.addEventListener('pointercancel', () => (this.from = null), { signal });
      }

      /* Only one side on screen right now? */
      switching() {
        return (wide.matches ? this.dataset.desktop : this.dataset.mobile) === 'switch';
      }

      show(side, byHand) {
        this.side = side === 'b' ? 'b' : 'a';
        this.dataset.side = this.side;
        this.picks.forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.hdPick === this.side)));
        if (byHand) this.keep(this.side);
      }

      keep(side) {
        if (!this.remember || !allowed()) return;
        try {
          window.localStorage.setItem(KEY, side);
        } catch (e) {}
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('hero-duo', HeroDuo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-banner')) {
    class HeroBanner extends HTMLElement {
      constructor() {
        super();
        this.handleToggle = this.handleToggle.bind(this);
        this.handleIntersect = this.handleIntersect.bind(this);
      }

      connectedCallback() {
        this.video = this.querySelector('.hero__video');
        this.toggle = this.querySelector('.hero__pause');
        this.inView = true;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.toggle) this.toggle.addEventListener('click', this.handleToggle);

        if (this.video) {
          this.video.muted = true;
          this.video.playsInline = true;
        }

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.handleIntersect, { threshold: 0 });
          this.observer.observe(this);
        }

        this.update();
      }

      disconnectedCallback() {
        if (this.toggle) this.toggle.removeEventListener('click', this.handleToggle);
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        if (this.video) this.video.pause();
      }

      handleToggle() {
        this.paused = !this.paused;
        this.update();
      }

      handleIntersect(entries) {
        const entry = entries[entries.length - 1];
        if (!entry) return;
        this.inView = entry.isIntersecting;
        this.update();
      }

      update() {
        this.setAttribute('data-motion', this.paused ? 'paused' : 'playing');
        this.toggleAttribute('data-offscreen', !this.inView);
        if (this.toggle) this.toggle.setAttribute('aria-pressed', String(this.paused));

        if (!this.video) return;

        if (this.paused || !this.inView) {
          this.video.pause();
          return;
        }

        const playback = this.video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
      }
    }

    customElements.define('hero-banner', HeroBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('image-with-text')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class ImageWithText extends HTMLElement {
      connectedCallback() {
        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.io.disconnect();
            this.classList.add('is-in');
            this.timer = setTimeout(() => this.classList.add('is-settled'), 1800);
          },
          { rootMargin: '0px 0px -12% 0px' }
        );
        this.io.observe(this);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        clearTimeout(this.timer);
      }
    }

    customElements.define('image-with-text', ImageWithText);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-book"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lookbook-book')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const TURN = 950; /* how long a page takes to land, a little over the CSS turn */
    const pad = (n) => (n < 10 ? `0${n}` : String(n));
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

    class LookbookBook extends HTMLElement {
      connectedCallback() {
        this.book = this.querySelector('[data-bk-book]');
        this.view = this.querySelector('[data-bk-view]');
        this.leaves = Array.from(this.querySelectorAll('[data-bk-leaf]'));
        this.L = this.leaves.length;
        if (!this.book || !this.view || !this.L || this.ac) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.m = Number(this.dataset.pages) || 0;
        this.t = 0;
        this.side = 'r';
        this.turning = new Map();
        this.dragEnd = 0;
        this.small = window.matchMedia('(max-width: 749px)');
        this.faces = this.leaves.map((leaf) => [leaf.querySelector('.bk-face--front'), leaf.querySelector('.bk-face--back')]);
        this.edges = { l: this.querySelector('[data-bk-edge="l"]'), r: this.querySelector('[data-bk-edge="r"]') };
        this.now = this.querySelector('[data-bk-now]');
        this.fill = this.querySelector('[data-bk-fill]');
        this.live = this.querySelector('[data-bk-live]');
        this.prevBtn = this.querySelector('[data-bk-go="-1"]');
        this.nextBtn = this.querySelector('[data-bk-go="1"]');

        this.addEventListener('click', (e) => {
          const go = e.target instanceof Element && e.target.closest('[data-bk-go]');
          if (!go) return;
          this.classList.add('is-touched');
          if (go.dataset.bkGo === '1' && !this.next()) this.go(0, 'r');
          else if (go.dataset.bkGo === '-1') this.prev();
          this.announce();
        }, { signal });
        this.addEventListener('keydown', (e) => {
          if (!(e.target instanceof Element) || !e.target.closest('.bk-stage')) return;
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          this.classList.add('is-touched');
          if (e.key === 'ArrowRight') this.next();
          else this.prev();
          this.announce();
        }, { signal });
        this.addEventListener('shopify:block:select', (e) => {
          const face = e.target instanceof Element && e.target.closest('[data-bk-page]');
          if (face) this.show(Number(face.dataset.bkPage));
        }, { signal });
        this.small.addEventListener('change', () => {
          if (this.t === 0) this.side = 'r';
          else if (this.t === this.L) this.side = 'l';
          this.paint();
        }, { signal });
        this.bindHand();

        const designMode = window.Shopify && window.Shopify.designMode;
        const below = this.getBoundingClientRect().top > window.innerHeight;
        if (!designMode && below && !reduceMotion.matches) this.classList.add('is-armed');
        this.peek = !designMode && !reduceMotion.matches && this.classList.contains('bk--animate');
        if ('IntersectionObserver' in window) {
          this.seen = new IntersectionObserver((entries) => {
            if (!entries[entries.length - 1].isIntersecting) return;
            this.seen.disconnect();
            this.arrive();
          }, { threshold: 0.35 });
          this.seen.observe(this.view);
        } else {
          this.arrive();
        }
        this.paint();
        this.classList.add('is-ready');
      }

      /* First time in view: the words rise and the cover lifts a little, then settles */
      arrive() {
        this.classList.add('is-in');
        if (!this.peek || this.t !== 0 || this.press) return;
        const cover = this.leaves[0];
        cover.classList.add('is-peek');
        this.later(() => cover.classList.remove('is-peek'), 650);
      }

      /* ---------- Where the book is open ---------- */

      /* t = how many leaves have been turned; side = which page a phone shows */
      shiftOf(t, side) {
        if (this.small.matches) return side === 'l' ? 25 : -25;
        if (t === 0) return -25;
        if (t === this.L) return 25;
        return 0;
      }

      stepFrom(dir) {
        const t = this.t;
        if (this.small.matches) {
          if (dir > 0) {
            if (this.side === 'l' && t < this.L) return { t, side: 'r' };
            if (this.side === 'r' && t < this.L) return { t: t + 1, side: 'l' };
            return null;
          }
          if (this.side === 'r' && t > 0) return { t, side: 'l' };
          if (this.side === 'l' && t > 0) return { t: t - 1, side: 'r' };
          return null;
        }
        const n = t + dir;
        if (n < 0 || n > this.L) return null;
        return { t: n, side: n === 0 ? 'r' : 'l' };
      }

      next() {
        const step = this.stepFrom(1);
        if (step) this.go(step.t, step.side);
        return !!step;
      }

      prev() {
        const step = this.stepFrom(-1);
        if (step) this.go(step.t, step.side);
        return !!step;
      }

      /* Open the book at a page (by its place: 0 is the cover) */
      show(i) {
        const t = i % 2 ? (i + 1) / 2 : i / 2;
        this.go(clamp(t, 0, this.L), i % 2 ? 'l' : 'r');
      }

      go(t, side) {
        const from = this.t;
        if (t !== from) {
          const fwd = t > from;
          const a = Math.min(t, from);
          const b = Math.max(t, from);
          for (let j = a; j < b; j += 1) this.lift(j, fwd);
        }
        this.t = t;
        this.side = side;
        this.paint();
      }

      /* A leaf in the air rides above both stacks until it lands */
      lift(j, fwd) {
        const leaf = this.leaves[j];
        if (this.turning.has(j)) clearTimeout(this.turning.get(j));
        leaf.classList.add('is-turning');
        leaf.style.zIndex = String(this.L * 4 + (fwd ? j : this.L - j));
        const id = setTimeout(() => {
          this.timers.delete(id);
          this.turning.delete(j);
          leaf.classList.remove('is-turning');
          this.paintLeaf(j);
        }, TURN);
        this.timers.add(id);
        this.turning.set(j, id);
      }

      paintLeaf(j) {
        const leaf = this.leaves[j];
        const turned = j < this.t;
        leaf.classList.toggle('is-turned', turned);
        leaf.classList.toggle('is-top', j === this.t);
        leaf.classList.toggle('is-top-l', j === this.t - 1);
        leaf.classList.toggle('is-far', j < this.t - 2 || j > this.t + 1);
        if (!this.turning.has(j)) leaf.style.zIndex = String(turned ? j + 1 : this.L * 2 - j);
      }

      paint() {
        const t = this.t;
        const small = this.small.matches;
        for (let j = 0; j < this.L; j += 1) this.paintLeaf(j);
        this.classList.toggle('is-start', t === 0);
        this.classList.toggle('is-end', t === this.L);
        this.classList.toggle('is-left', this.side === 'l');
        const span = Math.max(1, this.L - 1);
        if (this.edges.r) this.edges.r.style.transform = `scaleX(${clamp((this.L - 1 - t) / span, 0, 1).toFixed(3)})`;
        if (this.edges.l) this.edges.l.style.transform = `scaleX(${clamp((t - 1) / span, 0, 1).toFixed(3)})`;

        /* Only the pages in view can be reached */
        const shown = new Set();
        if (t >= 1 && (!small || this.side === 'l')) shown.add(this.faces[t - 1][1]);
        if (t < this.L && (!small || this.side === 'r')) shown.add(this.faces[t][0]);
        this.faces.forEach((pair) => pair.forEach((f) => {
          if (f) f.inert = !shown.has(f);
        }));
        const active = document.activeElement;
        if (active && this.contains(active) && active.closest('[inert]') && this.nextBtn) this.nextBtn.focus({ preventScroll: true });

        const label = this.label();
        if (this.now) this.now.textContent = label.short;
        const done = small ? (this.side === 'r' ? 2 * t : 2 * t - 1) / (2 * this.L - 1) : t / this.L;
        if (this.fill) this.fill.style.transform = `scaleX(${clamp(done, 0, 1).toFixed(4)})`;
        if (this.prevBtn) this.prevBtn.disabled = !this.stepFrom(-1);
        if (this.nextBtn) this.nextBtn.setAttribute('aria-label', this.stepFrom(1) ? 'Next page' : 'Back to the cover');
      }

      label() {
        const t = this.t;
        const m = this.m;
        if (t === 0) return { short: 'Cover', long: 'Cover' };
        if (t === this.L && (this.small.matches ? this.side === 'l' : true)) return { short: 'Back cover', long: 'Back cover' };
        const left = 2 * t - 1;
        const right = 2 * t;
        if (this.small.matches) {
          const i = this.side === 'l' ? left : right;
          const shownNum = Math.min(i, m);
          return { short: `${pad(shownNum)} / ${pad(m)}`, long: `Page ${shownNum} of ${m}` };
        }
        if (right > m) return { short: `${pad(left)} / ${pad(m)}`, long: `Page ${left} of ${m}` };
        return { short: `${pad(left)}–${pad(right)} / ${pad(m)}`, long: `Pages ${left} and ${right} of ${m}` };
      }

      announce() {
        if (!this.live) return;
        const text = this.label().long;
        this.live.textContent = '';
        this.later(() => {
          if (this.live) this.live.textContent = text;
        }, 60);
      }

      /* ---------- Turning by hand ---------- */

      bindHand() {
        const signal = this.ac.signal;
        const view = this.view;
        view.addEventListener('dragstart', (e) => e.preventDefault(), { signal });
        view.addEventListener('pointerdown', (e) => {
          if (e.button > 0 || !e.isPrimary) return;
          this.press = { x: e.clientX, y: e.clientY, id: e.pointerId, moved: false, step: null, p: 0, samples: [] };
        }, { signal });
        view.addEventListener('pointermove', (e) => {
          const p = this.press;
          if (!p || e.pointerId !== p.id) return;
          const dx = e.clientX - p.x;
          const dy = e.clientY - p.y;
          if (!p.moved) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
            if (Math.abs(dy) > Math.abs(dx)) {
              this.press = null;
              return;
            }
            const dir = dx < 0 ? 1 : -1;
            const to = this.stepFrom(dir);
            if (!to) {
              this.press = null;
              return;
            }
            p.moved = true;
            p.dir = dir;
            p.step = this.describe(to, dir);
            p.width = Math.max(120, (this.book.clientWidth / 2) * 1.2);
            try {
              view.setPointerCapture(e.pointerId);
            } catch (err) {
              /* the pointer is gone */
            }
            this.classList.add('is-touched');
            this.hold(p.step);
          }
          p.p = clamp((-dx * p.dir) / p.width, 0, 1);
          p.samples.push({ x: e.clientX, t: performance.now() });
          if (p.samples.length > 5) p.samples.shift();
          this.drag(p.step, p.p);
        }, { signal });
        const end = (e) => {
          const p = this.press;
          if (!p || (e && e.pointerId !== p.id)) return;
          this.press = null;
          if (!p.moved) return;
          this.dragEnd = performance.now();
          let flick = 0;
          const s0 = p.samples[0];
          const s1 = p.samples[p.samples.length - 1];
          if (s0 && s1 && s1.t > s0.t && this.dragEnd - s1.t < 90) flick = ((s0.x - s1.x) * p.dir) / (s1.t - s0.t);
          const done = e && e.type !== 'pointercancel' && (p.p > 0.32 || (flick > 0.35 && p.p > 0.04));
          this.release(p.step, done);
          if (done) this.announce();
        };
        view.addEventListener('pointerup', end, { signal });
        view.addEventListener('pointercancel', end, { signal });
        /* Taking the pointer over from the page under the finger makes that page "lose" it;
           only the book itself losing it means the hand has gone */
        view.addEventListener('lostpointercapture', (e) => {
          if (e.target === view) end(e);
        }, { signal });

        /* A tap on a page turns it: the right-hand page forward, the left-hand page back.
           On phones the right part of the page goes on and the left part goes back. */
        view.addEventListener('click', (e) => {
          if (performance.now() - this.dragEnd < 400) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          const t = e.target;
          if (!(t instanceof Element) || t.closest('a, button')) return;
          let dir = 0;
          if (this.small.matches) {
            const r = view.getBoundingClientRect();
            dir = e.clientX > r.left + r.width * 0.4 ? 1 : -1;
          } else {
            const face = t.closest('.bk-face');
            if (face && face.classList.contains('bk-face--front')) dir = 1;
            else if (face) dir = -1;
          }
          if (!dir) return;
          this.classList.add('is-touched');
          if (dir > 0) this.next();
          else this.prev();
        }, { signal });
      }

      /* What a step moves: a leaf turning over the spine and/or the book sliding */
      describe(to, dir) {
        const turns = to.t !== this.t;
        return {
          to,
          dir,
          leaf: turns ? this.leaves[dir > 0 ? this.t : this.t - 1] : null,
          s0: this.shiftOf(this.t, this.side),
          s1: this.shiftOf(to.t, to.side),
        };
      }

      hold(step) {
        this.book.style.transition = 'none';
        if (!step.leaf) return;
        const j = this.leaves.indexOf(step.leaf);
        if (this.turning.has(j)) {
          clearTimeout(this.turning.get(j));
          this.turning.delete(j);
        }
        step.leaf.classList.add('is-turning', 'is-held');
        step.leaf.style.transition = 'none';
        step.leaf.style.zIndex = String(this.L * 5);
      }

      drag(step, k) {
        const shift = step.s0 + (step.s1 - step.s0) * k;
        this.book.style.transform = `translate3d(${shift.toFixed(2)}%, 0, 0)`;
        if (!step.leaf) return;
        /* The page's outer edge follows the hand across the spread */
        const lifted = (Math.acos(1 - 2 * k) * 180) / Math.PI;
        const a = step.dir > 0 ? -lifted : -180 + lifted;
        step.leaf.style.transform = `rotateY(${a.toFixed(2)}deg)`;
        step.leaf.style.setProperty('--bk-sh', (Math.sin(k * Math.PI) * 0.85).toFixed(3));
      }

      /* Let go: the page carries on over, or falls back, from wherever the hand left it */
      release(step, done) {
        this.book.style.removeProperty('transition');
        this.book.style.removeProperty('transform');
        if (step.leaf) {
          const leaf = step.leaf;
          const j = this.leaves.indexOf(leaf);
          leaf.classList.remove('is-held');
          leaf.style.removeProperty('transition');
          leaf.style.removeProperty('transform');
          leaf.style.removeProperty('--bk-sh');
          this.lift(j, step.dir > 0);
        }
        if (done) {
          this.t = step.to.t;
          this.side = step.to.side;
        }
        this.paint();
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
        return id;
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.ac = null;
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        if (this.seen) this.seen.disconnect();
        this.press = null;
      }
    }

    customElements.define('lookbook-book', LookbookBook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
  if (!customElements.get('not-found-scene')) {
    class NotFoundScene extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-parallax')) return;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: no-preference) and (pointer: fine)');
        if (!this.motionQuery.matches) return;

        this.target = { x: 0, y: 0 };
        this.current = { x: 0, y: 0 };
        this.frame = null;
        this.maxOffset = 14;

        this.onMove = this.onMove.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.tick = this.tick.bind(this);

        this.addEventListener('pointermove', this.onMove, { passive: true });
        this.addEventListener('pointerleave', this.onLeave, { passive: true });
      }

      disconnectedCallback() {
        this.removeEventListener('pointermove', this.onMove);
        this.removeEventListener('pointerleave', this.onLeave);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      onMove(event) {
        if (!this.rect || event.timeStamp - (this.rectStamp || 0) > 500) {
          this.rect = this.getBoundingClientRect();
          this.rectStamp = event.timeStamp;
        }
        const nx = (event.clientX - this.rect.left) / this.rect.width - 0.5;
        const ny = (event.clientY - this.rect.top) / this.rect.height - 0.5;
        this.target.x = Math.max(-0.5, Math.min(0.5, nx)) * this.maxOffset * 2;
        this.target.y = Math.max(-0.5, Math.min(0.5, ny)) * this.maxOffset;
        this.start();
      }

      onLeave() {
        this.target.x = 0;
        this.target.y = 0;
        this.rect = null;
        this.start();
      }

      start() {
        if (!this.frame) this.frame = requestAnimationFrame(this.tick);
      }

      tick() {
        this.current.x += (this.target.x - this.current.x) * 0.08;
        this.current.y += (this.target.y - this.current.y) * 0.08;

        this.style.setProperty('--nf-x', this.current.x.toFixed(2));
        this.style.setProperty('--nf-y', this.current.y.toFixed(2));

        const settled =
          Math.abs(this.target.x - this.current.x) < 0.05 && Math.abs(this.target.y - this.current.y) < 0.05;

        this.frame = settled ? null : requestAnimationFrame(this.tick);
      }
    }

    customElements.define('not-found-scene', NotFoundScene);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-activate-account"]) return;
  try {
    
  (() => {
    if (customElements.get('activate-account')) return;
    const MIN = 5;

    class ActivateAccount extends HTMLElement {
      connectedCallback() {
        this.ctrl = new AbortController();
        const signal = this.ctrl.signal;
        this.pass = this.querySelector('[data-av-pass]');
        this.confirm = this.querySelector('[data-av-confirm]');
        this.meter = Array.from(this.querySelectorAll('[data-av-meter] i'));
        this.live = this.querySelector('[data-av-live]');
        if (!this.pass || !this.confirm) return;
        this.classList.add('is-js');

        this.querySelectorAll('[data-av-toggle]').forEach((btn) => {
          btn.hidden = false;
          btn.addEventListener(
            'click',
            () => {
              const show = this.pass.type === 'password';
              this.pass.type = show ? 'text' : 'password';
              this.confirm.type = this.pass.type;
              btn.setAttribute('aria-pressed', String(show));
              btn.querySelector('[data-av-toggle-label]').textContent = show ? 'Hide' : 'Show';
            },
            { signal }
          );
        });
        this.addEventListener('input', () => this.update(), { signal });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });
        this.update();

        const alert = this.querySelector('[data-av-alert]');
        if (alert) alert.focus({ preventScroll: false });
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
      }

      update() {
        const len = this.pass.value.length;
        this.meter.forEach((stitch, i) => stitch.classList.toggle('is-on', i < Math.min(10, len)));
        const match = len >= MIN && this.confirm.value === this.pass.value;
        if (match !== this.classList.contains('is-match')) {
          this.classList.toggle('is-match', match);
          if (match && this.live) this.live.textContent = 'Passwords match';
        }
        if (this.pass.closest('.av-field').classList.contains('is-invalid') && len >= MIN) this.clear(this.pass);
        if (
          this.confirm.closest('.av-field').classList.contains('is-invalid') &&
          this.confirm.value &&
          this.confirm.value === this.pass.value
        )
          this.clear(this.confirm);
      }

      onSubmit(e) {
        if (e.submitter && e.submitter.name === 'decline') return;
        let bad = null;
        if (this.pass.value.length < MIN) {
          bad = bad || this.pass;
          this.flag(this.pass, this.pass.value ? 'Use at least ' + MIN + ' characters.' : 'Enter a new password.');
        }
        if (this.confirm.value !== this.pass.value) {
          bad = bad || this.confirm;
          this.flag(this.confirm, "The passwords don't match yet.");
        }
        if (bad) {
          e.preventDefault();
          bad.focus();
        }
      }

      flag(input, text) {
        const field = input.closest('.av-field');
        field.classList.add('is-invalid');
        field.classList.remove('is-shake');
        void field.offsetWidth;
        field.classList.add('is-shake');
        input.setAttribute('aria-invalid', 'true');
        const msg = field.querySelector('[data-av-msg]');
        if (msg) msg.textContent = text;
      }

      clear(input) {
        const field = input.closest('.av-field');
        field.classList.remove('is-invalid', 'is-shake');
        input.removeAttribute('aria-invalid');
        const msg = field.querySelector('[data-av-msg]');
        if (msg) msg.textContent = '';
      }
    }

    customElements.define('activate-account', ActivateAccount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (() => {
    if (customElements.get('address-book')) return;

    class AddressBook extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
        this.ctrl = null;
      }

      setup() {
        if (this.ctrl || !this.isConnected) return;
        this.ctrl = new AbortController();
        const signal = this.ctrl.signal;

        this.querySelectorAll('[data-ad-cancel]').forEach((b) => (b.hidden = false));
        this.querySelectorAll('[data-ad-country]').forEach((sel) => {
          this.pickDefault(sel);
          this.fillRegions(sel, true);
        });

        this.addEventListener(
          'change',
          (e) => {
            if (e.target.matches('[data-ad-country]')) this.fillRegions(e.target, false);
          },
          { signal }
        );
        this.addEventListener(
          'click',
          (e) => {
            const cancel = e.target.closest('[data-ad-cancel]');
            if (!cancel) return;
            const fold = cancel.closest('[data-ad-fold]');
            if (!fold) return;
            fold.open = false;
            const summary = fold.querySelector('summary');
            if (summary) summary.focus();
          },
          { signal }
        );
        // Opening a form puts the cursor in its first field.
        this.addEventListener(
          'toggle',
          (e) => {
            const fold = e.target;
            if (!fold.matches || !fold.matches('[data-ad-fold]') || !fold.open) return;
            const first = fold.querySelector('.ad-field__input, .ad-btn--danger');
            if (first && document.activeElement && fold.contains(document.activeElement))
              first.focus({ preventScroll: true });
          },
          { signal, capture: true }
        );
        this.addEventListener(
          'keydown',
          (e) => {
            if (e.key !== 'Escape') return;
            const fold = e.target.closest && e.target.closest('[data-ad-fold][open]');
            if (!fold) return;
            fold.open = false;
            const summary = fold.querySelector('summary');
            if (summary) summary.focus();
          },
          { signal }
        );

        // A form that came back with errors: show the message first.
        const alert = this.querySelector('[data-ad-alert]');
        if (alert) {
          alert.focus({ preventScroll: true });
          alert.scrollIntoView({ block: 'center' });
        }
      }

      pickDefault(sel) {
        const want = (sel.dataset.default || '').trim();
        if (!want) return;
        const match = Array.from(sel.options).find((o) => o.value === want || o.textContent.trim() === want);
        if (match) sel.value = match.value;
      }

      fillRegions(sel, useDefault) {
        const region = document.getElementById(sel.dataset.province);
        if (!region) return;
        const wrap = region.closest('[data-ad-province-wrap]');
        const opt = sel.selectedOptions[0];
        let list = [];
        try {
          list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]');
        } catch (e) {
          list = [];
        }
        const keep = useDefault ? region.dataset.default : region.value;
        region.innerHTML = '';
        list.forEach((pair) => region.add(new Option(pair[1], pair[0])));
        if (wrap) wrap.hidden = list.length === 0;
        region.disabled = list.length === 0;
        if (keep) {
          const match = Array.from(region.options).find((o) => o.value === keep || o.textContent === keep);
          if (match) region.value = match.value;
        }
      }
    }

    customElements.define('address-book', AddressBook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    if (customElements.get('journal-article')) return;

    class JournalArticle extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        clearTimeout(this.statusTimer);
        this.ctrl = null;
        this.ro = null;
        this.raf = 0;
      }

      setup() {
        if (this.ctrl || !this.isConnected) return;
        this.ctrl = new AbortController();
        const signal = this.ctrl.signal;

        this.read = this.querySelector('[data-ja-read]');
        this.rte = this.querySelector('[data-ja-rte]');
        this.thread = this.querySelector('[data-ja-thread]');
        this.tip = this.querySelector('[data-ja-tip]');

        this.wrapTables();
        this.setupShare(signal);

        if (this.thread) {
          this.measure();
          const tick = () => {
            if (this.raf) return;
            this.raf = requestAnimationFrame(() => {
              this.raf = 0;
              this.update();
            });
          };
          window.addEventListener('scroll', tick, { passive: true, signal });
          window.addEventListener(
            'resize',
            () => {
              this.measure();
              tick();
            },
            { signal }
          );
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(() => {
              this.measure();
              tick();
            });
            this.ro.observe(this.rte);
          }
          this.update();
        }

        // After a comment is sent (or refused), the page reloads at the form: bring its message into focus.
        const msg = this.querySelector('[data-ja-focus]');
        if (msg) msg.focus({ preventScroll: true });
      }

      wrapTables() {
        if (!this.rte) return;
        this.rte.querySelectorAll('table').forEach((table) => {
          if (table.parentElement.classList.contains('ja-table')) return;
          const box = document.createElement('div');
          box.className = 'ja-table';
          box.tabIndex = 0;
          box.setAttribute('role', 'region');
          box.setAttribute('aria-label', 'Table');
          table.before(box);
          box.append(table);
        });
      }

      measure() {
        // the needle rides on the end of the thread, so it travels the thread's length
        this.height = this.thread.offsetHeight;
        this.classList.toggle('is-short', this.read.offsetHeight < window.innerHeight * 1.1);
      }

      update() {
        const rect = this.read.getBoundingClientRect();
        const p = Math.min(1, Math.max(0, (window.innerHeight * 0.4 - rect.top) / Math.max(1, rect.height)));
        this.thread.style.transform = 'scaleY(' + p.toFixed(4) + ')';
        if (this.tip) this.tip.style.transform = 'translate3d(0,' + (p * this.height).toFixed(1) + 'px,0)';
      }

      setupShare(signal) {
        const box = this.querySelector('[data-ja-share]');
        if (!box) return;
        const btn = box.querySelector('[data-ja-share-btn]');
        const field = box.querySelector('[data-ja-share-field]');
        const status = box.querySelector('[data-ja-status]');
        const url = box.dataset.url || window.location.href;
        const title = box.dataset.title || document.title;
        box.hidden = false;

        const say = (text) => {
          status.textContent = text;
          clearTimeout(this.statusTimer);
          this.statusTimer = setTimeout(() => (status.textContent = ''), 3000);
        };
        const showField = () => {
          field.hidden = false;
          field.focus();
          field.select();
          say('Copy the link above.');
        };

        btn.addEventListener(
          'click',
          async () => {
            if (navigator.share) {
              try {
                await navigator.share({ title, url });
                return;
              } catch (error) {
                if (error && error.name === 'AbortError') return;
              }
            }
            try {
              await navigator.clipboard.writeText(url);
              say('Link copied');
            } catch (error) {
              showField();
            }
          },
          { signal }
        );
      }
    }

    customElements.define('journal-article', JournalArticle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (() => {
    if (customElements.get('journal-index')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

    class JournalIndex extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
        if (this.io) this.io.disconnect();
        this.ctrl = null;
        this.io = null;
        this.looping = false;
      }

      setup() {
        if (this.ctrl || !this.isConnected) return;
        this.ctrl = new AbortController();
        this.reveal();
        if (this.classList.contains('jb--hover')) this.setupFloat(this.ctrl.signal);
      }

      // Rows ease in, a few at a time, as they scroll into view.
      reveal() {
        const rows = [...this.querySelectorAll('.jb-row')];
        if (!rows.length || reduceMotion.matches || !('IntersectionObserver' in window)) return;
        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            let k = 0;
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.style.transitionDelay = Math.min(k++ * 60, 360) + 'ms';
              entry.target.classList.add('is-in');
              this.io.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px' }
        );
        rows.forEach((row) => this.io.observe(row));
      }

      setupFloat(signal) {
        this.float = this.querySelector('[data-jb-float]');
        this.card = this.querySelector('[data-jb-card]');
        const list = this.querySelector('[data-jb-list]');
        if (!this.float || !this.card || !list) return;
        this.pics = new Map();
        this.pos = { x: 0, y: 0, tx: 0, ty: 0, tilt: 0 };

        list.addEventListener(
          'pointermove',
          (event) => {
            if (event.pointerType !== 'mouse' || !finePointer.matches || reduceMotion.matches) return;
            this.aim(event.clientX, event.clientY);
            this.show(event.target.closest('.jb-row'));
            this.loop();
          },
          { signal }
        );
        list.addEventListener('pointerleave', () => this.show(null), { signal });
        // The list moves under a still pointer while scrolling: put the print away until it moves again.
        window.addEventListener('scroll', () => this.current && this.show(null), { passive: true, signal });
      }

      aim(x, y) {
        const w = this.float.offsetWidth;
        const h = w * 1.25;
        const right = x + 32 + w < window.innerWidth - 16;
        this.pos.tx = right ? x + 32 : x - 32 - w;
        this.pos.ty = Math.min(window.innerHeight - h - 12, Math.max(12, y - h / 2));
      }

      show(row) {
        const src = row ? row.querySelector('.jb-row__img') : null;
        if (!src) {
          this.current = null;
          this.float.classList.remove('is-on');
          return;
        }
        if (this.current === row) return;
        this.current = row;
        let pic = this.pics.get(row);
        if (!pic) {
          pic = document.createElement('img');
          pic.className = 'jb-float__img';
          pic.alt = '';
          pic.decoding = 'async';
          pic.addEventListener('load', () => pic.classList.add('is-loaded'), { once: true });
          pic.sizes = '240px';
          if (src.getAttribute('srcset')) pic.srcset = src.getAttribute('srcset');
          pic.src = src.getAttribute('src');
          this.card.append(pic);
          this.pics.set(row, pic);
        }
        this.pics.forEach((p) => p.classList.toggle('is-on', p === pic));
        if (!this.float.classList.contains('is-on')) {
          // Appear where the pointer is, rather than flying in from the last spot
          this.pos.x = this.pos.tx;
          this.pos.y = this.pos.ty;
          this.pos.tilt = 0;
          this.paint();
        }
        this.float.classList.add('is-on');
      }

      paint() {
        const p = this.pos;
        this.float.style.transform =
          'translate3d(' + p.x.toFixed(1) + 'px,' + p.y.toFixed(1) + 'px,0) rotate(' + p.tilt.toFixed(2) + 'deg)';
      }

      loop() {
        if (this.looping) return;
        this.looping = true;
        const step = () => {
          if (!this.looping) return;
          const p = this.pos;
          const dx = p.tx - p.x;
          const dy = p.ty - p.y;
          p.x += dx * 0.18;
          p.y += dy * 0.18;
          const lean = Math.max(-7, Math.min(7, dx * 0.05));
          p.tilt += (lean - p.tilt) * 0.2;
          this.paint();
          if (Math.abs(dx) + Math.abs(dy) > 0.3 || Math.abs(p.tilt) > 0.03) requestAnimationFrame(step);
          else this.looping = false;
        };
        requestAnimationFrame(step);
      }
    }

    customElements.define('journal-index', JournalIndex);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  (() => {
    if (customElements.get('collection-decks')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class CollectionDecks extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        this.io = null;
        this.started = false;
      }

      // Decks ease in, a few at a time, as they scroll into view.
      setup() {
        if (this.started || !this.isConnected) return;
        this.started = true;
        const cards = [...this.querySelectorAll('.lc-card')];
        if (!cards.length || reduceMotion.matches || !('IntersectionObserver' in window)) return;
        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            let k = 0;
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.style.transitionDelay = Math.min(k++ * 70, 420) + 'ms';
              entry.target.classList.add('is-in');
              this.io.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -6% 0px' }
        );
        cards.forEach((card) => this.io.observe(card));
      }
    }

    customElements.define('collection-decks', CollectionDecks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (() => {
    if (customElements.get('login-form')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    class LoginForm extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.card = this.querySelector('[data-lg-card]');
        this.nameBox = this.querySelector('[data-lg-name]');
        this.placeholder = this.nameBox ? this.nameBox.textContent.trim() : '';
        this.shown = '';
        this.loginEmail = this.querySelector('[data-lg-view="login"] [data-lg-email]');
        this.pass = this.querySelector('[data-lg-pass]');

        // Take over the view switching from the plain #recover link.
        this.classList.add('is-js', 'is-first');
        // A reset link that was just sent always lands on the sign-in view with its note.
        if (window.location.hash === '#recover' && !this.classList.contains('is-sent'))
          this.classList.add('is-recover');
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-first')));

        this.addEventListener(
          'click',
          (e) => {
            const go = e.target.closest('[data-lg-go]');
            if (!go) return;
            e.preventDefault();
            this.show(go.dataset.lgGo, true);
          },
          { signal }
        );
        window.addEventListener(
          'hashchange',
          () => {
            if (window.location.hash === '#recover') this.show('recover', false);
            else if (window.location.hash === '#login') this.show('login', false);
          },
          { signal }
        );

        this.addEventListener('input', (e) => this.onInput(e), { signal });
        this.addEventListener('blur', (e) => this.onBlur(e), { signal, capture: true });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });

        const toggle = this.querySelector('[data-lg-toggle]');
        if (toggle && this.pass) {
          toggle.addEventListener(
            'click',
            () => {
              const show = this.pass.type === 'password';
              this.pass.type = show ? 'text' : 'password';
              toggle.setAttribute('aria-pressed', String(show));
              toggle.querySelector('[data-lg-toggle-label]').textContent = show ? 'Hide' : 'Show';
            },
            { signal }
          );
        }

        // After a failed attempt or a sent reset link, bring the message into focus.
        const focus = this.visibleFocus();
        if (focus) {
          this.focusMessage(focus);
          // Browsers drop focus when they jump to a #fragment on load; take it back once.
          if (window.location.hash && document.readyState !== 'complete') {
            window.addEventListener(
              'load',
              () =>
                requestAnimationFrame(() => {
                  if (document.activeElement === document.body) this.focusMessage(focus);
                }),
              { once: true, signal }
            );
          }
        }
        this.updateReady();
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
      }

      focusMessage(el) {
        el.focus({ preventScroll: true });
        const r = el.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) el.scrollIntoView({ block: 'center' });
      }

      visibleFocus() {
        const view = this.classList.contains('is-recover') ? 'recover' : 'login';
        return this.querySelector(`[data-lg-view="${view}"] [data-lg-focus]`);
      }

      show(view, fromClick) {
        const recover = view === 'recover';
        if (recover === this.classList.contains('is-recover')) return;
        this.classList.toggle('is-recover', recover);
        if (fromClick)
          history.replaceState(
            history.state,
            '',
            recover ? '#recover' : window.location.pathname + window.location.search
          );
        const box = this.querySelector(`[data-lg-view="${view}"]`);
        // Carry the typed email across so nobody types it twice.
        const from = this.querySelector(`[data-lg-view="${recover ? 'login' : 'recover'}"] [data-lg-email]`);
        const to = box && box.querySelector('[data-lg-email]');
        if (from && to && from.value && !to.value) {
          to.value = from.value;
          if (to === this.loginEmail) this.updateCard();
          this.updateReady();
        }
        const title = box && box.querySelector('[data-lg-title]');
        if (title) title.focus({ preventScroll: true });
        const r = box && box.getBoundingClientRect();
        if (r && (r.top < 0 || r.top > window.innerHeight * 0.8))
          box.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      onInput(e) {
        const t = e.target;
        if (t === this.loginEmail) this.updateCard();
        const field = t.closest('.lg-field');
        if (field && field.classList.contains('is-invalid') && this.check(t, false)) this.clear(field, t);
        this.updateReady();
      }

      onBlur(e) {
        const t = e.target;
        if (!t.matches || !t.matches('[data-lg-email]') || !t.value) return;
        this.check(t, true);
      }

      /* The part before the @ becomes the name on the card */
      updateCard() {
        if (!this.nameBox || !this.loginEmail) return;
        const text = this.loginEmail.value.trim().split('@')[0].slice(0, 22);
        if (text === this.shown) return;
        const prev = this.shown;
        this.shown = text;
        if (this.card) this.card.classList.toggle('is-filled', !!text);
        if (!text) {
          this.nameBox.textContent = '';
          const ph = document.createElement('span');
          ph.className = 'lg-card__ph';
          ph.textContent = this.placeholder;
          this.nameBox.appendChild(ph);
          return;
        }
        let same = 0;
        while (same < prev.length && same < text.length && prev[same] === text[same]) same += 1;
        if (!prev || this.nameBox.querySelector('.lg-card__ph')) {
          this.nameBox.textContent = '';
          same = 0;
        } else {
          Array.from(this.nameBox.querySelectorAll('.lg-card__ch'))
            .slice(same)
            .forEach((c) => c.remove());
        }
        for (let i = same; i < text.length; i += 1) {
          const c = document.createElement('span');
          c.className = 'lg-card__ch';
          c.textContent = text[i];
          if (reduceMotion.matches) c.style.animation = 'none';
          this.nameBox.appendChild(c);
        }
      }

      updateReady() {
        if (!this.card) return;
        const ok =
          this.loginEmail && EMAIL.test(this.loginEmail.value.trim()) && (!this.pass || this.pass.value.length > 0);
        this.card.classList.toggle('is-ready', !!ok);
      }

      check(input, show) {
        let msg = '';
        if (input.matches('[data-lg-email]')) {
          const v = input.value.trim();
          if (!v) msg = 'Please enter your email address.';
          else if (!EMAIL.test(v)) msg = 'That email doesn’t look quite right.';
        } else if (input === this.pass && !input.value) {
          msg = 'Please enter your password.';
        }
        const field = input.closest('.lg-field');
        if (!msg) {
          if (field) this.clear(field, input);
          return true;
        }
        if (show && field) {
          field.classList.add('is-invalid');
          input.setAttribute('aria-invalid', 'true');
          const box = field.querySelector('[data-lg-msg]');
          if (box) box.textContent = msg;
        }
        return false;
      }

      clear(field, input) {
        field.classList.remove('is-invalid');
        input.removeAttribute('aria-invalid');
        const box = field.querySelector('[data-lg-msg]');
        if (box) box.textContent = '';
      }

      onSubmit(e) {
        const form = e.target;
        if (!form.classList.contains('lg-form')) return; // guest checkout form goes straight through
        const inputs = Array.from(form.querySelectorAll('[data-lg-email], [data-lg-pass]'));
        const bad = inputs.filter((i) => !this.check(i, true));
        if (bad.length) {
          e.preventDefault();
          const field = bad[0].closest('.lg-field');
          if (field && !reduceMotion.matches) {
            field.classList.remove('is-shake');
            void field.offsetWidth;
            field.classList.add('is-shake');
          }
          bad[0].focus();
          return;
        }
        const btn = form.querySelector('[data-lg-submit]');
        if (!btn) return;
        if (btn.getAttribute('aria-busy') === 'true') {
          e.preventDefault();
          return;
        }
        btn.setAttribute('aria-busy', 'true');
        window.addEventListener('pageshow', () => btn.removeAttribute('aria-busy'), { once: true });
      }
    }

    customElements.define('login-form', LoginForm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-order"]) return;
  try {
    
  (() => {
    const wire = () => {
      document.querySelectorAll('[data-od-print]').forEach((btn) => {
        if (btn.dataset.odReady) return;
        btn.dataset.odReady = '1';
        btn.hidden = false;
        btn.addEventListener('click', () => window.print());
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire, { once: true });
    else wire();
    document.addEventListener('shopify:section:load', wire);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    if (customElements.get('stitched-page')) return;

    const slugify = (text) =>
      text
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^\p{L}\p{N}]+/gu, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60) || 'section';

    class StitchedPage extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.ctrl = null;
        this.ro = null;
        this.raf = 0;
      }

      setup() {
        if (this.ctrl || !this.isConnected) return;
        this.ctrl = new AbortController();
        const signal = this.ctrl.signal;

        this.read = this.querySelector('[data-mp-read]');
        this.rte = this.querySelector('[data-mp-rte]');
        this.thread = this.querySelector('[data-mp-thread]');
        this.tip = this.querySelector('[data-mp-tip]');
        this.active = -2;

        this.setOffset();
        this.wrapTables();
        this.buildToc(signal);
        this.measure();

        const tick = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = 0;
            this.update();
          });
        };
        this.tick = tick;
        window.addEventListener('scroll', tick, { passive: true, signal });
        window.addEventListener(
          'resize',
          () => {
            this.setOffset();
            this.measure();
            tick();
          },
          { signal }
        );
        // Images and embeds change the height after load
        if ('ResizeObserver' in window && this.rte) {
          this.ro = new ResizeObserver(() => {
            this.measure();
            tick();
          });
          this.ro.observe(this.rte);
        }
        this.update();
      }

      // A sticky header covers the top of the page; headings and the margin list stay clear of it.
      setOffset() {
        const header = document.querySelector('[data-sticky]:not([data-sticky="none"])');
        const h = header ? Math.round(header.getBoundingClientRect().height) : 0;
        this.style.setProperty('--mp-offset', h + 'px');
      }

      wrapTables() {
        if (!this.rte) return;
        this.rte.querySelectorAll('table').forEach((table) => {
          if (table.parentElement.classList.contains('mp-table')) return;
          const box = document.createElement('div');
          box.className = 'mp-table';
          box.tabIndex = 0;
          box.setAttribute('role', 'region');
          box.setAttribute('aria-label', 'Table');
          table.before(box);
          box.append(table);
        });
      }

      buildToc(signal) {
        const wrap = this.querySelector('[data-mp-tocwrap]');
        if (!wrap || !this.rte) return;
        const heads = [...this.rte.querySelectorAll(this.dataset.tocSel || 'h2')].filter((h) => h.textContent.trim());
        if (heads.length < 2) return;

        const used = new Set([...document.querySelectorAll('[id]')].map((el) => el.id));
        const list = wrap.querySelector('[data-mp-list]');
        list.textContent = '';
        heads.forEach((h) => {
          if (!h.id) {
            const base = slugify(h.textContent.trim());
            let id = base;
            let n = 2;
            while (used.has(id)) id = base + '-' + n++;
            h.id = id;
            used.add(id);
          }
          const li = document.createElement('li');
          li.className = 'mp-toc__item' + (h.tagName === 'H3' ? ' mp-toc__item--sub' : '');
          const a = document.createElement('a');
          a.className = 'mp-toc__link';
          a.href = '#' + h.id;
          a.textContent = h.textContent.trim();
          li.append(a);
          list.append(li);
        });

        this.heads = heads;
        this.links = [...list.querySelectorAll('a')];
        this.mark = wrap.querySelector('[data-mp-mark]');
        this.toc = wrap.querySelector('[data-mp-toc]');
        this.tocwrap = wrap;
        const sum = this.toc.querySelector('summary');
        wrap.hidden = false;

        // Margin list on wide screens, folded list on smaller ones
        const mq = window.matchMedia(this.dataset.sideMq || '(min-width: 1240px)');
        const apply = () => {
          const side = mq.matches;
          wrap.classList.toggle('is-side', side);
          this.toc.open = side;
          if (side) sum.setAttribute('aria-hidden', 'true');
          else sum.removeAttribute('aria-hidden');
          sum.tabIndex = side ? -1 : 0;
          this.measureMarks();
          this.active = -2;
          if (this.tick) this.tick();
        };
        mq.addEventListener('change', apply, { signal });
        sum.addEventListener(
          'click',
          (event) => {
            if (mq.matches) event.preventDefault();
          },
          { signal }
        );
        this.toc.addEventListener('toggle', () => this.measureMarks(), { signal });
        apply();

        // A link to one of the headings we just named: go there now that it exists
        const hash = decodeURIComponent(location.hash.slice(1));
        if (hash) {
          const target = document.getElementById(hash);
          if (target && this.rte.contains(target)) {
            try {
              target.scrollIntoView({ block: 'start', behavior: 'instant' });
            } catch (error) {
              target.scrollIntoView();
            }
          }
        }
      }

      measureMarks() {
        if (!this.links) return;
        this.markTops = this.links.map((a) => {
          const li = a.parentElement;
          return li.offsetTop + Math.max(0, (li.offsetHeight - 19) / 2);
        });
      }

      measure() {
        if (!this.read) return;
        // the needle rides on the end of the thread, so it travels the thread's length
        this.height = this.thread ? this.thread.offsetHeight : this.read.offsetHeight;
        this.classList.toggle('is-short', this.read.offsetHeight < window.innerHeight * 1.1);
      }

      update() {
        if (!this.read) return;
        // Read everything first…
        const rect = this.read.getBoundingClientRect();
        const line = window.innerHeight * 0.4;
        const p = Math.min(1, Math.max(0, (line - rect.top) / Math.max(1, rect.height)));
        let idx = -1;
        if (this.heads) {
          const limit = window.innerHeight * 0.3;
          for (let i = 0; i < this.heads.length; i++) {
            if (this.heads[i].getBoundingClientRect().top <= limit) idx = i;
            else break;
          }
        }
        // …then write.
        if (this.thread) this.thread.style.transform = 'scaleY(' + p.toFixed(4) + ')';
        if (this.tip) this.tip.style.transform = 'translate3d(0,' + (p * this.height).toFixed(1) + 'px,0)';
        if (this.heads && idx !== this.active) this.setActive(idx);
      }

      setActive(idx) {
        this.active = idx;
        this.links.forEach((a, i) => {
          if (i === idx) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
        if (!this.mark || !this.markTops) return;
        this.mark.classList.toggle('is-on', idx >= 0);
        if (idx >= 0) this.mark.style.transform = 'translate3d(0,' + this.markTops[idx] + 'px,0)';
      }
    }

    customElements.define('stitched-page', StitchedPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  (() => {
    if (customElements.get('password-page')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const canHover = window.matchMedia('(hover: hover)');

    class PasswordPage extends HTMLElement {
      connectedCallback() {
        // The page is tiny; if this runs before it has been parsed, wait for it.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      setup() {
        if (!this.isConnected || this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.sign = this.querySelector('[data-pw-sign]');
        this.key = this.querySelector('[data-pw-key]');

        // After its first swing the sign rests; then a passing pointer gives it a little push.
        if (this.sign) {
          this.sign.addEventListener('pointerenter', () => this.nudge(), { signal });
          this.sign.addEventListener(
            'animationend',
            (event) => {
              if (event.target !== this.sign) return;
              this.sign.classList.add('is-rest');
              this.sign.classList.remove('is-nudge');
            },
            { signal }
          );
        }

        // Opening the password panel puts the cursor straight in the field.
        if (this.key) {
          this.key.addEventListener(
            'toggle',
            () => {
              if (!this.key.open) return;
              const input = this.key.querySelector('[data-pw-input]');
              if (input) input.focus({ preventScroll: true });
            },
            { signal }
          );
        }

        // After a sent form, bring its message into focus.
        const msg = this.querySelector('[data-pw-focus]');
        if (msg) msg.focus({ preventScroll: true });
        else if (this.key && this.key.open) {
          const input = this.key.querySelector('[data-pw-input]');
          if (input) input.focus({ preventScroll: true });
        }
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        this.abort = null;
      }

      nudge() {
        if (!this.sign || reduceMotion.matches || !canHover.matches) return;
        if (!this.sign.classList.contains('is-rest') || this.sign.classList.contains('is-nudge')) return;
        this.sign.classList.add('is-nudge');
      }
    }

    customElements.define('password-page', PasswordPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    if (customElements.get('product-page')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wide = window.matchMedia('(min-width: 990px)');
    const smooth = () => (reduceMotion.matches ? 'auto' : 'smooth');
    // Variants this visitor has already asked to hear about, so the card says so next time.
    const NOTIFY_KEY = 'turblyn:notify';

    class ProductPage extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
        if (this.loadCtrl) this.loadCtrl.abort();
        (this.observers || []).forEach((o) => o.disconnect());
        clearTimeout(this.statusTimer);
        document.documentElement.classList.remove('pp-lock');
        this.ctrl = null;
      }

      setup() {
        if (this.ctrl || !this.isConnected) return;
        this.ctrl = new AbortController();
        const signal = this.ctrl.signal;
        this.sectionId = this.dataset.sectionId;
        this.cache = new Map();
        this.observers = [];
        this.markHold = 0;
        const first = this.readVariant();
        this.variantId = first ? first.id : null;
        this.form = document.getElementById(this.dataset.form);
        this.gallery = this.querySelector('[data-pp-gallery]');
        this.thumbs = this.querySelector('[data-pp-thumbs]');
        this.bar = this.querySelector('[data-pp-bar]');

        this.addEventListener('change', (e) => this.onChange(e), { signal });
        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });
        this.addEventListener('keydown', (e) => this.onKeydown(e), { signal });
        window.addEventListener(
          'resize',
          () => {
            this.setOffset();
            this.stickInfo();
          },
          { signal }
        );
        wide.addEventListener('change', () => this.stickInfo(), { signal });
        // Theme editor: selecting a tab block opens it.
        document.addEventListener(
          'shopify:block:select',
          (e) => {
            if (!this.contains(e.target)) return;
            const tab = e.target.querySelector('details');
            if (tab) tab.open = true;
          },
          { signal }
        );

        this.setOffset();
        this.initShare(signal);
        this.initGift();
        this.initNotify();
        this.watchGallery(signal);
        this.watchBar();
        this.loadComplementary();
        this.initXR();
        this.stickInfo();
        const info = this.querySelector('[data-pp-info]');
        if (info && 'ResizeObserver' in window) {
          const ro = new ResizeObserver(() => this.stickInfo());
          ro.observe(info);
          this.observers.push(ro);
        }
      }

      setOffset() {
        const header = document.querySelector('[data-sticky]:not([data-sticky="none"])');
        const h = header ? Math.round(header.getBoundingClientRect().height) : 0;
        this.offset = h;
        this.style.setProperty('--pp-offset', h + 'px');
      }

      // The details column only sticks when it fits on screen; otherwise it scrolls normally.
      stickInfo() {
        const info = this.querySelector('[data-pp-info]');
        if (!info) return;
        const fits = info.offsetHeight + (this.offset || 0) + 48 < window.innerHeight;
        this.classList.toggle('is-stick', this.hasAttribute('data-sticky-info') && wide.matches && fits);
      }

      /* ---------- events ---------- */

      onChange(e) {
        const t = e.target;
        if (t.matches('[data-pp-option]')) return this.onOption(t);
        if (t.matches('[data-pp-plan]')) return this.refresh();
        if (t.matches('[data-pp-gift-check]')) return this.toggleGift(t.checked);
        if (t.matches('[data-pp-qty]')) this.clampQty(t);
      }

      onClick(e) {
        const t = e.target;
        const zoom = t.closest('[data-pp-zoom]');
        if (zoom) return this.openZoom(zoom.dataset.ppZoom);
        const thumb = t.closest('[data-pp-thumb]');
        if (thumb) return this.showMedia(thumb.dataset.ppThumb, false, true);
        const play = t.closest('[data-pp-play]');
        if (play) return this.play(play);
        const step = t.closest('[data-pp-step]');
        if (step) return this.step(step);
        const zstep = t.closest('[data-pp-zoom-step]');
        if (zstep) return this.zoomStep(Number(zstep.dataset.ppZoomStep));
        const opener = t.closest('[data-pp-open]');
        if (opener) return this.openDialog(document.getElementById(opener.dataset.ppOpen), opener);
        const close = t.closest('[data-pp-close-dialog]');
        if (close) return close.closest('dialog').close();
        const notifyOpen = t.closest('[data-pp-notify-open]');
        if (notifyOpen) return this.toggleNotify(notifyOpen.getAttribute('aria-expanded') !== 'true', false);
        if (t.closest('[data-pp-bar-notify]')) return this.toggleNotify(true, true);
        if (t.closest('[data-pp-notify-again]')) return this.notifyAgain();
        if (t.closest('[data-pp-bar-add]')) return this.barAdd();
        // A click on the dimmed backdrop of a small dialog closes it.
        if (t.matches('dialog.pp-dialog') && this.hasAttribute('data-close-outside')) {
          const r = t.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) t.close();
        }
      }

      onKeydown(e) {
        const dlg = e.target.closest && e.target.closest('[data-pp-zoomer]');
        if (dlg && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
          e.preventDefault();
          this.zoomStep(e.key === 'ArrowRight' ? 1 : -1);
        }
      }

      /* ---------- options → Section Rendering API ---------- */

      selectedIds() {
        const picker = this.querySelector('[data-pp-picker]');
        if (!picker) return [];
        return Array.from(picker.querySelectorAll('.pp-opt'))
          .map((opt) => {
            const sel = opt.querySelector('select[data-pp-option]');
            const el = sel ? sel.selectedOptions[0] : opt.querySelector('[data-pp-option]:checked');
            return el ? el.dataset.optionValueId : null;
          })
          .filter(Boolean);
      }

      onOption(el) {
        const chosen = el.tagName === 'SELECT' ? el.selectedOptions[0] : el;
        const ids = this.selectedIds();
        const url = chosen && chosen.dataset.productUrl;
        // Combined listings: this value belongs to a sibling product.
        if (url && url !== this.dataset.url) {
          window.location.href = url + (url.includes('?') ? '&' : '?') + 'option_values=' + ids.join(',');
          return;
        }
        const legend = el.closest('fieldset') && el.closest('fieldset').querySelector('.pp-opt__chosen');
        if (legend && el.value) legend.textContent = el.value;
        this.refresh(ids);
      }

      async refresh(ids = this.selectedIds()) {
        const params = new URLSearchParams();
        if (ids.length) params.set('option_values', ids.join(','));
        const plan = this.querySelector('[data-pp-plan]:checked');
        if (plan && plan.value) params.set('selling_plan', plan.value);
        params.set('section_id', this.sectionId);
        const url = this.dataset.url + '?' + params.toString();

        if (this.loadCtrl) this.loadCtrl.abort();
        this.loadCtrl = new AbortController();
        this.classList.add('is-busy');
        try {
          let html = this.cache.get(url);
          if (!html) {
            const res = await fetch(url, { signal: this.loadCtrl.signal });
            if (!res.ok) throw new Error(String(res.status));
            html = await res.text();
            this.cache.set(url, html);
          }
          const doc = new DOMParser().parseFromString(html, 'text/html');
          this.swap(doc);
          this.applyVariant(this.readVariant(), plan && plan.value);
        } catch (err) {
          if (err.name === 'AbortError') return;
          const fallback = new URL(this.dataset.url, window.location.origin);
          if (ids.length) fallback.searchParams.set('option_values', ids.join(','));
          window.location.href = fallback.toString();
        } finally {
          this.classList.remove('is-busy');
        }
      }

      swap(doc) {
        const active = document.activeElement;
        const focusId = active && this.contains(active) ? active.id : null;
        const qty = this.querySelector('[data-pp-qty]');
        const qtyVal = qty ? qty.value : null;
        // An open back-in-stock card stays open, with the address typed so far, if the new choice is sold out too.
        const notifyBox = this.querySelector('[data-pp-notify]');
        const notifyEmail = notifyBox && notifyBox.querySelector('input[type="email"]');
        const notifyKeep = notifyBox
          ? { open: notifyBox.classList.contains('is-open'), email: notifyEmail ? notifyEmail.value : '' }
          : null;
        this.querySelectorAll('[data-pp-dyn][id]').forEach((el) => {
          const next = doc.getElementById(el.id);
          if (next) el.innerHTML = next.innerHTML;
        });
        // Keep the quantity someone typed when the new variant allows it.
        const q = this.querySelector('[data-pp-qty]');
        if (q && qtyVal) {
          const n = Number(qtyVal);
          const min = Number(q.min) || 1;
          const max = q.max ? Number(q.max) : Infinity;
          const stepBy = Number(q.step) || 1;
          if (n >= min && n <= max && (n - min) % stepBy === 0) q.value = qtyVal;
        }
        this.initNotify(notifyKeep);
        if (focusId) {
          const el = document.getElementById(focusId);
          if (el) el.focus({ preventScroll: true });
        }
      }

      readVariant() {
        const node = this.querySelector('[data-pp-variant]');
        if (!node) return undefined;
        try {
          return JSON.parse(node.textContent);
        } catch (e) {
          return undefined;
        }
      }

      applyVariant(variant, planId) {
        if (variant === undefined) return;
        const idInput = this.form && this.form.querySelector('[data-pp-id]');
        if (idInput) {
          idInput.value = variant ? variant.id : '';
          idInput.disabled = !variant;
        }
        if (this.form) this.form.classList.toggle('is-off', !variant || !variant.available);
        const changed = variant && String(variant.id) !== String(this.variantId);
        if (variant) this.variantId = variant.id;
        if (variant) {
          const u = new URL(this.dataset.url, window.location.origin);
          u.searchParams.set('variant', variant.id);
          if (planId) u.searchParams.set('selling_plan', planId);
          history.replaceState(history.state, '', u.pathname + u.search);
          if (changed && variant.featured_media) this.showMedia(variant.featured_media.id, true, false);
        }
        // Tell screen readers what changed.
        const price = this.querySelector('.pp-price');
        const btn = this.querySelector('[data-pp-submit] .pp-add__label');
        const bits = [];
        if (price) bits.push(price.textContent.replace(/\s+/g, ' ').trim());
        if (btn) bits.push(btn.textContent.trim());
        this.say(bits.join('. '));
      }

      /* ---------- pictures ---------- */

      watchGallery(signal) {
        if (!this.gallery) return;
        // Phones: the thread follows the strip.
        const thread = this.querySelector('[data-pp-thread]');
        if (thread) {
          const n = this.gallery.children.length;
          let raf = 0;
          const paint = () => {
            raf = 0;
            const g = this.gallery;
            const max = g.scrollWidth - g.clientWidth;
            const p = max > 0 ? Math.min(1, Math.max(0, g.scrollLeft / max)) : 0;
            thread.style.transform = 'translate3d(' + (p * (n - 1) * 100).toFixed(2) + '%,0,0)';
          };
          this.gallery.addEventListener('scroll', () => raf || (raf = requestAnimationFrame(paint)), {
            passive: true,
            signal,
          });
        }
        // Desktop: the rail marks the picture in the middle of the screen.
        if (this.thumbs && 'IntersectionObserver' in window) {
          const io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && wide.matches && Date.now() > this.markHold)
                  this.markThumb(entry.target.dataset.mediaId);
              });
            },
            { rootMargin: '-45% 0px -50% 0px' }
          );
          Array.from(this.gallery.children).forEach((slide) => io.observe(slide));
          this.observers.push(io);
        }
      }

      markThumb(id) {
        if (!this.thumbs) return;
        this.thumbs.querySelectorAll('[data-pp-thumb]').forEach((b) => {
          if (b.dataset.ppThumb === String(id)) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
      }

      showMedia(id, moveFirst, fromThumb) {
        if (!this.gallery) return;
        const item = this.gallery.querySelector('[data-media-id="' + id + '"]');
        if (!item) return;
        if (moveFirst && item !== this.gallery.firstElementChild) {
          this.gallery.prepend(item);
          const t = this.thumbs && this.thumbs.querySelector('.pp-thumbs__item[data-media-id="' + id + '"]');
          if (t) this.thumbs.prepend(t);
        }
        this.markThumb(id);
        if (fromThumb) this.markHold = Date.now() + 1200;
        if (wide.matches) {
          const r = item.getBoundingClientRect();
          const top = (this.offset || 0) + 16;
          if (fromThumb || r.top < top || r.top > window.innerHeight * 0.6) {
            window.scrollTo({ top: r.top + window.scrollY - top, behavior: smooth() });
          }
        } else {
          this.gallery.scrollTo({
            left:
              item.offsetLeft - this.gallery.offsetLeft - parseFloat(getComputedStyle(this.gallery).paddingLeft || 0),
            behavior: smooth(),
          });
        }
      }

      play(btn) {
        const box = btn.closest('[data-pp-defer]');
        const tpl = box && box.querySelector('template');
        if (!tpl) return;
        box.append(tpl.content.cloneNode(true));
        tpl.remove();
        btn.remove();
        const video = box.querySelector('video');
        if (video) {
          video.focus();
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
        const frame = box.querySelector('iframe');
        if (frame) frame.focus();
        const model = box.querySelector('model-viewer');
        if (model && window.Shopify && window.Shopify.loadFeatures) {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: (errors) => {
                if (errors || !window.Shopify.ModelViewerUI) return;
                const ui = new window.Shopify.ModelViewerUI(model);
                if (ui && ui.play) ui.play();
              },
            },
          ]);
        }
      }

      initXR() {
        const json = this.querySelector('script[id^="PPModels-"]');
        if (!json || !window.Shopify || !window.Shopify.loadFeatures) return;
        window.Shopify.loadFeatures([
          {
            name: 'shopify-xr',
            version: '1.0',
            onLoad: (errors) => {
              if (errors) return;
              const setup = () => {
                if (!window.ShopifyXR) {
                  document.addEventListener('shopify_xr_initialized', setup, { once: true });
                  return;
                }
                try {
                  window.ShopifyXR.addModels(JSON.parse(json.textContent));
                  window.ShopifyXR.setupXRElements();
                } catch (e) {
                  /* no AR on this device */
                }
              };
              setup();
            },
          },
        ]);
      }

      /* ---------- full screen ---------- */

      openZoom(id) {
        const dlg = this.querySelector('[data-pp-zoomer]');
        if (!dlg || !dlg.showModal) return;
        const list = dlg.querySelector('[data-pp-zoom-list]');
        const items = Array.from(list.children);
        this.zoomOpener = document.activeElement;
        if (!dlg.dataset.ready) {
          dlg.dataset.ready = '1';
          let raf = 0;
          list.addEventListener(
            'scroll',
            () => raf || (raf = requestAnimationFrame(() => ((raf = 0), this.zoomMark()))),
            { passive: true }
          );
          dlg.addEventListener('close', () => {
            document.documentElement.classList.remove('pp-lock');
            if (this.zoomOpener && this.zoomOpener.isConnected) this.zoomOpener.focus({ preventScroll: true });
          });
        }
        dlg.showModal();
        document.documentElement.classList.add('pp-lock');
        const idx = Math.max(
          0,
          items.findIndex((li) => li.dataset.mediaId === String(id))
        );
        list.scrollLeft = idx * list.clientWidth;
        this.zoomMark(idx);
      }

      zoomMark(force) {
        const dlg = this.querySelector('[data-pp-zoomer]');
        const list = dlg.querySelector('[data-pp-zoom-list]');
        const n = list.children.length;
        const idx = typeof force === 'number' ? force : Math.round(list.scrollLeft / Math.max(1, list.clientWidth));
        this.zoomAt = idx;
        dlg.querySelector('[data-pp-zoom-count]').textContent = idx + 1 + ' / ' + n;
        dlg.querySelector('[data-pp-zoom-step="-1"]').disabled = idx <= 0;
        dlg.querySelector('[data-pp-zoom-step="1"]').disabled = idx >= n - 1;
      }

      zoomStep(dir) {
        const dlg = this.querySelector('[data-pp-zoomer]');
        if (!dlg || !dlg.open) return;
        const list = dlg.querySelector('[data-pp-zoom-list]');
        const n = list.children.length;
        const idx = Math.min(n - 1, Math.max(0, (this.zoomAt || 0) + dir));
        list.scrollTo({ left: idx * list.clientWidth, behavior: smooth() });
        this.zoomMark(idx);
      }

      openDialog(dlg, opener) {
        if (!dlg || !dlg.showModal) return;
        dlg.showModal();
        dlg.addEventListener('close', () => opener && opener.isConnected && opener.focus({ preventScroll: true }), {
          once: true,
        });
      }

      /* ---------- quantity ---------- */

      step(btn) {
        const input = this.querySelector('[data-pp-qty]');
        if (!input) return;
        const by = Number(input.step) || 1;
        const min = Number(input.min) || 1;
        const max = input.max ? Number(input.max) : Infinity;
        const next = (Number(input.value) || min) + by * Number(btn.dataset.ppStep);
        input.value = String(Math.min(max, Math.max(min, next)));
      }

      clampQty(input) {
        const by = Number(input.step) || 1;
        const min = Number(input.min) || 1;
        const max = input.max ? Number(input.max) : Infinity;
        let n = Math.round(Number(input.value));
        if (!Number.isFinite(n) || n < min) n = min;
        if (n > max) n = max;
        n = min + Math.round((n - min) / by) * by;
        if (n > max) n -= by;
        input.value = String(n);
      }

      /* ---------- gift card ---------- */

      initGift() {
        const box = this.querySelector('[data-pp-gift]');
        if (!box) return;
        const offset = box.querySelector('[data-pp-gift-offset]');
        if (offset) offset.value = String(new Date().getTimezoneOffset());
        this.toggleGift(box.querySelector('[data-pp-gift-check]').checked);
      }

      toggleGift(on) {
        const box = this.querySelector('[data-pp-gift]');
        if (!box) return;
        box.querySelector('[data-pp-gift-fields]').hidden = !on;
        box.querySelectorAll('[data-pp-gift-input]').forEach((i) => (i.disabled = !on));
        if (on) {
          const email = box.querySelector('input[type="email"]');
          if (email) email.focus();
        }
      }

      giftOk() {
        const box = this.querySelector('[data-pp-gift]');
        if (!box || !box.querySelector('[data-pp-gift-check]').checked) return true;
        const email = box.querySelector('input[type="email"]');
        const ok = email.value.trim() !== '' && email.checkValidity();
        email.toggleAttribute('aria-invalid', !ok);
        if (!ok) {
          const msg = this.form.querySelector('[data-pp-msg]');
          if (msg) msg.textContent = "Enter the recipient's email address.";
          email.focus();
        }
        return ok;
      }

      /* ---------- back in stock ---------- */

      initNotify(keep) {
        const box = this.querySelector('[data-pp-notify]');
        if (!box) return;
        const ok = box.querySelector('[data-pp-notify-ok]');
        const msg = box.querySelector('[data-pp-notify-msg]');
        // After a plain (no script) send, the page comes back with the answer: show it open.
        const answered = (ok && !ok.hidden) || (msg && msg.textContent.trim() !== '');
        if (this.notifyAsked(box.dataset.variant)) this.notifyDone(box, false);
        const input = box.querySelector('input[type="email"]');
        if (keep && keep.email && input && !input.value) input.value = keep.email;
        this.openNotify(box, answered || !!(keep && keep.open), false);
        // Arriving from a "Notify me" link on a sold-out card: open the form and bring it into view.
        if (!keep && window.location.hash === '#notify') {
          history.replaceState(history.state, '', window.location.pathname + window.location.search);
          requestAnimationFrame(() => this.toggleNotify(true, true));
        }
      }

      openNotify(box, open, focus) {
        box.classList.toggle('is-open', open);
        const btn = box.querySelector('[data-pp-notify-open]');
        if (btn) btn.setAttribute('aria-expanded', String(open));
        if (!open || !focus) return;
        const input = box.querySelector('input[type="email"]');
        const again = box.querySelector('[data-pp-notify-again]');
        const target = input && !input.closest('[hidden]') ? input : again || btn;
        if (target) target.focus({ preventScroll: true });
      }

      toggleNotify(open, fromBar) {
        const box = this.querySelector('[data-pp-notify]');
        if (!box) return;
        if (fromBar) {
          const r = box.getBoundingClientRect();
          window.scrollTo({ top: r.top + window.scrollY - (this.offset || 0) - 96, behavior: smooth() });
        }
        this.openNotify(box, open, open);
      }

      async sendNotify(form) {
        const box = form.closest('[data-pp-notify]');
        const input = form.querySelector('input[type="email"]');
        const msg = form.querySelector('[data-pp-notify-msg]');
        const btn = form.querySelector('[data-pp-notify-send]');
        if (!box || !input || !msg || !btn || btn.getAttribute('aria-busy') === 'true') return;
        input.value = input.value.trim();
        let problem = '';
        if (!input.value) problem = box.dataset.msgEmpty;
        else if (!input.checkValidity()) problem = box.dataset.msgBad;
        msg.textContent = problem;
        if (problem) {
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        btn.setAttribute('aria-busy', 'true');
        try {
          // Sent the way the form itself would send it, so the store treats it as an ordinary message.
          const res = await fetch(form.action, {
            method: 'POST',
            body: new URLSearchParams(new FormData(form)),
            headers: { Accept: 'text/html' },
          });
          // Shopify sometimes asks for a quick spam check first: let the browser send the form so it can be shown.
          if (/\/challenge/.test(res.url || '')) {
            form.submit();
            return;
          }
          if (!res.ok) throw new Error(String(res.status));
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const echo = doc.getElementById(form.id);
          const said = echo && echo.querySelector('[data-pp-notify-msg]');
          if (said && said.textContent.trim()) {
            msg.textContent = said.textContent.trim();
            input.setAttribute('aria-invalid', 'true');
            input.focus();
            return;
          }
          this.notifyRemember(box.dataset.variant);
          this.notifyDone(box, true);
        } catch (err) {
          msg.textContent = box.dataset.msgFail;
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      notifyDone(box, announce) {
        const fields = box.querySelector('[data-pp-notify-fields]');
        const ok = box.querySelector('[data-pp-notify-ok]');
        const msg = box.querySelector('[data-pp-notify-msg]');
        if (fields) fields.hidden = true;
        if (ok) ok.hidden = false;
        if (msg) msg.textContent = '';
        box.classList.add('is-done');
        if (!announce || !ok) return;
        const text = ok.querySelector('.pp-notify__ok-text');
        if (text) this.say(text.textContent.trim());
        // The field and button that had focus are gone; keep focus inside the card.
        const again = ok.querySelector('[data-pp-notify-again]');
        if (again) again.focus({ preventScroll: true });
      }

      notifyAgain() {
        const box = this.querySelector('[data-pp-notify]');
        if (!box) return;
        const fields = box.querySelector('[data-pp-notify-fields]');
        const ok = box.querySelector('[data-pp-notify-ok]');
        if (ok) ok.hidden = true;
        if (!fields) return;
        fields.hidden = false;
        box.classList.remove('is-done');
        const input = fields.querySelector('input[type="email"]');
        if (input) {
          input.value = '';
          input.focus();
        }
      }

      notifyAsked(id) {
        try {
          const list = JSON.parse(window.localStorage.getItem(NOTIFY_KEY) || '[]');
          return Array.isArray(list) && list.indexOf(String(id)) !== -1;
        } catch (e) {
          return false;
        }
      }

      notifyRemember(id) {
        try {
          const saved = JSON.parse(window.localStorage.getItem(NOTIFY_KEY) || '[]');
          const list = (Array.isArray(saved) ? saved : []).filter((x) => x !== String(id));
          list.push(String(id));
          window.localStorage.setItem(NOTIFY_KEY, JSON.stringify(list.slice(-40)));
        } catch (e) {
          /* storage may be switched off; the card simply asks again next time */
        }
      }

      /* ---------- add to bag ---------- */

      onSubmit(e) {
        const form = e.target;
        if (form.matches('.pp-notify__form')) {
          e.preventDefault();
          this.sendNotify(form);
          return;
        }
        if (form === this.form) {
          const msg = form.querySelector('[data-pp-msg]');
          if (msg) msg.textContent = '';
          if (!this.giftOk()) {
            e.preventDefault();
            return;
          }
          // The bag drawer adds the item itself and opens.
          if (document.querySelector('cart-drawer[data-open-on-add]')) return;
          e.preventDefault();
          this.add(form, form.querySelector('[data-pp-submit]'), msg);
          return;
        }
        if (form.matches('[data-pp-add]')) {
          if (document.querySelector('cart-drawer[data-open-on-add]')) return;
          e.preventDefault();
          this.add(form, form.querySelector('[data-pp-add-btn]'), null);
        }
      }

      async add(form, btn, msg) {
        if (btn && btn.getAttribute('aria-busy') === 'true') return;
        const barBtn = form === this.form && this.querySelector('[data-pp-bar-add]');
        [btn, barBtn].forEach((b) => b && b.setAttribute('aria-busy', 'true'));
        try {
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || 'This item could not be added.');
          this.say('Added to your bag.');
          if (btn) {
            btn.classList.add('is-added');
            setTimeout(() => btn.classList.remove('is-added'), 2000);
          }
          const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .catch(() => null);
          if (cart)
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'product-page' } }));
        } catch (err) {
          const text = (err && err.message) || 'Something went wrong. Please try again.';
          if (msg) msg.textContent = text;
          this.say(text);
        } finally {
          [btn, barBtn].forEach((b) => b && b.removeAttribute('aria-busy'));
        }
      }

      /* ---------- the bar that follows ---------- */

      watchBar() {
        const buy = this.querySelector('.pp-block--buy');
        if (!this.bar || !buy || !('IntersectionObserver' in window)) return;
        // The root reaches far below the screen, so the block only stops "intersecting" once it has
        // passed the top edge, however the page got there (a fling, the End key, a restored scroll).
        const io = new IntersectionObserver(([entry]) => this.toggleBar(!entry.isIntersecting), {
          rootMargin: '0px 0px 100000px 0px',
        });
        io.observe(buy);
        this.observers.push(io);
      }

      toggleBar(show) {
        if (!this.bar || this.bar.classList.contains('is-shown') === show) return;
        this.bar.classList.toggle('is-shown', show);
        this.bar.toggleAttribute('inert', !show);
        this.bar.setAttribute('aria-hidden', String(!show));
      }

      barAdd() {
        const submit = this.querySelector('[data-pp-submit]');
        if (!this.form || !submit || submit.disabled) return;
        if (this.form.requestSubmit) this.form.requestSubmit(submit);
        else submit.click();
      }

      /* ---------- pairs well with ---------- */

      loadComplementary() {
        this.querySelectorAll('[data-pp-comp]').forEach((box) => {
          if (!('IntersectionObserver' in window)) {
            this.fetchComp(box);
            return;
          }
          const io = new IntersectionObserver(
            (entries) => {
              if (!entries.some((en) => en.isIntersecting)) return;
              io.disconnect();
              this.fetchComp(box);
            },
            { rootMargin: '400px 0px' }
          );
          io.observe(box);
          this.observers.push(io);
        });
      }

      async fetchComp(box) {
        const block = box.closest('.pp-block');
        try {
          const res = await fetch(box.dataset.url);
          if (!res.ok) throw new Error(String(res.status));
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const next = doc.getElementById(box.id);
          if (next && next.innerHTML.trim()) box.innerHTML = next.innerHTML;
          else if (block) block.hidden = true;
        } catch (e) {
          if (block) block.hidden = true;
        }
      }

      /* ---------- share ---------- */

      initShare(signal) {
        const box = this.querySelector('[data-pp-share]');
        if (!box) return;
        const btn = box.querySelector('[data-pp-share-btn]');
        const field = box.querySelector('[data-pp-share-field]');
        const status = box.querySelector('[data-pp-share-status]');
        box.hidden = false;
        const tell = (text) => {
          status.textContent = text;
          clearTimeout(this.statusTimer);
          this.statusTimer = setTimeout(() => (status.textContent = ''), 3000);
        };
        btn.addEventListener(
          'click',
          async () => {
            const url = box.dataset.url;
            if (navigator.share) {
              try {
                await navigator.share({ title: box.dataset.title, url });
                return;
              } catch (error) {
                if (error && error.name === 'AbortError') return;
              }
            }
            try {
              await navigator.clipboard.writeText(url);
              tell('Link copied');
            } catch (error) {
              field.hidden = false;
              field.focus();
              field.select();
              tell('Copy the link above.');
            }
          },
          { signal }
        );
      }

      say(text) {
        const live = this.querySelector('[data-pp-live]');
        if (!live || !text) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }
    }

    customElements.define('product-page', ProductPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  (() => {
    if (customElements.get('register-form')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    class RegisterForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form.rg-form');
        if (!this.form) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;

        this.first = this.querySelector('[data-rg-first]');
        this.last = this.querySelector('[data-rg-last]');
        this.email = this.querySelector('[data-rg-email]');
        this.pass = this.querySelector('[data-rg-pass]');
        this.card = this.querySelector('[data-rg-card]');
        this.nameBox = this.querySelector('[data-rg-name]');
        this.meter = this.querySelector('[data-rg-meter]');
        this.placeholder = this.nameBox ? this.nameBox.textContent.trim() : '';
        this.shown = '';

        this.form.addEventListener('input', (e) => this.onInput(e), { signal });
        this.form.addEventListener('blur', (e) => this.onBlur(e), { signal, capture: true });
        this.form.addEventListener('submit', (e) => this.onSubmit(e), { signal });

        const toggle = this.querySelector('[data-rg-toggle]');
        if (toggle && this.pass) {
          toggle.addEventListener(
            'click',
            () => {
              const show = this.pass.type === 'password';
              this.pass.type = show ? 'text' : 'password';
              toggle.setAttribute('aria-pressed', String(show));
              toggle.querySelector('[data-rg-toggle-label]').textContent = show ? 'Hide' : 'Show';
            },
            { signal }
          );
        }

        // Values Shopify sends back after an error fill the card straight away.
        this.updateCard(false);
        this.updateMeter();
        this.updateReady();

        const alert = this.querySelector('[data-rg-alert]');
        if (alert) {
          alert.focus({ preventScroll: true });
          const r = alert.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) alert.scrollIntoView({ block: 'center', behavior: 'auto' });
        }
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
      }

      onInput(e) {
        const t = e.target;
        if (t === this.first || t === this.last) this.updateCard(true);
        if (t === this.pass) this.updateMeter();
        const field = t.closest('.rg-field');
        if (field && field.classList.contains('is-invalid') && this.check(t, false)) this.clear(field, t);
        this.updateReady();
      }

      onBlur(e) {
        const t = e.target;
        if (t !== this.email && t !== this.pass) return;
        if (!t.value) return; // no nagging on an untouched field
        this.check(t, true);
      }

      /* ---------- Member card ---------- */
      updateCard(animate) {
        if (!this.nameBox) return;
        const name = [this.first && this.first.value.trim(), this.last && this.last.value.trim()]
          .filter(Boolean)
          .join(' ');
        const text = name.slice(0, 28);
        if (text === this.shown) return;
        const prev = this.shown;
        this.shown = text;
        if (this.card) this.card.classList.toggle('is-filled', !!text);

        if (!text) {
          this.nameBox.innerHTML = '';
          const ph = document.createElement('span');
          ph.className = 'rg-card__ph';
          ph.textContent = this.placeholder;
          this.nameBox.appendChild(ph);
          return;
        }

        // Keep the letters that didn't change; ink in only the new ones.
        let same = 0;
        while (same < prev.length && same < text.length && prev[same] === text[same]) same += 1;
        if (!prev || this.nameBox.querySelector('.rg-card__ph')) {
          this.nameBox.textContent = '';
          same = 0;
        } else {
          const chars = Array.from(this.nameBox.querySelectorAll('.rg-card__ch'));
          chars.slice(same).forEach((c) => c.remove());
        }
        for (let i = same; i < text.length; i += 1) {
          const c = document.createElement('span');
          c.className = 'rg-card__ch';
          c.textContent = text[i];
          if (!animate || reduceMotion.matches) c.style.animation = 'none';
          this.nameBox.appendChild(c);
        }
      }

      updateMeter() {
        if (!this.meter || !this.pass) return;
        const v = this.pass.value;
        let score = 0;
        if (v.length >= 5) score += 1;
        if (v.length >= 9) score += 1;
        if (/[A-Z]/.test(v) && /[a-z]/.test(v)) score += 1;
        if (/\d/.test(v) || /[^A-Za-z0-9]/.test(v)) score += 1;
        const level = v.length === 0 ? 0 : Math.max(1, score);
        this.meter.style.setProperty('--s', (level / 4).toFixed(2));
        this.meter.dataset.level = String(level);
      }

      updateReady() {
        if (!this.card) return;
        const ok = this.email && EMAIL.test(this.email.value.trim()) && this.pass && this.pass.value.length >= 5;
        this.card.classList.toggle('is-ready', !!ok);
      }

      /* ---------- Friendly checks (Shopify still has the final word) ---------- */
      check(input, show) {
        let msg = '';
        if (input === this.email) {
          const v = input.value.trim();
          if (!v) msg = 'Please enter your email address.';
          else if (!EMAIL.test(v)) msg = 'That email doesn’t look quite right.';
        } else if (input === this.pass) {
          if (!input.value) msg = 'Please choose a password.';
          else if (input.value.length < 5) msg = 'Your password needs at least 5 characters.';
        }
        const field = input.closest('.rg-field');
        if (!msg) {
          if (field) this.clear(field, input);
          return true;
        }
        if (show && field) {
          field.classList.add('is-invalid');
          input.setAttribute('aria-invalid', 'true');
          const box = field.querySelector('[data-rg-msg]');
          if (box) box.textContent = msg;
        }
        return false;
      }

      clear(field, input) {
        field.classList.remove('is-invalid');
        input.removeAttribute('aria-invalid');
        const box = field.querySelector('[data-rg-msg]');
        if (box) box.textContent = '';
      }

      onSubmit(e) {
        const bad = [this.email, this.pass].filter((i) => i && !this.check(i, true));
        if (bad.length) {
          e.preventDefault();
          const field = bad[0].closest('.rg-field');
          if (field && !reduceMotion.matches) {
            field.classList.remove('is-shake');
            void field.offsetWidth;
            field.classList.add('is-shake');
          }
          bad[0].focus();
          return;
        }
        const btn = this.querySelector('[data-rg-submit]');
        if (btn) {
          if (btn.getAttribute('aria-busy') === 'true') {
            e.preventDefault(); // no double accounts from a double tap
            return;
          }
          btn.setAttribute('aria-busy', 'true');
          // If the browser comes back from the cache, let the button work again.
          window.addEventListener('pageshow', () => btn.removeAttribute('aria-busy'), { once: true });
        }
      }
    }

    customElements.define('register-form', RegisterForm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  (() => {
    if (customElements.get('reset-password')) return;
    const MIN = 5;

    class ResetPassword extends HTMLElement {
      connectedCallback() {
        this.ctrl = new AbortController();
        const signal = this.ctrl.signal;
        this.pass = this.querySelector('[data-rs-pass]');
        this.confirm = this.querySelector('[data-rs-confirm]');
        this.meter = Array.from(this.querySelectorAll('[data-rs-meter] i'));
        this.live = this.querySelector('[data-rs-live]');
        if (!this.pass || !this.confirm) return;
        this.classList.add('is-js');

        this.querySelectorAll('[data-rs-toggle]').forEach((btn) => {
          btn.hidden = false;
          btn.addEventListener(
            'click',
            () => {
              const show = this.pass.type === 'password';
              this.pass.type = show ? 'text' : 'password';
              this.confirm.type = this.pass.type;
              btn.setAttribute('aria-pressed', String(show));
              btn.querySelector('[data-rs-toggle-label]').textContent = show ? 'Hide' : 'Show';
            },
            { signal }
          );
        });
        this.addEventListener('input', () => this.update(), { signal });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });
        this.update();

        const alert = this.querySelector('[data-rs-alert]');
        if (alert) alert.focus({ preventScroll: false });
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
      }

      update() {
        const len = this.pass.value.length;
        this.meter.forEach((stitch, i) => stitch.classList.toggle('is-on', i < Math.min(10, len)));
        const match = len >= MIN && this.confirm.value === this.pass.value;
        if (match !== this.classList.contains('is-match')) {
          this.classList.toggle('is-match', match);
          if (match && this.live) this.live.textContent = 'Passwords match';
        }
        if (this.pass.closest('.rs-field').classList.contains('is-invalid') && len >= MIN) this.clear(this.pass);
        if (
          this.confirm.closest('.rs-field').classList.contains('is-invalid') &&
          this.confirm.value &&
          this.confirm.value === this.pass.value
        )
          this.clear(this.confirm);
      }

      onSubmit(e) {
        let bad = null;
        if (this.pass.value.length < MIN) {
          bad = bad || this.pass;
          this.flag(this.pass, this.pass.value ? 'Use at least ' + MIN + ' characters.' : 'Enter a new password.');
        }
        if (this.confirm.value !== this.pass.value) {
          bad = bad || this.confirm;
          this.flag(this.confirm, "The passwords don't match yet.");
        }
        if (bad) {
          e.preventDefault();
          bad.focus();
        }
      }

      flag(input, text) {
        const field = input.closest('.rs-field');
        field.classList.add('is-invalid');
        field.classList.remove('is-shake');
        void field.offsetWidth;
        field.classList.add('is-shake');
        input.setAttribute('aria-invalid', 'true');
        const msg = field.querySelector('[data-rs-msg]');
        if (msg) msg.textContent = text;
      }

      clear(input) {
        const field = input.closest('.rs-field');
        field.classList.remove('is-invalid', 'is-shake');
        input.removeAttribute('aria-invalid');
        const msg = field.querySelector('[data-rs-msg]');
        if (msg) msg.textContent = '';
      }
    }

    customElements.define('reset-password', ResetPassword);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (() => {
    if (customElements.get('search-page')) return;

    // Theme settings › Animations "none" counts as a standing request for less motion
    const reduceMotion = window.matchMedia(
      document.documentElement.dataset.motion === 'none' ? 'all' : '(prefers-reduced-motion: reduce)'
    );
    // Fresh results ease in only while the theme reveals content (Animations › reveal on scroll)
    const revealOff = () => reduceMotion.matches || document.documentElement.dataset.reveal === 'none';
    const sheetQuery = window.matchMedia('(max-width: 989px)');

    class SearchPage extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.sectionId = this.dataset.sectionId;
        this.cache = new Map();
        this.sheetOpen = false;
        this.classList.add('is-js');

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('change', (e) => this.onChange(e), { signal });
        this.addEventListener('input', (e) => this.onInput(e), { signal });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });
        this.addEventListener('keydown', (e) => this.onKeydown(e), { signal });
        window.addEventListener(
          'popstate',
          (e) => {
            if (e.state && e.state.srh === this.sectionId) this.load(window.location.href, { push: false });
          },
          { signal }
        );

        this.layoutFilters();
        sheetQuery.addEventListener('change', () => this.layoutFilters(), { signal });
        history.replaceState(Object.assign({}, history.state, { srh: this.sectionId }), '');
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.loadCtrl) this.loadCtrl.abort();
        document.documentElement.classList.remove('srh-lock');
      }

      /* Sidebar on desktop, sheet on phones (or everywhere with the drawer layout). */
      layoutFilters() {
        const box = this.querySelector('[data-srh-filters]');
        if (!box) return;
        const sheet = this.classList.contains('srh--filters-drawer') || sheetQuery.matches;
        if (!sheet && this.sheetOpen) this.closeSheet(false);
        box.classList.toggle('is-sheet', sheet);
        const panel = box.querySelector('[data-srh-panel]');
        if (sheet) {
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          if (!this.sheetOpen) box.setAttribute('inert', '');
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-modal');
          box.removeAttribute('inert');
        }
      }

      /* ---------- events ---------- */

      onClick(e) {
        if (e.target.closest('[data-srh-clear]')) {
          const input = this.querySelector('[data-srh-input]');
          input.value = '';
          input.focus();
          return;
        }
        if (e.target.closest('[data-srh-filter-toggle]')) {
          this.openSheet();
          return;
        }
        if (e.target.closest('[data-srh-filter-close]')) {
          this.closeSheet(true);
          return;
        }
        const more = e.target.closest('[data-srh-more]');
        if (more && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
          e.preventDefault();
          this.loadMore(more);
          return;
        }
        const link = e.target.closest('a[data-srh-link]');
        if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
          e.preventDefault();
          this.load(link.href, { scroll: true });
        }
      }

      onChange(e) {
        const t = e.target;
        if (t.matches('[data-srh-sort]') || (t.form && t.form.hasAttribute('data-srh-form') && t.type === 'checkbox')) {
          this.submitFilters();
        }
      }

      onInput(e) {
        if (!e.target.closest('[data-srh-price]')) return;
        clearTimeout(this.priceTimer);
        this.priceTimer = setTimeout(() => this.submitFilters(), 700);
      }

      onSubmit(e) {
        const form = e.target;
        if (form.hasAttribute('data-srh-form')) {
          e.preventDefault();
          clearTimeout(this.priceTimer);
          this.submitFilters();
          return;
        }
        // A new query is a new page: let the browser load it normally.
        if (form.hasAttribute('data-srh-query')) {
          const input = form.querySelector('[data-srh-input]');
          if (input && !input.value.trim()) {
            e.preventDefault();
            input.focus();
          }
        }
      }

      onKeydown(e) {
        if (!this.sheetOpen) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          this.closeSheet(true);
          return;
        }
        if (e.key === 'Tab') this.trap(e, this.querySelector('[data-srh-panel]'));
      }

      /* ---------- filter sheet ---------- */

      openSheet() {
        const box = this.querySelector('[data-srh-filters]');
        if (!box) return;
        this.layoutFilters();
        if (!box.classList.contains('is-sheet')) return;
        this.sheetOpen = true;
        this.opener = document.activeElement;
        box.removeAttribute('inert');
        box.classList.add('is-open');
        document.documentElement.classList.add('srh-lock');
        const toggle = this.querySelector('[data-srh-filter-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        const close = box.querySelector('.srh-filters__close');
        requestAnimationFrame(() => close && close.focus({ preventScroll: true }));
      }

      closeSheet(returnFocus) {
        const box = this.querySelector('[data-srh-filters]');
        if (!box || !this.sheetOpen) return;
        this.sheetOpen = false;
        box.classList.remove('is-open');
        document.documentElement.classList.remove('srh-lock');
        const toggle = this.querySelector('[data-srh-filter-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (box.classList.contains('is-sheet')) box.setAttribute('inert', '');
        if (returnFocus) (toggle || this.opener || this).focus({ preventScroll: true });
      }

      trap(e, root) {
        if (!root) return;
        const items = Array.from(
          root.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, summary, [tabindex]:not([tabindex="-1"])'
          )
        ).filter((el) => el.offsetParent !== null);
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      /* ---------- Section Rendering API ---------- */

      submitFilters() {
        const form = this.querySelector('[data-srh-form]');
        const params = new URLSearchParams();
        const data = form ? new FormData(form) : new FormData();
        const sort = this.querySelector('[data-srh-sort]');
        if (sort) data.set('sort_by', sort.value);
        for (const [k, v] of data.entries()) {
          if (typeof v === 'string' && v.trim() !== '') params.append(k, v);
        }
        this.load(`${this.dataset.searchUrl}?${params.toString()}`, {});
      }

      sectionUrl(url) {
        const u = new URL(url, window.location.origin);
        u.searchParams.set('section_id', this.sectionId);
        return u.toString();
      }

      async fetchHtml(url, signal) {
        const key = this.sectionUrl(url);
        if (this.cache.has(key)) return this.cache.get(key);
        const html = await fetch(key, { signal }).then((r) => {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        });
        this.cache.set(key, html);
        return html;
      }

      async load(url, { push = true, scroll = false } = {}) {
        if (this.loadCtrl) this.loadCtrl.abort();
        this.loadCtrl = new AbortController();
        this.classList.add('is-loading');
        this.setAttribute('aria-busy', 'true');
        try {
          const html = await this.fetchHtml(url, this.loadCtrl.signal);
          const doc = new DOMParser().parseFromString(html, 'text/html');
          this.swap(doc);
          if (push) {
            const clean = new URL(url, window.location.origin);
            clean.searchParams.delete('section_id');
            history.pushState({ srh: this.sectionId }, '', clean.pathname + clean.search);
          }
          if (scroll) {
            const top = this.querySelector('[data-srh-bar]') || this;
            const y =
              top.getBoundingClientRect().top +
              window.scrollY -
              12 -
              (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0);
            if (window.scrollY > y) window.scrollTo({ top: y, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          }
        } catch (err) {
          if (err.name === 'AbortError') return;
          window.location.href = url; // fall back to a normal page load
        } finally {
          this.classList.remove('is-loading');
          this.removeAttribute('aria-busy');
        }
      }

      /* A different shape of page (e.g. a tab with no filters): swap the whole section. */
      shape(root) {
        return [
          !!root.querySelector('[data-srh-filters]'),
          !!root.querySelector('[data-srh-bar]'),
          root.className.replace(/\bis-\S+/g, '').trim(),
        ].join('|');
      }

      swap(doc) {
        const next = doc.querySelector('search-page');
        if (next && this.shape(next) !== this.shape(this)) {
          if (this.sheetOpen) this.closeSheet(false);
          const keep = ['is-js'];
          this.className = next.className;
          keep.forEach((c) => this.classList.add(c));
          this.innerHTML = next.innerHTML;
          this.layoutFilters();
          this.reveal();
          return;
        }
        const active = document.activeElement;
        const focusId = active && this.contains(active) ? active.id : null;
        const open = new Set(Array.from(this.querySelectorAll('.srh-facet[open]')).map((d) => d.dataset.srhFacet));
        const closed = new Set(
          Array.from(this.querySelectorAll('.srh-facet:not([open])')).map((d) => d.dataset.srhFacet)
        );
        const scroller =
          this.querySelector('.srh-filters.is-sheet .srh-facets') || this.querySelector('.srh-filters__panel');
        const scrollTop = scroller ? scroller.scrollTop : 0;

        ['[data-srh-meta]', '[data-srh-form]', '[data-srh-active]', '[data-srh-results]'].forEach((sel) => {
          const next = doc.querySelector(sel);
          const cur = this.querySelector(sel);
          if (next && cur) cur.innerHTML = next.innerHTML;
        });
        ['[data-srh-filter-count]', '[data-srh-show]'].forEach((sel) => {
          const next = doc.querySelector(sel);
          const cur = this.querySelector(sel);
          if (next && cur) {
            cur.innerHTML = next.innerHTML;
            cur.className = next.className;
          }
        });
        const sort = doc.querySelector('[data-srh-sort]');
        const curSort = this.querySelector('[data-srh-sort]');
        if (sort && curSort) curSort.value = sort.value;

        this.querySelectorAll('.srh-facet').forEach((d) => {
          if (open.has(d.dataset.srhFacet)) d.open = true;
          else if (closed.has(d.dataset.srhFacet) && !d.querySelector('input:checked')) d.open = false;
        });
        const box =
          this.querySelector('.srh-filters.is-sheet .srh-facets') || this.querySelector('.srh-filters__panel');
        if (box) box.scrollTop = scrollTop;

        if (focusId) {
          const el = document.getElementById(focusId);
          if (el) el.focus({ preventScroll: true });
        }

        this.reveal();
      }

      reveal() {
        if (revealOff()) return;
        this.querySelectorAll('[data-srh-card]').forEach((c, i) => c.style.setProperty('--d', Math.min(i, 8)));
        this.classList.remove('is-swapped');
        void this.offsetWidth;
        this.classList.add('is-swapped');
      }

      async loadMore(btn) {
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        try {
          const html = await this.fetchHtml(btn.href);
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = this.querySelector('[data-srh-grid]');
          const fresh = Array.from(doc.querySelectorAll('[data-srh-grid] > [data-srh-card]'));
          const firstNew = fresh[0];
          const animate = !revealOff();
          fresh.forEach((c, i) => {
            if (animate) {
              c.style.setProperty('--d', i % 8);
              c.classList.add('is-new');
            }
            grid.append(c);
          });
          const pager = doc.querySelector('[data-srh-pager]');
          const cur = this.querySelector('[data-srh-pager]');
          if (cur && pager) cur.innerHTML = pager.innerHTML;
          else if (cur) cur.remove();
          // Keep keyboard users where the new results start.
          const link = firstNew && firstNew.querySelector('a');
          if (link) link.focus({ preventScroll: true });
        } catch (err) {
          window.location.href = btn.href;
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('search-page', SearchPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('map-locator')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class MapLocator extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;

        this.map = this.querySelector('[data-mp-map]');
        this.frameWrap = this.querySelector('[data-mp-frame]');
        this.loadBtn = this.querySelector('[data-mp-load]');
        this.chipName = this.querySelector('[data-mp-chip-name]');
        this.chipLink = this.querySelector('[data-mp-chip-link]');
        this.rail = this.querySelector('[data-mp-rail]');
        this.listWrap = this.rail ? this.rail.parentElement : null;
        this.locs = Array.from(this.querySelectorAll('[data-mp-loc]'));
        this.index = Math.max(
          0,
          this.locs.findIndex((l) => l.classList.contains('is-active'))
        );
        this.loaded = false;

        this.locs.forEach((loc, i) => {
          const btn = loc.querySelector('[data-mp-select]');
          if (btn) btn.addEventListener('click', () => this.select(i, true), { signal });
        });

        if (this.loadBtn) this.loadBtn.addEventListener('click', () => this.load(), { signal });

        this.initObservers();
        this.moveRail(true);

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener(
            'shopify:block:select',
            (e) => {
              const i = this.locs.indexOf(e.target);
              if (i > -1) this.select(i, false);
            },
            { signal }
          );
        }
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.io) this.io.disconnect();
        if (this.revealIO) this.revealIO.disconnect();
        if (this.ro) this.ro.disconnect();
      }

      initObservers() {
        const reveal = Array.from(this.querySelectorAll('[data-mp-reveal]'));

        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-inview');
          if (this.dataset.load === 'visible') this.load();
          return;
        }

        // Decorative loops only run while the section is on screen; auto-load if chosen.
        this.io = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle('is-inview', entry.isIntersecting);
            if (entry.isIntersecting && this.dataset.load === 'visible') this.load();
          },
          { rootMargin: '200px 0px' }
        );
        this.io.observe(this);

        // Reveal: anything already on screen shows instantly (no flash, no layout shift).
        if (!reduceMotion.matches && !(window.Shopify && window.Shopify.designMode)) {
          const vh = window.innerHeight;
          const pending = reveal.filter((el) => {
            const r = el.getBoundingClientRect();
            return !(r.top < vh && r.bottom > 0);
          });
          if (pending.length) {
            this.classList.add('has-reveal');
            reveal.filter((el) => !pending.includes(el)).forEach((el) => el.classList.add('is-revealed'));
            this.revealIO = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;
                  entry.target.classList.add('is-revealed');
                  this.revealIO.unobserve(entry.target);
                });
              },
              { threshold: 0.12 }
            );
            pending.forEach((el) => this.revealIO.observe(el));
          }
        }

        if (this.rail && 'ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.moveRail(true));
          this.locs.forEach((loc) => this.ro.observe(loc));
        }
      }

      select(i, fromUser) {
        if (!this.locs[i]) return;
        const changed = i !== this.index;
        this.locs.forEach((loc, n) => {
          const on = n === i;
          loc.classList.toggle('is-active', on);
          const btn = loc.querySelector('[data-mp-select]');
          if (btn) btn.setAttribute('aria-pressed', String(on));
        });
        this.index = i;
        this.moveRail(false);
        this.updateChip();
        this.keepInView(i);

        // On phones, bring the chosen card into view inside the swipe row.
        const loc = this.locs[i];
        if (fromUser && loc.parentElement.scrollWidth > loc.parentElement.clientWidth) {
          loc.parentElement.scrollTo({
            left: loc.offsetLeft - loc.parentElement.offsetLeft - 20,
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
          });
        }

        if (this.loaded) {
          if (changed) this.setSrc();
        } else if (fromUser) {
          // Choosing a store is a clear intent to see it on the map.
          this.load();
        }
      }

      // Desktop list is its own scroll area: once the card has expanded, make sure it is fully visible.
      keepInView(i) {
        const wrap = this.listWrap;
        if (!wrap || wrap.scrollHeight <= wrap.clientHeight) return;
        clearTimeout(this.viewTimer);
        this.viewTimer = setTimeout(() => {
          const loc = this.locs[i];
          if (!loc || this.index !== i) return;
          const top = loc.offsetTop;
          const bottom = top + loc.offsetHeight;
          let target = null;
          if (top < wrap.scrollTop) target = top - 4;
          else if (bottom > wrap.scrollTop + wrap.clientHeight)
            target = Math.min(top - 4, bottom - wrap.clientHeight + 4);
          if (target !== null)
            wrap.scrollTo({ top: Math.max(0, target), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }, 520);
      }

      moveRail(instant) {
        if (!this.rail) return;
        const loc = this.locs[this.index];
        if (!loc) return;
        if (instant) this.rail.classList.add('no-anim');
        this.rail.style.setProperty('--y', `${loc.offsetTop}px`);
        this.rail.style.setProperty('--h', `${loc.offsetHeight}px`);
        if (instant) requestAnimationFrame(() => requestAnimationFrame(() => this.rail.classList.remove('no-anim')));
      }

      updateChip() {
        const loc = this.locs[this.index];
        if (!loc) return;
        if (this.chipName) this.chipName.textContent = loc.dataset.name || '';
        if (this.chipLink) {
          this.chipLink.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            loc.dataset.query || ''
          )}`;
        }
      }

      load() {
        if (this.loaded || !this.locs.length || !this.frameWrap) return;
        this.loaded = true;
        let hadFocus = document.activeElement === this.loadBtn;
        this.map.classList.add('is-loading');
        this.iframe = document.createElement('iframe');
        this.iframe.setAttribute('loading', 'lazy');
        this.iframe.setAttribute('allowfullscreen', '');
        this.iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
        this.iframe.addEventListener('load', () => {
          this.map.classList.remove('is-loading', 'is-switching');
          this.map.classList.add('is-loaded');
          // The button disappears with the cover: keep keyboard focus inside the map.
          if (hadFocus && this.chipLink) this.chipLink.focus({ preventScroll: true });
          hadFocus = false;
        });
        this.frameWrap.appendChild(this.iframe);
        this.setSrc();
      }

      setSrc() {
        const loc = this.locs[this.index];
        if (!this.iframe || !loc) return;
        const query = loc.dataset.query || '';
        const params = new URLSearchParams({ q: query, z: this.dataset.zoom || '15', output: 'embed' });
        if (this.dataset.lang) params.set('hl', this.dataset.lang);
        this.iframe.title = `Map: ${loc.dataset.name || query}`;
        if (this.map.classList.contains('is-loaded')) this.map.classList.add('is-switching');
        this.iframe.src = `https://www.google.com/maps?${params.toString()}`;
      }
    }

    customElements.define('map-locator', MapLocator);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('multi-column')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class MultiColumn extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-mc-list]');
        this.timers = [];
        this.ac = new AbortController();

        // A swipe row with nothing to tab to still has to be scrollable by keyboard
        if (this.list && this.classList.contains('mc--m-swipe') && 'ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.keyboard());
          this.ro.observe(this.list);
        }

        document.addEventListener('shopify:block:select', (e) => this.select(e), { signal: this.ac.signal });

        this.pager = this.querySelector('[data-mc-pager]');
        if (this.pager && this.list) {
          this.list.addEventListener(
            'scroll',
            () => {
              if (this.raf) return;
              this.raf = requestAnimationFrame(() => {
                this.raf = null;
                this.page();
              });
            },
            { passive: true, signal: this.ac.signal }
          );
        }

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        const items = Array.from(this.querySelectorAll('[data-mc-item]'));
        if (!items.length) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => this.reveal(el, Math.min(n, 5) * 110));
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        items.forEach((el) => this.io.observe(el));
      }

      reveal(el, delay) {
        if (this.io) this.io.unobserve(el);
        if (el.classList.contains('is-in')) return;
        el.style.setProperty('--d', delay + 'ms');
        el.classList.add('is-in');
        this.timers.push(setTimeout(() => el.classList.add('is-settled'), 1700 + delay));
      }

      page() {
        const cols = Array.from(this.list.children);
        const x = this.list.scrollLeft;
        let on = 0;
        if (x >= this.list.scrollWidth - this.list.clientWidth - 2) {
          on = cols.length - 1;
        } else {
          let best = Infinity;
          cols.forEach((c, i) => {
            const d = Math.abs(c.offsetLeft - this.list.firstElementChild.offsetLeft - x);
            if (d < best) {
              best = d;
              on = i;
            }
          });
        }
        Array.from(this.pager.children).forEach((dot, i) => dot.classList.toggle('is-on', i === on));
      }

      keyboard() {
        const scrolls = this.list.scrollWidth > this.list.clientWidth + 1;
        if (scrolls && !this.list.querySelector('a[href]')) {
          this.list.setAttribute('tabindex', '0');
          this.list.setAttribute('aria-label', this.list.dataset.mcLabel);
        } else {
          this.list.removeAttribute('tabindex');
          this.list.removeAttribute('aria-label');
        }
      }

      select(e) {
        const col = e.target instanceof Element ? e.target.closest('[data-mc-item]') : null;
        if (!col || !this.contains(col)) return;
        this.reveal(col, 0);
        if (this.list && this.list.scrollWidth > this.list.clientWidth + 1) {
          col.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.ac) this.ac.abort();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
        (this.timers || []).forEach(clearTimeout);
      }
    }

    customElements.define('multi-column', MultiColumn);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('news-letter')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class NewsLetter extends HTMLElement {
      connectedCallback() {
        this.timers = new Set();
        this.ac = new AbortController();
        this.onlyMine();

        const ok = this.querySelector('[data-nl-ok]');
        if (ok && this.isMine()) {
          // Move focus to the thank-you once the page (and its jump to the form) has settled
          const wait = reduceMotion.matches ? 60 : 1700;
          const go = () => this.later(() => ok.focus({ preventScroll: true }), wait);
          if (document.readyState === 'complete') go();
          else window.addEventListener('load', go, { once: true, signal: this.ac.signal });
        }

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        const box = this.querySelector('[data-nl-box]');
        if (!box) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.io.disconnect();
            this.classList.add('is-in');
            this.later(() => this.classList.add('is-settled'), 2400);
          },
          { rootMargin: '0px 0px -12% 0px' }
        );
        this.io.observe(box);
      }

      // After a sign-up Shopify returns to the page with the form's id in the hash.
      // If another sign-up form on the page was the one used, this one stays as it was.
      isMine() {
        const hash = decodeURIComponent(window.location.hash.slice(1));
        return !hash || hash === this.dataset.formId;
      }

      onlyMine() {
        const posted =
          /[?&](customer_posted|contact_posted)=/.test(window.location.search) ||
          !!this.querySelector('[data-nl-error]');
        if (!posted || this.isMine()) return;
        this.classList.remove('nl--sent');
        this.querySelectorAll('[data-nl-ok], [data-nl-error]').forEach((el) => el.remove());
        const input = this.querySelector('input[type="email"]');
        if (input) {
          input.removeAttribute('aria-invalid');
          const note = this.querySelector('.nl-note');
          if (note) input.setAttribute('aria-describedby', note.id);
          else input.removeAttribute('aria-describedby');
        }
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('news-letter', NewsLetter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-mockup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('pack-mockup')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const RAD = Math.PI / 180;
    const REST = 2500;
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
    const norm = (a) => ((a % 360) + 360) % 360;
    const toward = (a, b) => ((norm(b) - norm(a) + 540) % 360) - 180;
    /* Where each side faces before turning (y points down, z toward the viewer) */
    const NORMALS = { front: [0, 0, 1], back: [0, 0, -1], right: [1, 0, 0], left: [-1, 0, 0], top: [0, -1, 0], bottom: [0, 1, 0] };
    /* The light comes from the upper left, in front */
    const LIGHT = (() => {
      const v = [-0.45, -0.6, 0.66];
      const l = Math.hypot(v[0], v[1], v[2]);
      return v.map((x) => x / l);
    })();

    class PackMockup extends HTMLElement {
      connectedCallback() {
        this.obj = this.querySelector('[data-pm-obj]');
        this.stage = this.querySelector('[data-pm-stage]');
        if (!this.obj || !this.stage || this.ac) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.base = Number(this.dataset.tilt) || -16;
        this.tilt = this.base;
        this.angle = -28;
        this.speed = Math.max(5, Number(this.dataset.speed) || 15);
        this.paused = this.dataset.auto !== 'true' || reduceMotion.matches;
        this.inertia = 0;
        this.goal = null;
        this.restUntil = 0;
        this.visible = false;
        this.tickFn = (t) => this.tick(t);
        this.faces = Array.from(this.querySelectorAll('[data-pm-face]')).map((el) => ({ n: NORMALS[el.dataset.pmFace], shade: el.querySelector('.pm-shade'), o: -1 }));
        this.views = Array.from(this.querySelectorAll('[data-pm-angle]'));
        this.playBtn = this.querySelector('[data-pm-play]');
        this.live = this.querySelector('[data-pm-live]');

        this.addEventListener('click', (e) => {
          const t = e.target;
          if (!(t instanceof Element)) return;
          if (t.closest('[data-pm-play]')) return this.setPaused(!this.paused, true);
          const v = t.closest('[data-pm-angle]');
          if (!v) return;
          const tilt = v.dataset.pmTilt ? Number(v.dataset.pmTilt) : this.base;
          this.turnTo(Number(v.dataset.pmAngle) || 0, tilt);
          this.say(`Showing the ${v.textContent.trim().toLowerCase()}.`);
        }, { signal });
        this.stage.addEventListener('keydown', (e) => {
          const steps = { ArrowLeft: [-15, 0], ArrowRight: [15, 0], ArrowUp: [0, -10], ArrowDown: [0, 10] };
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            return this.setPaused(!this.paused, true);
          }
          if (e.key === 'Home') {
            e.preventDefault();
            return this.turnTo(0, this.base);
          }
          const st = steps[e.key];
          if (!st) return;
          e.preventDefault();
          this.classList.add('is-touched');
          this.setPaused(true);
          this.goal = null;
          this.inertia = 0;
          this.angle += st[0];
          this.tilt = clamp(this.tilt + st[1], -80, 30);
          this.paint();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.kick(), { signal });
        this.bindHand();
        if ('IntersectionObserver' in window) {
          this.seen = new IntersectionObserver((entries) => {
            this.visible = entries[entries.length - 1].isIntersecting;
            this.kick();
          }, { threshold: 0.05 });
          this.seen.observe(this.stage);
        } else {
          this.visible = true;
        }
        this.paintPlay();
        this.paint();
        this.classList.add('is-ready');
        this.kick();
      }

      /* ---------- Turning and lighting ---------- */

      paint() {
        this.obj.style.transform = `rotateX(${this.tilt.toFixed(2)}deg) rotateY(${this.angle.toFixed(2)}deg)`;
        const a = this.tilt * RAD;
        const b = this.angle * RAD;
        const ca = Math.cos(a);
        const sa = Math.sin(a);
        const cb = Math.cos(b);
        const sb = Math.sin(b);
        for (const f of this.faces) {
          if (!f.shade) continue;
          const [x, y, z] = f.n;
          /* turn the side's direction the same way the object is turned (y first, then x) */
          const x1 = x * cb + z * sb;
          const z1 = -x * sb + z * cb;
          const y2 = y * ca - z1 * sa;
          const z2 = y * sa + z1 * ca;
          const lit = Math.max(0, x1 * LIGHT[0] + y2 * LIGHT[1] + z2 * LIGHT[2]);
          const o = Math.round((1 - lit) * 0.5 * 50) / 50;
          if (o === f.o) continue;
          f.o = o;
          f.shade.style.opacity = String(o);
        }
        const facing = norm(this.angle);
        this.views.forEach((v) => {
          const hasTilt = !!v.dataset.pmTilt;
          const on = hasTilt ? this.tilt < -55 : this.tilt >= -55 && Math.abs(toward(facing, Number(v.dataset.pmAngle) || 0)) <= 25;
          v.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      running(now) {
        return !this.paused && !this.press && this.visible && !document.hidden && now >= this.restUntil;
      }

      kick() {
        if (this.raf || !this.visible || document.hidden || !this.ac) return;
        this.last = 0;
        this.raf = requestAnimationFrame(this.tickFn);
      }

      wake(ms) {
        this.later(() => this.kick(), Math.max(16, ms));
      }

      tick(now) {
        this.raf = 0;
        const dt = this.last ? Math.min(50, now - this.last) : 16;
        this.last = now;
        let busy = false;
        if (this.press) {
          /* the hand turns it */
        } else if (this.inertia) {
          this.angle += this.inertia * dt;
          this.inertia *= Math.pow(0.93, dt / 16.7);
          if (Math.abs(this.inertia) < 0.004) this.inertia = 0;
          busy = true;
        } else if (this.goal) {
          /* a set glide that eases out, so it lands exactly and stops */
          const g = this.goal;
          const k = Math.min(1, (now - g.start) / g.span);
          const eased = 1 - Math.pow(1 - k, 3);
          this.angle = g.a0 + (g.a - g.a0) * eased;
          this.tilt = g.t0 + (g.t - g.t0) * eased;
          if (k >= 1) this.goal = null;
          else busy = true;
        } else if (this.running(now)) {
          this.angle += (this.speed * dt) / 1000;
          /* drifting back to the usual height while it turns */
          this.tilt += (this.base - this.tilt) * (1 - Math.exp(-dt / 700));
          busy = true;
        } else if (!this.paused && this.restUntil > now) {
          this.wake(this.restUntil - now);
        }
        if (Math.abs(this.angle) > 7200) this.angle = norm(this.angle);
        this.paint();
        if (busy && this.visible && !document.hidden) this.raf = requestAnimationFrame(this.tickFn);
      }

      turnTo(angle, tilt) {
        this.classList.add('is-touched');
        this.setPaused(true);
        this.inertia = 0;
        const a = this.angle + toward(this.angle, angle);
        if (reduceMotion.matches) {
          this.angle = a;
          this.tilt = tilt;
          this.goal = null;
          this.paint();
          return;
        }
        const span = Math.min(900, 380 + Math.max(Math.abs(a - this.angle), Math.abs(tilt - this.tilt) * 2) * 3);
        this.goal = { a0: this.angle, t0: this.tilt, a, t: tilt, start: performance.now(), span };
        this.kick();
      }

      setPaused(on, byHand) {
        this.paused = on;
        if (!on) this.restUntil = 0;
        this.paintPlay();
        if (byHand) this.say(on ? 'Stopped.' : 'Turning.');
        this.kick();
      }

      paintPlay() {
        this.classList.toggle('is-going', !this.paused);
        this.classList.toggle('is-paused', this.paused);
        if (this.playBtn) this.playBtn.setAttribute('aria-label', this.paused ? 'Turn on its own' : 'Stop turning');
      }

      /* ---------- Turning by hand ---------- */

      bindHand() {
        const signal = this.ac.signal;
        const stage = this.stage;
        stage.addEventListener('dragstart', (e) => e.preventDefault(), { signal });
        stage.addEventListener('pointerdown', (e) => {
          if (e.button > 0 || !e.isPrimary) return;
          this.press = { x: e.clientX, y: e.clientY, a: this.angle, tl: this.tilt, t: performance.now(), id: e.pointerId, moved: false, samples: [] };
          this.inertia = 0;
          this.goal = null;
          this.classList.add('is-touched');
        }, { signal });
        stage.addEventListener('pointermove', (e) => {
          const p = this.press;
          if (!p || e.pointerId !== p.id) return;
          const dx = e.clientX - p.x;
          const dy = e.clientY - p.y;
          if (!p.moved) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            /* On touch screens an upward or downward stroke scrolls the page instead */
            if (e.pointerType !== 'mouse' && Math.abs(dy) > Math.abs(dx)) {
              this.press = null;
              this.restUntil = performance.now() + 600;
              return this.kick();
            }
            p.moved = true;
            try {
              stage.setPointerCapture(e.pointerId);
            } catch (err) {
              /* the pointer is gone */
            }
            stage.classList.add('is-dragging');
          }
          this.angle = p.a + dx * 0.45;
          if (e.pointerType === 'mouse') this.tilt = clamp(p.tl - dy * 0.3, -80, 30);
          p.samples.push({ a: this.angle, t: performance.now() });
          if (p.samples.length > 5) p.samples.shift();
          this.paint();
        }, { signal });
        const end = (e) => {
          const p = this.press;
          if (!p || (e && e.pointerId !== p.id)) return;
          this.press = null;
          stage.classList.remove('is-dragging');
          const now = performance.now();
          if (p.moved) {
            const s0 = p.samples[0];
            const s1 = p.samples[p.samples.length - 1];
            if (!reduceMotion.matches && s0 && s1 && s1.t > s0.t && now - s1.t < 90) this.inertia = clamp((s1.a - s0.a) / (s1.t - s0.t), -1.2, 1.2);
          } else if (e && e.type === 'pointerup' && now - p.t < 350) {
            /* A tap stops it; another tap sets it going */
            this.setPaused(!this.paused, true);
          }
          this.restUntil = now + REST;
          this.kick();
        };
        stage.addEventListener('pointerup', end, { signal });
        stage.addEventListener('pointercancel', end, { signal });
        stage.addEventListener('lostpointercapture', (e) => {
          if (e.target === stage) end(e);
        }, { signal });
      }

      say(text) {
        if (!this.live) return;
        this.live.textContent = '';
        this.later(() => {
          if (this.live) this.live.textContent = text;
        }, 60);
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
        return id;
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        this.ac = null;
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        if (this.seen) this.seen.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.press = null;
      }
    }

    customElements.define('pack-mockup', PackMockup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["picks-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('picks-drawer')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 990px)');
    const DAY = 864e5;

    class PicksDrawer extends HTMLElement {
      connectedCallback() {
        if (this.classList.contains('pk--preview')) return;
        this.dialog = this.querySelector('[data-pk-dialog]');
        this.tab = this.querySelector('[data-pk-tab]');
        if (!this.dialog || !this.tab) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.isOpen = false;
        this.turn = 0;
        this.sectionId = this.dataset.sectionId;
        this.key = 'turblyn:picks:' + this.sectionId;
        this.design = !!(window.Shopify && window.Shopify.designMode);

        this.tab.hidden = false;
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));

        this.tab.addEventListener('click', () => this.open(this.tab), { signal });
        this.tab.addEventListener('pointerenter', () => this.warm(), { signal });
        this.tab.addEventListener('focus', () => this.warm(), { signal });
        this.dialog.addEventListener(
          'click',
          (e) => {
            if (e.target.closest('[data-pk-close]')) this.close();
          },
          { signal }
        );
        // Escape slides it away (handled here so the browser doesn't snap it shut)
        this.dialog.addEventListener(
          'keydown',
          (e) => {
            if (e.key !== 'Escape' || e.defaultPrevented) return;
            e.preventDefault();
            this.close();
          },
          { signal }
        );
        this.dialog.addEventListener(
          'cancel',
          (e) => {
            e.preventDefault();
            this.close();
          },
          { signal }
        );
        // Shut by the browser itself (a phone's back gesture): tidy up
        this.dialog.addEventListener(
          'close',
          () => {
            if (this.dialog.open || (!this.isOpen && !this.classList.contains('is-shown'))) return;
            this.isOpen = false;
            this.turn += 1;
            this.classList.remove('is-open', 'is-closing', 'is-shown');
            this.unlock();
            this.tab.setAttribute('aria-expanded', 'false');
          },
          { signal }
        );
        this.addEventListener(
          'submit',
          (e) => {
            const form = e.target.closest('[data-pk-add]');
            // A cart drawer that opens on add takes the form itself and slides in on top
            if (!form || document.querySelector('cart-drawer[data-open-on-add]')) return;
            e.preventDefault();
            this.add(form);
          },
          { signal }
        );

        if (this.design) {
          const mine = (e) => e.detail && e.detail.sectionId === this.sectionId;
          document.addEventListener('shopify:section:select', (e) => mine(e) && this.open(null), { signal });
          document.addEventListener('shopify:section:load', (e) => mine(e) && this.open(null), { signal });
          document.addEventListener('shopify:section:deselect', (e) => mine(e) && this.close(), { signal });
          return;
        }
        this.schedule(signal);
      }

      /* ---------- Opening by itself ---------- */

      schedule(signal) {
        const mode = this.dataset.auto;
        if (mode === 'off' || (mode === 'desktop' && !desktop.matches)) return;
        if (this.onCartPage() || this.seen()) return;
        const delay = Math.max(parseFloat(this.dataset.delay) || 0, 0) * 1000;
        const go = () => {
          this.later(() => this.warm(), Math.max(delay - 1500, 0));
          this.later(() => this.tryAuto(0), delay);
        };
        if (document.readyState === 'complete') go();
        else window.addEventListener('load', go, { once: true, signal });
      }

      tryAuto(n) {
        if (this.isOpen) return;
        const el = document.activeElement;
        const typing = el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName));
        // Never over another open window, in a background tab or while someone types
        if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || typing) {
          if (n < 10) this.later(() => this.tryAuto(n + 1), 2500);
          return;
        }
        if (!this.mark()) return;
        this.open(null);
      }

      seen() {
        try {
          if (this.dataset.every === 'session') return window.sessionStorage.getItem(this.key) === '1';
          const at = Number(window.localStorage.getItem(this.key));
          const days = this.dataset.every === 'week' ? 7 : 1;
          return at > 0 && Date.now() - at < days * DAY;
        } catch (e) {
          return true;
        }
      }

      mark() {
        // Without somewhere to remember it, it would open on every page, so it doesn't open at all
        try {
          if (this.dataset.every === 'session') window.sessionStorage.setItem(this.key, '1');
          else window.localStorage.setItem(this.key, String(Date.now()));
          return true;
        } catch (e) {
          return false;
        }
      }

      onCartPage() {
        try {
          const cart = new URL(this.dataset.cartUrl, window.location.origin).pathname.replace(/\/$/, '');
          return window.location.pathname.replace(/\/$/, '') === cart;
        } catch (e) {
          return false;
        }
      }

      warm() {
        if (this.warmed) return;
        this.warmed = true;
        this.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
      }

      /* ---------- Open / close ---------- */

      open(opener) {
        if (this.isOpen) return;
        this.isOpen = true;
        this.turn += 1;
        this.opener = opener;
        this.warm();
        this.lock();
        this.classList.remove('is-closing');
        this.classList.add('is-shown');
        if (!this.dialog.open) {
          if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          else this.dialog.setAttribute('open', '');
        }
        this.tab.setAttribute('aria-expanded', 'true');
        const turn = this.turn;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            if (this.isOpen && turn === this.turn) this.classList.add('is-open');
          })
        );
        // Focus goes to the drawer itself: its name is read out, and Tab reaches the close button next
        const panel = this.querySelector('[data-pk-panel]');
        if (panel && !this.design) panel.focus({ preventScroll: true });
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.turn += 1;
        const turn = this.turn;
        this.classList.add('is-closing');
        this.classList.remove('is-open');
        const finish = () => {
          if (turn !== this.turn || this.isOpen) return;
          // The handle is back where the tab sits: swap them in the same frame
          this.classList.remove('is-closing', 'is-shown');
          if (typeof this.dialog.close === 'function') this.dialog.close();
          else this.dialog.removeAttribute('open');
          this.unlock();
          this.tab.setAttribute('aria-expanded', 'false');
          this.say('');
          if (this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
        };
        if (reduceMotion.matches) finish();
        else this.later(finish, 430);
      }

      lock() {
        const sbw = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--pk-sbw', `${Math.max(sbw, 0)}px`);
        document.documentElement.classList.add('pk-locked');
      }

      unlock() {
        document.documentElement.classList.remove('pk-locked');
        document.documentElement.style.removeProperty('--pk-sbw');
      }

      /* ---------- Add to cart ---------- */

      async add(form) {
        const btn = form.querySelector('[data-pk-add-btn]');
        if (!btn || btn.getAttribute('aria-busy') === 'true') return;
        this.fail('');
        btn.setAttribute('aria-busy', 'true');
        try {
          const fd = new FormData(form);
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }] }),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || 'This could not be added to your cart.');
          btn.classList.add('is-added');
          this.later(() => btn.classList.remove('is-added'), 2000);
          this.say('Added to your cart.');
          await this.afterAdd();
        } catch (err) {
          this.fail((err && err.message) || 'Something went wrong. Please try again.');
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      async afterAdd() {
        if (document.querySelector('cart-drawer')) {
          // The cart drawer fetches the new cart and slides in on top of this one
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .catch(() => null);
        if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'picks-drawer' } }));
      }

      fail(text) {
        const msg = this.querySelector('[data-pk-msg]');
        if (!msg) return;
        msg.textContent = text;
        msg.hidden = !text;
      }

      say(text) {
        const live = this.querySelector('[data-pk-live]');
        if (!live) return;
        live.textContent = '';
        if (text) requestAnimationFrame(() => (live.textContent = text));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        if (this.isOpen || this.classList.contains('is-shown')) this.unlock();
        this.isOpen = false;
      }
    }

    customElements.define('picks-drawer', PicksDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pop-up"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('section-popup')) return;

    const DAY = 86400000;
    const FOREVER = 3650;

    class SectionPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.panel = this.querySelector('.popup__panel');
        if (!this.dialog || !this.panel) return;

        this.sectionId = this.dataset.sectionId;
        this.storageKey = `section-popup:${this.sectionId}`;
        this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
        this.isOpen = false;
        this.listeners = [];
        this.timers = [];

        this.listen(this, 'click', (event) => this.onClick(event));
        this.listen(this.dialog, 'cancel', (event) => {
          event.preventDefault();
          this.close();
        });
        this.listen(this.dialog, 'close', () => this.onNativeClose());

        if (this.designMode) {
          this.listen(document, 'shopify:section:select', (event) => {
            if (event.detail && event.detail.sectionId === this.sectionId) this.open();
          });
          this.listen(document, 'shopify:section:deselect', (event) => {
            if (event.detail && event.detail.sectionId === this.sectionId) this.close();
          });
          return;
        }

        if (this.dataset.success === 'true') this.remember(FOREVER);

        if (this.dataset.openNow === 'true') {
          this.eagerLoadMedia();
          this.open(true);
          return;
        }

        if (this.dataset.enabled !== 'true' || !this.canShow()) return;
        this.setupTrigger();
      }

      disconnectedCallback() {
        this.clearTriggers();
        (this.listeners || []).forEach(([target, type, handler, options]) =>
          target.removeEventListener(type, handler, options)
        );
        this.listeners = [];
        this.unlockScroll();
      }

      listen(target, type, handler, options) {
        target.addEventListener(type, handler, options);
        this.listeners.push([target, type, handler, options]);
      }

      clearTriggers() {
        (this.timers || []).forEach((id) => clearTimeout(id));
        this.timers = [];
        if (this.triggerCleanup) {
          this.triggerCleanup();
          this.triggerCleanup = null;
        }
      }

      setupTrigger() {
        this.eagerLoadMedia();
        const trigger = this.dataset.trigger;
        const delay = Math.max(0, parseInt(this.dataset.delay, 10) || 0) * 1000;

        if (trigger === 'scroll') {
          const target = Math.min(100, Math.max(1, parseInt(this.dataset.scroll, 10) || 50));
          let ticking = false;
          const check = () => {
            ticking = false;
            const root = document.documentElement;
            const scrollable = root.scrollHeight - window.innerHeight;
            if (scrollable <= 0) return;
            if ((window.scrollY / scrollable) * 100 >= target) this.autoOpen();
          };
          const onScroll = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(check);
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          this.triggerCleanup = () => window.removeEventListener('scroll', onScroll);
          return;
        }

        const canExitIntent = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (trigger === 'exit' && canExitIntent) {
          const onMouseOut = (event) => {
            if (!event.relatedTarget && event.clientY <= 0) this.autoOpen();
          };
          const armId = setTimeout(() => {
            document.addEventListener('mouseout', onMouseOut);
            this.triggerCleanup = () => document.removeEventListener('mouseout', onMouseOut);
          }, 2000);
          this.timers.push(armId);
          return;
        }

        this.timers.push(setTimeout(() => this.autoOpen(), delay));
      }

      autoOpen() {
        this.clearTriggers();
        if (document.querySelector('section-popup.is-open')) return;
        this.open();
      }

      eagerLoadMedia() {
        this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      }

      open(skipRemember) {
        if (this.isOpen) return;
        this.isOpen = true;
        this.clearTriggers();
        this.lastFocus = document.activeElement;
        this.classList.remove('is-closing');

        try {
          if (!this.dialog.open) {
            if (this.designMode) {
              this.dialog.show();
            } else {
              this.lockScroll();
              this.dialog.showModal();
            }
          }
        } catch (error) {
          this.isOpen = false;
          this.unlockScroll();
          return;
        }

        if (!this.designMode && !skipRemember) this.remember();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (this.isOpen) this.classList.add('is-open');
          });
        });

        this.panel.focus({ preventScroll: true });
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open');
        this.classList.add('is-closing');

        if (!this.designMode && this.dataset.success !== 'true') this.remember();

        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          clearTimeout(fallback);
          this.panel.removeEventListener('transitionend', onEnd);
          this.classList.remove('is-closing');
          if (this.isOpen) return;
          if (this.dialog.open) this.dialog.close();
          this.unlockScroll();
          this.restoreFocus();
        };
        const onEnd = (event) => {
          if (event.target === this.panel && event.propertyName === 'opacity') finish();
        };
        const fallback = setTimeout(finish, 450);
        this.panel.addEventListener('transitionend', onEnd);
      }

      onNativeClose() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open', 'is-closing');
        this.unlockScroll();
        this.restoreFocus();
      }

      restoreFocus() {
        const target = this.lastFocus;
        this.lastFocus = null;
        if (target && typeof target.focus === 'function' && document.contains(target)) {
          target.focus({ preventScroll: true });
        }
      }

      onClick(event) {
        const closer = event.target.closest('[data-popup-close]');
        if (closer && this.contains(closer)) {
          event.preventDefault();
          this.close();
          return;
        }

        const copyButton = event.target.closest('[data-popup-copy]');
        if (copyButton && this.contains(copyButton)) this.copy(copyButton);
      }

      async copy(button) {
        const code = button.dataset.code || '';
        let copied = false;

        try {
          await navigator.clipboard.writeText(code);
          copied = true;
        } catch (error) {
          const field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;';
          this.panel.appendChild(field);
          field.select();
          try {
            copied = document.execCommand('copy');
          } catch (e) {
            copied = false;
          }
          field.remove();
        }

        if (!copied) return;

        const label = button.querySelector('[data-popup-copy-label]');
        const live = this.querySelector('[data-popup-live]');
        button.classList.add('is-copied');
        if (label) label.textContent = button.dataset.labelCopied;
        if (live) live.textContent = button.dataset.labelCopied;

        clearTimeout(button._popupTimer);
        button._popupTimer = setTimeout(() => {
          button.classList.remove('is-copied');
          if (label) label.textContent = button.dataset.labelDefault;
          if (live) live.textContent = '';
        }, 2000);
      }

      canShow() {
        try {
          const stored = JSON.parse(localStorage.getItem(this.storageKey));
          return !(stored && typeof stored.until === 'number' && stored.until > Date.now());
        } catch (error) {
          return true;
        }
      }

      remember(days) {
        const span = typeof days === 'number' ? days : parseInt(this.dataset.frequency, 10) || 1;
        try {
          localStorage.setItem(this.storageKey, JSON.stringify({ until: Date.now() + span * DAY }));
        } catch (error) {
          /* Storage unavailable: popup still works, only frequency capping is skipped. */
        }
      }

      lockScroll() {
        if (this.scrollLocked) return;
        const root = document.documentElement;
        const scrollbar = window.innerWidth - root.clientWidth;
        this.previousOverflow = root.style.overflow;
        this.previousPadding = root.style.paddingRight;
        root.style.overflow = 'hidden';
        if (scrollbar > 0) root.style.paddingRight = `${scrollbar}px`;
        this.scrollLocked = true;
      }

      unlockScroll() {
        if (!this.scrollLocked) return;
        const root = document.documentElement;
        root.style.overflow = this.previousOverflow || '';
        root.style.paddingRight = this.previousPadding || '';
        this.scrollLocked = false;
      }
    }

    customElements.define('section-popup', SectionPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('product-finder')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class ProductFinder extends HTMLElement {
      connectedCallback() {
        this.qs = Array.from(this.querySelectorAll('[data-pf-q]'));
        if (!this.qs.length) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.cards = Array.from(this.querySelectorAll('[data-pf-card]'));
        this.steps = Array.from(this.querySelectorAll('.pf-step[data-pf-step]:not(.pf-step--end)'));
        this.back = this.querySelector('[data-pf-back]');
        this.next = this.querySelector('[data-pf-next]');
        this.n = this.qs.length;
        this.at = 0;
        this.turn = 0;
        this.done = false;
        this.picks = new Array(this.n).fill(null);
        this.key = 'turblyn:finder:' + this.dataset.sectionId;
        this.design = !!(window.Shopify && window.Shopify.designMode);
        this.pointer = false;

        // A tap or click on an answer moves on by itself; arrow keys only choose
        this.addEventListener(
          'pointerdown',
          (e) => {
            const opt = e.target.closest('[data-pf-opt]');
            this.pointer = !!opt;
            this.again = !!opt && opt.querySelector('input').checked;
          },
          { signal }
        );
        this.addEventListener('keydown', () => (this.pointer = false), { signal, capture: true });
        this.addEventListener(
          'change',
          (e) => {
            const input = e.target.closest('.pf-opt__input');
            if (!input) return;
            const qi = this.qs.indexOf(input.closest('[data-pf-q]'));
            if (qi < 0) return;
            this.picks[qi] = input;
            this.again = false;
            this.paint();
            if (this.pointer && qi === this.at) this.advanceSoon();
          },
          { signal }
        );
        this.addEventListener(
          'click',
          (e) => {
            const input = e.target.closest('.pf-opt__input');
            if (!input || !this.pointer || !this.again) return;
            this.again = false;
            if (this.qs.indexOf(input.closest('[data-pf-q]')) === this.at) this.advanceSoon();
          },
          { signal }
        );

        this.back.addEventListener('click', () => this.at > 0 && this.go(this.at - 1, -1), { signal });
        this.next.addEventListener('click', () => this.forward(), { signal });
        this.steps.forEach((step, i) => {
          const btn = step.querySelector('[data-pf-goto]');
          btn.addEventListener('click', () => this.go(i, i < this.at || this.done ? -1 : 1), { signal });
        });
        this.addEventListener(
          'click',
          (e) => {
            const chip = e.target.closest('[data-pf-chip]');
            if (chip) this.go(Number(chip.dataset.pfChip), -1);
          },
          { signal }
        );
        const restart = this.querySelector('[data-pf-restart]');
        if (restart) restart.addEventListener('click', () => this.restart(), { signal });

        this.addEventListener(
          'submit',
          (e) => {
            const form = e.target.closest('[data-pf-add]');
            // A cart drawer that opens on add takes the form itself
            if (!form || document.querySelector('cart-drawer[data-open-on-add]')) return;
            e.preventDefault();
            this.add(form);
          },
          { signal }
        );

        if (this.design) {
          document.addEventListener(
            'shopify:block:select',
            (e) => {
              const el = e.target instanceof Element ? e.target : null;
              if (!el || !this.contains(el)) return;
              const q = el.closest('[data-pf-q]');
              if (!q) return;
              this.querySelectorAll('.pf-opt.is-lit').forEach((o) => o.classList.remove('is-lit'));
              if (el.matches('[data-pf-opt]')) el.classList.add('is-lit');
              this.go(this.qs.indexOf(q), 0, false);
            },
            { signal }
          );
          document.addEventListener(
            'shopify:block:deselect',
            () => {
              this.querySelectorAll('.pf-opt.is-lit').forEach((o) => o.classList.remove('is-lit'));
            },
            { signal }
          );
        }

        if (!this.restore()) this.go(0, 0, false);
      }

      /* ---------- Moving through the questions ---------- */

      advanceSoon() {
        const turn = ++this.turn;
        this.later(() => turn === this.turn && this.forward(), reduceMotion.matches ? 120 : 420);
      }

      forward() {
        if (!this.picks[this.at]) return;
        if (this.at < this.n - 1) this.go(this.at + 1, 1);
        else this.reveal(true, true);
      }

      go(i, dir, focus = true) {
        this.turn += 1;
        this.done = false;
        this.at = Math.max(0, Math.min(i, this.n - 1));
        this.classList.remove('is-done', 'is-revealing');
        this.qs.forEach((q, k) => {
          q.hidden = k !== this.at;
          q.classList.remove('is-from-r', 'is-from-l');
        });
        const q = this.qs[this.at];
        if (dir && !reduceMotion.matches) {
          void q.offsetWidth;
          q.classList.add(dir > 0 ? 'is-from-r' : 'is-from-l');
        }
        this.paint();
        if (!focus) return;
        this.keepInView();
        const title = q.querySelector('legend');
        if (title) title.focus({ preventScroll: true });
        this.say(`Question ${this.at + 1} of ${this.n}`);
      }

      paint() {
        const firstOpen = this.picks.indexOf(null);
        const reach = firstOpen < 0 ? this.n : firstOpen;
        this.style.setProperty('--pf-prog', String(this.done ? 1 : this.at / this.n));
        const count = this.querySelector('[data-pf-count]');
        if (count) count.textContent = `Question ${this.at + 1} of ${this.n}`;
        this.steps.forEach((step, i) => {
          const pick = this.picks[i];
          const current = !this.done && i === this.at;
          step.classList.toggle('is-current', current);
          step.classList.toggle('is-answered', !!pick);
          const btn = step.querySelector('[data-pf-goto]');
          btn.disabled = current || i > reach;
          if (current) btn.setAttribute('aria-current', 'step');
          else btn.removeAttribute('aria-current');
          const label = step.querySelector('[data-pf-pick]');
          if (label) label.textContent = pick ? pick.dataset.label : '';
        });
        this.back.disabled = this.at === 0;
        this.next.disabled = !this.picks[this.at];
        const label = this.querySelector('[data-pf-next-label]');
        if (label) label.textContent = this.at === this.n - 1 ? 'See my matches' : 'Next';
      }

      /* ---------- The result ---------- */

      reveal(animate, focus) {
        this.turn += 1;
        const score = new Map();
        const first = new Map();
        let order = 0;
        this.picks.forEach((input) => {
          if (!input) return;
          (input.dataset.products || '')
            .split(',')
            .filter(Boolean)
            .forEach((id) => {
              score.set(id, (score.get(id) || 0) + 1);
              if (!first.has(id)) first.set(id, order++);
            });
        });
        const want = Math.max(1, Number(this.dataset.count) || 3);
        const ranked = this.cards
          .filter((c) => score.has(c.dataset.pfId))
          .sort(
            (a, b) =>
              score.get(b.dataset.pfId) - score.get(a.dataset.pfId) ||
              first.get(a.dataset.pfId) - first.get(b.dataset.pfId)
          );
        let shown = ranked.slice(0, want);
        if (shown.length < want) {
          // Fill the gaps from the backup collection
          shown = shown.concat(
            this.cards
              .filter((c) => c.hasAttribute('data-pf-fallback') && !shown.includes(c))
              .slice(0, want - shown.length)
          );
        }
        const answered = this.picks.filter(Boolean).length;
        this.cards.forEach((card) => {
          const at = shown.indexOf(card);
          const on = at >= 0;
          card.classList.toggle('is-on', on);
          card.style.order = on ? String(at) : '';
          card.style.setProperty('--i', String(Math.max(at, 0)));
          const s = score.get(card.dataset.pfId) || 0;
          card.classList.toggle('is-top', on && at === 0 && s > 0);
          this.fit(card, on && s > 0 ? s : 0, answered);
        });
        const grid = this.querySelector('[data-pf-cards]');
        if (grid)
          grid.style.setProperty('--pf-cols', String(shown.length === 4 ? 2 : Math.min(Math.max(shown.length, 1), 3)));
        const none = this.querySelector('[data-pf-none]');
        if (none) {
          none.hidden = ranked.length > 0;
          none.textContent = shown.length
            ? 'Nothing fits every answer, so here are a few favorites to start with.'
            : 'Nothing matches these answers yet. Try changing one of them.';
        }
        const recap = this.querySelector('[data-pf-recap]');
        if (recap) {
          recap.textContent = '';
          this.picks.forEach((pick, i) => {
            if (!pick) return;
            const chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'pf-chip';
            chip.dataset.pfChip = String(i);
            chip.textContent = pick.dataset.label;
            const legend = this.qs[i].querySelector('legend');
            chip.setAttribute(
              'aria-label',
              `Change your answer to "${legend ? legend.textContent.trim() : ''}": ${pick.dataset.label}`
            );
            recap.appendChild(chip);
          });
          recap.hidden = !recap.children.length;
        }

        this.done = true;
        this.classList.add('is-done');
        this.classList.remove('is-revealing');
        if (animate && !reduceMotion.matches) {
          void this.offsetWidth;
          this.classList.add('is-revealing');
        }
        this.paint();
        this.store();
        if (!focus) return;
        this.keepInView();
        const title = this.querySelector('[data-pf-title]');
        if (title) title.focus({ preventScroll: true });
        const top = ranked.length;
        this.say(
          top
            ? `${Math.min(top, want)} ${Math.min(top, want) === 1 ? 'match' : 'matches'} found.`
            : 'No exact match. Showing a few favorites.'
        );
      }

      fit(card, s, total) {
        const el = card.querySelector('[data-pf-fit]');
        if (!el) return;
        el.textContent = '';
        el.hidden = !s || !this.hasAttribute('data-fit');
        if (el.hidden) return;
        const dots = document.createElement('span');
        dots.className = 'pf-fit__dots';
        dots.setAttribute('aria-hidden', 'true');
        for (let i = 0; i < total; i += 1) {
          const dot = document.createElement('i');
          if (i < s) dot.className = 'is-on';
          dots.appendChild(dot);
        }
        el.append(dots, document.createTextNode(`Fits ${s} of your ${total} answers`));
      }

      restart() {
        this.qs.forEach((q) => q.querySelectorAll('.pf-opt__input').forEach((i) => (i.checked = false)));
        this.picks = new Array(this.n).fill(null);
        try {
          window.sessionStorage.removeItem(this.key);
        } catch (e) {
          /* nothing stored */
        }
        this.go(0, -1);
      }

      /* ---------- Remembered for the visit ---------- */

      store() {
        if (!this.hasAttribute('data-remember') || this.design) return;
        try {
          window.sessionStorage.setItem(this.key, JSON.stringify(this.picks.map((p) => (p ? p.value : null))));
        } catch (e) {
          /* not remembered */
        }
      }

      restore() {
        if (!this.hasAttribute('data-remember') || this.design) return false;
        let saved = null;
        try {
          saved = JSON.parse(window.sessionStorage.getItem(this.key) || 'null');
        } catch (e) {
          saved = null;
        }
        if (!Array.isArray(saved) || saved.length !== this.n) return false;
        const inputs = saved.map((value, i) =>
          Array.from(this.qs[i].querySelectorAll('.pf-opt__input')).find((x) => x.value === value)
        );
        if (inputs.some((x) => !x)) return false;
        inputs.forEach((x, i) => {
          x.checked = true;
          this.picks[i] = x;
        });
        this.at = this.n - 1;
        this.reveal(false, false);
        return true;
      }

      keepInView() {
        const stage = this.querySelector('.pf-stage');
        if (!stage) return;
        const r = stage.getBoundingClientRect();
        if (r.top < 0) stage.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      /* ---------- Add to cart ---------- */

      async add(form) {
        const btn = form.querySelector('[data-pf-add-btn]');
        if (!btn || btn.getAttribute('aria-busy') === 'true') return;
        this.fail('');
        btn.setAttribute('aria-busy', 'true');
        try {
          const fd = new FormData(form);
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }] }),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || 'This could not be added to your cart.');
          btn.classList.add('is-added');
          this.later(() => btn.classList.remove('is-added'), 2000);
          this.say('Added to your cart.');
          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else {
            const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
              .then((r) => r.json())
              .catch(() => null);
            if (cart)
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'product-finder' } }));
          }
        } catch (err) {
          this.fail((err && err.message) || 'Something went wrong. Please try again.');
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      fail(text) {
        const msg = this.querySelector('[data-pf-msg]');
        if (!msg) return;
        msg.textContent = text;
        msg.hidden = !text;
      }

      say(text) {
        const live = this.querySelector('[data-pf-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('product-finder', ProductFinder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* The trail: [{ h: product handle, t: when it was seen }], newest first */
    const KEY = 'turblyn:viewed';
    const KEEP = 24;

    const read = () => {
      try {
        const list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
        if (!Array.isArray(list)) return [];
        const seen = new Set();
        return list.filter((x) => {
          if (!x || typeof x.h !== 'string' || !x.h || typeof x.t !== 'number' || seen.has(x.h)) return false;
          seen.add(x.h);
          return true;
        });
      } catch (e) {
        return [];
      }
    };
    const write = (list) => {
      try {
        if (list.length) window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, KEEP)));
        else window.localStorage.removeItem(KEY);
      } catch (e) {}
    };
    /* Respect the shop's cookie banner when it is on the page */
    const allowed = () => {
      try {
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (privacy && typeof privacy.preferencesProcessingAllowed === 'function') {
          return privacy.preferencesProcessingAllowed() !== false;
        }
      } catch (e) {}
      return true;
    };
    const remember = (handle) => {
      if (!handle || !allowed()) return;
      const list = read().filter((x) => x.h !== handle);
      list.unshift({ h: handle, t: Date.now() });
      write(list);
    };

    /* Every product page adds itself to the trail, wherever this section is used */
    try {
      const meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      const type = meta && meta.page && meta.page.pageType;
      const hit = window.location.pathname.match(/\/products\/([^/]+)\/?$/);
      if (hit && (!type || type === 'product')) remember(decodeURIComponent(hit[1]));
    } catch (e) {}

    if (customElements.get('recently-viewed')) return;
    // Theme settings › Animations "none" counts as a standing request for less motion
    const reduceMotion = window.matchMedia(
      document.documentElement.dataset.motion === 'none' ? 'all' : '(prefers-reduced-motion: reduce)'
    );
    // The cards ease in on arrival only while the theme reveals content (Animations › reveal on scroll)
    const revealOff = () => reduceMotion.matches || document.documentElement.dataset.reveal === 'none';
    const COLOR_OPTIONS = ['color', 'colour', 'colors', 'colours', 'renk', 'renkler', 'farbe', 'couleur', 'colore'];

    /* One request per product per page, shared by every copy of the section */
    const cache = new Map();
    const fetchProduct = (root, handle) => {
      if (!cache.has(handle)) {
        const job = fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
          headers: { Accept: 'application/json' },
        })
          .then((res) => {
            if (res.status === 404) return { gone: true };
            return res.ok ? res.json() : null;
          })
          .then((data) => (data && (data.gone || (data.id && data.handle)) ? data : null))
          .catch(() => null)
          .then((data) => {
            if (!data) cache.delete(handle);
            return data;
          });
        cache.set(handle, job);
      }
      return cache.get(handle);
    };

    class RecentlyViewed extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-rv-list]');
        this.tpl = this.querySelector('template[data-rv-card]');
        if (!this.list || !this.tpl) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.ph = this.querySelector('template[data-rv-ph]');
        this.note = this.querySelector('[data-rv-empty]');
        this.example = this.querySelector('[data-rv-example]');
        this.hint = this.querySelector('[data-rv-hint]');
        this.prev = this.querySelector('[data-rv-prev]');
        this.next = this.querySelector('[data-rv-next]');
        this.max = Math.max(1, Number(this.dataset.max) || 8);
        this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
        this.current = this.dataset.current || '';
        this.currentId = Number(this.dataset.currentId) || 0;
        this.design = this.hasAttribute('data-design');
        this.pool = [];
        // Theme settings › Product cards / Badges / Prices, printed by the section
        this.saleBadge = this.dataset.saleBadge || 'text';
        this.newDays = Math.max(0, Number(this.dataset.newDays) || 0);
        this.swatchLimit = Math.max(0, Number(this.dataset.swatches) || 0);
        this.tagBadges = this.hasAttribute('data-tag-badges');
        this.secondImage = this.hasAttribute('data-second-image');
        this.savings = this.hasAttribute('data-savings');
        this.ratioAuto = this.hasAttribute('data-ratio-auto');
        this.money = this.readMoney(this.dataset.money);
        this.moneyShort = this.dataset.moneyShort ? this.readMoney(this.dataset.moneyShort) : this.money;
        try {
          this.rtf = new Intl.RelativeTimeFormat(document.documentElement.lang || 'en', { numeric: 'auto' });
        } catch (e) {
          this.rtf = null;
        }
        if (!revealOff()) this.classList.add('is-ready');
        if (this.current) remember(this.current);

        this.addEventListener(
          'click',
          (e) => {
            const t = e.target;
            if (!(t instanceof Element)) return;
            const x = t.closest('[data-rv-remove]');
            if (x) return this.drop(x.closest('[data-rv-item]'));
            if (t.closest('[data-rv-clear]')) return this.clear();
            if (t.closest('[data-rv-prev]')) return this.step(-1);
            if (t.closest('[data-rv-next]')) return this.step(1);
          },
          { signal }
        );
        this.addEventListener(
          'submit',
          (e) => {
            const form = e.target instanceof Element && e.target.closest('[data-rv-add-form]');
            if (!form) return;
            // A cart drawer that opens on add takes the form itself and slides in
            if (document.querySelector('cart-drawer[data-open-on-add]')) return;
            e.preventDefault();
            this.add(form);
          },
          { signal }
        );
        this.list.addEventListener('scroll', () => this.queueArrows(), { passive: true, signal });
        // Coming back with the browser's back button shows the page as it was: bring the trail up to date
        window.addEventListener(
          'pageshow',
          (e) => {
            if (e.persisted) this.load();
          },
          { signal }
        );
        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.visibilityState === 'visible') this.times();
          },
          { signal }
        );
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.queueArrows());
          this.ro.observe(this.list);
        }
        this.load();
      }

      /* ---------- Filling the trail ---------- */

      async load() {
        const token = (this.token = (this.token || 0) + 1);
        const trail = read().filter((x) => x.h !== this.current);
        if (!trail.length) return this.blank();
        const wanted = trail.slice(0, this.max + 4);
        this.open();
        if (!this.list.querySelector('[data-rv-item]')) this.ghosts(Math.min(trail.length, this.max));
        const found = await Promise.all(wanted.map((x) => fetchProduct(this.root, x.h)));
        if (token !== this.token || !this.isConnected) return;

        // Products that no longer exist leave the trail for good
        const gone = wanted.filter((x, i) => found[i] && found[i].gone).map((x) => x.h);
        if (gone.length) write(read().filter((x) => !gone.includes(x.h)));

        const ids = new Set(this.currentId ? [this.currentId] : []);
        const items = [];
        wanted.forEach((x, i) => {
          const p = found[i];
          if (!p || p.gone || ids.has(p.id)) return;
          ids.add(p.id);
          items.push({ h: x.h, t: x.t, p });
        });
        if (!items.length) return this.blank();
        this.render(items.slice(0, this.max));
        this.pool = items.slice(this.max);
      }

      open() {
        this.hidden = false;
        this.classList.remove('is-empty', 'is-example');
        this.list.hidden = false;
        if (this.note) this.note.hidden = true;
        if (this.example) this.example.hidden = true;
        if (this.hint) this.hint.hidden = true;
      }

      /* Nothing to show: off the page, or an example in the theme editor */
      blank() {
        this.list.replaceChildren();
        this.list.removeAttribute('aria-busy');
        this.pool = [];
        if (this.design && this.example) {
          this.open();
          this.list.hidden = true;
          this.example.hidden = false;
          if (this.hint) this.hint.hidden = false;
          this.classList.add('is-example');
          this.arrive();
        } else {
          this.hidden = true;
        }
        this.paintArrows();
      }

      ghosts(n) {
        const frag = document.createDocumentFragment();
        for (let i = 0; i < n; i += 1) {
          const li = document.createElement('li');
          li.className = 'rv-ghost';
          li.setAttribute('aria-hidden', 'true');
          li.innerHTML =
            '<span class="rv-ghost__stamp"></span><span class="rv-ghost__frame"></span><span class="rv-ghost__line"></span><span class="rv-ghost__line rv-ghost__line--short"></span>';
          frag.appendChild(li);
        }
        this.list.replaceChildren(frag);
        this.list.setAttribute('aria-busy', 'true');
      }

      render(items) {
        const frag = document.createDocumentFragment();
        items.forEach((item, i) => frag.appendChild(this.card(item, i)));
        this.list.replaceChildren(frag);
        this.list.removeAttribute('aria-busy');
        this.list.scrollLeft = 0;
        this.paintArrows();
        this.arrive();
      }

      card(item, i) {
        const p = item.p;
        const li = this.tpl.content.firstElementChild.cloneNode(true);
        li.dataset.handle = item.h;
        li.style.setProperty('--i', String(i));

        const link = li.querySelector('[data-rv-link]');
        link.href = `${this.root}products/${encodeURIComponent(p.handle)}`;
        link.textContent = p.title;

        const vendor = li.querySelector('[data-rv-vendor]');
        if (vendor) {
          vendor.textContent = p.vendor || '';
          vendor.hidden = !p.vendor;
        }
        const time = li.querySelector('[data-rv-time]');
        if (time) {
          time.dateTime = new Date(item.t).toISOString();
          time.dataset.t = String(item.t);
          time.textContent = this.ago(item.t);
        }
        const frame = li.querySelector('[data-rv-frame]');
        this.picture(frame, p);

        const badges = this.badges(p);
        if (badges.length && frame) {
          const wrap = document.createElement('span');
          wrap.className = 'badges';
          badges.forEach(([kind, text]) => {
            const badge = document.createElement('span');
            badge.className = `badge badge--${kind}`;
            badge.textContent = text;
            wrap.append(badge);
          });
          frame.after(wrap);
        }
        const priceEl = li.querySelector('[data-rv-price]');
        this.price(priceEl, p);
        const swatches = this.swatches(p);
        if (swatches && priceEl) priceEl.after(swatches);

        const x = li.querySelector('[data-rv-remove]');
        if (x) x.setAttribute('aria-label', `Remove ${p.title} from recently viewed`);

        const form = li.querySelector('[data-rv-add-form]');
        if (form) {
          const v = Array.isArray(p.variants) && p.variants.length === 1 ? p.variants[0] : null;
          if (v && p.available && v.available && !p.requires_selling_plan) {
            const min = (v.quantity_rule && Number(v.quantity_rule.min)) || 1;
            form.querySelector('[data-rv-id]').value = String(v.id);
            form.querySelector('[data-rv-qty]').value = String(Math.max(1, min));
            form.querySelector('[data-rv-add]').setAttribute('aria-label', `Add ${p.title} to cart`);
            form.hidden = false;
          } else {
            form.remove();
          }
        }
        return li;
      }

      picture(frame, p) {
        if (!frame) return;
        const pictures = Array.isArray(p.media)
          ? p.media.filter((m) => m && m.preview_image && m.preview_image.src)
          : [];
        const media = pictures[0] || null;
        const src = (media && media.preview_image.src) || p.featured_image;
        const placeholder = () => {
          frame.style.removeProperty('aspect-ratio');
          if (this.ph && this.ph.content.firstElementChild)
            frame.replaceChildren(this.ph.content.firstElementChild.cloneNode(true));
        };
        if (!src) return placeholder();
        const w = (media && Number(media.preview_image.width)) || 0;
        const h = (media && Number(media.preview_image.height)) || 0;
        // Theme settings › Product cards › "adapt to image": the frame takes this picture's own shape
        if (this.ratioAuto && w && h) frame.style.aspectRatio = `${w} / ${h}`;
        const img = this.img(src, w, h, 'rv-card__img');
        img.addEventListener('error', placeholder, { once: true });
        frame.replaceChildren(img);
        // A second picture that fades in on hover (Theme settings › Product cards)
        const next = this.secondImage && pictures[1];
        if (next) {
          const pi = next.preview_image;
          const alt = this.img(pi.src, Number(pi.width) || 0, Number(pi.height) || 0, 'rv-card__img rv-card__img--alt');
          alt.addEventListener('error', () => alt.remove(), { once: true });
          frame.append(alt);
        }
      }

      img(src, w, h, className) {
        let widths = [180, 270, 360, 540, 720];
        if (w) widths = widths.filter((x) => x <= w);
        if (!widths.length) widths = [w];
        const img = document.createElement('img');
        img.className = className;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        if (w && h) {
          img.width = w;
          img.height = h;
        }
        img.sizes = this.dataset.sizes || '46vw';
        img.srcset = widths.map((x) => `${this.sized(src, x)} ${x}w`).join(', ');
        img.src = this.sized(src, widths[Math.min(2, widths.length - 1)]);
        img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
        if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
        return img;
      }

      sized(src, width) {
        const base = String(src)
          .replace(/([?&])width=\d+&?/, '$1')
          .replace(/[?&]$/, '');
        return `${base}${base.includes('?') ? '&' : '?'}width=${width}`;
      }

      price(el, p) {
        if (!el) return;
        const sr = (text) => {
          const span = document.createElement('span');
          span.className = 'rv-sr';
          span.textContent = text;
          return span;
        };
        const sale = !p.price_varies && p.compare_at_price > p.price;
        const now = document.createElement('span');
        const low = typeof p.price_min === 'number' ? p.price_min : p.price;
        now.textContent = p.price_varies ? `From ${this.money(low)}` : this.money(p.price);
        if (sale) now.className = 'price__sale';
        el.replaceChildren(sr(sale ? 'Sale price' : 'Price'), now);
        if (sale) {
          const was = document.createElement('s');
          was.className = 'price__compare';
          was.append(sr('Regular price'), document.createTextNode(this.money(p.compare_at_price)));
          el.append(was);
          // Theme settings › Prices › show savings
          if (this.savings) {
            const save = document.createElement('span');
            save.className = 'price__save';
            save.textContent = `Save ${this.money(p.compare_at_price - p.price)}`;
            el.append(save);
          }
        }
      }

      /* Sold out or sale, new, then the shop's own "badge:" tags — two at most (Theme settings › Badges) */
      badges(p) {
        const list = [];
        if (!p.available) {
          list.push(['sold-out', 'Sold out']);
        } else if (p.compare_at_price > p.price) {
          const saving = p.compare_at_price - p.price;
          let text = 'Sale';
          if (this.saleBadge === 'percent') {
            const pct = Math.round((saving * 100) / p.compare_at_price);
            if (pct > 0) text = `-${pct}%`;
          } else if (this.saleBadge === 'amount') {
            text = `-${this.moneyShort(saving)}`;
          }
          list.push(['sale', text]);
        }
        if (this.newDays && p.created_at) {
          const age = Date.now() - Date.parse(p.created_at);
          if (age >= 0 && age < this.newDays * 86400000) list.push(['new', 'New']);
        }
        if (this.tagBadges && Array.isArray(p.tags)) {
          p.tags.forEach((tag) => {
            const raw = String(tag);
            if (list.length >= 2 || raw.slice(0, 6).toLowerCase() !== 'badge:') return;
            const text = raw.slice(6).trim();
            if (text) list.push(['tag', text]);
          });
        }
        return list.slice(0, 2);
      }

      /* Colour dots (Theme settings › Product cards): the value's own swatch, else its variant's picture,
         else the colour its name spells */
      swatches(p) {
        if (!this.swatchLimit || !Array.isArray(p.options)) return null;
        const at = p.options.findIndex((o) => o && COLOR_OPTIONS.includes(`${o.name || ''}`.trim().toLowerCase()));
        if (at < 0) return null;
        const option = p.options[at];
        const key = `option${option.position || at + 1}`;
        const variants = Array.isArray(p.variants) ? p.variants : [];
        const dots = [];
        (Array.isArray(option.values) ? option.values : []).forEach((value) => {
          const name = String(value && typeof value === 'object' ? value.name || value.value || '' : value);
          const own = value && typeof value === 'object' ? value.swatch : null;
          let paint = '';
          if (own && own.color) paint = String(own.color);
          else if (own && own.image) paint = `url("${this.sized(own.image.src || own.image, 60)}")`;
          if (!paint) {
            const v = variants.find((x) => x && x[key] === name && x.featured_image && x.featured_image.src);
            if (v) paint = `url("${this.sized(v.featured_image.src, 60)}")`;
          }
          if (!paint && window.CSS && CSS.supports('color', name.replace(/\s+/g, '').toLowerCase())) {
            paint = name.replace(/\s+/g, '').toLowerCase();
          }
          if (paint && name) dots.push([name, paint]);
        });
        if (dots.length < 2) return null;
        const row = document.createElement('p');
        row.className = 'rv-card__swatches';
        const box = document.createElement('span');
        box.className = 'rv-card__dots';
        box.setAttribute('aria-hidden', 'true');
        dots.slice(0, this.swatchLimit).forEach(([name, paint]) => {
          const dot = document.createElement('span');
          dot.className = 'swatch swatch--card';
          dot.title = name;
          dot.style.setProperty('--swatch-color', paint);
          box.append(dot);
        });
        const more = dots.length - this.swatchLimit;
        if (more > 0) {
          const extra = document.createElement('span');
          extra.className = 'rv-card__more';
          extra.textContent = `+${more}`;
          box.append(extra);
        }
        const sr = document.createElement('span');
        sr.className = 'rv-sr';
        sr.textContent = `${dots.length} colors`;
        row.append(box, sr);
        return row;
      }

      /* ---------- When it was seen ---------- */

      ago(t) {
        const sec = Math.max(0, (Date.now() - t) / 1000);
        if (sec < 45) return 'Just now';
        let value;
        let unit;
        if (sec < 3600) [value, unit] = [Math.floor(sec / 60), 'minute'];
        else if (sec < 86400) [value, unit] = [Math.floor(sec / 3600), 'hour'];
        else if (sec < 604800) [value, unit] = [Math.floor(sec / 86400), 'day'];
        else if (sec < 2629800) [value, unit] = [Math.floor(sec / 604800), 'week'];
        else [value, unit] = [Math.floor(sec / 2629800), 'month'];
        value = Math.max(1, value);
        if (this.rtf) return this.rtf.format(-value, unit);
        return `${value} ${unit}${value === 1 ? '' : 's'} ago`;
      }

      times() {
        this.querySelectorAll('[data-rv-time][data-t]').forEach((el) => {
          el.textContent = this.ago(Number(el.dataset.t));
        });
      }

      /* ---------- Arriving ---------- */

      arrive() {
        if (this.classList.contains('is-in')) return;
        if (!this.classList.contains('is-ready') || !('IntersectionObserver' in window)) return this.land();
        if (this.io) return;
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((x) => x.isIntersecting)) return;
            this.io.disconnect();
            this.io = null;
            requestAnimationFrame(() => this.land());
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this.io.observe(this);
      }

      land() {
        this.classList.add('is-in');
        if (!this.classList.contains('is-ready')) {
          this.classList.add('is-settled');
          return;
        }
        this.later(() => this.classList.add('is-settled'), 1600);
      }

      /* ---------- Dropping and clearing ---------- */

      drop(li) {
        if (!li || li.classList.contains('is-leaving')) return;
        write(read().filter((x) => x.h !== li.dataset.handle));
        const cards = Array.from(this.list.querySelectorAll('[data-rv-item]'));
        const at = cards.indexOf(li);
        const after = cards[at + 1] || cards[at - 1] || null;
        const hadFocus = li.contains(document.activeElement);
        const link = li.querySelector('[data-rv-link]');
        this.say(`${link ? link.textContent : 'Product'} removed from recently viewed.`);
        li.classList.add('is-leaving');

        const finish = () => {
          if (!li.isConnected) return;
          const before = new Map();
          cards.forEach((c) => {
            if (c !== li) before.set(c, c.getBoundingClientRect().left);
          });
          li.remove();
          // The next product in the trail steps up to fill the row
          if (this.pool.length) {
            const card = this.card(this.pool.shift(), 0);
            card.classList.add('is-new');
            this.list.appendChild(card);
          }
          const rest = Array.from(this.list.querySelectorAll('[data-rv-item]'));
          if (!rest.length) return this.cleared(hadFocus);
          if (!reduceMotion.matches) this.slide(rest, before);
          this.paintArrows();
          if (hadFocus && after && after.isConnected) {
            const target = after.querySelector('[data-rv-remove]') || after.querySelector('[data-rv-link]');
            if (target) target.focus({ preventScroll: true });
          }
        };
        if (reduceMotion.matches) finish();
        else this.later(finish, 260);
      }

      /* The cards left behind glide into the gap */
      slide(cards, before) {
        const moved = [];
        cards.forEach((c) => {
          if (!before.has(c)) return;
          const dx = before.get(c) - c.getBoundingClientRect().left;
          if (Math.abs(dx) < 1) return;
          c.style.transition = 'none';
          c.style.transform = `translate3d(${dx}px, 0, 0)`;
          moved.push(c);
        });
        if (!moved.length) return;
        void this.list.offsetWidth;
        moved.forEach((c) => {
          c.style.transition = '';
          c.style.transform = '';
        });
      }

      clear() {
        write([]);
        this.pool = [];
        const cards = Array.from(this.list.querySelectorAll('[data-rv-item]'));
        cards.forEach((c) => c.classList.add('is-leaving'));
        this.say('Your recently viewed list is cleared.');
        if (reduceMotion.matches || !cards.length) this.cleared(true);
        else this.later(() => this.cleared(true), 260);
      }

      cleared(focus) {
        this.list.replaceChildren();
        this.pool = [];
        this.classList.add('is-empty');
        if (this.note) {
          this.note.hidden = false;
          if (focus) this.note.focus({ preventScroll: true });
        }
        this.paintArrows();
      }

      /* ---------- Arrows ---------- */

      queueArrows() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.paintArrows();
        });
      }

      paintArrows() {
        if (!this.prev || !this.next) return;
        const l = this.list;
        const focused = document.activeElement;
        const room = l.scrollWidth - l.clientWidth;
        const pos = Math.abs(l.scrollLeft);
        const over =
          room > 2 && !l.hidden && !this.classList.contains('is-empty') && !this.classList.contains('is-example');
        this.classList.toggle('has-overflow', over);
        this.prev.disabled = !over || pos <= 2;
        this.next.disabled = !over || pos >= room - 2;
        // A button that just ran out of room hands the focus to its partner
        if (focused === this.next && this.next.disabled && !this.prev.disabled) this.prev.focus();
        else if (focused === this.prev && this.prev.disabled && !this.next.disabled) this.next.focus();
      }

      step(dir) {
        const l = this.list;
        const card = l.querySelector('[data-rv-item]');
        if (!card) return;
        const style = getComputedStyle(l);
        const gap = parseFloat(style.columnGap) || 0;
        const width = card.getBoundingClientRect().width + gap;
        const inner = l.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
        const n = Math.max(1, Math.floor((inner + gap) / width));
        const flip = style.direction === 'rtl' ? -1 : 1;
        l.scrollBy({ left: dir * flip * n * width, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      /* ---------- Straight to the cart ---------- */

      async add(form) {
        const btn = form.querySelector('[data-rv-add]');
        if (!btn || btn.getAttribute('aria-busy') === 'true') return;
        const id = Number(form.querySelector('[data-rv-id]').value);
        const quantity = Math.max(1, Number(form.querySelector('[data-rv-qty]').value) || 1);
        if (!id) return;
        const li = form.closest('[data-rv-item]');
        const link = li && li.querySelector('[data-rv-link]');
        const name = link ? link.textContent : 'Product';
        this.fail('');
        btn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: [{ id, quantity }] }),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || `${name} could not be added to your cart.`);
          btn.classList.add('is-added');
          this.later(() => btn.classList.remove('is-added'), 2000);
          this.say(`${name} added to your cart.`);
          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else {
            const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
              .then((r) => r.json())
              .catch(() => null);
            if (cart)
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'recently-viewed' } }));
          }
        } catch (err) {
          this.fail((err && err.message) || 'Something went wrong. Please try again.');
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      /* The shop's own money format (with the currency code when Theme settings › Prices asks), read from a
         sample the theme printed */
      readMoney(sample = '') {
        const m = String(sample).match(/1([^0-9]?)000(?:([^0-9])(0+))?/);
        if (!m) return (cents) => (cents / 100).toFixed(2);
        const [hit, group, dec, decimals] = m;
        const places = decimals ? decimals.length : 0;
        const before = sample.slice(0, m.index);
        const after = sample.slice(m.index + hit.length);
        return (cents) => {
          const fixed = (Math.round(Number(cents) || 0) / 100).toFixed(places);
          const [whole, frac] = fixed.split('.');
          const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, group);
          return before + grouped + (places ? dec + frac : '') + after;
        };
      }

      fail(text) {
        const msg = this.querySelector('[data-rv-msg]');
        if (!msg) return;
        msg.textContent = text;
        msg.hidden = !text;
      }

      say(text) {
        const live = this.querySelector('[data-rv-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        this.token = (this.token || 0) + 1;
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        if (this.io) this.io.disconnect();
        this.io = null;
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }
    }

    customElements.define('recently-viewed', RecentlyViewed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('related-products')) return;

    const root = document.documentElement;
    // Theme settings › Animations: "none" behaves like the visitor's reduced-motion preference,
    // "subtle" keeps fades and state changes but drops the decorative swing.
    const reduceMotion = window.matchMedia(root.dataset.motion === 'none' ? 'all' : '(prefers-reduced-motion: reduce)');
    const calm = () => reduceMotion.matches || root.dataset.motion === 'subtle';
    const speed = () => parseFloat(getComputedStyle(root).getPropertyValue('--motion-speed')) || 1;
    const plainClick = (e) => e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

    class RelatedProducts extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        if (this.ctrl) this.ctrl.abort();
        if (this.loadCtrl) this.loadCtrl.abort();
        [this.loadIo, this.showIo, this.ro].forEach((o) => o && o.disconnect());
        clearTimeout(this.settleTimer);
        cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.ctrl = null;
      }

      setup() {
        if (this.ctrl || !this.isConnected) return;
        this.ctrl = new AbortController();
        const signal = this.ctrl.signal;
        this.sectionId = this.dataset.sectionId;

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('submit', (e) => this.onSubmit(e), { signal });
        this.addEventListener('keydown', (e) => this.onKeydown(e), { signal });
        this.addEventListener('pointerover', (e) => this.onPointerOver(e), { signal });
        this.addEventListener('pointerout', (e) => this.onPointerOut(e), { signal });
        this.addEventListener(
          'animationend',
          (e) => {
            if (e.target.classList && e.target.classList.contains('rp-tag')) e.target.classList.remove('is-swing');
          },
          { signal }
        );
        document.addEventListener(
          'pointerdown',
          (e) => {
            if (this.quickCard && !this.quickCard.contains(e.target)) this.closeQuick(false);
          },
          { signal }
        );
        document.addEventListener(
          'cart:updated',
          (e) => {
            if (!this.quickCard) return;
            if (e.detail && e.detail.source === 'related-products') {
              const card = this.quickCard;
              setTimeout(() => this.quickCard === card && this.closeQuick(true), 1200);
            } else {
              this.closeQuick(false);
            }
          },
          { signal }
        );

        if (this.querySelector('[data-rp-list]')) {
          this.init();
          return;
        }
        if (!this.dataset.url) return;
        if (!('IntersectionObserver' in window)) {
          this.load();
          return;
        }
        this.loadIo = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.loadIo.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        this.loadIo.observe(this);
      }

      async load() {
        this.loadCtrl = new AbortController();
        try {
          const res = await fetch(this.dataset.url, { signal: this.loadCtrl.signal });
          if (!res.ok) throw new Error(String(res.status));
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const next = doc.querySelector('related-products');
          if (!next || !next.innerHTML.trim() || !this.ctrl) return;
          this.innerHTML = next.innerHTML;
          this.init();
        } catch (err) {
          /* No row is better than a broken one. */
        }
      }

      /* ---------- the row ---------- */

      init() {
        this.list = this.querySelector('[data-rp-list]');
        if (!this.list) return;
        this.nav = this.querySelector('[data-rp-nav]');
        this.progress = this.querySelector('[data-rp-progress]');
        this.thumb = this.querySelector('[data-rp-thumb]');
        const signal = this.ctrl.signal;

        this.list.addEventListener(
          'scroll',
          () => {
            if (this.raf) return;
            this.raf = requestAnimationFrame(() => {
              this.raf = 0;
              this.update(false);
            });
          },
          { passive: true, signal }
        );
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.update(true));
          this.ro.observe(this.list);
        }
        this.update(true);
        this.reveal();
      }

      reveal() {
        // Scroll-in off in Theme settings (or no motion at all): the cards are simply there.
        if (reduceMotion.matches || root.dataset.reveal === 'none' || !('IntersectionObserver' in window)) return;
        this.classList.add('is-ready');
        this.showIo = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.showIo.disconnect();
            this.classList.add('is-in');
            // Once every card has settled, drop the transitions so nothing lingers.
            this.settleTimer = setTimeout(() => this.classList.add('is-settled'), Math.round(1400 * speed()));
          },
          { threshold: 0.15 }
        );
        this.showIo.observe(this.list);
      }

      isRtl() {
        return getComputedStyle(this.list).direction === 'rtl';
      }

      update(full) {
        const list = this.list;
        if (!list) return;
        const max = list.scrollWidth - list.clientWidth;
        const over = max > 2;
        const pos = Math.min(max, Math.abs(list.scrollLeft));
        if (full) {
          this.classList.toggle('rp--over', over);
          if (this.nav) this.nav.hidden = !over;
          if (this.progress) this.progress.hidden = !over;
          if (this.thumb && over)
            this.thumb.style.width = ((list.clientWidth / list.scrollWidth) * 100).toFixed(2) + '%';
        }
        if (this.nav) {
          const [prev, next] = this.nav.querySelectorAll('[data-rp-step]');
          const focused = document.activeElement;
          prev.disabled = !over || pos <= 2;
          next.disabled = !over || pos >= max - 2;
          // Never strand keyboard focus on an arrow that just switched off.
          if (focused === prev && prev.disabled && !next.disabled) next.focus({ preventScroll: true });
          if (focused === next && next.disabled && !prev.disabled) prev.focus({ preventScroll: true });
        }
        if (this.thumb && over && this.progress) {
          const track = this.progress.clientWidth;
          const room = track - this.thumb.offsetWidth;
          const x = max > 0 ? (room * pos) / max : 0;
          this.thumb.style.transform = 'translate3d(' + (this.isRtl() ? -x : x).toFixed(1) + 'px,0,0)';
        }
      }

      step(dir) {
        const list = this.list;
        const item = list && list.querySelector('[data-rp-item]');
        if (!item) return;
        const cs = getComputedStyle(list);
        const gap = parseFloat(cs.columnGap) || 0;
        const visible = list.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        const one = item.getBoundingClientRect().width + gap;
        const n = Math.max(1, Math.floor((visible + gap + 1) / one));
        list.scrollBy({
          left: dir * n * one * (this.isRtl() ? -1 : 1),
          behavior: reduceMotion.matches ? 'auto' : 'smooth',
        });
      }

      /* ---------- events ---------- */

      onClick(e) {
        const t = e.target;
        const stepBtn = t.closest('[data-rp-step]');
        if (stepBtn) return this.step(Number(stepBtn.dataset.rpStep));
        const open = t.closest('[data-rp-open]');
        if (open) {
          if (!plainClick(e)) return;
          e.preventDefault();
          return this.toggleQuick(open);
        }
        if (t.closest('[data-rp-close-quick]')) return this.closeQuick(true);
        const sw = t.closest('[data-rp-sw]');
        if (sw) return this.pickSwatch(sw);
      }

      onSubmit(e) {
        const form = e.target;
        if (form.hasAttribute('data-rp-add')) this.addToCart(e, form);
      }

      onKeydown(e) {
        if (e.key === 'Escape' && this.quickCard) {
          e.preventDefault();
          this.closeQuick(true);
        }
      }

      onPointerOver(e) {
        if (e.pointerType !== 'mouse') return;
        const sw = e.target.closest('[data-rp-sw]');
        if (sw) {
          if (sw.dataset.src) this.showImage(sw.closest('[data-rp-card]'), sw.dataset.src, sw.dataset.srcset);
          return;
        }
        const card = e.target.closest('[data-rp-card]');
        if (card && !(e.relatedTarget && card.contains(e.relatedTarget))) this.swing(card);
      }

      onPointerOut(e) {
        if (e.pointerType !== 'mouse') return;
        const list = e.target.closest('.rp-swatches');
        if (!list || (e.relatedTarget && list.contains(e.relatedTarget))) return;
        this.restoreImage(list.closest('[data-rp-card]'));
      }

      swing(card) {
        if (calm() || !this.classList.contains('rp--card-tag')) return;
        const tag = card.querySelector('.rp-tag');
        if (tag && !tag.classList.contains('is-swing')) tag.classList.add('is-swing');
      }

      /* ---------- color dots ---------- */

      pickSwatch(sw) {
        const card = sw.closest('[data-rp-card]');
        card
          .querySelectorAll('[data-rp-sw]')
          .forEach((el) => el.setAttribute('aria-pressed', el === sw ? 'true' : 'false'));
        const link = card.querySelector('.rp-card__link');
        if (link && sw.dataset.url) link.href = sw.dataset.url;
        if (sw.dataset.src) {
          card.dataset.pickSrc = sw.dataset.src;
          card.dataset.pickSet = sw.dataset.srcset || '';
          card.classList.add('is-picked');
          this.showImage(card, sw.dataset.src, sw.dataset.srcset);
        }
      }

      restoreImage(card) {
        const img = card && card.querySelector('.rp-card__img:not(.rp-card__img--2)');
        if (!img || !img.dataset.origSrc) return;
        if (card.dataset.pickSrc) this.showImage(card, card.dataset.pickSrc, card.dataset.pickSet);
        else this.showImage(card, img.dataset.origSrc, img.dataset.origSet);
      }

      showImage(card, src, srcset) {
        const img = card && card.querySelector('.rp-card__img:not(.rp-card__img--2)');
        if (!img || img.tagName !== 'IMG') return;
        if (!img.dataset.origSrc) {
          img.dataset.origSrc = img.getAttribute('src');
          img.dataset.origSet = img.getAttribute('srcset') || '';
          img.dataset.showing = img.dataset.origSrc;
        }
        if (img.dataset.showing === src) return;
        img.dataset.showing = src;
        const apply = () => {
          if (img.dataset.showing !== src) return;
          if (srcset) img.srcset = srcset;
          else img.removeAttribute('srcset');
          img.src = src;
          img.classList.remove('is-swap');
        };
        const pre = new Image();
        pre.sizes = img.sizes;
        if (srcset) pre.srcset = srcset;
        pre.src = src;
        if (pre.complete) {
          apply();
        } else {
          img.classList.add('is-swap');
          pre.onload = pre.onerror = apply;
        }
      }

      /* ---------- quick add ---------- */

      toggleQuick(btn) {
        const card = btn.closest('[data-rp-card]');
        if (!card) return;
        if (this.quickCard === card) {
          this.closeQuick(true);
          return;
        }
        this.closeQuick(false);
        let panel = card.querySelector('[data-rp-quick]');
        if (!panel) {
          const tpl = card.querySelector('[data-rp-tpl]');
          if (!tpl) return;
          card.append(tpl.content.cloneNode(true));
          panel = card.querySelector('[data-rp-quick]');
          this.qid = (this.qid || 0) + 1;
          panel.id = 'RPQuick-' + this.sectionId + '-' + this.qid;
          btn.setAttribute('aria-controls', panel.id);
        }
        panel.hidden = false;
        void panel.offsetWidth; // start the slide from its resting place
        this.quickCard = card;
        this.quickBtn = btn;
        btn.setAttribute('aria-expanded', 'true');
        card.classList.add('is-quick');
        const first =
          panel.querySelector('input:checked:not(:disabled)') ||
          panel.querySelector('input[type="radio"]:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      }

      closeQuick(returnFocus) {
        const card = this.quickCard;
        if (!card) return;
        const btn = this.quickBtn;
        const panel = card.querySelector('[data-rp-quick]');
        this.quickCard = null;
        this.quickBtn = null;
        card.classList.remove('is-quick');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        const hide = () => {
          if (panel && !card.classList.contains('is-quick')) panel.hidden = true;
        };
        if (reduceMotion.matches) hide();
        else setTimeout(hide, Math.round(400 * speed()));
        if (returnFocus && btn && btn.isConnected) btn.focus({ preventScroll: true });
      }

      async addToCart(e, form) {
        // The bag drawer adds the item itself and opens.
        if (document.querySelector('cart-drawer[data-open-on-add]')) return;
        e.preventDefault();
        const btn = form.querySelector('[data-rp-add-btn]');
        if (btn && btn.getAttribute('aria-busy') === 'true') return;
        const msg = form.querySelector('[data-rp-msg]');
        if (msg) msg.textContent = '';
        if (btn) btn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || 'This item could not be added.');
          this.say('Added to your bag.');
          if (btn) {
            btn.classList.add('is-added');
            setTimeout(() => btn.classList.remove('is-added'), 1800);
          }
          const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .catch(() => null);
          if (cart)
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'related-products' } }));
        } catch (err) {
          const text = (err && err.message) || 'Something went wrong. Please try again.';
          if (msg) msg.textContent = text;
          else this.say(text);
        } finally {
          if (btn) btn.removeAttribute('aria-busy');
        }
      }

      say(text) {
        const live = this.querySelector('[data-rp-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }
    }

    customElements.define('related-products', RelatedProducts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('rich-text')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class RichText extends HTMLElement {
      connectedCallback() {
        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.io.disconnect();
            this.classList.add('is-in');
            this.timer = setTimeout(() => this.classList.add('is-settled'), 1800);
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this.io.observe(this);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        clearTimeout(this.timer);
      }
    }

    customElements.define('rich-text', RichText);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('care-routine')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const canHover = window.matchMedia('(hover: hover)');

    class CareRoutine extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.cards = Array.from(this.querySelectorAll('[data-rn-step]'));
        this.checks = Array.from(this.querySelectorAll('[data-rn-check]'));
        this.dial = this.querySelector('[data-rn-dial]');
        this.reset = this.querySelector('[data-rn-reset]');
        this.live = this.querySelector('[data-rn-live]');
        this.hover = null;
        this.pinned = null;
        if (!this.cards.length) return;

        this.cards.forEach((card, i) => {
          card.addEventListener('pointerenter', () => canHover.matches && this.look(i), { signal });
          card.addEventListener('pointerleave', () => canHover.matches && this.look(null), { signal });
          card.addEventListener('focusin', () => this.look(i), { signal });
          card.addEventListener(
            'focusout',
            (e) => {
              if (!card.contains(e.relatedTarget)) this.look(null);
            },
            { signal }
          );
          // Phones: tapping a step (not its tick box) shows it on the dial
          card.addEventListener(
            'click',
            (e) => {
              if (canHover.matches || e.target.closest('[data-rn-check], label, a')) return;
              this.pinned = this.pinned === i ? null : i;
              this.paint();
            },
            { signal }
          );
        });
        this.checks.forEach((box, i) => box.addEventListener('change', () => this.ticked(i, box.checked), { signal }));
        if (this.reset) this.reset.addEventListener('click', () => this.startOver(), { signal });

        document.addEventListener(
          'shopify:block:select',
          (e) => {
            const card = e.target instanceof Element ? e.target.closest('[data-rn-step]') : null;
            if (!card || !this.contains(card)) return;
            this.querySelectorAll('[data-rn-rise]').forEach((el) => el.classList.add('is-in', 'is-settled'));
            this.pinned = this.cards.indexOf(card);
            this.paint();
          },
          { signal }
        );
        document.addEventListener(
          'shopify:block:deselect',
          () => {
            this.pinned = null;
            this.paint();
          },
          { signal }
        );

        this.paint();

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => {
              this.io.unobserve(el);
              const delay = Math.min(n, 6) * 80;
              el.style.setProperty('--d', delay + 'ms');
              el.classList.add('is-in');
              const hold = el === this.dial ? 1500 + this.cards.length * 90 : 1300;
              this.later(() => el.classList.add('is-settled'), hold + delay);
            });
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        this.querySelectorAll('[data-rn-rise]').forEach((el) => this.io.observe(el));
      }

      done() {
        return this.checks.map((c) => c.checked);
      }

      look(i) {
        this.hover = i;
        this.paint();
      }

      paint() {
        const done = this.done();
        const count = done.filter(Boolean).length;
        const all = this.checks.length > 0 && count === this.checks.length;
        const firstOpen = done.indexOf(false);
        const shown = this.hover !== null ? this.hover : this.pinned;
        // The pointer: the step being looked at, otherwise the next one to do
        const point = shown !== null ? shown : firstOpen >= 0 ? firstOpen : 0;
        if (this.dial) this.dial.style.setProperty('--sel', String(point));

        this.cards.forEach((card, i) => {
          card.classList.toggle('is-sel', i === shown);
          card.classList.toggle('is-done', !!done[i]);
        });
        this.querySelectorAll('[data-rn-sel]').forEach((el) =>
          el.classList.toggle('is-on', Number(el.dataset.rnSel) === shown && !done[shown])
        );
        this.querySelectorAll('[data-rn-fill]').forEach((el) =>
          el.classList.toggle('is-on', !!done[Number(el.dataset.rnFill)])
        );

        const face = shown !== null ? String(shown) : all ? 'done' : 'rest';
        this.querySelectorAll('[data-rn-face]').forEach((el) =>
          el.classList.toggle('is-on', el.dataset.rnFace === face)
        );
        const counter = this.querySelector('[data-rn-count]');
        if (counter && this.checks.length)
          counter.textContent = count ? `${count} of ${this.checks.length} done` : `${this.checks.length} steps`;
        if (this.reset) this.reset.hidden = count === 0;
      }

      ticked(i, on) {
        // Ticking a step off sends the pointer on to the next one
        if (on) {
          this.hover = null;
          this.pinned = null;
        }
        this.paint();
        const done = this.done();
        const count = done.filter(Boolean).length;
        let text = `Step ${i + 1} ${on ? 'done' : 'not done'}. ${count} of ${this.checks.length} done.`;
        if (count === this.checks.length) text += ' ' + (this.dataset.doneLabel || 'All done') + '.';
        this.say(text);
      }

      startOver() {
        this.checks.forEach((c) => (c.checked = false));
        this.pinned = null;
        this.paint();
        this.say(`All ${this.checks.length} steps cleared.`);
        if (this.checks[0]) this.checks[0].focus();
      }

      say(text) {
        if (!this.live) return;
        this.live.textContent = '';
        requestAnimationFrame(() => (this.live.textContent = text));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('care-routine', CareRoutine);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-sentence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('shop-sentence')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

    /* Round a price to a friendly number: 47 → 45, 128 → 120, 3.4 → 3.5 */
    const nice = (v) => {
      if (!(v > 0)) return 0;
      const m = Math.pow(10, Math.floor(Math.log10(v)));
      const r = v / m;
      const step = r < 2 ? m / 5 : r < 5 ? m / 2 : m;
      return Math.max(step, Math.round(v / step) * step);
    };

    class ShopSentence extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.timers = [];
        this.token = 0;
        this.spinning = false;
        this.cards = Array.from(this.querySelectorAll('[data-sen-card]'));
        this.selects = Array.from(this.querySelectorAll('[data-sen-select]'));
        this.countEl = this.querySelector('[data-sen-count]');
        this.moreBtn = this.querySelector('[data-sen-more]');
        this.diceBtn = this.querySelector('[data-sen-surprise]');
        this.hint = this.querySelector('[data-sen-hint]');
        this.max = Math.max(1, parseInt(this.dataset.max, 10) || 8);
        this.limit = this.max;

        this.cards.forEach((c) => c.classList.remove('is-extra'));
        this.buildBudget();
        this.classList.add('is-js');

        this.selects.forEach((sel) => {
          const slot = sel.closest('[data-sen-slot]');
          sel.addEventListener('change', () => this.onPick(sel), { signal });
          sel.addEventListener('focus', () => slot.classList.toggle('is-focus', sel.matches(':focus-visible')), {
            signal,
          });
          sel.addEventListener('blur', () => slot.classList.remove('is-focus'), { signal });
        });
        const form = this.querySelector('[data-sen-form]');
        if (form) form.addEventListener('submit', (e) => e.preventDefault(), { signal });
        if (this.diceBtn) this.diceBtn.addEventListener('click', () => this.shuffle(), { signal });
        if (this.moreBtn) {
          this.moreBtn.addEventListener(
            'click',
            () => {
              this.limit += this.max;
              this.apply(true, true);
            },
            { signal }
          );
        }
        document.addEventListener('shopify:block:select', (e) => this.onBlock(e), { signal });

        this.apply(false, false);
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        this.stopSpin();
      }

      /* ---------- budget: built from the real prices, in the shopper's currency ---------- */

      money(v) {
        const frac = v % 1 ? 2 : 0;
        try {
          return new Intl.NumberFormat(this.dataset.locale || undefined, {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
            minimumFractionDigits: frac,
            maximumFractionDigits: frac,
          }).format(v);
        } catch (err) {
          return String(v);
        }
      }

      buildBudget() {
        const sel = this.querySelector('[data-sen-select="3"]');
        if (!sel) return;
        const wrap = this.querySelector('[data-sen-budget]');
        const prices = this.cards
          .map((c) => parseInt(c.dataset.price, 10))
          .filter((p) => p > 0)
          .sort((a, b) => a - b);
        const at = (f) => prices[Math.round((prices.length - 1) * f)] / 100;
        const ranges = [];
        if (new Set(prices).size >= 3) {
          let a = nice(at(1 / 3));
          const b = nice(at(2 / 3));
          if (b > a) {
            ranges.push(
              ['u', a, 0, `under ${this.money(a)}`],
              ['m', a, b, `${this.money(a)} to ${this.money(b)}`],
              ['o', b, 0, `over ${this.money(b)}`]
            );
          } else {
            a = nice(at(0.5));
            ranges.push(['u', a, 0, `under ${this.money(a)}`], ['o', a, 0, `over ${this.money(a)}`]);
          }
        }
        // Keep only choices that actually have something in them.
        const usable = ranges.filter(([k, a, b]) => prices.some((p) => this.inRange(p, `${k}:${a}:${b}`)));
        if (usable.length < 2) {
          if (wrap) wrap.hidden = true;
          sel.disabled = true;
          return;
        }
        usable.forEach(([k, a, b, label]) => {
          const o = document.createElement('option');
          o.value = `${k}:${a}:${b}`;
          o.textContent = label;
          sel.appendChild(o);
        });
      }

      inRange(cents, value) {
        const [k, a, b] = value.split(':');
        const p = cents / 100;
        if (k === 'u') return p < parseFloat(a);
        if (k === 'o') return p > parseFloat(a);
        return p >= parseFloat(a) && p <= parseFloat(b);
      }

      /* ---------- matching ---------- */

      active() {
        return this.selects.filter((s) => !s.disabled);
      }

      fits(card, sel) {
        const o = sel.options[sel.selectedIndex];
        if (!o || o.value === 'any') return true;
        if (sel.dataset.senSelect === '3') return this.inRange(parseInt(card.dataset.price, 10) || 0, o.value);
        if (o.dataset.ids !== undefined) return o.dataset.ids.indexOf(`,${card.dataset.id},`) !== -1;
        if (o.dataset.tag) return (card.dataset.tags || '').indexOf(` ${o.dataset.tag} `) !== -1;
        return true;
      }

      score(sels) {
        return this.cards.map((c) => {
          const hits = sels.map((s) => this.fits(c, s));
          return { c, hits, score: hits.filter(Boolean).length };
        });
      }

      apply(animate, keepLimit) {
        if (!this.cards.length) return;
        const sels = this.active();
        const scored = this.score(sels);
        let list = scored.filter((x) => x.score === sels.length);
        const exact = list.length > 0;
        if (!exact) {
          const best = Math.max(0, ...scored.map((x) => x.score));
          list = scored.filter((x) => x.score === best);
        }
        if (!keepLimit) this.limit = this.max;
        const show = list.slice(0, this.limit);
        const showing = new Set(show.map((x) => x.c));

        const motion = animate && !reduceMotion.matches;
        const before = new Map();
        if (motion)
          this.cards.forEach((c) => {
            if (!c.hidden) before.set(c, c.getBoundingClientRect());
          });

        this.cards.forEach((c) => {
          c.hidden = !showing.has(c);
        });
        show.forEach((x) => this.explain(x, exact, sels));

        if (motion) {
          let n = 0;
          show.forEach((x) => {
            const c = x.c;
            const was = before.get(c);
            if (was) {
              const now = c.getBoundingClientRect();
              const dx = was.left - now.left;
              const dy = was.top - now.top;
              if (Math.abs(dx) > 1 || Math.abs(dy) > 1) {
                c.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], {
                  duration: 520,
                  easing: EASE,
                });
              }
            } else {
              c.animate(
                [
                  { opacity: 0, transform: 'translate3d(0, 18px, 0)' },
                  { opacity: 1, transform: 'none' },
                ],
                { duration: 520, delay: Math.min(n, 8) * 45, easing: EASE, fill: 'backwards' }
              );
              n += 1;
            }
          });
        }

        if (this.countEl) {
          const n = list.length;
          this.countEl.textContent = exact
            ? `${n} ${n === 1 ? 'find' : 'finds'} for that sentence`
            : `Nothing fits every word yet. ${n === 1 ? 'Here is the closest match.' : `Here are the ${n} closest.`}`;
        }
        if (this.moreBtn) {
          const rest = list.length - show.length;
          this.moreBtn.hidden = rest <= 0;
          this.moreBtn.textContent = `Show ${Math.min(rest, this.max)} more`;
        }
      }

      /* Near matches say which words they keep and which they miss */
      explain(x, exact, sels) {
        const box = x.c.querySelector('[data-sen-why]');
        if (!box) return;
        box.textContent = '';
        if (exact) {
          box.hidden = true;
          return;
        }
        sels.forEach((s, i) => {
          const o = s.options[s.selectedIndex];
          if (!o || o.value === 'any') return;
          const w = document.createElement('span');
          w.className = `sen-why ${x.hits[i] ? 'is-hit' : 'is-miss'}`;
          if (!x.hits[i]) {
            const vh = document.createElement('span');
            vh.className = 'sen-vh';
            vh.textContent = 'Not ';
            w.appendChild(vh);
          }
          w.appendChild(document.createTextNode(o.textContent));
          box.appendChild(w);
        });
        box.hidden = !box.childNodes.length;
      }

      /* ---------- words ---------- */

      wordOf(sel) {
        return sel.closest('[data-sen-slot]').querySelector('[data-sen-word]');
      }

      swap(sel, text, mode) {
        const word = this.wordOf(sel);
        if (!word) return;
        if (mode === 'land' && word.textContent === text) return;
        word.textContent = text;
        if (reduceMotion.matches || !word.animate) return;
        if (mode === 'roll') {
          word.animate(
            [
              { transform: 'translate3d(0, -75%, 0)', opacity: 0 },
              { transform: 'none', opacity: 1 },
            ],
            { duration: 110, easing: 'linear' }
          );
        } else {
          word.animate(
            [
              { transform: 'translate3d(0, 65%, 0)', opacity: 0 },
              { transform: 'none', opacity: 1 },
            ],
            { duration: 560, easing: 'cubic-bezier(0.34, 1.45, 0.64, 1)' }
          );
        }
      }

      onPick(sel) {
        this.stopSpin();
        this.hideHint();
        this.swap(sel, sel.options[sel.selectedIndex].textContent, 'land');
        this.apply(true, false);
      }

      onBlock(e) {
        const id = e.detail && e.detail.blockId;
        const sel = this.selects.find((s) => Array.from(s.options).some((o) => o.value === id));
        if (!sel) return;
        this.stopSpin();
        sel.value = id;
        this.swap(sel, sel.options[sel.selectedIndex].textContent, 'land');
        this.apply(true, false);
      }

      hideHint() {
        if (this.hint) this.hint.classList.add('is-gone');
      }

      /* ---------- surprise: the blanks spin like reels and land on a sentence with results ---------- */

      shuffle() {
        if (this.spinning) return;
        const sels = this.active();
        if (!sels.length) return;
        const choices = sels.map((s) => {
          const real = Array.from(s.options).filter((o) => o.value !== 'any');
          return real.length ? real : Array.from(s.options);
        });
        const current = sels.map((s) => s.value).join('|');
        let pick = null;
        for (let t = 0; t < 40 && !pick; t += 1) {
          const combo = choices.map((list) => list[Math.floor(Math.random() * list.length)]);
          if (combo.map((o) => o.value).join('|') === current && t < 39) continue;
          const was = sels.map((s) => s.value);
          sels.forEach((s, i) => {
            s.value = combo[i].value;
          });
          const ok = this.score(sels).some((x) => x.score === sels.length);
          sels.forEach((s, i) => {
            s.value = was[i];
          });
          if (ok || t === 39) pick = combo;
        }
        if (!pick) return;

        this.hideHint();
        const token = ++this.token;
        const icon = this.diceBtn && this.diceBtn.querySelector('.sen-dice__icon');

        if (reduceMotion.matches) {
          sels.forEach((s, i) => {
            s.value = pick[i].value;
            this.swap(s, pick[i].textContent, 'land');
          });
          this.apply(false, false);
          return;
        }

        this.spinning = true;
        if (this.diceBtn) this.diceBtn.setAttribute('aria-disabled', 'true');
        if (icon && icon.animate)
          icon.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], {
            duration: 900,
            easing: EASE,
          });

        Promise.all(sels.map((s, i) => this.spin(s, pick[i], 7 + i * 4, token))).then(() => {
          if (token !== this.token) return;
          this.spinning = false;
          if (this.diceBtn) this.diceBtn.removeAttribute('aria-disabled');
          this.apply(true, false);
        });
      }

      spin(sel, target, steps, token) {
        return new Promise((resolve) => {
          const opts = Array.from(sel.options);
          let k = 0;
          let idx = sel.selectedIndex;
          const tick = () => {
            if (token !== this.token) {
              resolve();
              return;
            }
            k += 1;
            if (k >= steps) {
              sel.value = target.value;
              this.swap(sel, target.textContent, 'land');
              resolve();
              return;
            }
            idx = (idx + 1) % opts.length;
            this.swap(sel, opts[idx].textContent, 'roll');
            this.timers.push(setTimeout(tick, 60 + Math.pow(k / steps, 2) * 170));
          };
          tick();
        });
      }

      stopSpin() {
        this.token += 1;
        (this.timers || []).forEach((t) => clearTimeout(t));
        this.timers = [];
        if (!this.spinning) return;
        this.spinning = false;
        if (this.diceBtn) this.diceBtn.removeAttribute('aria-disabled');
        // Put every blank's word back in line with its real value.
        this.selects.forEach((s) => {
          const w = this.wordOf(s);
          if (w && s.selectedIndex > -1) w.textContent = s.options[s.selectedIndex].textContent;
        });
      }
    }

    customElements.define('shop-sentence', ShopSentence);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('shop-the-look')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const canHover = window.matchMedia('(hover: hover)');

    class ShopTheLook extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.pins = Array.from(this.querySelectorAll('[data-lk-pin]'));
        this.bubbles = Array.from(this.querySelectorAll('[data-lk-bubble]'));
        this.items = Array.from(this.querySelectorAll('[data-lk-item]'));
        this.dots = Array.from(this.querySelectorAll('[data-lk-pager] i'));
        this.list = this.querySelector('[data-lk-list]');
        this.active = null;
        this.hover = null;

        this.pins.forEach((pin) => {
          pin.addEventListener('click', (e) => this.pick(pin.dataset.lkPin, { scroll: true, focus: e.detail === 0 }), {
            signal,
          });
          pin.addEventListener('pointerenter', () => canHover.matches && this.preview(pin.dataset.lkPin), { signal });
          pin.addEventListener('pointerleave', () => canHover.matches && this.preview(null), { signal });
        });
        this.items.forEach((item) => {
          item.addEventListener('pointerenter', () => canHover.matches && this.preview(item.dataset.lkItem), {
            signal,
          });
          item.addEventListener('pointerleave', () => canHover.matches && this.preview(null), { signal });
          item.addEventListener('focusin', () => this.preview(item.dataset.lkItem), { signal });
          item.addEventListener(
            'focusout',
            (e) => {
              if (!item.contains(e.relatedTarget)) this.preview(null);
            },
            { signal }
          );
        });
        this.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'Escape' && this.active) {
              const pin = this.pins.find((p) => p.dataset.lkPin === this.active);
              this.pick(null);
              if (pin && this.contains(document.activeElement)) pin.focus();
            }
          },
          { signal }
        );

        // Phones: the swipe row and the pins follow each other
        if (this.list && 'IntersectionObserver' in window) {
          this.rowIO = new IntersectionObserver(
            (entries) => {
              if (!this.isRow() || this.steering) return;
              const seen = entries.filter((en) => en.isIntersecting && en.intersectionRatio >= 0.6);
              if (!seen.length) return;
              this.pick(seen[0].target.dataset.lkItem, { quiet: true });
            },
            { root: this.list, threshold: [0.6] }
          );
          this.items.forEach((item) => this.rowIO.observe(item));
        }

        // Adding to the cart: the cart drawer does it itself when it's set to open on add
        this.addEventListener(
          'submit',
          (e) => {
            const form = e.target.closest('[data-lk-add]');
            if (!form || document.querySelector('cart-drawer[data-open-on-add]')) return;
            e.preventDefault();
            this.addOne(form);
          },
          { signal }
        );
        const all = this.querySelector('[data-lk-add-all]');
        if (all) all.addEventListener('click', () => this.addAll(all), { signal });

        document.addEventListener(
          'shopify:block:select',
          (e) => {
            const item = e.target instanceof Element ? e.target.closest('[data-lk-item]') : null;
            if (!item || !this.contains(item)) return;
            this.reveal();
            this.pick(item.dataset.lkItem, { scroll: true });
          },
          { signal }
        );
        document.addEventListener('shopify:block:deselect', () => this.pick(null), { signal });

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        const rise = Array.from(this.querySelectorAll('[data-lk-rise]'));
        if (!rise.length) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => this.arrive(el, Math.min(n, 6) * 80));
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        rise.forEach((el) => this.io.observe(el));
      }

      arrive(el, delay) {
        if (this.io) this.io.unobserve(el);
        if (el.classList.contains('is-in')) return;
        el.style.setProperty('--d', delay + 'ms');
        el.classList.add('is-in');
        const hold = el.classList.contains('lk-media') ? 1100 + this.pins.length * 110 : 1300;
        this.later(() => el.classList.add('is-settled'), hold + delay);
      }

      reveal() {
        this.querySelectorAll('[data-lk-rise]').forEach((el) => el.classList.add('is-in', 'is-settled'));
      }

      isRow() {
        return (
          !!this.list &&
          getComputedStyle(this.list).overflowX !== 'visible' &&
          this.list.scrollWidth > this.list.clientWidth + 1
        );
      }

      pick(id, opts = {}) {
        this.active = id;
        this.paint();
        if (!id) return;
        const item = this.items.find((x) => x.dataset.lkItem === id);
        if (!item) return;
        if (opts.scroll && this.isRow()) {
          // Steer the row without letting it pick something else on the way
          this.steering = true;
          this.list.scrollTo({
            left: item.offsetLeft - this.items[0].offsetLeft,
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
          });
          clearTimeout(this.steerTimer);
          this.steerTimer = setTimeout(() => (this.steering = false), 700);
        }
        if (opts.focus) {
          const target = item.querySelector('a, button:not([disabled])');
          if (target) target.focus({ preventScroll: this.isRow() });
        }
      }

      preview(id) {
        this.hover = id;
        this.paint();
      }

      paint() {
        const on = this.hover || this.active;
        this.pins.forEach((p) => {
          p.classList.toggle('is-on', p.dataset.lkPin === on);
          p.classList.toggle('is-dim', !!on && p.dataset.lkPin !== on);
        });
        this.bubbles.forEach((b) => b.classList.toggle('is-on', b.dataset.lkBubble === on));
        this.items.forEach((item, i) => {
          const lit = item.dataset.lkItem === on;
          item.classList.toggle('is-on', lit);
          if (this.dots[i]) this.dots[i].classList.toggle('is-on', lit || (!on && i === 0));
        });
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      say(text) {
        const live = this.querySelector('[data-lk-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }

      fail(text) {
        const msg = this.querySelector('[data-lk-msg]');
        if (!msg) return;
        msg.textContent = text;
        msg.hidden = !text;
      }

      async post(items) {
        const res = await fetch(this.dataset.addUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || data.status)
          throw new Error(data.description || data.message || 'This could not be added to your cart.');
      }

      async afterAdd() {
        if (document.querySelector('cart-drawer')) {
          // Let the drawer fetch the new cart and show it
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .catch(() => null);
        if (cart)
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'shop-the-look' } }));
      }

      async addOne(form) {
        const btn = form.querySelector('[data-lk-add-btn]');
        if (!btn || btn.getAttribute('aria-busy') === 'true') return;
        this.fail('');
        btn.setAttribute('aria-busy', 'true');
        try {
          const fd = new FormData(form);
          await this.post([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }]);
          btn.classList.add('is-added');
          this.later(() => btn.classList.remove('is-added'), 1800);
          this.say('Added to your cart.');
          await this.afterAdd();
        } catch (err) {
          this.fail((err && err.message) || 'Something went wrong. Please try again.');
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      async addAll(btn) {
        if (btn.getAttribute('aria-busy') === 'true') return;
        const items = this.items
          .filter((x) => x.dataset.lkVariant)
          .map((x) => ({ id: Number(x.dataset.lkVariant), quantity: Number(x.dataset.lkQty) || 1 }));
        if (!items.length) return;
        this.fail('');
        btn.setAttribute('aria-busy', 'true');
        try {
          await this.post(items);
          this.say(items.length + ' products added to your cart.');
          await this.afterAdd();
        } catch (err) {
          this.fail((err && err.message) || 'Something went wrong. Please try again.');
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.rowIO) this.rowIO.disconnect();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        clearTimeout(this.steerTimer);
      }
    }

    customElements.define('shop-the-look', ShopTheLook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('social-rail')) return;
    // Phones, held either way: the rail starts tucked so it never covers the page
    const phone = window.matchMedia('(max-width: 749px), (max-height: 500px)');

    class SocialRail extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-sl-rail]');
        if (!this.rail) return;
        this.handle = this.querySelector('[data-sl-handle]');
        this.fold = this.querySelector('[data-sl-fold]');
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.sectionId = this.dataset.sectionId;
        this.key = 'turblyn:social:' + this.sectionId;
        this.canFold = this.classList.contains('sl--fold');
        this.phoneTuck = this.classList.contains('sl--phone-tuck');
        this.peeking = false;
        if (this.handle) this.handle.hidden = false;

        this.settle();
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
        this.later(() => this.classList.add('is-settled'), 2200);

        if (this.fold) this.fold.addEventListener('click', () => this.tuck(true, true), { signal });
        if (this.handle) this.handle.addEventListener('click', () => this.tuck(false, true), { signal });
        phone.addEventListener('change', () => this.settle(), { signal });

        // Opened on a phone: a tap anywhere else tucks it away again
        document.addEventListener(
          'pointerdown',
          (e) => {
            if (this.peeking && !this.contains(e.target)) this.tuck(true, false);
          },
          { signal }
        );
        this.addEventListener(
          'keydown',
          (e) => {
            if (e.key !== 'Escape' || !this.peeking) return;
            e.preventDefault();
            this.tuck(true, true);
          },
          { signal }
        );

        if (window.Shopify && window.Shopify.designMode) {
          const mine = (e) => e.detail && e.detail.sectionId === this.sectionId;
          document.addEventListener('shopify:section:select', (e) => mine(e) && this.apply(false), { signal });
          document.addEventListener('shopify:section:deselect', (e) => mine(e) && this.settle(), { signal });
          document.addEventListener(
            'shopify:block:select',
            (e) => {
              const item = e.target instanceof Element ? e.target.closest('[data-sl-item]') : null;
              if (!item || !this.contains(item)) return;
              this.apply(false);
              this.querySelectorAll('[data-sl-item]').forEach((el) => el.classList.toggle('is-lit', el === item));
            },
            { signal }
          );
          document.addEventListener(
            'shopify:block:deselect',
            () => {
              this.querySelectorAll('[data-sl-item].is-lit').forEach((el) => el.classList.remove('is-lit'));
            },
            { signal }
          );
        }
      }

      /* Can it be tucked away on this screen? */
      folds() {
        return !!this.handle && (phone.matches ? this.phoneTuck : this.canFold);
      }

      /* Where it should be: phones start tucked, computers as the customer left it */
      settle() {
        if (!this.folds()) return this.apply(false);
        if (phone.matches) return this.apply(true);
        let tucked = false;
        try {
          tucked = window.sessionStorage.getItem(this.key) === '1';
        } catch (e) {
          tucked = false;
        }
        this.apply(tucked);
      }

      tuck(on, moveFocus) {
        if (!this.folds()) return;
        // From here on the customer is moving it: plain slides, no arrival timing
        this.classList.add('is-settled');
        this.apply(on);
        if (!phone.matches) {
          try {
            if (on) window.sessionStorage.setItem(this.key, '1');
            else window.sessionStorage.removeItem(this.key);
          } catch (e) {
            /* not remembered; it still works on this page */
          }
        }
        if (!moveFocus) return;
        if (on) this.handle.focus({ preventScroll: true });
        else {
          const first = this.querySelector('.sl-link[href]');
          if (first) first.focus({ preventScroll: true });
        }
      }

      apply(on) {
        const tucked = on && this.folds();
        this.peeking = !tucked && phone.matches && this.folds();
        this.classList.toggle('is-tucked', tucked);
        this.classList.toggle('is-peek', this.peeking);
        this.rail.inert = tucked;
        if (this.handle) {
          this.handle.inert = !tucked;
          this.handle.setAttribute('aria-expanded', String(!tucked));
        }
        if (this.fold) this.fold.setAttribute('aria-expanded', String(!tucked));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('social-rail', SocialRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-rings"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('story-rings')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class StoryRings extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-st-dialog]');
        this.rings = Array.from(this.querySelectorAll('[data-st-ring]'));
        this.stories = Array.from(this.querySelectorAll('[data-st-story]'));
        if (!this.dialog || !this.stories.length) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.frameEl = this.querySelector('[data-st-frame]');
        this.barsSlot = this.querySelector('[data-st-bars-slot]');
        this.isOpen = false;
        this.si = 0;
        this.k = 0;
        this.muted = true;
        this.paused = { user: false, hold: false, hidden: false };
        this.key = 'turblyn:stories:' + this.dataset.sectionId;
        this.design = !!(window.Shopify && window.Shopify.designMode);
        this.dur = Math.max(2, Number(this.dataset.duration) || 5) * 1000;
        this.paintSeen();

        this.rings.forEach((ring, i) => ring.addEventListener('click', () => this.open(i, ring), { signal }));
        this.dialog.addEventListener('click', (e) => this.onClick(e), { signal });
        this.dialog.addEventListener('keydown', (e) => this.onKey(e), { signal });
        this.dialog.addEventListener(
          'cancel',
          (e) => {
            e.preventDefault();
            this.close();
          },
          { signal }
        );
        this.dialog.addEventListener(
          'close',
          () => {
            if (this.dialog.open || !this.isOpen) return;
            this.cleanup();
          },
          { signal }
        );
        this.dialog.addEventListener(
          'submit',
          (e) => {
            const form = e.target.closest('[data-st-add]');
            if (!form) return;
            // Adding something pauses the story so the shopper can look
            this.paused.user = true;
            this.paintPause();
            this.sync();
            if (document.querySelector('cart-drawer[data-open-on-add]')) return;
            e.preventDefault();
            this.add(form);
          },
          { signal }
        );

        // Hold to pause; swipe sideways for another story, down to close
        this.frameEl.addEventListener('pointerdown', (e) => this.down(e), { signal });
        this.frameEl.addEventListener('pointerup', (e) => this.up(e), { signal });
        this.frameEl.addEventListener('pointercancel', () => this.release(), { signal });
        this.frameEl.addEventListener(
          'contextmenu',
          (e) => {
            if (e.target.closest('.st-tap')) e.preventDefault();
          },
          { signal }
        );
        document.addEventListener(
          'visibilitychange',
          () => {
            this.paused.hidden = document.visibilityState !== 'visible';
            this.sync();
          },
          { signal }
        );

        if (this.design) {
          document.addEventListener(
            'shopify:block:select',
            (e) => {
              const li = e.target instanceof Element ? e.target.closest('.st-rings__item') : null;
              if (!li || !this.contains(li)) return;
              const ring = li.querySelector('[data-st-ring]');
              if (ring) this.open(Number(ring.dataset.stRing), null);
            },
            { signal }
          );
          document.addEventListener('shopify:block:deselect', () => this.close(), { signal });
          document.addEventListener(
            'shopify:section:deselect',
            (e) => {
              if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.close();
            },
            { signal }
          );
        }

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.classList.add('is-in');
            this.io.disconnect();
          },
          { rootMargin: '0px 0px -5% 0px' }
        );
        this.io.observe(this.querySelector('.st-rings'));
      }

      /* ---------- Watched ---------- */

      seenList() {
        if (!this.hasAttribute('data-remember')) return [];
        try {
          const v = JSON.parse(window.localStorage.getItem(this.key) || '[]');
          return Array.isArray(v) ? v : [];
        } catch (e) {
          return [];
        }
      }

      markSeen(i) {
        const ring = this.rings[i];
        if (!ring) return;
        ring.classList.add('is-seen');
        const text = ring.querySelector('[data-st-seen-text]');
        if (text) text.textContent = ', seen';
        if (!this.hasAttribute('data-remember') || this.design) return;
        const list = this.seenList();
        if (list.includes(ring.dataset.stId)) return;
        list.push(ring.dataset.stId);
        try {
          window.localStorage.setItem(this.key, JSON.stringify(list.slice(-60)));
        } catch (e) {
          /* not remembered */
        }
      }

      paintSeen() {
        const list = this.seenList();
        this.rings.forEach((ring) => {
          const seen = list.includes(ring.dataset.stId);
          ring.classList.toggle('is-seen', seen);
          const text = ring.querySelector('[data-st-seen-text]');
          if (text) text.textContent = seen ? ', seen' : '';
        });
      }

      /* ---------- Open / close ---------- */

      open(i, opener) {
        if (!this.stories[i]) return;
        this.opener = opener;
        if (!this.isOpen) {
          this.isOpen = true;
          const sbw = window.innerWidth - document.documentElement.clientWidth;
          document.documentElement.style.setProperty('--st-sbw', `${Math.max(sbw, 0)}px`);
          document.documentElement.classList.add('st-locked');
          if (!this.dialog.open) {
            if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
            else this.dialog.setAttribute('open', '');
          }
          requestAnimationFrame(() => requestAnimationFrame(() => this.isOpen && this.classList.add('is-open')));
          this.paused.user = false;
          this.paused.hold = false;
          this.paintPause();
        }
        this.go(i, 0, 0);
        if (!this.design) this.frameEl.focus({ preventScroll: true });
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.stop();
        this.classList.remove('is-open');
        const done = () => {
          if (this.isOpen) return;
          if (typeof this.dialog.close === 'function') this.dialog.close();
          else this.dialog.removeAttribute('open');
          this.cleanup();
          if (this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
        };
        if (reduceMotion.matches) done();
        else this.later(done, 320);
      }

      cleanup() {
        this.isOpen = false;
        this.stop();
        this.classList.remove('is-open');
        document.documentElement.classList.remove('st-locked');
        document.documentElement.style.removeProperty('--st-sbw');
        this.stories.forEach((st) => (st.hidden = true));
      }

      /* ---------- Moving through ---------- */

      slidesOf(si) {
        return Array.from(this.stories[si].querySelectorAll('[data-st-slide]'));
      }

      go(si, k, dir) {
        this.stop();
        if (si < 0) si = 0;
        if (si >= this.stories.length) {
          this.close();
          return;
        }
        const changed = si !== this.si || !this.started;
        this.started = true;
        this.si = si;
        const slides = this.slidesOf(si);
        this.k = Math.max(0, Math.min(k, slides.length - 1));
        const story = this.stories[si];
        this.stories.forEach((st, i) => {
          st.hidden = i !== si;
          if (i !== si) st.classList.remove('is-from-r', 'is-from-l');
        });
        if (changed) {
          // The bars of this story move up into the top strip
          this.barsSlot.textContent = '';
          const bars = story.querySelector('[data-st-bars]');
          if (bars) this.barsSlot.appendChild(bars.cloneNode(true));
          if (this.barsSlot.firstElementChild) this.barsSlot.firstElementChild.style.display = 'flex';
          const title = this.querySelector('[data-st-title]');
          if (title) title.textContent = story.dataset.stTitle;
          const thumb = this.querySelector('[data-st-thumb]');
          const tpl = story.querySelector('[data-st-thumb-src]');
          if (thumb) {
            thumb.textContent = '';
            if (tpl) thumb.appendChild(tpl.content.cloneNode(true));
          }
          if (dir && !reduceMotion.matches) {
            story.classList.remove('is-from-r', 'is-from-l');
            void story.offsetWidth;
            story.classList.add(dir > 0 ? 'is-from-r' : 'is-from-l');
          }
          this.markSeen(si);
          this.say(`${story.dataset.stTitle}, ${slides.length} ${slides.length === 1 ? 'slide' : 'slides'}`);
        }
        slides.forEach((sl, i) => {
          const on = i === this.k;
          sl.classList.toggle('is-on', on);
          sl.inert = !on;
          const v = sl.querySelector('video');
          if (v && !on) v.pause();
        });
        Array.from(this.barsSlot.querySelectorAll('.st-bar')).forEach((bar, i) => {
          bar.classList.toggle('is-done', i < this.k);
          const fill = bar.querySelector('i');
          if (fill) fill.style.transform = i < this.k ? 'none' : 'scaleX(0)';
        });
        const prev = this.querySelector('[data-st-prev-story]');
        const next = this.querySelector('[data-st-next-story]');
        if (prev) prev.disabled = si === 0;
        if (next) next.disabled = si === this.stories.length - 1;

        // Fetch the next picture ahead of time
        const ahead = slides[this.k + 1] || (this.stories[si + 1] && this.slidesOf(si + 1)[0]);
        if (ahead) ahead.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
        slides[this.k].querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));

        this.slide = slides[this.k];
        this.video = this.slide.querySelector('video');
        const mute = this.querySelector('[data-st-mute]');
        if (mute) mute.hidden = !this.video;
        if (this.video) {
          const v = this.video;
          v.muted = this.muted;
          v.playsInline = true;
          v.preload = 'auto';
          try {
            v.currentTime = 0;
          } catch (e) {
            /* not loaded yet */
          }
          v.onended = () => this.isOpen && this.video === v && this.next();
          // A video that can't load (its sources fail) plays for the picture time instead
          v.addEventListener('error', () => this.video === v && this.dropVideo(), { capture: true, once: true });
        }
        this.elapsed = 0;
        this.since = null;
        this.sync();
      }

      dropVideo() {
        if (!this.video) return;
        this.video.onended = null;
        this.video = null;
        const mute = this.querySelector('[data-st-mute]');
        if (mute) mute.hidden = true;
        this.elapsed = 0;
        this.since = this.isPaused() ? null : performance.now();
        this.sync();
      }

      next() {
        const n = this.slidesOf(this.si).length;
        if (this.k + 1 < n) this.go(this.si, this.k + 1, 0);
        else this.go(this.si + 1, 0, 1);
      }

      back() {
        if (this.k > 0) this.go(this.si, this.k - 1, 0);
        else if (this.si > 0) this.go(this.si - 1, 0, -1);
        else this.go(this.si, 0, 0);
      }

      /* ---------- The clock ---------- */

      isPaused() {
        return this.paused.user || this.paused.hold || this.paused.hidden;
      }

      sync() {
        if (!this.isOpen || !this.slide) return;
        const now = performance.now();
        if (this.isPaused()) {
          if (this.since !== null) this.elapsed += now - this.since;
          this.since = null;
          if (this.video) this.video.pause();
          cancelAnimationFrame(this.raf);
          return;
        }
        if (this.since === null) this.since = now;
        if (this.video) {
          const p = this.video.play();
          if (p && p.catch) p.catch(() => {});
        }
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.step());
      }

      step() {
        if (!this.isOpen || this.isPaused()) return;
        let progress;
        const played = this.elapsed + (performance.now() - this.since);
        if (this.video && this.video.currentTime > 0 && this.video.duration && isFinite(this.video.duration)) {
          progress = this.video.currentTime / this.video.duration;
        } else if (this.video) {
          // Still not moving after a few seconds of play: give up on it
          if (played > 6000) {
            this.dropVideo();
            return;
          }
          progress = 0;
        } else {
          progress = played / this.dur;
        }
        const bar = this.barsSlot.querySelectorAll('.st-bar i')[this.k];
        if (bar) bar.style.transform = `scaleX(${Math.min(Math.max(progress, 0), 1)})`;
        if (!this.video && progress >= 1) {
          this.next();
          return;
        }
        this.raf = requestAnimationFrame(() => this.step());
      }

      stop() {
        cancelAnimationFrame(this.raf);
        if (this.video) {
          this.video.pause();
          this.video.onended = null;
        }
      }

      paintPause() {
        const btn = this.querySelector('[data-st-pause]');
        if (!btn) return;
        btn.classList.toggle('is-on', this.paused.user);
        btn.setAttribute('aria-pressed', String(this.paused.user));
        const label = btn.querySelector('.st-sr');
        if (label) label.textContent = this.paused.user ? 'Play' : 'Pause';
      }

      /* ---------- Hands ---------- */

      onClick(e) {
        if (this.swallow) {
          this.swallow = false;
          if (e.target.closest('.st-tap')) return;
        }
        const t = e.target;
        if (t.closest('[data-st-close]')) return this.close();
        if (t.closest('[data-st-prev-story]')) return this.go(this.si - 1, 0, -1);
        if (t.closest('[data-st-next-story]')) return this.go(this.si + 1, 0, 1);
        const tap = t.closest('[data-st-tap]');
        if (tap) return Number(tap.dataset.stTap) > 0 ? this.next() : this.back();
        if (t.closest('[data-st-pause]')) {
          this.paused.user = !this.paused.user;
          this.paintPause();
          this.sync();
          this.say(this.paused.user ? 'Paused' : 'Playing');
          return;
        }
        if (t.closest('[data-st-mute]')) {
          this.muted = !this.muted;
          if (this.video) this.video.muted = this.muted;
          const btn = t.closest('[data-st-mute]');
          btn.classList.toggle('is-on', !this.muted);
          const label = btn.querySelector('[data-st-mute-label]');
          if (label) label.textContent = this.muted ? 'Turn sound on' : 'Turn sound off';
        }
      }

      onKey(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
        } else if (e.key === 'ArrowRight' && !e.target.closest('input, select, textarea')) {
          e.preventDefault();
          this.next();
        } else if (e.key === 'ArrowLeft' && !e.target.closest('input, select, textarea')) {
          e.preventDefault();
          this.back();
        }
      }

      down(e) {
        if (!e.isPrimary) return;
        this.swallow = false;
        this.pt = { x: e.clientX, y: e.clientY, tap: !!e.target.closest('.st-tap') };
        clearTimeout(this.holdTimer);
        if (!this.pt.tap) return;
        this.holdTimer = setTimeout(() => {
          this.paused.hold = true;
          this.held = true;
          this.sync();
        }, 220);
      }

      up(e) {
        clearTimeout(this.holdTimer);
        const pt = this.pt;
        this.pt = null;
        if (this.held) {
          this.held = false;
          this.swallow = true;
          this.release();
          return;
        }
        if (!pt) return;
        const dx = e.clientX - pt.x;
        const dy = e.clientY - pt.y;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
          this.swallow = true;
          this.go(this.si + (dx < 0 ? 1 : -1), 0, dx < 0 ? 1 : -1);
        } else if (dy > 90 && dy > Math.abs(dx)) {
          this.swallow = true;
          this.close();
        }
      }

      release() {
        clearTimeout(this.holdTimer);
        if (!this.paused.hold) return;
        this.paused.hold = false;
        this.sync();
      }

      /* ---------- Add to cart ---------- */

      async add(form) {
        const btn = form.querySelector('[data-st-add-btn]');
        if (!btn || btn.getAttribute('aria-busy') === 'true') return;
        const msg = this.querySelector('[data-st-msg]');
        if (msg) msg.hidden = true;
        btn.setAttribute('aria-busy', 'true');
        try {
          const fd = new FormData(form);
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }] }),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status)
            throw new Error(data.description || data.message || 'This could not be added to your cart.');
          const label = btn.querySelector('[data-st-add-label]');
          if (label) label.textContent = 'Added';
          this.later(() => label && (label.textContent = 'Add'), 2000);
          this.say('Added to your cart.');
          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else {
            const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
              .then((r) => r.json())
              .catch(() => null);
            if (cart)
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'story-rings' } }));
          }
        } catch (err) {
          if (msg) {
            msg.textContent = (err && err.message) || 'Something went wrong. Please try again.';
            msg.hidden = false;
          }
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      say(text) {
        const live = this.querySelector('[data-st-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        clearTimeout(this.holdTimer);
        if (this.isOpen) this.cleanup();
      }
    }

    customElements.define('story-rings', StoryRings);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["style-spotlight-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('style-spotlight')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class StyleSpotlight extends HTMLElement {
      connectedCallback() {
        this.prints = Array.from(this.querySelectorAll('[data-ss-print]'));
        this.panels = Array.from(this.querySelectorAll('[data-ss-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[data-ss-tab]'));
        this.deck = this.querySelector('[data-ss-deck]');
        this.live = this.querySelector('[data-ss-live]');
        this.count = this.panels.length;
        this.index = 0;
        this.holds = new Set();
        if (!this.count) return;

        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.editor = !!(window.Shopify && window.Shopify.designMode);
        this.autoplay = this.hasAttribute('data-autoplay') && !reduceMotion.matches;

        this.applyState(0, 0, true);

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        this.addEventListener('keydown', (e) => this.onKey(e), { signal });
        this.addEventListener(
          'animationend',
          (e) => {
            if (e.target.hasAttribute('data-ss-fill') && e.animationName === 'ss-fill')
              this.go(this.index + 1, 1, true);
          },
          { signal }
        );
        this.addEventListener(
          'transitionend',
          (e) => {
            if (e.target.classList && e.target.classList.contains('is-out') && e.propertyName === 'transform') {
              e.target.classList.add('is-instant');
              e.target.classList.remove('is-out');
              requestAnimationFrame(() => e.target.classList.remove('is-instant'));
            }
          },
          { signal }
        );

        // Hotspots light up their product row, and back again.
        this.addEventListener('pointerover', (e) => this.linkSpot(e, true), { signal });
        this.addEventListener('pointerout', (e) => this.linkSpot(e, false), { signal });
        this.addEventListener(
          'focusin',
          (e) => {
            this.linkSpot(e, true);
            let keyboard = true;
            try {
              keyboard = e.target.matches(':focus-visible');
            } catch (err) {
              /* old browsers: treat as keyboard */
            }
            if (keyboard) this.hold('focus', true);
          },
          { signal }
        );
        this.addEventListener(
          'focusout',
          (e) => {
            this.linkSpot(e, false);
            if (!this.contains(e.relatedTarget)) this.hold('focus', false);
          },
          { signal }
        );

        if (window.matchMedia('(hover: hover)').matches) {
          this.addEventListener('pointerenter', () => this.hold('hover', true), { signal });
          this.addEventListener('pointerleave', () => this.hold('hover', false), { signal });
        }

        this.initSwipe(signal);

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            ([entry]) => {
              this.classList.toggle('is-inview', entry.isIntersecting);
              this.hold('offscreen', !entry.isIntersecting);
            },
            { threshold: 0.2 }
          );
          this.io.observe(this);
        } else {
          this.classList.add('is-inview');
        }
        document.addEventListener('visibilitychange', () => this.hold('hidden', document.hidden), { signal });

        if (this.autoplay) this.classList.add('is-running');
        else {
          const pause = this.querySelector('[data-ss-pause]');
          if (pause) pause.hidden = true;
        }

        if (this.editor) {
          document.addEventListener(
            'shopify:block:select',
            (e) => {
              const i = this.panels.indexOf(e.target);
              if (i < 0) return;
              this.hold('editor', true);
              this.go(i, i >= this.index ? 1 : -1, false, true);
            },
            { signal }
          );
          document.addEventListener(
            'shopify:block:deselect',
            (e) => {
              if (this.panels.includes(e.target)) this.hold('editor', false);
            },
            { signal }
          );
        }
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.io) this.io.disconnect();
      }

      /* ---------- Pausing ---------- */
      hold(reason, on) {
        if (on) this.holds.add(reason);
        else this.holds.delete(reason);
        this.classList.toggle('is-paused', this.holds.size > 0);
      }

      /* ---------- Slide changes ---------- */
      go(target, dir, fromTimer, silent) {
        const n = this.count;
        const next = ((target % n) + n) % n;
        if (next === this.index) return;
        const prev = this.index;
        this.index = next;
        this.applyState(prev, dir || 1, false);
        if (!silent && !fromTimer && this.live) {
          this.live.textContent = '';
          const label = this.tabs[next] ? this.tabs[next].textContent.trim() : '';
          setTimeout(() => (this.live.textContent = `${label} — ${next + 1} of ${n}`), 60);
        }
      }

      applyState(prev, dir, initial) {
        const n = this.count;
        const cur = this.index;

        this.prints.forEach((p, i) => {
          const pos = (i - cur + n) % n;
          if (!initial && i === prev && prev !== cur && dir > 0 && !reduceMotion.matches) {
            // Toss the old top print aside, then it slips to the back of the deck.
            p.classList.add('is-out');
            p.dataset.pos = String(pos > 2 ? 9 : pos);
            return;
          }
          if (!initial && i === cur && dir < 0 && !reduceMotion.matches) {
            // Going back: the print returns from where it was tossed.
            p.classList.add('is-instant', 'is-out');
            void p.offsetWidth;
            p.classList.remove('is-instant', 'is-out');
          }
          p.dataset.pos = String(pos > 2 ? 9 : pos);
          p.inert = pos !== 0;
        });
        if (this.prints[prev] && prev !== cur) this.prints[prev].inert = true;

        this.panels.forEach((panel, i) => {
          const on = i === cur;
          panel.classList.toggle('is-active', on);
          panel.inert = !on;
        });

        this.tabs.forEach((tab, i) => {
          const on = i === cur;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
        });
      }

      /* ---------- Input ---------- */
      onClick(e) {
        const tab = e.target.closest('[data-ss-tab]');
        if (tab) {
          const i = this.tabs.indexOf(tab);
          this.go(i, i > this.index ? 1 : -1);
          return;
        }
        if (e.target.closest('[data-ss-next]')) {
          this.go(this.index + 1, 1);
          return;
        }
        if (e.target.closest('[data-ss-prev]')) {
          this.go(this.index - 1, -1);
          return;
        }
        const pause = e.target.closest('[data-ss-pause]');
        if (pause) {
          const paused = pause.getAttribute('aria-pressed') !== 'true';
          pause.setAttribute('aria-pressed', String(paused));
          this.hold('user', paused);
          return;
        }
        const spot = e.target.closest('[data-ss-spot]');
        if (spot) {
          const row = this.panels[this.index].querySelector(`[data-ss-row="${spot.dataset.ssSpot}"]`);
          this.querySelectorAll('.ss-spot.is-on').forEach((s) => s !== spot && s.classList.remove('is-on'));
          spot.classList.toggle('is-on');
          if (row) {
            this.panels[this.index].querySelectorAll('.is-hot').forEach((r) => r.classList.remove('is-hot'));
            row.classList.add('is-hot');
            const r = row.getBoundingClientRect();
            if (r.bottom > window.innerHeight || r.top < 0) {
              row.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
            }
          }
        }
      }

      onKey(e) {
        const tab = e.target.closest('[data-ss-tab]');
        if (!tab) return;
        let i = this.tabs.indexOf(tab);
        if (e.key === 'ArrowRight') i += 1;
        else if (e.key === 'ArrowLeft') i -= 1;
        else if (e.key === 'Home') i = 0;
        else if (e.key === 'End') i = this.count - 1;
        else return;
        e.preventDefault();
        i = (i + this.count) % this.count;
        this.go(i, i > this.index ? 1 : -1);
        this.tabs[i].focus();
      }

      linkSpot(e, on) {
        const spot = e.target.closest && e.target.closest('[data-ss-spot]');
        const row = e.target.closest && e.target.closest('[data-ss-row]');
        if (spot) {
          const r = this.panels[this.index].querySelector(`[data-ss-row="${spot.dataset.ssSpot}"]`);
          if (r) r.classList.toggle('is-hot', on);
        } else if (row) {
          const p = this.prints[this.index];
          const s = p && p.querySelector(`[data-ss-spot="${row.dataset.ssRow}"]`);
          if (s) s.classList.toggle('is-on', on);
        }
      }

      /* ---------- Swipe: the top print follows the finger ---------- */
      initSwipe(signal) {
        if (!this.deck || this.count < 2) return;
        let startX = 0;
        let startY = 0;
        let dx = 0;
        let active = false;
        let locked = false;
        let frame = 0;
        let top = null;

        const paint = () => {
          frame = 0;
          if (top) top.style.transform = `translate3d(${dx}px, 0, 0) rotate(${dx * 0.02}deg)`;
        };

        this.deck.addEventListener(
          'pointerdown',
          (e) => {
            if (e.button !== 0 || e.target.closest('[data-ss-spot]')) return;
            active = true;
            locked = false;
            startX = e.clientX;
            startY = e.clientY;
            dx = 0;
            top = this.prints[this.index];
          },
          { signal }
        );

        this.deck.addEventListener(
          'pointermove',
          (e) => {
            if (!active) return;
            const mx = e.clientX - startX;
            const my = e.clientY - startY;
            if (!locked) {
              if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
              if (Math.abs(my) > Math.abs(mx)) {
                active = false; // vertical scroll wins
                return;
              }
              locked = true;
              this.deck.classList.add('is-dragging');
              this.hold('drag', true);
              try {
                this.deck.setPointerCapture(e.pointerId);
              } catch (err) {
                /* ignore */
              }
            }
            dx = mx;
            if (!frame) frame = requestAnimationFrame(paint);
          },
          { signal }
        );

        const end = () => {
          if (!active) return;
          active = false;
          if (frame) cancelAnimationFrame(frame);
          frame = 0;
          this.deck.classList.remove('is-dragging');
          this.hold('drag', false);
          if (top) top.style.transform = '';
          if (locked) {
            const limit = Math.min(90, this.deck.offsetWidth * 0.18);
            if (dx < -limit) this.go(this.index + 1, 1);
            else if (dx > limit) this.go(this.index - 1, -1);
          }
          locked = false;
          top = null;
        };
        this.deck.addEventListener('pointerup', end, { signal });
        this.deck.addEventListener('pointercancel', end, { signal });
        // Only our own capture ending counts (touch pointers start captured by the child they hit).
        this.deck.addEventListener(
          'lostpointercapture',
          (e) => {
            if (e.target === this.deck) end();
          },
          { signal }
        );
      }
    }

    customElements.define('style-spotlight', StyleSpotlight);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swatch-book"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('swatch-book')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class SwatchBook extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.tabs = Array.from(this.querySelectorAll('[data-sw-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-sw-panel]'));
        this.row = this.querySelector('[data-sw-tabs]');
        this.current = this.tabs.length ? this.tabs[0].dataset.swTab : null;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab.dataset.swTab), { signal });
          tab.addEventListener('keydown', (e) => this.keys(e, tab), { signal });
        });

        document.addEventListener(
          'shopify:block:select',
          (e) => {
            const tab = e.target instanceof Element ? e.target.closest('[data-sw-tab]') : null;
            if (!tab || !this.contains(tab)) return;
            this.reveal();
            this.select(tab.dataset.swTab);
          },
          { signal }
        );

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
        const rise = Array.from(this.querySelectorAll('[data-sw-rise], [data-sw-deck]'));
        if (!rise.length) return;
        this.classList.add('is-ready');
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => this.arrive(el, Math.min(n, 4) * 90));
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        rise.forEach((el) => this.io.observe(el));
      }

      arrive(el, delay) {
        if (this.io) this.io.unobserve(el);
        el.style.setProperty('--d', delay + 'ms');
        el.classList.add('is-in');
        const hold = el.hasAttribute('data-sw-deck') ? 1500 + this.tabs.length * 45 : 1300;
        this.later(() => el.classList.add('is-settled'), hold + delay);
      }

      reveal() {
        this.querySelectorAll('[data-sw-rise], [data-sw-deck]').forEach((el) =>
          el.classList.add('is-in', 'is-settled')
        );
      }

      keys(e, tab) {
        const i = this.tabs.indexOf(tab);
        let next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = this.tabs[(i + 1) % this.tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp')
          next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
        else if (e.key === 'Home') next = this.tabs[0];
        else if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (!next) return;
        e.preventDefault();
        this.select(next.dataset.swTab);
        next.focus();
      }

      select(id) {
        if (!id || id === this.current) return;
        const prevPanel = this.panels.find((p) => p.dataset.swPanel === this.current);
        const nextPanel = this.panels.find((p) => p.dataset.swPanel === id);
        this.current = id;

        const deck = this.querySelector('[data-sw-deck]');
        if (deck)
          deck.style.setProperty(
            '--a',
            String(
              Math.max(
                0,
                this.tabs.findIndex((t) => t.dataset.swTab === id)
              )
            )
          );
        this.tabs.forEach((t) => {
          const on = t.dataset.swTab === id;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on) this.keepInRow(t);
        });
        if (!nextPanel) return;

        // Show the new swatch once its picture is ready, then fade the old one out
        this.panels.forEach((p) => {
          if (p !== nextPanel && p !== prevPanel) {
            p.classList.remove('is-on');
            p.hidden = true;
          }
        });
        nextPanel.hidden = false;
        const img = nextPanel.querySelector('img');
        const ready = img && img.decode ? img.decode().catch(() => {}) : Promise.resolve();
        const token = (this.token = (this.token || 0) + 1);
        ready.then(() => {
          if (token !== this.token) return;
          void nextPanel.offsetWidth;
          nextPanel.classList.add('is-on');
          if (prevPanel && prevPanel !== nextPanel) {
            prevPanel.classList.remove('is-on');
            this.later(
              () => {
                if (!prevPanel.classList.contains('is-on')) prevPanel.hidden = true;
              },
              reduceMotion.matches ? 0 : 450
            );
          }
        });
      }

      // On phones the chips are a row; bring the chosen one into view without moving the page
      keepInRow(tab) {
        const row = this.row;
        if (!row || row.scrollWidth <= row.clientWidth + 1) return;
        const left = tab.offsetLeft - row.clientWidth / 2 + tab.offsetWidth / 2;
        row.scrollTo({ left, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
      }
    }

    customElements.define('swatch-book', SwatchBook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('testimonial-notes')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class TestimonialNotes extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        this.timers = new Set();
        const signal = this.ac.signal;
        this.notes = Array.from(this.querySelectorAll('[data-tm-note]'));
        this.deck = this.querySelector('[data-tm-deck]');
        if (this.deck && this.notes.length > 1) this.setupDeck(signal);

        document.addEventListener(
          'shopify:block:select',
          (e) => {
            const note = e.target instanceof Element ? e.target.closest('[data-tm-note]') : null;
            if (!note || !this.contains(note)) return;
            note.classList.add('is-in', 'is-settled');
            this.classList.add('is-in', 'is-settled');
            if (this.order) this.bringUp(this.notes.indexOf(note));
          },
          { signal }
        );

        if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

        if (document.documentElement.getAttribute('data-reveal') === 'none') return;
        this.classList.add('is-ready');
        const rise = Array.from(this.querySelectorAll('[data-tm-rise]'));
        if (this.classList.contains('tm--wall')) rise.push(...this.notes);
        this.io = new IntersectionObserver(
          (entries) => {
            const coming = entries.filter((en) => en.isIntersecting).map((en) => en.target);
            coming.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
            coming.forEach((el, n) => {
              this.io.unobserve(el);
              const delay = Math.min(n, 6) * 90;
              if (el === this.deck) {
                this.classList.add('is-in');
                this.later(() => this.classList.add('is-settled'), 1400);
                return;
              }
              el.style.setProperty('--d', delay + 'ms');
              el.classList.add('is-in');
              this.later(() => el.classList.add('is-settled'), 1400 + delay);
            });
          },
          { rootMargin: '0px 0px -8% 0px' }
        );
        rise.forEach((el) => this.io.observe(el));
        if (this.order) this.io.observe(this.deck);
        else this.classList.add('is-in', 'is-settled');
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      setupDeck(signal) {
        this.order = this.notes.map((n, i) => i);
        this.now = this.querySelector('[data-tm-now]');
        const prev = this.querySelector('[data-tm-prev]');
        const next = this.querySelector('[data-tm-next]');
        if (prev) prev.addEventListener('click', () => this.go(-1), { signal });
        if (next) next.addEventListener('click', () => this.go(1), { signal });

        // Throw the top note aside
        this.deck.addEventListener('pointerdown', (e) => this.down(e), { signal });
        this.deck.addEventListener('pointermove', (e) => this.move(e), { signal });
        this.deck.addEventListener('pointerup', (e) => this.up(e), { signal });
        this.deck.addEventListener('pointercancel', (e) => this.up(e, true), { signal });
        this.deck.addEventListener(
          'selectstart',
          (e) => {
            if (this.drag && this.drag.on) e.preventDefault();
          },
          { signal }
        );
        // A drag that ends over a link must not follow it
        this.deck.addEventListener(
          'click',
          (e) => {
            if (!this.dragged) return;
            e.preventDefault();
            e.stopPropagation();
            this.dragged = false;
          },
          { capture: true, signal }
        );
        this.layout();
      }

      layout() {
        this.order.forEach((idx, p) => {
          const note = this.notes[idx];
          note.dataset.p = String(Math.min(p, 3));
          const top = p === 0;
          note.toggleAttribute('inert', !top);
          note.setAttribute('aria-hidden', top ? 'false' : 'true');
        });
        if (this.now) this.now.textContent = String(this.order[0] + 1).padStart(2, '0');
      }

      go(dir, side) {
        if (this.busy) return;
        const quick = reduceMotion.matches;
        this.busy = true;
        if (dir > 0) {
          const top = this.notes[this.order[0]];
          top.classList.remove('is-drag');
          top.classList.add(side === 'left' ? 'is-out-l' : 'is-out-r');
          this.order.push(this.order.shift());
          this.layout();
          this.later(
            () => {
              // Slip it under the pile, then let it fade in there
              top.classList.add('is-jump');
              top.classList.remove('is-out-l', 'is-out-r');
              top.style.removeProperty('--dx');
              top.style.removeProperty('--dr');
              void top.offsetWidth;
              top.classList.remove('is-jump');
              this.busy = false;
            },
            quick ? 0 : 520
          );
        } else {
          const idx = this.order.pop();
          this.order.unshift(idx);
          const card = this.notes[idx];
          card.classList.add('is-jump', 'is-out-l');
          void card.offsetWidth;
          card.classList.remove('is-jump');
          this.layout();
          void card.offsetWidth;
          card.classList.remove('is-out-l');
          this.later(() => (this.busy = false), quick ? 0 : 420);
        }
      }

      bringUp(idx) {
        if (idx < 0 || this.order[0] === idx) return;
        const at = this.order.indexOf(idx);
        this.order = this.order.slice(at).concat(this.order.slice(0, at));
        this.notes.forEach((n) => n.classList.add('is-jump'));
        this.layout();
        void this.deck.offsetWidth;
        this.notes.forEach((n) => n.classList.remove('is-jump', 'is-out-l', 'is-out-r'));
      }

      down(e) {
        if (this.busy || (e.pointerType === 'mouse' && e.button !== 0)) return;
        const top = this.notes[this.order[0]];
        if (!top.contains(e.target)) return;
        this.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, dx: 0, top, on: false };
      }

      move(e) {
        const d = this.drag;
        if (!d || e.pointerId !== d.id) return;
        const dx = e.clientX - d.x;
        const dy = e.clientY - d.y;
        if (!d.on) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            this.drag = null;
            return;
          }
          d.on = true;
          d.top.classList.add('is-drag');
          const sel = window.getSelection && window.getSelection();
          if (sel && sel.removeAllRanges) sel.removeAllRanges();
          try {
            this.deck.setPointerCapture(d.id);
          } catch (err) {}
        }
        d.dx = dx;
        d.top.style.setProperty('--dx', dx + 'px');
        d.top.style.setProperty('--dr', (dx / 28).toFixed(2) + 'deg');
      }

      up(e, cancel) {
        const d = this.drag;
        if (!d || e.pointerId !== d.id) return;
        this.drag = null;
        if (!d.on) return;
        this.dragged = true;
        this.later(() => (this.dragged = false), 60);
        d.top.classList.remove('is-drag');
        const far = Math.abs(d.dx) > Math.min(110, this.deck.offsetWidth * 0.25);
        if (far && !cancel) {
          this.go(1, d.dx < 0 ? 'left' : 'right');
        } else {
          d.top.style.removeProperty('--dx');
          d.top.style.removeProperty('--dr');
        }
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        this.busy = false;
        this.drag = null;
      }
    }

    customElements.define('testimonial-notes', TestimonialNotes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["turntable"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('turn-table')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const RAD = Math.PI / 180;
    const norm = (a) => ((a % 360) + 360) % 360;
    const apart = (a, b) => {
      const d = Math.abs(norm(a) - norm(b));
      return Math.min(d, 360 - d);
    };
    /* Signed shortest way from a to b, in degrees */
    const toward = (a, b) => ((norm(b) - norm(a) + 540) % 360) - 180;
    const WINDOW = 25;
    const REST = 2500;

    class TurnTable extends HTMLElement {
      connectedCallback() {
        this.view = this.querySelector('[data-td-view]');
        if (!this.view) return;
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.kind = this.dataset.kind;
        this.speed = Math.max(5, Number(this.dataset.speed) || 25);
        this.way = this.dataset.dir === 'left' ? -1 : 1;
        this.auto = this.dataset.auto === 'true' && !reduceMotion.matches;
        this.paused = !this.auto;
        this.angle = 0;
        this.shown = -1;
        this.restUntil = 0;
        this.visible = false;
        this.plate = this.querySelector('[data-td-plate]');
        this.mark = this.querySelector('[data-td-mark]');
        this.ticks = Array.from(this.querySelectorAll('[data-td-tick]'));
        this.needle = this.querySelector('[data-td-needle]');
        this.deg = this.querySelector('[data-td-deg]');
        this.notes = Array.from(this.querySelectorAll('[data-td-note]'));
        this.playBtn = this.querySelector('[data-td-play]');

        this.addEventListener(
          'click',
          (e) => {
            const t = e.target;
            if (!(t instanceof Element)) return;
            if (t.closest('[data-td-play]')) return this.setPaused(!this.paused, true);
            const note = t.closest('[data-td-note]');
            if (note) this.turnTo(Number(note.dataset.tdNote) || 0);
          },
          { signal }
        );
        this.addEventListener(
          'shopify:block:select',
          (e) => {
            const note = e.target instanceof Element && e.target.querySelector('[data-td-note]');
            if (note) this.turnTo(Number(note.dataset.tdNote) || 0);
          },
          { signal }
        );
        document.addEventListener('visibilitychange', () => this.kick(), { signal });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.measure());
          this.ro.observe(this.view);
          if (this.plate) this.ro.observe(this.plate);
        }
        this.measure();

        if (this.kind === 'model') this.setupModel();
        else this.setupSpin();

        if ('IntersectionObserver' in window) {
          // Pictures and the 3D viewer load only as the section comes near
          this.near = new IntersectionObserver(
            (entries) => {
              if (!entries.some((x) => x.isIntersecting)) return;
              this.near.disconnect();
              this.near = null;
              this.prepare();
            },
            { rootMargin: '400px 0px' }
          );
          this.near.observe(this);
          // Turning only while it can be seen
          this.seen = new IntersectionObserver(
            (entries) => {
              this.visible = entries[entries.length - 1].isIntersecting;
              this.kick();
            },
            { threshold: 0.15 }
          );
          this.seen.observe(this.view);
        } else {
          this.visible = true;
          this.prepare();
        }
        this.paintPlay();
        this.setAngle(0, true);
      }

      /* ---------- Where it faces ---------- */

      setAngle(a, force) {
        this.angle = norm(a);
        if (this.kind !== 'model') this.render();
        const whole = Math.round(this.angle) % 360;
        if (!force && whole === this.shown) return;
        this.shown = whole;
        this.paintMark();
        if (this.needle) this.needle.style.setProperty('--td-a', `${this.angle}deg`);
        if (this.deg) this.deg.textContent = `${whole}°`;
        if (this.view.getAttribute('role') === 'slider') {
          this.view.setAttribute('aria-valuenow', String(whole));
          this.view.setAttribute('aria-valuetext', `${whole} degrees`);
        }
        this.notes.forEach((n) => {
          const on = apart(Number(n.dataset.tdNote) || 0, this.angle) <= WINDOW;
          if (on) n.setAttribute('aria-current', 'true');
          else n.removeAttribute('aria-current');
        });
        this.ticks.forEach((t) =>
          t.classList.toggle('is-on', apart(Number(t.dataset.tdTick) || 0, this.angle) <= WINDOW)
        );
      }

      /* The rivet on the plate marks the product's front as it goes round */
      spot(a) {
        const r = norm(a) * RAD;
        return { x: Math.sin(r) * this.rx, y: Math.cos(r) * this.ry, front: Math.cos(r) >= 0 };
      }

      paintMark() {
        if (!this.mark || !this.rx) return;
        const p = this.spot(this.angle);
        this.mark.style.setProperty('--td-mx', `${p.x.toFixed(1)}px`);
        this.mark.style.setProperty('--td-my', `${p.y.toFixed(1)}px`);
        this.mark.style.setProperty('--td-ms', p.front ? '1' : '0.7');
        this.mark.style.setProperty('--td-mo', p.front ? '1' : '0.45');
      }

      measure() {
        if (this.plate) {
          this.rx = this.plate.clientWidth / 2;
          this.ry = this.plate.clientHeight / 2;
          this.ticks.forEach((t) => {
            const p = this.spot(Number(t.dataset.tdTick) || 0);
            t.style.transform = `translate3d(${p.x.toFixed(1)}px, ${p.y.toFixed(1)}px, 0)`;
          });
          this.paintMark();
        }
        if (this.canvas) this.fit();
      }

      /* ---------- Turning on its own ---------- */

      setPaused(on, byHand) {
        this.paused = on;
        if (!on) this.restUntil = 0;
        if (this.kind === 'model') this.applyAuto();
        this.paintPlay();
        if (byHand) this.say(on ? 'Stopped.' : 'Turning.');
        this.kick();
      }

      turning() {
        return (
          !this.paused &&
          !this.holding &&
          this.visible &&
          !document.hidden &&
          this.ready &&
          performance.now() >= this.restUntil
        );
      }

      paintPlay() {
        const on = !this.paused;
        this.classList.toggle('is-turning', on);
        if (this.playBtn) this.playBtn.setAttribute('aria-label', on ? 'Stop turning' : 'Turn on its own');
      }

      kick() {
        if (this.raf || !this.visible || document.hidden) return;
        this.last = 0;
        this.raf = requestAnimationFrame((t) => this.loop(t));
      }

      loop(now) {
        this.raf = 0;
        const dt = this.last ? Math.min(64, now - this.last) : 16;
        this.last = now;
        let more = false;
        if (this.kind === 'model') {
          more = this.readModel(now);
        } else {
          if (this.inertia) {
            this.setAngle(this.angle + this.inertia * dt);
            this.inertia *= Math.pow(0.92, dt / 16.7);
            if (Math.abs(this.inertia) < 0.003) this.inertia = 0;
            more = true;
          } else if (this.turning()) {
            this.setAngle(this.angle + (this.way * this.speed * dt) / 1000);
            more = true;
          } else if (!this.paused && this.ready) {
            more = true; // resting after a touch: wake up when the rest is over
          }
        }
        if (more && this.visible && !document.hidden) this.raf = requestAnimationFrame((t) => this.loop(t));
      }

      /* ---------- Turning by hand ---------- */

      bindHand(target) {
        const signal = this.ac.signal;
        target.addEventListener(
          'pointerdown',
          (e) => {
            if (e.button > 0) return;
            this.press = {
              x: e.clientX,
              y: e.clientY,
              t: performance.now(),
              a: this.angle,
              id: e.pointerId,
              moved: false,
              samples: [],
            };
            this.inertia = 0;
            this.holding = true;
            this.classList.add('is-touched');
          },
          { signal }
        );
        target.addEventListener(
          'pointermove',
          (e) => {
            const p = this.press;
            if (!p || e.pointerId !== p.id) return;
            const dx = e.clientX - p.x;
            const dy = e.clientY - p.y;
            if (!p.moved) {
              if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
              if (Math.abs(dy) > Math.abs(dx)) {
                // Going up or down: that is the page scrolling, not a turn
                this.press = null;
                this.holding = false;
                this.restUntil = performance.now() + 600;
                return this.kick();
              }
              p.moved = true;
              if (this.kind !== 'model') {
                try {
                  target.setPointerCapture(e.pointerId);
                } catch (err) {}
                this.view.classList.add('is-dragging');
              }
            }
            if (this.kind === 'model') return; // the 3D viewer turns itself
            const per = 360 / Math.max(260, this.view.clientWidth * 1.15);
            this.setAngle(p.a + dx * per * this.way);
            const now = performance.now();
            p.samples.push({ a: p.a + dx * per * this.way, t: now });
            if (p.samples.length > 4) p.samples.shift();
          },
          { signal }
        );
        const end = (e) => {
          const p = this.press;
          if (!p || (e && e.pointerId !== p.id)) return;
          this.press = null;
          this.holding = false;
          this.view.classList.remove('is-dragging');
          const now = performance.now();
          if (p.moved) {
            if (this.kind !== 'model' && p.samples.length > 1) {
              const s0 = p.samples[0];
              const s1 = p.samples[p.samples.length - 1];
              if (now - s1.t < 80 && s1.t > s0.t)
                this.inertia = Math.max(-1.2, Math.min(1.2, (s1.a - s0.a) / (s1.t - s0.t)));
            }
          } else if (e && e.type === 'pointerup' && now - p.t < 350) {
            // A tap stops it, another tap sets it going again
            this.setPaused(!this.paused, true);
          }
          this.restUntil = now + REST;
          this.kick();
        };
        target.addEventListener('pointerup', end, { signal });
        target.addEventListener('pointercancel', end, { signal });
        target.addEventListener('lostpointercapture', end, { signal });
      }

      turnTo(a) {
        this.classList.add('is-touched');
        this.setPaused(true);
        if (this.kind === 'model') return this.aimModel(a);
        this.inertia = 0;
        const from = this.angle;
        const by = toward(from, a);
        if (reduceMotion.matches || !by) return this.setAngle(a);
        // Glide there the short way round
        const start = performance.now();
        const span = Math.min(900, 300 + Math.abs(by) * 4);
        cancelAnimationFrame(this.glide);
        const step = (now) => {
          const k = Math.min(1, (now - start) / span);
          const ease = 1 - Math.pow(1 - k, 3);
          this.setAngle(from + by * ease);
          if (k < 1) this.glide = requestAnimationFrame(step);
        };
        this.glide = requestAnimationFrame(step);
      }

      /* ---------- Pictures all the way round ---------- */

      setupSpin() {
        const signal = this.ac.signal;
        this.canvas = this.querySelector('.td-canvas');
        this.loadDots = Array.from(this.querySelectorAll('[data-td-load] i'));
        this.bindHand(this.view);
        this.view.addEventListener(
          'keydown',
          (e) => {
            const steps = { ArrowRight: 15, ArrowUp: 15, ArrowLeft: -15, ArrowDown: -15, PageUp: 90, PageDown: -90 };
            let next = null;
            if (e.key in steps) next = this.angle + steps[e.key];
            else if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = 180;
            else if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              return this.setPaused(!this.paused, true);
            }
            if (next === null) return;
            e.preventDefault();
            this.classList.add('is-touched');
            this.setPaused(true);
            this.setAngle(next);
          },
          { signal }
        );
        if (this.kind === 'demo') {
          this.demo = this.querySelector('.td-demo');
          this.ready = true;
          this.classList.add('is-ready');
        }
      }

      prepare() {
        if (this.kind === 'model') return this.loadModel();
        if (this.kind !== 'spin' || this.frames) return this.kick();
        const data = this.querySelector('script[data-td-frames]');
        let list = [];
        try {
          list = JSON.parse(data ? data.textContent : '[]');
        } catch (e) {
          list = [];
        }
        if (list.length < 2) return;
        this.frames = list.map(() => null);
        const big = this.view.clientWidth * Math.min(2, window.devicePixelRatio || 1) > 900;
        let settled = 0;
        const after = () => {
          settled += 1;
          const lit = Math.round((settled / list.length) * this.loadDots.length);
          this.loadDots.forEach((d, k) => d.classList.toggle('is-on', k < lit));
          if (settled === list.length) this.loaded();
        };
        list.forEach((f, i) => {
          const img = new Image();
          img.decoding = 'async';
          img.src = big ? f.l : f.s;
          const ready = img.decode
            ? img.decode()
            : new Promise((res, rej) => {
                img.onload = res;
                img.onerror = rej;
              });
          ready.then(() => {
            if (!this.frames) return;
            this.frames[i] = img;
            if (i === 0 || this.index() === i) this.render(true);
            after();
          }, after);
        });
      }

      loaded() {
        if (!this.frames || !this.frames.some(Boolean)) return;
        this.ready = true;
        this.classList.add('is-ready');
        this.kick();
      }

      index() {
        const n = this.frames ? this.frames.length : 0;
        return n ? Math.round((this.angle / 360) * n) % n : 0;
      }

      fit() {
        const dpr = Math.min(2, window.devicePixelRatio || 1);
        const w = Math.round(this.view.clientWidth * dpr);
        const h = Math.round(this.view.clientHeight * dpr);
        if (!w || !h) return;
        if (this.canvas.width !== w || this.canvas.height !== h) {
          this.canvas.width = w;
          this.canvas.height = h;
        }
        this.drawn = -1;
        this.render(true);
      }

      render(force) {
        if (this.kind === 'demo') {
          if (this.demo) this.demo.style.setProperty('--td-turn', `${this.angle.toFixed(1)}deg`);
          return;
        }
        if (!this.frames || !this.canvas) return;
        const n = this.frames.length;
        let i = this.index();
        // Not every picture may be in yet: show the nearest one that is
        if (!this.frames[i]) {
          for (let d = 1; d < n; d += 1) {
            if (this.frames[(i + d) % n]) {
              i = (i + d) % n;
              break;
            }
            if (this.frames[(i - d + n) % n]) {
              i = (i - d + n) % n;
              break;
            }
          }
        }
        const img = this.frames[i];
        if (!img || (!force && i === this.drawn)) return;
        const ctx = this.canvas.getContext('2d');
        const cw = this.canvas.width;
        const ch = this.canvas.height;
        const scale = Math.min(cw / img.naturalWidth, ch / img.naturalHeight);
        const w = img.naturalWidth * scale;
        const h = img.naturalHeight * scale;
        ctx.clearRect(0, 0, cw, ch);
        ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
        this.drawn = i;
        this.classList.add('is-live');
      }

      /* ---------- A 3D model ---------- */

      setupModel() {
        const signal = this.ac.signal;
        this.mv = this.querySelector('model-viewer');
        if (!this.mv) return;
        this.bindHand(this.mv);
        this.mv.addEventListener(
          'camera-change',
          () => {
            this.activeUntil = performance.now() + 900;
            this.kick();
          },
          { signal }
        );
      }

      loadModel() {
        if (!this.mv || this.asked) return;
        this.asked = true;
        const give = this.later(() => !this.ready && this.still(), 10000);
        const go = () => {
          customElements.whenDefined('model-viewer').then(() => {
            if (!this.isConnected) return;
            clearTimeout(give);
            const mv = this.mv;
            mv.setAttribute('rotation-per-second', `${this.way * this.speed}deg`);
            mv.setAttribute('auto-rotate-delay', String(REST));
            mv.setAttribute('interaction-prompt', 'none');
            mv.setAttribute('touch-action', 'pan-y');
            mv.setAttribute('disable-zoom', '');
            this.applyAuto();
            const live = () => {
              this.ready = true;
              this.classList.add('is-live', 'is-ready');
              this.kick();
            };
            if (mv.loaded) live();
            else mv.addEventListener('load', live, { once: true, signal: this.ac.signal });
            mv.addEventListener('error', () => this.still(), { once: true, signal: this.ac.signal });
          });
        };
        if (customElements.get('model-viewer')) go();
        else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([
            { name: 'model-viewer-ui', version: '1.0', onLoad: (err) => (err ? this.still() : go()) },
          ]);
        } else {
          this.still();
        }
        this.loadXR();
      }

      /* The 3D viewer could not start: the picture stays, the controls go */
      still() {
        this.classList.add('is-still');
        const c = this.querySelector('.td-controls');
        if (c) c.hidden = true;
      }

      applyAuto() {
        if (!this.mv) return;
        if (!this.paused) this.mv.setAttribute('auto-rotate', '');
        else this.mv.removeAttribute('auto-rotate');
      }

      /* Which side faces the visitor: the camera's way round, less how far the model has turned */
      readModel(now) {
        const mv = this.mv;
        if (!mv || !this.ready || typeof mv.getCameraOrbit !== 'function') return false;
        const orbit = mv.getCameraOrbit();
        const turned = Number(mv.turntableRotation) || 0;
        this.setAngle((turned - orbit.theta) / RAD);
        return !this.paused || now < (this.activeUntil || 0);
      }

      aimModel(a) {
        const mv = this.mv;
        if (!mv || !this.ready || typeof mv.getCameraOrbit !== 'function') return;
        const orbit = mv.getCameraOrbit();
        const by = toward(this.angle, a) * RAD;
        mv.cameraOrbit = `${orbit.theta - by}rad ${orbit.phi}rad ${orbit.radius}m`;
        this.activeUntil = performance.now() + 1500;
        this.kick();
      }

      loadXR() {
        const json = this.querySelector('script[data-td-models]');
        if (!json || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
        window.Shopify.loadFeatures([
          {
            name: 'shopify-xr',
            version: '1.0',
            onLoad: (err) => {
              if (err) return;
              const setup = () => {
                if (!window.ShopifyXR) {
                  document.addEventListener('shopify_xr_initialized', setup, { once: true });
                  return;
                }
                try {
                  window.ShopifyXR.addModels(JSON.parse(json.textContent));
                  window.ShopifyXR.setupXRElements();
                } catch (e) {
                  /* no AR on this device */
                }
              };
              setup();
            },
          },
        ]);
      }

      say(text) {
        const live = this.querySelector('[data-td-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
        return id;
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        if (this.near) this.near.disconnect();
        if (this.seen) this.seen.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        cancelAnimationFrame(this.glide);
        this.raf = 0;
        this.frames = null;
      }
    }

    customElements.define('turn-table', TurnTable);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unbox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('unbox-set')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class UnboxSet extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.timers = [];
        this.scene = this.querySelector('[data-bx-scene]');
        this.front = this.querySelector('[data-bx-front]');
        this.form = this.querySelector('[data-bx-form]');
        this.addBtn = this.querySelector('[data-bx-add]');
        this.addLabel = this.querySelector('[data-bx-add-label]');
        this.totalEl = this.querySelector('[data-bx-total]');
        this.msg = this.querySelector('[data-bx-msg]');
        this.checks = Array.from(this.querySelectorAll('[data-bx-check]'));
        this.items = Array.from(this.querySelectorAll('[data-bx-item]'));
        this.classList.add('is-js');

        this.checks.forEach((c) => c.addEventListener('change', () => this.sync(c), { signal }));
        this.querySelectorAll('[data-bx-variant]').forEach((sel) =>
          sel.addEventListener('change', () => this.pickVariant(sel), { signal })
        );
        this.items.forEach((it) => it.addEventListener('click', () => this.tapItem(it), { signal }));
        if (this.front)
          this.front.addEventListener(
            'click',
            () => (this.classList.contains('is-open') ? this.close() : this.open(true)),
            { signal }
          );
        if (this.form) this.form.addEventListener('submit', (e) => this.submit(e), { signal });
        document.addEventListener('shopify:block:select', (e) => this.onBlock(e), { signal });

        this.checks.forEach((c) => this.sync(c, true));
        this.updateTotal();

        if (this.dataset.auto === 'true' && this.scene) {
          if (reduceMotion.matches || !('IntersectionObserver' in window)) {
            this.open(false);
          } else {
            this.io = new IntersectionObserver(
              (entries) => {
                if (!entries.some((en) => en.isIntersecting)) return;
                this.io.disconnect();
                this.later(() => this.open(true), 250);
              },
              { threshold: 0.45 }
            );
            this.io.observe(this.scene);
          }
        }
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.io) this.io.disconnect();
        this.timers.forEach((t) => clearTimeout(t));
      }

      later(fn, ms) {
        this.timers.push(setTimeout(fn, ms));
      }

      /* ---------- the box ---------- */

      open(animate) {
        if (this.classList.contains('is-open')) return;
        if (this.io) this.io.disconnect();
        this.classList.remove('is-closing');
        if (animate && !reduceMotion.matches) {
          this.classList.add('is-opening');
          this.later(() => this.classList.remove('is-opening'), 520 + this.items.length * 90 + 800);
        }
        this.classList.add('is-open');
        if (this.front) this.front.setAttribute('aria-label', 'Close the box');
      }

      close() {
        this.classList.remove('is-opening');
        this.classList.add('is-closing');
        this.classList.remove('is-open');
        if (this.front) this.front.setAttribute('aria-label', 'Open the box');
        this.later(() => this.classList.remove('is-closing'), 1200);
      }

      tapItem(it) {
        if (!this.classList.contains('is-open') || it.classList.contains('is-locked')) return;
        const c = this.checks.find((x) => x.dataset.bxCheck === it.dataset.bxItem);
        if (!c || c.disabled) return;
        c.checked = !c.checked;
        this.sync(c);
      }

      /* ---------- the slip ---------- */

      sync(c, quiet) {
        const i = c.dataset.bxCheck;
        const it = this.items.find((x) => x.dataset.bxItem === i);
        if (it && !it.classList.contains('is-locked')) it.classList.toggle('is-off', !c.checked);
        if (!quiet) {
          this.updateTotal();
          if (this.msg) {
            this.msg.textContent = '';
            this.msg.classList.remove('is-bad');
          }
          // Taking the last piece out closes nothing; putting one back opens the box if needed.
          if (c.checked) this.open(true);
        }
      }

      pickVariant(sel) {
        const i = sel.dataset.bxVariant;
        const c = this.checks.find((x) => x.dataset.bxCheck === i);
        const o = sel.options[sel.selectedIndex];
        if (!c || !o) return;
        c.value = o.value;
        c.dataset.price = o.dataset.price;
        const row = sel.closest('[data-bx-row]');
        const price = row && row.querySelector('[data-bx-price]');
        if (price && o.dataset.fmt) price.textContent = o.dataset.fmt;
        const it = this.items.find((x) => x.dataset.bxItem === i);
        const tag = it && it.querySelector('.bx-item__tag');
        if (tag && tag.hasAttribute('data-bx-tagprice') && o.dataset.fmt) tag.textContent = o.dataset.fmt;
        this.updateTotal();
      }

      money(cents) {
        const v = cents / 100;
        try {
          return new Intl.NumberFormat(this.dataset.locale || undefined, {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
          }).format(v);
        } catch (err) {
          return v.toFixed(2);
        }
      }

      chosen() {
        return this.checks.filter((c) => c.checked && !c.disabled && c.value);
      }

      updateTotal() {
        const picked = this.chosen();
        const sum = picked.reduce((acc, c) => acc + (parseInt(c.dataset.price, 10) || 0), 0);
        if (this.totalEl) this.totalEl.textContent = this.money(sum);
        if (this.addBtn) this.addBtn.disabled = picked.length === 0;
        if (this.addLabel) {
          this.addLabel.textContent = picked.length
            ? `Add ${picked.length} ${picked.length === 1 ? 'item' : 'items'} to cart`
            : 'Pick at least one item';
        }
      }

      async submit(e) {
        e.preventDefault();
        const picked = this.chosen();
        if (!picked.length || !this.addBtn || this.addBtn.getAttribute('aria-busy') === 'true') return;
        this.addBtn.setAttribute('aria-busy', 'true');
        if (this.msg) {
          this.msg.textContent = '';
          this.msg.classList.remove('is-bad');
        }
        try {
          const res = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: picked.map((c) => ({ id: Number(c.value), quantity: 1 })) }),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status) {
            this.say(data.description || data.message || 'Something went wrong. Please try again.', true);
            return;
          }
          this.celebrate();
          const drawer = document.querySelector('cart-drawer');
          // Let the cart drawer and the header count catch up.
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (!drawer) this.say('Added to your cart.', false, true);
        } catch (err) {
          // Network trouble: fall back to a normal form post.
          this.form.submit();
        } finally {
          this.addBtn.removeAttribute('aria-busy');
        }
      }

      celebrate() {
        if (!this.scene || reduceMotion.matches) return;
        this.scene.classList.remove('is-shake');
        void this.scene.offsetWidth;
        this.scene.classList.add('is-shake');
        this.later(() => this.scene.classList.remove('is-shake'), 700);
      }

      say(text, bad, withLink) {
        if (!this.msg) return;
        this.msg.textContent = text;
        this.msg.classList.toggle('is-bad', !!bad);
        if (withLink) {
          const a = document.createElement('a');
          a.href = this.dataset.cartUrl;
          a.textContent = 'View cart';
          this.msg.append(' ', a);
        }
      }

      onBlock(e) {
        const id = e.detail && e.detail.blockId;
        const it = this.items.find(
          (x) => (x.getAttribute('data-shopify-editor-block') || '').indexOf(`"${id}"`) !== -1
        );
        if (!it) return;
        this.open(false);
        const row = this.querySelector(`[data-bx-row="${it.dataset.bxItem}"]`);
        [it, row].forEach((el) => {
          if (!el) return;
          el.classList.remove('is-flash');
          void el.offsetWidth;
          el.classList.add('is-flash');
        });
      }
    }

    customElements.define('unbox-set', UnboxSet);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('video-strip')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const saveData = () => !!(navigator.connection && navigator.connection.saveData);

    class VideoStrip extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vs-track]');
        if (!this.track) return;
        this.cards = Array.from(this.querySelectorAll('[data-vs-card]'));
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.timers = new Set();
        this.prev = this.querySelector('[data-vs-prev]');
        this.next = this.querySelector('[data-vs-next]');
        this.auto = this.dataset.autoplay === 'true' && !reduceMotion.matches && !saveData();
        this.sound = false;
        this.held = false;
        this.active = null;
        this.visible = false;
        if (!reduceMotion.matches && document.documentElement.getAttribute('data-reveal') !== 'none') this.classList.add('is-ready');

        this.cards.forEach((card) => {
          const v = this.videoOf(card);
          if (!v) return;
          v.muted = true;
          v.addEventListener('play', () => this.paint(card), { signal });
          v.addEventListener(
            'pause',
            () => {
              card.classList.remove('is-waiting');
              this.paint(card);
            },
            { signal }
          );
          v.addEventListener('waiting', () => card.classList.add('is-waiting'), { signal });
          v.addEventListener(
            'playing',
            () => {
              card.classList.remove('is-waiting');
              card.classList.add('is-started');
              this.paint(card);
              this.tick();
            },
            { signal }
          );
          // A source this browser can't use (the stream on most desktops) is skipped for the next one;
          // only when the last one fails, or the video itself breaks, does the card keep its picture
          const last = v.querySelector('source:last-of-type');
          v.addEventListener(
            'error',
            (e) => {
              if (e.target === v || e.target === last) this.broken(card);
            },
            { capture: true, signal }
          );
        });

        this.addEventListener(
          'click',
          (e) => {
            const t = e.target;
            if (!(t instanceof Element)) return;
            if (t.closest('[data-vs-prev]')) return this.step(-1);
            if (t.closest('[data-vs-next]')) return this.step(1);
            const card = t.closest('[data-vs-card]');
            if (!card) return;
            if (t.closest('[data-vs-sound]')) return this.setSound(!this.sound, card);
            if (t.closest('[data-vs-play]') || t.closest('[data-vs-surface]')) this.toggle(card);
          },
          { signal }
        );
        this.addEventListener(
          'submit',
          (e) => {
            const form = e.target instanceof Element && e.target.closest('[data-vs-add-form]');
            if (!form) return;
            // A cart drawer that opens on add takes the form itself and slides in
            if (document.querySelector('cart-drawer[data-open-on-add]')) return;
            e.preventDefault();
            this.add(form);
          },
          { signal }
        );

        // Computers: the video under the pointer plays (after a short pause, so sweeping across loads nothing)
        this.track.addEventListener(
          'pointerover',
          (e) => {
            if (e.pointerType !== 'mouse' || !finePointer.matches || !this.auto || this.held) return;
            const card = e.target instanceof Element && e.target.closest('[data-vs-card]');
            if (!card || card === this.hovered) return;
            this.hovered = card;
            clearTimeout(this.hoverWait);
            if (card === this.active || !this.videoOf(card) || card.classList.contains('is-broken')) return;
            this.hoverWait = setTimeout(() => {
              if (this.hovered === card && !this.held) this.pick(card);
            }, 160);
          },
          { signal }
        );
        this.track.addEventListener(
          'pointerleave',
          () => {
            this.hovered = null;
            clearTimeout(this.hoverWait);
          },
          { signal }
        );
        // Phones: the one that comes to rest in the middle plays
        this.track.addEventListener(
          'scroll',
          () => {
            this.queueArrows();
            clearTimeout(this.rest);
            this.rest = setTimeout(() => this.settle(), 140);
          },
          { passive: true, signal }
        );

        document.addEventListener('visibilitychange', () => (document.hidden ? this.sleep() : this.wake()), { signal });
        this.addEventListener(
          'shopify:block:select',
          (e) => {
            const card = e.target instanceof Element && e.target.closest('[data-vs-card]');
            if (!card) return;
            this.classList.add('is-in', 'is-settled');
            this.bring(card);
            if (this.videoOf(card)) this.pick(card, true);
          },
          { signal }
        );

        if ('IntersectionObserver' in window) {
          // Plays only while most of the strip is on screen
          this.seen = new IntersectionObserver(
            (entries) => {
              const entry = entries[entries.length - 1];
              this.visible = entry.isIntersecting;
              if (this.visible) this.wake();
              else this.sleep();
            },
            { threshold: 0.35 }
          );
          this.seen.observe(this.track);
          if (this.classList.contains('is-ready')) {
            this.arrival = new IntersectionObserver(
              (entries) => {
                if (!entries.some((x) => x.isIntersecting)) return;
                this.arrival.disconnect();
                this.arrival = null;
                requestAnimationFrame(() => this.land());
              },
              { rootMargin: '0px 0px -10% 0px' }
            );
            this.arrival.observe(this);
          }
        } else {
          this.visible = true;
          this.land();
        }
        if (!this.classList.contains('is-ready')) this.land();
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.queueArrows());
          this.ro.observe(this.track);
        }
        this.paintArrows();
      }

      land() {
        this.classList.add('is-in');
        if (!this.classList.contains('is-ready')) this.classList.add('is-settled');
        else this.later(() => this.classList.add('is-settled'), 1600);
      }

      videoOf(card) {
        return card ? card.querySelector('[data-vs-video]') : null;
      }

      /* ---------- Which one plays ---------- */

      pick(card, byHand) {
        if (!card) return;
        if (this.active && this.active !== card) this.stop(this.active);
        this.active = card;
        this.cards.forEach((c) => c.classList.toggle('is-active', c === card));
        if (byHand) this.held = false;
        if (byHand || (this.auto && !this.held && this.visible)) this.start(card);
      }

      start(card) {
        const v = this.videoOf(card);
        if (!v || card.classList.contains('is-broken')) return;
        v.muted = !this.sound;
        if (v.paused) card.classList.add('is-waiting');
        const job = v.play();
        if (job && job.catch) {
          job.catch(() => {
            card.classList.remove('is-waiting');
            if (v.error || v.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) return this.broken(card);
            // Sound may need a tap of its own on some phones: try again without it
            if (!v.muted) {
              v.muted = true;
              this.setSound(false);
              v.play().catch(() => this.paint(card));
            } else {
              this.paint(card);
            }
          });
        }
      }

      stop(card) {
        const v = this.videoOf(card);
        if (v && !v.paused) v.pause();
        card.classList.remove('is-waiting');
      }

      toggle(card) {
        const v = this.videoOf(card);
        if (!v || card.classList.contains('is-broken')) return;
        if (card !== this.active) {
          if (!finePointer.matches && !this.inView(card)) this.bring(card);
          return this.pick(card, true);
        }
        if (v.paused) {
          this.held = false;
          this.start(card);
        } else {
          // Paused by hand: nothing starts by itself again until the visitor plays something
          this.held = true;
          v.pause();
        }
      }

      /* After scrolling: the right card plays, a card that slid away stops */
      settle() {
        if (!this.visible || document.hidden) return;
        const target = finePointer.matches
          ? this.active && this.inView(this.active)
            ? this.active
            : this.firstInView()
          : this.centred();
        if (this.auto && !this.held) {
          if (target && target !== this.active && this.videoOf(target)) this.pick(target);
          else if (target && target === this.active) this.start(target);
        } else if (this.active && !this.inView(this.active)) {
          this.stop(this.active);
        }
      }

      sleep() {
        const v = this.videoOf(this.active);
        this.resume = !!(v && !v.paused);
        if (v && !v.paused) v.pause();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }

      wake() {
        if (document.hidden || !this.visible) return;
        if (this.resume && this.active && this.inView(this.active)) {
          this.resume = false;
          return this.start(this.active);
        }
        this.resume = false;
        this.settle();
      }

      inView(card) {
        const t = this.track.getBoundingClientRect();
        const r = card.getBoundingClientRect();
        const seen = Math.min(r.right, t.right) - Math.max(r.left, t.left);
        return r.width > 0 && seen / r.width >= 0.6;
      }

      firstInView() {
        return this.cards.find((c) => this.videoOf(c) && !c.classList.contains('is-broken') && this.inView(c)) || null;
      }

      centred() {
        const t = this.track.getBoundingClientRect();
        const mid = t.left + t.width / 2;
        let best = null;
        let gap = Infinity;
        this.cards.forEach((c) => {
          const r = c.getBoundingClientRect();
          const d = Math.abs(r.left + r.width / 2 - mid);
          if (d < gap) {
            gap = d;
            best = c;
          }
        });
        return best;
      }

      broken(card) {
        card.classList.add('is-broken');
        card.classList.remove('is-waiting', 'is-playing', 'is-started');
        const v = this.videoOf(card);
        if (v && !v.paused) v.pause();
      }

      paint(card) {
        const v = this.videoOf(card);
        if (!v) return;
        const playing = !v.paused && !v.ended;
        card.classList.toggle('is-playing', playing);
        const btn = card.querySelector('[data-vs-play]');
        if (btn) {
          const name = btn.dataset.name ? `: ${btn.dataset.name}` : '';
          btn.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} video${name}`);
        }
      }

      /* The thin bar along the top follows the video */
      tick() {
        if (this.raf) return;
        const loop = () => {
          this.raf = 0;
          const v = this.videoOf(this.active);
          if (!v || v.paused) return;
          const bar = this.active.querySelector('[data-vs-bar]');
          if (bar && v.duration && isFinite(v.duration))
            bar.style.transform = `scaleX(${Math.min(1, v.currentTime / v.duration)})`;
          this.raf = requestAnimationFrame(loop);
        };
        this.raf = requestAnimationFrame(loop);
      }

      setSound(on, card) {
        this.sound = on;
        this.classList.toggle('is-loud', on);
        this.querySelectorAll('[data-vs-sound]').forEach((btn) => btn.setAttribute('aria-pressed', String(on)));
        const target = card || this.active;
        if (card && card !== this.active) this.pick(card, true);
        const v = this.videoOf(target);
        if (!v) return;
        v.muted = !on;
        if (on && v.paused) {
          this.held = false;
          this.start(target);
        }
      }

      /* ---------- Arrows ---------- */

      /* Scroll a card into place: to the middle on phones, to the start on computers */
      bring(card) {
        const l = this.track;
        const pad = parseFloat(getComputedStyle(l).paddingLeft) || 0;
        const left = finePointer.matches
          ? card.offsetLeft - pad
          : card.offsetLeft + card.offsetWidth / 2 - l.clientWidth / 2;
        l.scrollTo({ left, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      queueArrows() {
        if (this.arrowRaf) return;
        this.arrowRaf = requestAnimationFrame(() => {
          this.arrowRaf = 0;
          this.paintArrows();
        });
      }

      paintArrows() {
        if (!this.prev || !this.next) return;
        const l = this.track;
        const focused = document.activeElement;
        const room = l.scrollWidth - l.clientWidth;
        const pos = Math.abs(l.scrollLeft);
        const over = room > 2;
        this.classList.toggle('has-overflow', over);
        this.prev.disabled = !over || pos <= 2;
        this.next.disabled = !over || pos >= room - 2;
        if (focused === this.next && this.next.disabled && !this.prev.disabled) this.prev.focus();
        else if (focused === this.prev && this.prev.disabled && !this.next.disabled) this.next.focus();
      }

      step(dir) {
        const l = this.track;
        const card = this.cards[0];
        if (!card) return;
        const style = getComputedStyle(l);
        const gap = parseFloat(style.columnGap) || 0;
        const width = card.getBoundingClientRect().width + gap;
        const inner = l.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
        const n = Math.max(1, Math.floor((inner + gap) / width));
        const flip = style.direction === 'rtl' ? -1 : 1;
        l.scrollBy({ left: dir * flip * n * width, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }

      /* ---------- Straight to the cart ---------- */

      async add(form) {
        const btn = form.querySelector('[data-vs-add]');
        if (!btn || btn.getAttribute('aria-busy') === 'true') return;
        const data = new FormData(form);
        const id = Number(data.get('id'));
        const quantity = Math.max(1, Number(data.get('quantity')) || 1);
        if (!id) return;
        const card = form.closest('[data-vs-card]');
        const link = card && card.querySelector('.vs-chip__title a');
        const name = link ? link.textContent : 'Product';
        this.fail('');
        btn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({ items: [{ id, quantity }] }),
          });
          const body = await res.json().catch(() => ({}));
          if (!res.ok || body.status)
            throw new Error(body.description || body.message || `${name} could not be added to your cart.`);
          btn.classList.add('is-added');
          this.later(() => btn.classList.remove('is-added'), 2000);
          this.say(`${name} added to your cart.`);
          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else {
            const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
              .then((r) => r.json())
              .catch(() => null);
            if (cart)
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'video-strip' } }));
          }
        } catch (err) {
          this.fail((err && err.message) || 'Something went wrong. Please try again.');
        } finally {
          btn.removeAttribute('aria-busy');
        }
      }

      fail(text) {
        const msg = this.querySelector('[data-vs-msg]');
        if (!msg) return;
        msg.textContent = text;
        msg.hidden = !text;
      }

      say(text) {
        const live = this.querySelector('[data-vs-live]');
        if (!live) return;
        live.textContent = '';
        requestAnimationFrame(() => (live.textContent = text));
      }

      later(fn, ms) {
        const id = setTimeout(() => {
          this.timers.delete(id);
          fn();
        }, ms);
        this.timers.add(id);
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.timers) this.timers.forEach((t) => clearTimeout(t));
        clearTimeout(this.rest);
        clearTimeout(this.hoverWait);
        if (this.seen) this.seen.disconnect();
        if (this.arrival) this.arrival.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this.arrowRaf) cancelAnimationFrame(this.arrowRaf);
        this.raf = 0;
        this.arrowRaf = 0;
        (this.cards || []).forEach((card) => {
          const v = this.videoOf(card);
          if (v && !v.paused) v.pause();
        });
      }
    }

    customElements.define('video-strip', VideoStrip);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('video-reel')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    class VideoReel extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.frame = this.querySelector('[data-vr-frame]');
        this.inner = this.querySelector('.vr-frame__inner');
        this.mode = this.dataset.mode;
        this.editor = !!(window.Shopify && window.Shopify.designMode);
        this.userPaused = false;
        this.visible = false;

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            ([entry]) => {
              this.visible = entry.isIntersecting;
              this.classList.toggle('is-inview', entry.isIntersecting);
              this.onVisibility();
            },
            { threshold: 0.25 }
          );
          this.io.observe(this.frame || this);
        } else {
          this.visible = true;
          this.classList.add('is-inview');
        }

        if (this.mode === 'click') this.initClick(signal);
        else this.initAmbient(signal);

        this.initGrow(signal);

        document.addEventListener('visibilitychange', () => this.onVisibility(), { signal });
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.io) this.io.disconnect();
        cancelAnimationFrame(this.growFrame);
        cancelAnimationFrame(this.followFrame);
      }

      /* ---------- Play on click: nothing heavy loads until asked ---------- */
      initClick(signal) {
        this.play = this.querySelector('[data-vr-play]');
        this.template = this.querySelector('[data-vr-template]');
        if (!this.play || !this.template) return;

        this.play.addEventListener('click', () => this.start(), { signal });

        // The button drifts after the pointer, then settles back in the middle.
        if (finePointer.matches && !reduceMotion.matches && this.inner) {
          this.target = { x: 0, y: 0 };
          this.pos = { x: 0, y: 0 };
          this.inner.addEventListener(
            'pointermove',
            (e) => {
              if (this.classList.contains('is-playing')) return;
              const r = this.inner.getBoundingClientRect();
              this.target.x = (e.clientX - r.left - r.width / 2) * 0.55;
              this.target.y = (e.clientY - r.top - r.height / 2) * 0.55;
              this.follow();
            },
            { signal }
          );
          this.inner.addEventListener(
            'pointerleave',
            () => {
              this.target.x = 0;
              this.target.y = 0;
              this.follow();
            },
            { signal }
          );
          // Clicking anywhere on the still plays it.
          this.inner.addEventListener(
            'click',
            (e) => {
              if (this.classList.contains('is-playing') || e.target.closest('[data-vr-play]')) return;
              if (e.target.closest('.vr-cover')) this.start();
            },
            { signal }
          );
        }
      }

      follow() {
        if (this.followFrame) return;
        const step = () => {
          const dx = this.target.x - this.pos.x;
          const dy = this.target.y - this.pos.y;
          this.pos.x += dx * 0.14;
          this.pos.y += dy * 0.14;
          this.play.style.setProperty('--px', `${this.pos.x.toFixed(1)}px`);
          this.play.style.setProperty('--py', `${this.pos.y.toFixed(1)}px`);
          if (Math.abs(dx) < 0.3 && Math.abs(dy) < 0.3) {
            this.followFrame = 0;
            return;
          }
          this.followFrame = requestAnimationFrame(step);
        };
        this.followFrame = requestAnimationFrame(step);
      }

      start() {
        if (this.classList.contains('is-playing') || !this.template) return;
        const media = this.querySelector('[data-vr-media]');
        media.appendChild(this.template.content.cloneNode(true));
        this.classList.add('is-playing');
        this.play.style.removeProperty('--px');
        this.play.style.removeProperty('--py');
        const video = media.querySelector('video');
        const iframe = media.querySelector('iframe');
        if (video) {
          video.setAttribute('playsinline', '');
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
          video.focus({ preventScroll: true });
          this.player = video;
        } else if (iframe) {
          iframe.focus({ preventScroll: true });
          this.player = iframe;
        }
      }

      /* ---------- Ambient loop ---------- */
      initAmbient(signal) {
        this.video = this.querySelector('.vr-media video');
        this.toggle = this.querySelector('[data-vr-toggle]');
        this.bar = this.querySelector('[data-vr-progress]');
        if (!this.video) return;
        this.video.muted = true;
        this.video.loop = true;
        this.video.setAttribute('playsinline', '');

        // Motion-sensitive visitors get the still and a play button, never an autostart.
        if (reduceMotion.matches) this.userPaused = true;
        this.syncToggle();

        this.video.addEventListener('playing', () => this.classList.add('is-rolling'), { signal });
        this.video.addEventListener(
          'timeupdate',
          () => {
            if (!this.bar || !this.video.duration) return;
            this.bar.style.transform = `scaleX(${(this.video.currentTime / this.video.duration).toFixed(4)})`;
          },
          { signal }
        );

        if (this.toggle) {
          this.toggle.addEventListener(
            'click',
            () => {
              this.userPaused = !this.userPaused;
              this.syncToggle();
              this.onVisibility();
            },
            { signal }
          );
        }
      }

      syncToggle() {
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        const label = this.toggle.querySelector('.vr-visually-hidden');
        if (label) label.textContent = this.userPaused ? 'Play background video' : 'Pause background video';
      }

      onVisibility() {
        const run = this.visible && !document.hidden;
        if (this.mode === 'ambient' && this.video) {
          if (run && !this.userPaused) {
            const p = this.video.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            this.video.pause();
          }
        } else if (this.player && this.player.tagName === 'VIDEO' && !run && !this.player.paused) {
          // A film that scrolls away stops, rather than talking to nobody.
          this.player.pause();
        }
      }

      /* ---------- The screen opens up as it scrolls in ---------- */
      initGrow(signal) {
        if (!this.classList.contains('vr--grow') || !this.frame || reduceMotion.matches) return;
        const min = window.matchMedia('(min-width: 750px)').matches ? 0.88 : 0.94;
        let ticking = false;
        const update = () => {
          ticking = false;
          if (!this.visible && this.growDone) return;
          const r = this.frame.getBoundingClientRect();
          const vh = window.innerHeight;
          const p = Math.min(Math.max((vh - r.top) / (vh * 0.75), 0), 1);
          const eased = 1 - Math.pow(1 - p, 3);
          const sc = min + (1 - min) * eased;
          this.frame.style.setProperty('--vr-s', sc.toFixed(4));
          this.growDone = p >= 1;
        };
        const request = () => {
          if (ticking) return;
          ticking = true;
          this.growFrame = requestAnimationFrame(update);
        };
        update();
        this.classList.add('is-ready');
        window.addEventListener('scroll', request, { passive: true, signal });
        window.addEventListener('resize', request, { passive: true, signal });
      }
    }

    customElements.define('video-reel', VideoReel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-fits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('what-fits')) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const FILL = 0.8; // soft bags never pack perfectly
    const EPS = 0.05; // mm
    const TILT = [-2.4, 1.7, -1.1, 2.6, -1.9, 1.2, -0.8, 2.1];
    const WORD = ['wide', 'tall', 'thick'];
    const tf = (x, y, sc, r) => `translate(${x}px, ${y}px) scale(${sc}) rotate(${r}deg)`;

    class WhatFits extends HTMLElement {
      connectedCallback() {
        this.inside = this.querySelector('[data-wf-inside]');
        if (!this.inside) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.timers = [];
        this.W = parseFloat(this.dataset.w);
        this.H = parseFloat(this.dataset.h);
        this.D = parseFloat(this.dataset.d);
        this.cap = this.W * this.H * this.D * FILL;
        this.used = 0;
        this.packed = new Map();
        this.chips = Array.from(this.querySelectorAll('[data-wf-item]'));
        this.note = this.querySelector('[data-wf-note]');
        this.emptyText = this.dataset.empty || '';

        let unit = this.dataset.unit;
        try {
          const saved = window.localStorage.getItem('wf-unit');
          if (saved === 'cm' || saved === 'in') unit = saved;
        } catch (err) {
          /* storage can be blocked; the section still works */
        }
        this.classList.add('is-js');
        this.setUnit(unit, false);
        this.update();

        this.addEventListener('click', (e) => this.onClick(e), { signal });
        document.addEventListener('shopify:block:select', (e) => this.onBlockSelect(e), { signal });

        this.prepack();
      }

      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        if (this.io) this.io.disconnect();
        (this.timers || []).forEach((t) => clearTimeout(t));
      }

      /* ---------- events ---------- */

      onClick(e) {
        const chip = e.target.closest('[data-wf-item]');
        if (chip) {
          if (this.packed.has(chip.dataset.id)) this.takeOut(chip, true);
          else this.pack(chip, true, false);
          return;
        }
        const thing = e.target.closest('.wf-thing');
        if (thing && !thing.classList.contains('is-ghost') && !thing.classList.contains('is-leaving')) {
          const c = this.chips.find((x) => x.dataset.id === thing.dataset.id);
          if (c) this.takeOut(c, true);
          return;
        }
        const u = e.target.closest('[data-wf-unit]');
        if (u) {
          this.setUnit(u.dataset.wfUnit, true);
          return;
        }
        if (e.target.closest('[data-wf-empty]')) this.emptyAll();
      }

      onBlockSelect(e) {
        const chip = this.chips.find((c) => c.dataset.id === (e.detail && e.detail.blockId));
        if (!chip) return;
        chip.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        chip.classList.remove('is-flash');
        void chip.offsetWidth;
        chip.classList.add('is-flash');
      }

      /* ---------- measuring ---------- */

      fmt(mm) {
        const v = this.unit === 'in' ? mm / 25.4 : mm / 10;
        return String(Math.round(v * 10) / 10);
      }

      /* Try every way of turning the thing; keep the drawn face forward when possible. */
      orient(w, h, d) {
        const ways = [
          [w, h, d, 'up'],
          [h, w, d, 'rot'],
          [w, d, h, 'side'],
          [d, w, h, 'side'],
          [h, d, w, 'side'],
          [d, h, w, 'side'],
        ];
        const bag = [this.W, this.H, this.D];
        let best = null;
        let near = null;
        ways.forEach(([fw, fh, fd, kind]) => {
          const over = [fw - bag[0], fh - bag[1], fd - bag[2]];
          const worst = Math.max(...over);
          const way = { fw, fh, fd, kind, over: worst, dim: over.indexOf(worst) };
          if (worst <= EPS) {
            if (!best) best = way;
            else if (best.kind === 'side' && kind === 'side' && fw * fh > best.fw * best.fh) best = way;
          } else if (!near || worst < near.over - EPS) {
            near = way;
          }
        });
        return best ? Object.assign(best, { ok: true }) : Object.assign(near, { ok: false });
      }

      /* Stand the thing on the bottom where it hides the least of what's already in. */
      slot(fw, fh) {
        const max = Math.max(0, this.W - fw);
        const spots = new Set([0, max]);
        this.packed.forEach((p) => {
          spots.add(p.x + p.fw);
          spots.add(p.x - fw);
        });
        let best = 0;
        let bestScore = Infinity;
        Array.from(spots)
          .map((x) => Math.min(max, Math.max(0, x)))
          .sort((a, b) => a - b)
          .forEach((x) => {
            let score = 0;
            this.packed.forEach((p) => {
              const ov = Math.min(x + fw, p.x + p.fw) - Math.max(x, p.x);
              if (ov > 0) score += ov * Math.min(fh, p.fh);
            });
            if (score < bestScore - 0.01) {
              bestScore = score;
              best = x;
            }
          });
        return best;
      }

      /* ---------- drawing ---------- */

      makeThing(chip, way, x) {
        const w = parseFloat(chip.dataset.w);
        const h = parseFloat(chip.dataset.h);
        const el = document.createElement('div');
        el.className = 'wf-thing';
        el.dataset.id = chip.dataset.id;
        el.style.left = `${(x / this.W) * 100}%`;
        el.style.width = `${(way.fw / this.W) * 100}%`;
        el.style.height = `${(way.fh / this.H) * 100}%`;
        // Smaller things sit in front so nothing small disappears behind a laptop.
        el.style.zIndex = String(Math.max(1, 1000000 - Math.round((way.fw * way.fh) / 10)));

        const art = document.createElement('span');
        art.className = 'wf-thing__art';
        if (way.kind === 'side') {
          art.classList.add('wf-thing__box');
        } else {
          const src = chip.querySelector('.wf-art');
          if (src) {
            const copy = src.cloneNode(true);
            if (copy.tagName === 'IMG') copy.loading = 'eager';
            art.appendChild(copy);
          }
          if (way.kind === 'rot') {
            el.classList.add('is-rot');
            art.style.setProperty('--aw', `${(w / way.fw) * 100}%`);
            art.style.setProperty('--ah', `${(h / way.fh) * 100}%`);
          }
        }
        el.appendChild(art);
        return el;
      }

      tiltFor(chip, way) {
        const i = Math.max(0, this.chips.indexOf(chip));
        return TILT[i % TILT.length] * Math.min(1, 90 / Math.max(way.fw, way.fh));
      }

      /* ---------- packing ---------- */

      pack(chip, animate, quiet) {
        const id = chip.dataset.id;
        if (this.packed.has(id)) return true;
        const name = chip.dataset.name;
        const w = parseFloat(chip.dataset.w);
        const h = parseFloat(chip.dataset.h);
        const d = parseFloat(chip.dataset.d);
        const way = this.orient(w, h, d);

        if (!way.ok) {
          if (!quiet) this.nope(chip, way);
          return false;
        }
        const vol = w * h * d;
        if (this.used + vol > this.cap + 1) {
          if (!quiet) {
            this.shake(chip);
            const meter = this.querySelector('.wf-meter');
            if (meter && !reduceMotion.matches) {
              meter.classList.remove('is-pulse');
              void meter.offsetWidth;
              meter.classList.add('is-pulse');
            }
            this.say(`${name}: no room left. Take something out first.`, true);
          }
          return false;
        }

        const x = this.slot(way.fw, way.fh);
        const el = this.makeThing(chip, way, x);
        const tilt = this.tiltFor(chip, way);
        el.style.setProperty('--r', `${tilt.toFixed(2)}deg`);
        this.inside.appendChild(el);

        this.packed.set(id, { el, vol, x, fw: way.fw, fh: way.fh, tilt });
        this.used += vol;
        chip.setAttribute('aria-pressed', 'true');
        chip.classList.remove('is-nofit');
        this.update();
        if (!quiet) this.say(`${name} is in.`, false);
        if (animate && !reduceMotion.matches && el.animate) this.fly(el, chip, tilt);
        return true;
      }

      fly(el, chip, tilt) {
        const from = (chip.querySelector('.wf-chip__art') || chip).getBoundingClientRect();
        const to = el.getBoundingClientRect();
        const box = this.inside.getBoundingClientRect();
        if (!to.width || !to.height) return;
        const sc = Math.max(0.04, Math.min(from.width / to.width, from.height / to.height));
        const dx = from.left + from.width / 2 - (to.left + to.width / 2);
        const dy = from.top + from.height / 2 - (to.top + to.height / 2);
        const lift = -(box.height + 10);
        el.animate(
          [
            { transform: tf(dx, dy, sc, 0), opacity: 0, easing: 'cubic-bezier(0.25, 0.7, 0.35, 1)' },
            { offset: 0.12, opacity: 1 },
            { offset: 0.55, transform: tf(0, lift, 1, tilt * 3), easing: 'cubic-bezier(0.55, 0, 0.85, 0.4)' },
            { offset: 0.82, transform: tf(0, 3, 1, tilt * 0.5), easing: 'cubic-bezier(0.3, 0.8, 0.4, 1)' },
            { transform: tf(0, 0, 1, tilt), opacity: 1 },
          ],
          { duration: 820, fill: 'backwards' }
        );
      }

      takeOut(chip, animate) {
        const id = chip.dataset.id;
        const item = this.packed.get(id);
        if (!item) return;
        this.packed.delete(id);
        this.used = Math.max(0, this.used - item.vol);
        if (this.packed.size === 0) this.used = 0;
        chip.setAttribute('aria-pressed', 'false');
        this.update();
        if (animate) this.say(`${chip.dataset.name} is out.`, false);
        this.lift(item, animate);
      }

      lift(item, animate) {
        const el = item.el;
        el.classList.add('is-leaving');
        if (!animate || reduceMotion.matches || !el.animate) {
          el.remove();
          return;
        }
        const up = -(this.inside.getBoundingClientRect().height * 0.55);
        const a = el.animate(
          [
            { transform: tf(0, 0, 1, item.tilt), opacity: 1 },
            { transform: tf(0, up, 0.96, -item.tilt), opacity: 0 },
          ],
          { duration: 420, easing: 'cubic-bezier(0.4, 0, 0.8, 0.4)', fill: 'forwards' }
        );
        a.onfinish = () => el.remove();
        a.oncancel = () => el.remove();
      }

      emptyAll() {
        let i = 0;
        this.chips.forEach((chip) => {
          const item = this.packed.get(chip.dataset.id);
          if (!item) return;
          this.packed.delete(chip.dataset.id);
          chip.setAttribute('aria-pressed', 'false');
          const delay = reduceMotion.matches ? 0 : i * 60;
          i += 1;
          if (delay) this.timers.push(setTimeout(() => this.lift(item, true), delay));
          else this.lift(item, true);
        });
        this.used = 0;
        this.update();
        this.say('The bag is empty.', false);
        const first = this.chips[0];
        if (first) first.focus({ preventScroll: true });
      }

      /* Too big: the thing appears to scale at the bag, shows by how much, and backs off. */
      nope(chip, way) {
        chip.classList.add('is-nofit');
        this.shake(chip);
        if (this.ghost) this.ghost.remove();
        const x = (this.W - way.fw) / 2;
        const g = this.makeThing(chip, way, x);
        g.classList.add('is-ghost');
        const tag = document.createElement('span');
        tag.className = 'wf-thing__tag';
        const amount = `${this.fmt(way.over)} ${this.unit} too ${WORD[way.dim]}`;
        tag.textContent = amount;
        g.appendChild(tag);
        this.inside.appendChild(g);
        this.ghost = g;

        const done = () => {
          g.remove();
          if (this.ghost === g) this.ghost = null;
        };
        const frames = reduceMotion.matches
          ? [{ opacity: 0 }, { offset: 0.08, opacity: 1 }, { offset: 0.88, opacity: 1 }, { opacity: 0 }]
          : [
              { transform: 'translate(0px, -40px)', opacity: 0, easing: 'cubic-bezier(0.3, 0.8, 0.4, 1)' },
              { offset: 0.16, transform: 'translate(0px, 0px)', opacity: 1 },
              { offset: 0.28, transform: 'translate(-5px, 0px)' },
              { offset: 0.38, transform: 'translate(4px, 0px)' },
              { offset: 0.48, transform: 'translate(-2px, 0px)' },
              { offset: 0.56, transform: 'translate(0px, 0px)' },
              { offset: 0.86, transform: 'translate(0px, 0px)', opacity: 1, easing: 'cubic-bezier(0.4, 0, 0.8, 0.4)' },
              { transform: 'translate(0px, -28px)', opacity: 0 },
            ];
        if (g.animate) {
          const a = g.animate(frames, { duration: 2000, fill: 'forwards' });
          a.onfinish = done;
          a.oncancel = done;
        } else {
          this.timers.push(setTimeout(done, 2000));
        }
        this.say(`${chip.dataset.name} won’t fit: it’s ${amount}.`, true);
      }

      shake(chip) {
        if (reduceMotion.matches) return;
        chip.classList.remove('is-shake');
        void chip.offsetWidth;
        chip.classList.add('is-shake');
      }

      /* ---------- read-outs ---------- */

      update() {
        const n = this.packed.size;
        const ratio = this.cap > 0 ? Math.min(1, this.used / this.cap) : 0;
        const pct = n ? Math.max(1, Math.round(ratio * 100)) : 0;
        const meter = this.querySelector('[data-wf-meter]');
        if (meter) meter.style.transform = `scaleX(${ratio})`;
        const count = this.querySelector('[data-wf-count]');
        if (count) count.textContent = n ? `${n} ${n === 1 ? 'thing' : 'things'} packed` : this.emptyText;
        const pctEl = this.querySelector('[data-wf-pct]');
        if (pctEl) pctEl.textContent = `${pct}% full`;
        const empty = this.querySelector('[data-wf-empty]');
        if (empty) empty.hidden = n === 0;
        this.classList.toggle('is-full', pct >= 95);
      }

      say(msg, bad) {
        if (!this.note) return;
        this.note.classList.toggle('is-bad', !!bad);
        // Clear first so the same sentence is announced again.
        this.note.textContent = '';
        window.requestAnimationFrame(() => {
          this.note.textContent = msg;
        });
      }

      setUnit(u, save) {
        this.unit = u === 'in' ? 'in' : 'cm';
        this.querySelectorAll('[data-wf-unit]').forEach((b) =>
          b.setAttribute('aria-pressed', String(b.dataset.wfUnit === this.unit))
        );
        this.chips.forEach((c) => {
          const out = c.querySelector('[data-wf-size]');
          if (out)
            out.textContent = `${this.fmt(parseFloat(c.dataset.w))} × ${this.fmt(parseFloat(c.dataset.h))} ${
              this.unit
            }`;
        });
        const size = this.querySelector('[data-wf-bagsize]');
        if (size) size.textContent = `${this.fmt(this.W)} × ${this.fmt(this.H)} × ${this.fmt(this.D)} ${this.unit}`;
        const dw = this.querySelector('[data-wf-dim="w"]');
        if (dw) dw.textContent = `${this.fmt(this.W)} ${this.unit}`;
        const dh = this.querySelector('[data-wf-dim="h"]');
        if (dh) dh.textContent = `${this.fmt(this.H)} ${this.unit}`;
        const key = this.querySelector('[data-wf-grid]');
        if (key) key.textContent = this.unit === 'in' ? '2 in' : '5 cm';
        this.grid(this.unit === 'in' ? 50.8 : 50);
        if (save) {
          try {
            window.localStorage.setItem('wf-unit', this.unit);
          } catch (err) {
            /* ignore */
          }
        }
      }

      /* Keep the mat's lines starting exactly at the bag's bottom-left corner. */
      grid(g) {
        const stage = this.querySelector('.wf-stage');
        if (!stage) return;
        const cs = getComputedStyle(stage);
        const ml = parseFloat(cs.getPropertyValue('--ml'));
        const t = parseFloat(cs.getPropertyValue('--t'));
        const vw = parseFloat(cs.getPropertyValue('--vw'));
        const vh = parseFloat(cs.getPropertyValue('--vh'));
        if (!ml || !vw) return;
        const mx = ml - Math.ceil(ml / g) * g;
        const my = t + this.H - Math.ceil((t + this.H) / g) * g;
        this.style.setProperty('--g', String(g));
        this.style.setProperty('--mx', mx.toFixed(2));
        this.style.setProperty('--my', my.toFixed(2));
        this.style.setProperty('--mw', (vw - mx + g).toFixed(2));
        this.style.setProperty('--mh', (vh - my + g).toFixed(2));
      }

      /* Things the merchant marked as already packed drop in when the bag comes into view. */
      prepack() {
        const pre = this.chips.filter((c) => c.hasAttribute('data-packed'));
        if (!pre.length) return;
        const run = (animate) => {
          pre.forEach((chip, i) => {
            if (!animate) {
              this.pack(chip, false, true);
              return;
            }
            this.timers.push(
              setTimeout(() => {
                if (this.isConnected) this.pack(chip, true, true);
              }, 200 + i * 200)
            );
          });
        };
        if (reduceMotion.matches || !('IntersectionObserver' in window)) {
          run(false);
          return;
        }
        this.io = new IntersectionObserver(
          (entries) => {
            if (!entries.some((en) => en.isIntersecting)) return;
            this.io.disconnect();
            run(true);
          },
          { threshold: 0.35 }
        );
        this.io.observe(this.querySelector('.wf-stage'));
      }
    }

    customElements.define('what-fits', WhatFits);
  })();

  } catch(e) { console.error(e); }
})();
})();
